import * as React from 'react';
import React__default, { createContext, forwardRef, createElement, Component, Fragment as Fragment$1, useState, useMemo, useRef, useCallback, PureComponent, useEffect, useContext, useLayoutEffect, useReducer, useImperativeHandle } from 'react';
import { createPortal } from 'react-dom';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _defineProperty$3 = unwrapExports(defineProperty);

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};
var removeLabel = function removeLabel(context, content) {
  if (context === 1 && // charcode for l
  content.charCodeAt(0) === 108 && // charcode for b
  content.charCodeAt(2) === 98 // this ignores label
  ) {
      return '';
    }
};

var isBrowser$3 = typeof document !== 'undefined';
var rootServerStylisCache = {};
var getServerStylisCache = isBrowser$3 ? undefined : weakMemoize(function () {
  var getCache = weakMemoize(function () {
    return {};
  });
  var prefixTrueCache = {};
  var prefixFalseCache = {};
  return function (prefix) {
    if (prefix === undefined || prefix === true) {
      return prefixTrueCache;
    }

    if (prefix === false) {
      return prefixFalseCache;
    }

    return getCache(prefix);
  };
});

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  if (isBrowser$3) {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  if (isBrowser$3) {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  } else {
    stylis.use(removeLabel);
    var serverStylisCache = rootServerStylisCache;

    if (options.stylisPlugins || options.prefix !== undefined) {
      stylis.use(options.stylisPlugins); // $FlowFixMe

      serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
    }

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = stylis(selector, serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser$2 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      if (!isBrowser$2 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$2 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$1 = typeof document !== 'undefined';
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = /*#__PURE__*/createContext({});
EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/forwardRef(render);
};

if (!isBrowser$1) {
  var BasicProvider = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose$1(BasicProvider, _React$Component);

    function BasicProvider(props, context, updater) {
      var _this;

      _this = _React$Component.call(this, props, context, updater) || this;
      _this.state = {
        value: createCache()
      };
      return _this;
    }

    var _proto = BasicProvider.prototype;

    _proto.render = function render() {
      return /*#__PURE__*/createElement(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
    };

    return BasicProvider;
  }(Component);

  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      return /*#__PURE__*/createElement(EmotionCacheContext.Consumer, null, function (context) {
        if (context === null) {
          return /*#__PURE__*/createElement(BasicProvider, null, function (newContext) {
            return func(props, newContext);
          });
        } else {
          return func(props, context);
        }
      });
    };
  };
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$1.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement(type, newProps);

  if (!isBrowser$1 && rules !== undefined) {
    var _ref;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement(Fragment$1, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var classnames$1 = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

withEmotionCache(function (props, context) {
  return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      if (isBrowser$1) {
        insertStyles(context, serialized, false);
      } else {
        var res = insertStyles(context, serialized, false);

        if (res !== undefined) {
          rules += res;
        }
      }

      if (!isBrowser$1) {
        serializedHashes += " " + serialized.name;
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames$1(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    if (!isBrowser$1 && rules.length !== 0) {
      var _ref;

      return /*#__PURE__*/createElement(Fragment$1, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = context.sheet.nonce, _ref)), ele);
    }

    return ele;
  });
});

var testOmitPropsOnStringTag = index;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser = typeof document !== 'undefined';

var createStyled = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var identifierName;
  var shouldForwardProp;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
      options.shouldForwardProp(propName);
    } : options.shouldForwardProp;
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, context, ref) {
      return createElement(ThemeContext.Consumer, null, function (theme) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = theme;
        }

        if (typeof props.className === 'string') {
          className = getRegisteredStyles(context.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = serializeStyles(styles.concat(classInterpolations), context.registered, mergedProps);
        var rules = insertStyles(context, serialized, typeof finalTag === 'string');
        className += context.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref || props.innerRef;

        if (process.env.NODE_ENV !== 'production' && props.innerRef) {
          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
        }

        var ele = createElement(finalTag, newProps);

        if (!isBrowser && rules !== undefined) {
          var _ref;

          var serializedNames = serialized.name;
          var next = serialized.next;

          while (next !== undefined) {
            serializedNames += ' ' + next.name;
            next = next.next;
          }

          return createElement(Fragment$1, null, createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
          }, _ref.nonce = context.sheet.nonce, _ref)), ele);
        }

        return ele;
      });
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, nextOptions !== undefined ? _objectSpread$8({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});

function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$8(Object(source), true).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$8(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

const CheckSvg = newStyled.svg`
  width: ${props => props.width ? props => props.width : '1.5rem'};
  height:  ${props => props.height ? props => props.height : '1.5rem'};
  xmlns: http://www.w3.org/2000/svg
`;
const CheckIcon = props => {
  return React__default.createElement(CheckSvg, _extends$3({
    "data-testid": "check-icon-status",
    viewBox: "0 0 150 150"
  }, props), React__default.createElement("path", {
    d: "M75 -6.10352e-05C60.1664 -6.10352e-05 45.6659 4.39862 33.3322 12.6397C20.9985 20.8808 11.3856 32.5942 5.70901 46.2987C0.032435 60.0031 -1.45281 75.0831 1.44108 89.6317C4.33497 104.18 11.478 117.544 21.967 128.033C32.4559 138.522 45.8196 145.665 60.3682 148.559C74.9168 151.453 89.9968 149.967 103.701 144.291C117.406 138.614 129.119 129.001 137.36 116.668C145.601 104.334 150 89.8335 150 74.9999C150 55.1087 142.098 36.0322 128.033 21.9669C113.968 7.90172 94.8912 -6.10352e-05 75 -6.10352e-05ZM62.2406 115.406L26.8125 79.9593L41.8969 64.8656L62.2406 85.2187L109.209 38.2406L124.303 53.325L62.2406 115.406Z"
  }));
};

const InProgressIcon = props => {
  return React__default.createElement("svg", _extends$3({
    "data-testid": "in-progress-icon-status",
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M68.5389 93.75H81.4612V100.003H68.5389V93.75ZM68.5389 106.256H81.4612V112.5H68.5389V106.256ZM107.334 113.569C111.581 118.475 113.872 124.768 113.772 131.25H106.92C98.2436 123.216 86.843 118.752 75.0047 118.752C63.1665 118.752 51.7658 123.216 43.089 131.25H36.219C36.1131 124.769 38.4012 118.475 42.6473 113.569L62.8719 89.8593C64.9923 87.3455 66.5553 84.4125 67.4581 81.2531H68.5201V87.5062H81.4424V81.2531H82.4949C83.405 84.4115 84.9708 87.3437 87.0906 89.8593L107.334 113.569ZM113.772 18.75C113.84 25.2599 111.498 31.566 107.193 36.4593L100.868 43.7531H49.1789L42.8634 36.4593C38.5502 31.5711 36.2064 25.2616 36.2848 18.75H113.772ZM117.08 44.4936C123.216 37.5113 126.628 28.56 126.694 19.275V0H23.3156V19.275C23.3779 28.559 26.7872 37.5104 32.9203 44.4936L52.8629 67.4905C54.6353 69.4708 55.6196 72.0299 55.63 74.6846C55.6404 77.3393 54.6761 79.9059 52.9193 81.8999L32.7041 105.619C26.6996 112.564 23.3682 121.413 23.3061 130.584V150H126.684V130.584C126.613 121.415 123.283 112.568 117.286 105.619L97.0619 81.8999C95.307 79.905 94.344 77.3387 94.3544 74.6846C94.3648 72.0305 95.3478 69.4718 97.1183 67.4905L117.08 44.4936Z"
  }));
};

const ErrorSvg = newStyled.svg`
  width: ${props => props.width ? props => props.width : '24px'};
  height:  ${props => props.height ? props => props.height : '24px'};
  xmlns: http://www.w3.org/2000/svg
`;

const ErrorIcon = props => {
  return React__default.createElement(ErrorSvg, _extends$3({
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "error-icon-status"
  }, props), React__default.createElement("path", {
    d: "M75 -7.62939e-05C60.1664 -7.62939e-05 45.666 4.39859 33.3323 12.6397C20.9986 20.8808 11.3857 32.5942 5.70909 46.2987C0.0325179 60.0032 -1.45276 75.0831 1.44113 89.6317C4.33502 104.18 11.4781 117.544 21.967 128.033C32.456 138.522 45.8197 145.665 60.3683 148.559C74.9168 151.453 89.9969 149.967 103.701 144.291C117.406 138.614 129.119 129.001 137.36 116.668C145.601 104.334 150 89.8335 150 74.9999C150 65.1508 148.06 55.3981 144.291 46.2987C140.522 37.1993 134.997 28.9313 128.033 21.9669C121.069 15.0025 112.801 9.47807 103.701 5.70897C94.6019 1.93987 84.8492 -7.62939e-05 75 -7.62939e-05ZM98.4001 115.2L75.9841 91.9559L53.9881 115.602L38.004 100.74L60.8041 76.2298L37.5601 52.1339L53.268 36.9779L75.678 60.2218L97.674 36.576L113.658 51.45L90.858 75.9599L114.102 100.062L98.4001 115.2Z"
  }));
};

const WarningSvg = newStyled.svg`
  width: ${props => props.width ? props => props.width : '24px'};
  height:  ${props => props.height ? props => props.height : '24px'};
  xmlns: http://www.w3.org/2000/svg
`;
const WarningIcon = props => {
  return React__default.createElement(WarningSvg, _extends$3({
    "data-testid": "warning-icon",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M148.199 131.109L86.1226 6.88133C85.0884 4.81233 83.498 3.07192 81.5298 1.85566C79.5615 0.639401 77.2932 -0.00457764 74.9792 -0.00457764C72.6651 -0.00457764 70.3968 0.639401 68.4285 1.85566C66.4603 3.07192 64.87 4.81233 63.8358 6.88133L1.31845 132.028C0.371042 133.907 -0.0789644 135.998 0.0113463 138.1C0.101657 140.202 0.729277 142.247 1.83435 144.038C2.95127 145.856 4.51495 147.358 6.37676 148.402C8.23857 149.445 10.3365 149.995 12.4712 150H137.562C140.859 149.993 144.018 148.68 146.349 146.35C148.68 144.021 149.993 140.864 150 137.569C149.994 135.293 149.372 133.06 148.199 131.109V131.109ZM75.0355 137.494C72.5625 137.494 70.1451 136.761 68.0889 135.388C66.0327 134.014 64.4301 132.063 63.4837 129.779C62.5374 127.496 62.2898 124.983 62.7722 122.559C63.2547 120.135 64.4455 117.908 66.1942 116.16C67.9428 114.413 70.1707 113.223 72.5962 112.74C75.0216 112.258 77.5356 112.505 79.8203 113.451C82.1051 114.397 84.0578 115.999 85.4317 118.054C86.8056 120.109 87.5389 122.525 87.5389 124.997C87.2738 128.227 85.8691 131.257 83.5755 133.548C81.2819 135.839 78.2485 137.241 75.0167 137.503L75.0355 137.494ZM87.5389 99.9939H62.5414L61.6033 37.4908H88.3737L87.5389 99.9939Z"
  }));
};

let StatusType;

(function (StatusType) {
  StatusType["PROCESSING"] = "Processing";
  StatusType["COMPLETE"] = "Complete";
  StatusType["ERROR"] = "Error";
  StatusType["IN_QUEUE"] = "In Queue";
  StatusType["PENDING_UPLOAD"] = "Pending Upload";
  StatusType["INITIALIZING"] = "Initializing";
  StatusType["UNPACKING"] = "Unpacking";
  StatusType["PENDING_REPORT_GENERATION"] = "Pending Report Generation";
  StatusType["INCOMPLETE"] = "Incomplete";
})(StatusType || (StatusType = {}));

const getStatusTypeFrom = status => {
  switch (status) {
    case 'Completed':
    case 'CompletedAndEmailSent':
      return StatusType.COMPLETE;

    case 'Processing':
    case 'JobReceived':
    case 'DownloadingData':
    case 'ParsingData':
    case 'ImportingData':
    case 'AnalyzingData':
    case 'CompletedAnalyzingData':
    case 'ExcelGenerationInProgress':
    case 'ExcelJobReceived':
    case 'ExcelReportsFinished':
    case 'PowerPointJobReceived':
    case 'PowerPointInProgress':
    case 'PowerPointReportsFinished':
    case 'PreppingPowerPointViewModels':
    case 'EmailServiceJobRecieved':
      return StatusType.PROCESSING;

    case 'Unpacking':
      return StatusType.UNPACKING;

    case 'PendingUpload':
    case 'Pending':
      return StatusType.PENDING_UPLOAD;

    case 'PendingReportGeneration':
      return StatusType.PENDING_REPORT_GENERATION;

    case 'InQueue':
      return StatusType.IN_QUEUE;

    case 'Initializing':
      return StatusType.INITIALIZING;

    case 'Incomplete':
      return StatusType.INCOMPLETE;

    default:
      return StatusType.ERROR;
  }
};

const StatuslabelSpan = newStyled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  word-break: normal;
  line-height: 1em;
`;
const Badge = newStyled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.5625rem;
  font-size: 0.875rem;
  text-align: center;
  height: 28px;
  padding: 0 0.75rem;
  svg {
    max-width: 1rem;
    max-height: 1rem;
    width: 1rem;
    height: 1rem;
    margin-right: 4px;
  }
`;
const GreenBadge$1 = newStyled(Badge)`
  background: #d4e8ad;
  color: #5c9901;
`;
const RedBadge$1 = newStyled(Badge)`
  background: #f8dbde;
  color: #ce1126;
`;
const YellowBadge = newStyled(Badge)`
  background: #fbe3a3;
  color: #d5a00e;
`;
const PurpleBadge = newStyled(Badge)`
  background: #e9dfed;
  color: #9746cb;
`;
const StatusBadge = props => {
  const {
    status
  } = props;

  switch (status) {
    case StatusType.COMPLETE:
      return React__default.createElement(StatuslabelSpan, null, React__default.createElement(GreenBadge$1, null, React__default.createElement(CheckIcon, null), status));

    case StatusType.ERROR:
      return React__default.createElement(StatuslabelSpan, null, React__default.createElement(RedBadge$1, null, React__default.createElement(ErrorIcon, null), status));

    case StatusType.INCOMPLETE:
      return React__default.createElement(StatuslabelSpan, null, React__default.createElement(YellowBadge, null, React__default.createElement(WarningIcon, null), status));

    default:
      return React__default.createElement(StatuslabelSpan, null, React__default.createElement(PurpleBadge, null, React__default.createElement(InProgressIcon, null), status));
  }
};

const ToggleIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("g", null, React__default.createElement("path", {
    d: "M75 150C89.8336 150 104.334 145.601 116.668 137.36C129.001 129.119 138.614 117.406 144.291 103.701C149.968 89.9968 151.453 74.9168 148.559 60.3683C145.665 45.8197 138.522 32.456 128.033 21.967C117.544 11.4781 104.18 4.33503 89.6318 1.44114C75.0832 -1.45275 60.0032 0.0324963 46.2987 5.70907C32.5943 11.3856 20.8809 20.9986 12.6398 33.3323C4.39867 45.6659 2.63021e-07 60.1664 2.63021e-07 75C-0.000824608 84.8494 1.93854 94.6025 5.70735 103.702C9.47616 112.802 15.0006 121.07 21.9651 128.035C28.9297 134.999 37.198 140.524 46.2978 144.293C55.3975 148.061 65.1506 150.001 75 150V150ZM75 9.42056C87.9704 9.42056 100.65 13.2667 111.434 20.4727C122.218 27.6787 130.624 37.9208 135.588 49.9038C140.551 61.8869 141.85 75.0728 139.319 87.7939C136.789 100.515 130.543 112.2 121.372 121.372C112.2 130.543 100.515 136.789 87.7939 139.319C75.0727 141.85 61.8869 140.551 49.9038 135.588C37.9207 130.624 27.6786 122.219 20.4727 111.434C13.2667 100.65 9.42053 87.9704 9.42053 75C9.44048 57.6134 16.3561 40.9446 28.6503 28.6504C40.9446 16.3562 57.6134 9.44051 75 9.42056V9.42056Z"
  }), React__default.createElement("path", {
    d: "M54.6642 86.8257L75.0126 65.2967L95.3421 86.8257C95.9257 87.4629 96.6356 87.9717 97.4265 88.3198C98.2174 88.6679 99.072 88.8477 99.9362 88.8477C100.8 88.8477 101.655 88.6679 102.446 88.3198C103.237 87.9717 103.947 87.4629 104.53 86.8257C105.751 85.4975 106.428 83.7593 106.428 81.9553C106.428 80.1513 105.751 78.4131 104.53 77.0849L79.5972 50.6195C79.0034 49.9882 78.2877 49.484 77.4933 49.1373C76.7136 48.7854 75.868 48.6033 75.0126 48.6033C74.1571 48.6033 73.3115 48.7854 72.5318 49.1373C71.7346 49.4822 71.0165 49.9866 70.4216 50.6195L45.4949 77.0849C44.2714 78.4118 43.5922 80.1505 43.5922 81.9553C43.5922 83.7602 44.2714 85.4989 45.4949 86.8257C46.0784 87.4599 46.7871 87.9661 47.5763 88.3124C48.3654 88.6586 49.2178 88.8374 50.0796 88.8374C50.9413 88.8374 51.7937 88.6586 52.5829 88.3124C53.372 87.9661 54.0807 87.4599 54.6642 86.8257Z"
  })));
};

const Heading = newStyled.h2`
  font-size: 1.25rem;
  line-height: 1.25rem;
  font-weight: 400;
  margin: 0;
  margin-left: 1rem;
  user-select: none;
  flex: 1;
`;
const CollapsiblePanelWrapper = newStyled.div`
  background-color: #ffffff;
  margin-bottom: 2rem;
  box-shadow: 0 0 1px 1px rgba(173, 173, 173, 0.2);
  transition: max-height 150ms ease-in-out;
  max-height: ${p => p.expanded ? '100vh' : '58px'};
  overflow-y: hidden;
`;
const CollapsiblePanelHeader = newStyled.div`
  color: #0076ce;
  height: 58px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-bottom: 2px solid #f5f6fb;
`;
const CollapsiblePanelBody = newStyled.div``;
const AnimatedToggleIcon = newStyled(ToggleIcon)`
  margin-right: 1rem;
  transition: transform 300ms ease;
  transform: ${p => p.expanded ? 'rotate(0deg)' : 'rotate(180deg)'};
`;
const CollapsiblePanel = props => {
  const [expanded, setExpanded] = useState(props.expanded !== undefined ? props.expanded : true);

  function handleToggle() {
    if (!props.disabled) {
      setExpanded(!expanded);
    }
  }

  return React__default.createElement(CollapsiblePanelWrapper, {
    "data-testid": "collapsible-panel",
    expanded: expanded ? 1 : 0
  }, React__default.createElement(CollapsiblePanelHeader, {
    onClick: handleToggle
  }, React__default.createElement(Heading, null, props.title), React__default.createElement(AnimatedToggleIcon, {
    expanded: expanded ? 1 : 0
  })), React__default.createElement(CollapsiblePanelBody, null, props.children));
};

const Wrapper$6 = newStyled.div`
  width: 100%;
`;
const Title$2 = newStyled.h3`
  color: #566072;
  font-size: 0.875rem;
  font-weight: 400;
  margin-top: 0;
  margin-left: 1rem;
`;
const ScrollableText = newStyled.div`
  border: 2px solid #bdcad2;
  margin: 0 1rem 1rem 1rem;
  padding: 0.7rem;
  height: 10rem;
  color: #566072;
  font-size: 0.75rem;
  letter-spacing: 0.03rem;
  line-height: 1.1rem;
  overflow-y: scroll;
  overflow-x: auto;
`;

function ErrorDetails(props) {
  return React__default.createElement(Wrapper$6, null, React__default.createElement(Title$2, null, "Error Details"), React__default.createElement(ScrollableText, null, props.details));
}

const defaultTheme = {
  name: 'default',
  colors: {
    primary: '#0076ce',
    lighterPrimary: '#9ad3fd',
    error: '#ce1126',
    white: '#ffffff',
    black: '#333333',
    orange: '#ef9d00'
  }
};

let ButtonSize;

(function (ButtonSize) {
  ButtonSize[ButtonSize["Medium"] = 0] = "Medium";
  ButtonSize[ButtonSize["Small"] = 1] = "Small";
  ButtonSize[ButtonSize["Large"] = 2] = "Large";
})(ButtonSize || (ButtonSize = {}));

const SMALL_STYLE = {
  minWidth: '100px;',
  minHeight: '35px',
  fontSize: '12px',
  padding: '6px 12px'
};
const MEDIUM_STYLE = {
  minWidth: '151px;',
  minHeight: '45px',
  fontSize: '16px',
  padding: '8px 20px'
};
const LARGE_STYLE = {
  minWidth: '187px',
  minHeight: '55px',
  fontSize: '20px',
  padding: '11px 25px'
};
function renderSize(size) {

  switch (size) {
    case ButtonSize.Small:
      return SMALL_STYLE;

    case ButtonSize.Large:
      return LARGE_STYLE;

    default:
      return MEDIUM_STYLE;
  }
}
const renderIconSize = size => {
  switch (size) {
    case ButtonSize.Small:
      return 'width: 20px; height: 20px;';

    case ButtonSize.Large:
      return 'width: 30px; height: 30px;';

    default:
      return 'width: 24px; height: 24px;';
  }
};

let Color$1;

(function (Color) {
  Color["white"] = "#FFFFFF";
  Color["black"] = "#000000";
  Color["blueDell"] = "#0076CE";
  Color["blue50"] = "#F5FBFF";
  Color["blue100"] = "#DCF0FE";
  Color["blue200"] = "#CFE6F7";
  Color["blue300"] = "#9AD3FD";
  Color["blue400"] = "#57A8E6";
  Color["blue500"] = "#4694CE";
  Color["blue600"] = "#006AA1";
  Color["blue800"] = "#00447C";
  Color["green100"] = "#DDEDBF";
  Color["green400"] = "#89CF00";
  Color["green500"] = "#7AB800";
  Color["green600"] = "#568F00";
  Color["gold100"] = "#FBE3A6";
  Color["gold500"] = "#F2AF00";
  Color["gold600"] = "#DE9200";
  Color["gold700"] = "#C78300";
  Color["red100"] = "#FAE7E9";
  Color["red400"] = "#F21C33";
  Color["red500"] = "#CE1126";
  Color["red600"] = "#BB1023";
  Color["lameGrey200"] = "#EEEEEE";
  Color["lameGrey300"] = "#E4E4E4";
  Color["lameGrey400"] = "#DDDDDD";
  Color["lameGrey500"] = "#CCCCCC";
  Color["lameGrey600"] = "#BBBBBB";
  Color["lameGrey700"] = "#AAAAAA";
  Color["lameGrey800"] = "#848484";
  Color["coolGray300"] = "#BDCAD2";
  Color["coolGray400"] = "#AEC0D7";
  Color["coolGray500"] = "#809DC4";
  Color["coolGray600"] = "#777F8E";
  Color["coolGray700"] = "#566072";
  Color["coolGray800"] = "#3D434E";
  Color["teal100"] = "#C8F1E4";
  Color["teal500"] = "#27C595";
  Color["magenta100"] = "#F8D9E5";
  Color["magenta500"] = "#D9427D";
  Color["purple100"] = "#E9DEED";
  Color["purple500"] = "#864999";
  Color["green300"] = "#DDEDBF";
  Color["green350"] = "#7AB800";
  Color["yellow400"] = "#FBE3A6";
  Color["yellow500"] = "#F2AF00";
  Color["yellow600"] = "#DE9200";
  Color["yellow700"] = "#C78300";
  Color["navy200"] = "#F5F6FB";
  Color["navy300"] = "#F5FBFF";
  Color["navy400"] = "#AEC0D7";
  Color["navy500"] = "#809DC4";
  Color["navy600"] = "#777F8E";
  Color["navy700"] = "#566072";
  Color["navy800"] = "#BDCAD2";
  Color["grey300"] = "#F2F2F2";
  Color["grey400"] = "#E4E4E4";
  Color["grey500"] = "#DDDDDD";
  Color["grey600"] = "#AAAAAA";
  Color["grey700"] = "#848484";
  Color["grey800"] = "#444444";
})(Color$1 || (Color$1 = {}));

var DellColor;

(function (DellColor) {
  DellColor[DellColor["blue"] = Color$1.blue500] = "blue";
  DellColor[DellColor["green"] = Color$1.green500] = "green";
  DellColor[DellColor["yellow"] = Color$1.gold500] = "yellow";
  DellColor[DellColor["midnight"] = Color$1.blue600] = "midnight";
  DellColor[DellColor["lightBlue"] = Color$1.blue200] = "lightBlue";
  DellColor[DellColor["red"] = Color$1.red500] = "red";
  DellColor[DellColor["carbon"] = Color$1.coolGray800] = "carbon";
})(DellColor || (DellColor = {}));

const brands = {
  dell: DellColor,
  lo: Color$1
};

const Button$1 = newStyled.button`
  ${p => renderSize(p.buttonSize)}
  background-color: ${defaultTheme.colors.primary};
  color: ${Color$1.white};
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  cursor: ${p => p.loading ? 'not-allowed' : 'pointer'};
  border-radius: 3px;
  border: 2px solid;
  border-color: ${defaultTheme.colors.primary};
  &:focus {
    outline: none;
    ${""};
  }
  &:hover {
    background-color: ${Color$1.blue400};
    border-color: ${Color$1.blue400};
    box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  }
  &:active {
    background-color: ${Color$1.blue600};
    border-color: ${Color$1.blue600};;
    box-shadow: none;
    box-shadow: 0px 3px 7px rgba(0, 0, 0, 0);
  }
  &:disabled {
    background-color: ${Color$1.lameGrey300};
    color: ${Color$1.lameGrey700};
    border-color: ${Color$1.lameGrey300};
    box-shadow: none;
    box-shadow: 0px 3px 7px rgba(0, 0, 0, 0);
  }
`;
const Loading = newStyled.span`
  display: inline-block;
  ${p => renderIconSize(p.buttonSize)}
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: ${Color$1.white};
  animation: rotating 1s linear infinite;

  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;
const LoadingTextWrapper = newStyled.span`
  margin-left: 0.5em;
`;
const PrimaryButton = props => {
  const innerText = useMemo(() => {
    if (props.loading) {
      if (props.loadingText) {
        return React__default.createElement(React__default.Fragment, null, React__default.createElement(Loading, {
          buttonSize: props.buttonSize,
          "data-testid": "button-spinner"
        }), React__default.createElement(LoadingTextWrapper, null, props.loadingText));
      }

      return React__default.createElement(Loading, {
        "data-testid": "button-spinner"
      });
    }

    return props.children;
  }, [props.children, props.loading, props.loadingText, props.buttonSize]);
  return React__default.createElement(Button$1, {
    buttonSize: props.buttonSize,
    "data-testid": props.testId,
    disabled: props.disabled,
    loading: props.loading,
    onClick: e => {
      if (!props.loading) props.clickFn(e);
    }
  }, innerText);
};

const Button = newStyled.button`
  ${p => renderSize(p.buttonSize)}
  border: 0px;
  width: auto;
  background-color: ${defaultTheme.colors.error};
  color: ${Color$1.white};
  border-radius: 3px;
  border: 2px solid;
  border-color: ${defaultTheme.colors.error};
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  &:focus {
    outline: none;
    ${""};
  }
  &:hover {
    background-color: ${Color$1.red400};
    border-color: ${Color$1.red400};
    box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  }
  &:active {
    background-color: ${Color$1.red600};
    border-color: ${Color$1.red600};
    box-shadow: none;
    box-shadow: 0px 3px 7px rgba(0, 0, 0, 0);
  }
  &:disabled {
    background-color: ${Color$1.lameGrey300};
    color: ${Color$1.lameGrey700};
    border-color: ${Color$1.lameGrey300};
    box-shadow: none;
    cursor: not-allowed;
    box-shadow: 0px 3px 7px rgba(0, 0, 0, 0);
  }
`;
const DangerButton = props => {
  return React__default.createElement(Button, {
    buttonSize: props.buttonSize,
    "data-testid": props.testId,
    disabled: props.disabled,
    onClick: props.clickFn
  }, props.children);
};

const Text$4 = newStyled.a`
  color: ${Color$1.blueDell};
  font-size: 16px;
  padding-top: 15px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    border-bottom: 2px solid ${Color$1.blue300};
  }
  &:active {
    color: ${Color$1.blue300};
  }
`;
const TextButton = props => {
  return React__default.createElement(Text$4, {
    onClick: props.clickFn
  }, props.children);
};

const SWITCH_WIDTH = 60;
const SWITCH_HEIGHT = 30;
const KNOB_DIAMETER = 20;

const _ToggleButton = newStyled.button`
  &[aria-pressed] {
    display: flex;
    box-sizing: border-box;
    border: none;
    position: relative;
    width: ${SWITCH_WIDTH}px;
    height: ${SWITCH_HEIGHT}px;
    align-items: center;
    justify-content: space-between;
    padding: ${SWITCH_HEIGHT / 2}px;
    margin-left: 0.75rem;
    margin-right: 0.5rem;
  }

  &[aria-pressed][disabled],
  &[aria-pressed][disabled]:hover {
    color: #999;
  }

  &[aria-pressed]:focus,
  &[aria-pressed]:hover {
    color: #00f;
    outline: none;
  }

  &[aria-pressed]:focus::before,
  &[aria-pressed]:hover::before {
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.25);
  }

  &[aria-pressed]:focus::after,
  &[aria-pressed]:hover::after {
    background-size: 30%;
    background-repeat: no-repeat;
    background-position: center center;
  }

  &[aria-pressed]::before,
  &[aria-pressed]::after {
    content: '';
    position: absolute;
    height: ${KNOB_DIAMETER}px;
    transition: all 0.25s ease;
  }

  &[aria-pressed]::before {
    left: 0;
    top: 0;

    width: ${SWITCH_WIDTH}px;
    border: ${SWITCH_HEIGHT / 2}px solid #767676;
    background: #767676;
    border-radius: 1.1em;
  }

  &[aria-pressed]::after {
    left: ${KNOB_DIAMETER / 4}px;
    top: ${KNOB_DIAMETER / 4}px;
    background-color: #fff;
    background-position: center center;
    border-radius: 50%;
    width: ${KNOB_DIAMETER}px;
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.25);
  }

  &[aria-pressed='true']::after {
    left: ${SWITCH_WIDTH - KNOB_DIAMETER * 1.25}px;
    border-color: #7bb801;
    color: #7bb801;
  }

  &[aria-pressed='true']::before {
    background-color: #7bb801;
    border-color: #7bb801;
  }

  &[aria-pressed][disabled]::before {
    background-color: transparent;
    border-color: #ddd;
  }

  &[aria-pressed][disabled]::after {
    border-color: #ddd;
  }

  &[aria-pressed][disabled]:hover {
    color: #999; /* case for CSS custom property if not supporting IE/Edge */
  }

  &[aria-pressed][disabled]:hover::before {
    box-shadow: none;
  }

  &[aria-pressed][disabled]:hover::after {
    background-image: none;
  }
`;

newStyled(_ToggleButton)`
  &[aria-pressed]::before,
  &[aria-pressed]::after {
    left: auto;
    right: 0;
  }

  &[aria-pressed]::after {
    left: auto;
    right: ${SWITCH_WIDTH - KNOB_DIAMETER * 1.25}px;
  }

  &[aria-pressed='true']::after {
    right: ${KNOB_DIAMETER / 4}px;
  }

  &[aria-pressed] {
    padding-left: 0;
    padding-right: 4em;
  }
`;

const ToggleButtonWrapper = newStyled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #566072;
  min-height: ${SWITCH_HEIGHT}px;
`;
const IndicatorWrapper = newStyled.span`
  font-weight: 600;
  font-size: 12px;
`;
const ToggleButton$1 = props => {
  const btnRef = useRef(null);
  const onClick = useCallback(() => {
    if (btnRef.current) {
      if ('onToggle' in props) {
        props.onToggle();
      } else {
        if (!props.active) {
          props.onActivate();
        }

        if (props.active) {
          props.onDeactivate();
        }
      }

      btnRef.current.blur();
    }
  }, [props]);
  return React__default.createElement(ToggleButtonWrapper, null, props.children, React__default.createElement(_ToggleButton, {
    ref: btnRef,
    "aria-pressed": props.active ? 'true' : 'false',
    onClick: onClick
  }), props.showIndicator && React__default.createElement(IndicatorWrapper, null, props.active ? 'On' : 'Off'));
};

const StyledRadioButton = newStyled.input`
  opacity: 0;
  visibility: hidden;
  display: none;
  box-sizing: border-box;
  &:checked + label {
    &::after {
      content: '';
      display: inline-block;
      background-color: #7ab800;
      position: absolute;
      width: 12px;
      height: 12px;
      left: 6px;
      top: 6px;
      border-radius: 50%;
      box-sizing: border-box;
    }
  }
  & + label {
    display: inline-flex;
    height: 24px;
    align-items: center;
    position: relative;
    color: #566072;
    font-size: 14px;
    box-sizing: border-box;
    &::after {
      display: none;
      box-sizing: border-box;
    }
    &::before {
      content: '';
      width: 24px;
      box-sizing: border-box;
      margin-right: 10px;
      height: 24px;
      border-radius: 50%;
      border: 2px #b5c1c9 solid;
      background-color: white;
      display: inline-block;
      position: relative;
      box-sizing: border-box;
      min-width: 24px;
    }
  }
`;
const RadioButton = props => {
  return React__default.createElement(StyledRadioButton, props);
};

function colorForeground(color) {
  switch (color) {
    case Color$1.blue500:
    case Color$1.blue600:
    case Color$1.green300:
    case Color$1.green350:
    case Color$1.green400:
    case Color$1.green500:
    case Color$1.green600:
    case Color$1.red500:
    case Color$1.red600:
    case Color$1.grey700:
    case Color$1.grey800:
    case Color$1.navy400:
    case Color$1.navy500:
    case Color$1.navy600:
      return Color$1.white;

    case Color$1.blue200:
    case Color$1.blue300:
    case Color$1.blue400:
    case Color$1.yellow400:
    case Color$1.yellow500:
    case Color$1.yellow600:
    case Color$1.yellow700:
    case Color$1.grey300:
    case Color$1.grey400:
    case Color$1.grey500:
    case Color$1.grey600:
    case Color$1.navy200:
    case Color$1.navy300:
    default:
      return Color$1.white;
  }
}
function colorHoverBackground(color) {
  switch (color) {
    case Color$1.blueDell:
      return Color$1.blue400;

    case Color$1.red500:
      return Color$1.red400;

    case Color$1.green500:
      return Color$1.green400;

    default:
      return Color$1.blue400;
  }
}
function colorHoverBorder(color) {
  switch (color) {
    case Color$1.blueDell:
      return Color$1.blue400;

    default:
      return 'transparent';
  }
}
function colorActiveBackground(color) {
  switch (color) {
    case Color$1.blueDell:
      return Color$1.blue600;

    case Color$1.red500:
      return Color$1.red600;

    case Color$1.green500:
      return Color$1.green600;

    default:
      return 'none';
  }
}
function colorActiveBorder(color) {
  switch (color) {
    case Color$1.blueDell:
      return Color$1.blue600;

    case Color$1.red500:
      return Color$1.red600;

    case Color$1.green500:
      return Color$1.green600;

    default:
      return 'transparent';
  }
}
function colorDisabledBackground(color) {
  switch (color) {
    case Color$1.blueDell:
    case Color$1.red500:
    case Color$1.green500:
      return Color$1.lameGrey300;

    default:
      return 'none';
  }
}
function colorDisabledForeground(color) {
  switch (color) {
    case Color$1.blueDell:
    case Color$1.red500:
    case Color$1.green500:
      return Color$1.lameGrey700;

    default:
      return 'none';
  }
}
function colorDisabledBorder(color) {
  switch (color) {
    case Color$1.blueDell:
    case Color$1.red500:
      return Color$1.lameGrey300;

    default:
      return 'transparent';
  }
}

const BaseButton = newStyled.button`
  ${p => renderSize(p.buttonSize)}
  border: 2px solid;
  width: auto;
  color: ${p => colorForeground(p.color)};
  background-color: ${p => p.color || Color$1.blueDell};
  border-color: ${p => p.borderColor || Color$1.blueDell};
  cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  box-shadow: rgb(0 0 0 / 25%) 0px 3px 7px;
  &:focus {
    outline: none;
    ${""};
  }
  &:hover {
    background-color: ${p => colorHoverBackground(p.color)};
    border-color: ${p => colorHoverBorder(p.color)};
  }
  &:active {
    background-color: ${p => colorActiveBackground(p.color)};
    border-color: ${p => colorActiveBorder(p.color)};
    box-shadow: none;
  }
  &:disabled {
    background-color: ${p => colorDisabledBackground(p.color)};
    color: ${p => colorDisabledForeground(p.color)};
    border-color: ${p => colorDisabledBorder(p.color)};
    box-shadow: none;
  }
`;

const SpecialButton = props => {
  const clickFn = props.onClick;
  const buttonSize = props.buttonSize;
  return React__default.createElement(BaseButton, _extends$3({}, props, {
    color: Color$1.green500,
    borderColor: Color$1.green500,
    onClick: clickFn,
    buttonSize: buttonSize,
    "data-testid": props.testId
  }));
};

const CloseIcon$2 = props => {
  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    viewBox: "0 0 150 150"
  }, props), React__default.createElement("rect", {
    x: "-5.05249",
    y: "137.485",
    width: "201.578",
    height: "24.8445",
    rx: "12.4222",
    transform: "rotate(-45 -5.05249 137.485)"
  }), React__default.createElement("rect", {
    x: "137.485",
    y: "155.052",
    width: "201.578",
    height: "24.8445",
    rx: "12.4222",
    transform: "rotate(-135 137.485 155.052)"
  }));
};

const SummaryIcon = props => {
  return React__default.createElement("svg", _extends$3({
    viewBox: "0 0 150 120",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px"
  }, props), React__default.createElement("circle", {
    cx: "15",
    cy: "105",
    r: "15"
  }), React__default.createElement("rect", {
    x: "46",
    y: "95",
    width: "104",
    height: "19",
    rx: "9.5"
  }), React__default.createElement("circle", {
    cx: "15",
    cy: "60",
    r: "15"
  }), React__default.createElement("rect", {
    x: "46",
    y: "50",
    width: "104",
    height: "19",
    rx: "9.5"
  }), React__default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }), React__default.createElement("rect", {
    x: "46",
    y: "5",
    width: "104",
    height: "19",
    rx: "9.5"
  }));
};

const SystemIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M143.315 112.84V128.201C143.315 140.237 111.526 150 75 150C38.474 150 6.68454 140.247 6.68454 128.21V112.84C23.1987 123.708 54.5236 126.941 75 126.941C95.4764 126.941 126.838 123.68 143.315 112.84ZM75 91.5342C54.4689 91.5342 23.1804 88.2648 6.68454 77.4338V92.6484C6.68454 104.685 38.4831 114.447 75 114.447C111.517 114.447 143.315 104.685 143.315 92.6484V77.4338C126.801 88.3014 95.4764 91.5342 75 91.5342ZM75 0C38.5651 0 6.68454 9.74429 6.68454 21.79C6.68454 33.8356 38.4831 43.589 75 43.589C111.517 43.589 143.315 33.79 143.315 21.79C143.315 9.78995 111.526 0 75 0V0ZM75 56.1005C54.4689 56.1005 23.1804 52.8311 6.68454 42V57.2511C6.68454 69.2877 38.4831 79.0502 75 79.0502C111.517 79.0502 143.315 69.2694 143.315 57.2329V42.0091C126.801 52.8493 95.4764 56.0822 75 56.0822V56.1005Z"
  }));
};

const InfoIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    color: "#3f97d4",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("g", null, React__default.createElement("path", {
    d: "M74.9933 64.1454C73.0042 64.1454 71.0965 64.9356 69.69 66.3421C68.2835 67.7487 67.4933 69.6563 67.4933 71.6454V107.523C67.4933 108.508 67.6873 109.483 68.0642 110.393C68.4411 111.303 68.9936 112.13 69.69 112.826C70.3864 113.522 71.2132 114.075 72.1232 114.452C73.0331 114.829 74.0084 115.023 74.9933 115.023C75.9782 115.023 76.9535 114.829 77.8634 114.452C78.7734 114.075 79.6002 113.522 80.2966 112.826C80.993 112.13 81.5455 111.303 81.9224 110.393C82.2993 109.483 82.4933 108.508 82.4933 107.523V71.6454C82.4933 69.6563 81.7031 67.7487 80.2966 66.3421C78.8901 64.9356 76.9824 64.1454 74.9933 64.1454ZM74.9933 33.8864C73.0045 33.8877 71.0608 34.4787 69.4079 35.5845C67.755 36.6904 66.467 38.2616 65.7069 40.0993C64.9467 41.9371 64.7486 43.959 65.1374 45.9093C65.5262 47.8597 66.4845 49.651 67.8913 51.0568C69.298 52.4626 71.09 53.4197 73.0406 53.8072C74.9913 54.1947 77.013 53.9952 78.8503 53.2338C80.6875 52.4724 82.2578 51.1834 83.3625 49.5297C84.4673 47.876 85.0569 45.9319 85.0569 43.9432C85.0533 41.2759 83.9917 38.7189 82.105 36.8335C80.2182 34.9481 77.6606 33.8882 74.9933 33.8864Z"
  }), React__default.createElement("circle", {
    cx: "75",
    cy: "75",
    r: "69.25",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "11.5"
  })));
};

const ShareIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M6.17504 137.5C4.53675 137.498 2.96602 136.846 1.80817 135.687C0.650309 134.528 -8.37466e-07 132.957 0 131.319V43.6812C-8.37466e-07 42.043 0.650309 40.4717 1.80817 39.3126C2.96602 38.1536 4.53675 37.5017 6.17504 37.5H68.3563C63.1158 41.2165 58.2228 45.4003 53.7374 50H12.5V125H112.5V107.156L125 95.1938V131.319C125 132.957 124.35 134.528 123.192 135.687C122.034 136.846 120.463 137.498 118.825 137.5H6.17504ZM106.25 33.3312V12.5L150 53.9812L106.25 95.8563V75C93.2951 75.4136 80.5503 78.388 68.7506 83.7515C56.9509 89.115 46.3299 96.7615 37.5 106.25C41.0495 88.9067 49.3631 72.896 61.5072 60.0155C73.6514 47.1349 89.1454 37.8944 106.25 33.3312Z"
  }));
};

const PrintIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M112.5 99.0573L131.25 134.87H18.75L37.5 99.0573H51.2812L39 122.964H111L98.8125 99.0573H112.5ZM150 27.4323V110.964H132.75L120.187 87.151H29.8125L17.25 110.964H0V27.526H25.0313V3.61978H124.969V27.526L150 27.4323ZM112.5 15.526H37.5V27.526H112.5V15.526ZM137.531 42.3385C137.55 41.723 137.384 41.1159 137.056 40.5949C136.728 40.074 136.251 39.6629 135.688 39.4143C135.124 39.1657 134.5 39.0909 133.893 39.1995C133.287 39.3081 132.727 39.5951 132.285 40.0238C131.843 40.4525 131.539 41.0034 131.412 41.6059C131.285 42.2085 131.34 42.8352 131.571 43.406C131.803 43.9768 132.199 44.4656 132.709 44.8099C133.22 45.1542 133.822 45.3382 134.438 45.3385C135.227 45.34 135.986 45.0399 136.561 44.4997C137.136 43.9594 137.483 43.2199 137.531 42.4323V42.3385Z",
    fill: "#007DB8"
  }));
};

const XLSXIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("g", null, React__default.createElement("path", {
    d: "M149.884 114.208V25.6079C150.097 22.615 149.498 19.6202 148.151 16.9393C145.543 15.596 142.616 14.9962 139.691 15.2056H88.5315V1.78107H78.3945C52.256 6.39485 26.1176 10.8097 -0.0208435 15.4235V134.576C25.9281 139.19 52.0855 143.416 78.0061 148.219H88.5789V132.852H141.633C144.475 132.663 148.748 132.663 149.515 129.006C150.027 124.091 150.151 119.142 149.884 114.208V114.208ZM50.1434 101.721C46.9544 94.7685 44.1243 87.6569 41.6642 80.4143C39.3621 87.3302 36.0936 93.8672 33.403 100.594C29.7556 100.594 25.9092 100.404 22.2523 100.205C26.6766 91.5556 30.9019 82.9059 35.3167 74.4552C31.4703 65.6161 27.245 57.1559 23.3986 48.3168L34.5494 47.7389C37.0505 54.4653 39.9305 61.0023 42.0432 67.7288C44.3454 60.4244 47.6138 53.6979 50.5034 46.5925C54.3498 46.4031 58.1867 46.0146 62.0331 45.8252C57.4193 55.0527 52.8055 64.4698 48.1918 73.6878C52.8055 83.2944 57.6088 92.7114 62.4026 102.327C58.4046 102.289 54.1792 101.911 50.1434 101.721ZM144.702 127.86H88.5789V117.666H102.221V105.757H88.5789V99.0305H102.221V87.1123H88.5789V80.1964H102.221V68.2783H88.5789V61.3623H102.221V49.4442H88.5789V42.5188H102.221V30.6101H88.5789V20.4257H144.93V127.86H144.702Z"
  }), React__default.createElement("path", {
    d: "M132.774 30.7994H108.947V42.7176H132.774V30.7994Z"
  }), React__default.createElement("path", {
    d: "M132.774 49.4442H108.947V61.3624H132.774V49.4442Z"
  }), React__default.createElement("path", {
    d: "M132.774 68.2783H108.947V80.1965H132.774V68.2783Z"
  }), React__default.createElement("path", {
    d: "M132.774 86.9229H108.947V98.841H132.774V86.9229Z"
  }), React__default.createElement("path", {
    d: "M132.774 105.757H108.947V117.675H132.774V105.757Z"
  })));
};

const DeleteBinIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M99.975 16.65V0H50.025V16.65H0V33.3H16.65V150H133.35V33.3H150V16.65H99.975ZM50.025 133.35H33.3V33.3H50.025V133.35ZM83.325 133.35H66.675V33.3H83.325V133.35ZM116.625 133.35H99.975V33.3H116.625V133.35Z"
  }));
};

const FilledInfoIcon = props => {
  return React__default.createElement("svg", _extends$3({
    "data-testid": "filled-info-icon",
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M75 0C60.1664 0 45.6659 4.39867 33.3323 12.6398C20.9986 20.8809 11.3856 32.5943 5.70907 46.2987C0.032496 60.0032 -1.45275 75.0832 1.44114 89.6318C4.33503 104.18 11.4781 117.544 21.967 128.033C32.456 138.522 45.8197 145.665 60.3682 148.559C74.9168 151.453 89.9968 149.968 103.701 144.291C117.406 138.614 129.119 129.001 137.36 116.668C145.601 104.334 150 89.8336 150 75C150 55.1088 142.098 36.0322 128.033 21.967C113.968 7.90176 94.8913 0 75 0V0ZM87 119.143H63.7143V64.2857H87V119.143ZM75.3572 53.5C72.8536 53.5141 70.4023 52.7847 68.3138 51.4041C66.2253 50.0235 64.5938 48.0539 63.6259 45.745C62.658 43.4361 62.3974 40.8919 62.8772 38.4347C63.3569 35.9776 64.5553 33.7181 66.3206 31.9429C68.0859 30.1676 70.3384 28.9563 72.7928 28.4627C75.2472 27.969 77.793 28.2152 80.1073 29.17C82.4216 30.1248 84.4004 31.7452 85.7928 33.8258C87.1852 35.9064 87.9286 38.3536 87.9286 40.8571C87.938 42.514 87.6198 44.1565 86.9922 45.69C86.3647 47.2234 85.4402 48.6177 84.2719 49.7927C83.1035 50.9676 81.7145 51.9 80.1846 52.5363C78.6547 53.1725 77.0141 53.5 75.3572 53.5Z"
  }));
};

const PPTIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("g", null, React__default.createElement("path", {
    d: "M104.441 35.6632V56.528H124.759C124.796 53.8235 124.3 51.1381 123.299 48.6254C122.298 46.1128 120.811 43.8221 118.924 41.8843C117.037 39.9465 114.787 38.3997 112.302 37.3322C109.816 36.2648 107.145 35.6976 104.441 35.6632V35.6632Z"
  }), React__default.createElement("path", {
    d: "M145.049 17.662H85.7048V1.70499L-0.0148926 16.9744V133.026L85.7613 148.295V129.069H145.106C146.424 129.045 147.679 128.5 148.598 127.555C149.517 126.609 150.026 125.339 150.013 124.02V22.7016C150.03 22.0417 149.913 21.3852 149.671 20.7712C149.428 20.1573 149.064 19.5986 148.601 19.1283C148.138 18.658 147.584 18.2858 146.974 18.0339C146.364 17.782 145.709 17.6555 145.049 17.662V17.662ZM55.5616 71.6654C55.0863 74.3375 53.848 76.815 51.996 78.799C50.1441 80.783 47.7576 82.1887 45.1245 82.8467C42.1493 83.3345 39.143 83.6084 36.1287 83.6662V100.028H27.5284V50.6877C34.207 50.6877 40.7161 50.5558 47.3099 50.8195C49.25 51.1428 51.0268 52.1041 52.3589 53.5513C54.3995 56.0433 55.7699 59.0152 56.3403 62.1852C56.9107 65.3552 56.6621 68.6184 55.6181 71.6654H55.5616ZM145.049 123.898H85.7048V111.21H131.937V105.322H85.7613V95.3843H131.993V89.5253H85.7613V73.1632C87.6245 75.4552 89.9734 77.305 92.6385 78.5789C95.3035 79.8527 98.2182 80.519 101.172 80.5294C106.629 80.4401 111.828 78.1962 115.637 74.2873C119.445 70.3783 121.553 65.1218 121.5 59.6647H101.172V38.5268C98.2182 38.5372 95.3035 39.2034 92.6385 40.4773C89.9734 41.7512 87.6245 43.6009 85.7613 45.893V22.7016H145.106L145.049 123.898Z"
  })));
};

const Logo = props => {
  return React__default.createElement("svg", _extends$3({
    height: "46px",
    viewBox: "0 0 807 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M39.3163 101.691C36.0697 99.6382 33.1003 97.1769 30.4809 94.3674L16.7072 106.159C20.6865 110.597 25.2794 114.443 30.3466 117.581L39.3163 101.691ZM56.416 126.719L57.9613 108.611C52.809 108.006 47.8045 106.494 43.1797 104.143L34.1764 119.933C41.1116 123.537 48.6498 125.838 56.416 126.719V126.719ZM97.8717 94.065C92.2603 100.142 85.1097 104.588 77.1775 106.932C72.8197 108.256 68.294 108.946 63.7396 108.981H62.1943L60.6489 127.089C67.9843 127.465 75.329 126.555 82.351 124.401C93.628 121 103.751 114.561 111.612 105.79L97.8717 94.065ZM93.1349 70.9855L103.213 74.5801C104.156 71.4908 104.72 68.2983 104.893 65.0729H94.1427C93.9427 67.0645 93.6059 69.04 93.1349 70.9855V70.9855ZM99.921 82.1725C100.566 81.1172 101.085 79.9896 101.466 78.8131L91.388 75.2184C91.1192 75.8567 90.7497 76.495 90.4809 77.1333C89.8795 78.301 89.1946 79.4237 88.4316 80.4928L96.6623 87.2117C97.9426 85.6657 99.0364 83.9743 99.921 82.1725V82.1725ZM85.6769 83.9866C82.1129 87.6177 77.7033 90.3073 72.8437 91.8142C70.0153 92.6867 67.069 93.1173 64.1092 93.0908L63.2021 103.74C67.5943 103.841 71.9738 103.229 76.1696 101.926C82.9565 99.7485 89.0818 95.8885 93.9748 90.7055L85.6769 83.9866Z",
    fill: "#FAA719"
  }), React__default.createElement("path", {
    d: "M125.218 82.5419C127.025 76.8373 128.064 70.9174 128.308 64.9384H110.066C109.94 68.7701 109.296 72.5671 108.151 76.2262L125.218 82.5419ZM108.017 49.6864C109.029 53.2046 109.671 56.8188 109.932 60.4703H128.174C127.917 55.03 127.015 49.6396 125.486 44.4121C124.805 42.125 123.986 39.8812 123.034 37.6931L106.606 45.5207C107.175 46.8738 107.647 48.2659 108.017 49.6864V49.6864ZM74.1201 18.1075C78.1598 19.0083 82.0509 20.4788 85.6766 22.4748C93.7232 26.7294 100.302 33.3084 104.557 41.355L120.85 33.5946C116.481 25.1341 110.303 17.7387 102.756 11.9329C95.208 6.12715 86.4754 2.05319 77.1772 0L74.1201 18.1075ZM67.0988 32.9899L68.9129 22.4748C67.3676 22.4748 65.8222 22.206 64.2769 22.206C62.7315 22.206 60.9174 22.206 59.2713 22.4748L61.1862 32.9899C63.155 32.8612 65.13 32.8612 67.0988 32.9899V32.9899ZM51.007 35.9462C52.4083 35.2538 53.8702 34.6915 55.3743 34.2665L56.5165 33.897L54.6016 23.5162C53.829 23.785 52.9219 23.8858 52.1492 24.1545C49.818 24.8018 47.5648 25.7031 45.4303 26.8421L51.007 35.9462ZM71.4325 33.7626C73.7611 34.4178 76.0134 35.3187 78.1515 36.4501C83.1839 39.0978 87.3302 43.1623 90.0775 48.1411L99.7864 43.673C96.022 36.6636 90.2565 30.9332 83.2242 27.2116C80.0428 25.5321 76.6543 24.2783 73.1459 23.4826L71.4325 33.7626Z",
    fill: "#79B943"
  }), React__default.createElement("path", {
    d: "M23.4261 41.3549L24.9715 38.6673L10.1898 28.253C9.28278 29.664 8.37573 31.2093 7.50227 32.7547C3.42921 40.396 0.953507 48.7862 0.225805 57.4147C-0.501897 66.0431 0.533622 74.7295 3.26935 82.945L20.0667 76.6628C18.2354 70.8522 17.5891 64.7332 18.1662 58.6682C18.7433 52.6033 20.5319 46.7159 23.4261 41.3549V41.3549ZM42.911 22.0716C45.3623 20.7797 47.9404 19.744 50.6042 18.9809L53.6613 18.2418L50.3018 0.268707C48.6221 0.638248 46.9423 1.04138 45.1618 1.5453C41.1335 2.77833 37.2214 4.36339 33.4709 6.28214L42.911 22.0716ZM27.659 34.804C30.8401 30.7224 34.6503 27.173 38.9468 24.2889L29.8427 8.60017C23.1758 12.7461 17.3422 18.1011 12.6422 24.3896L27.659 34.804ZM37.5359 48.7793C37.8046 48.4098 37.9054 48.0066 38.1742 47.6371L29.4396 41.5901C29.07 42.3627 28.5325 43.001 28.163 43.7737C25.6408 48.4753 24.0698 53.6277 23.5394 58.9366C23.0091 64.2454 23.53 69.6068 25.0723 74.7144L35.1506 70.9854C33.044 63.5534 33.8989 55.5943 37.5359 48.7793V48.7793ZM42.6758 83.9865L34.5795 91.0413C36.7998 93.3932 39.3052 95.4584 42.0375 97.1891L47.3119 87.9506C45.5975 86.8408 44.0384 85.5077 42.6758 83.9865V83.9865ZM31.4888 87.5475L39.5851 80.627C38.4024 79.035 37.4102 77.3099 36.6288 75.487L26.7856 79.216C28.0775 82.1401 29.6528 84.9306 31.4888 87.5475V87.5475Z",
    fill: "#4694D0"
  }), React__default.createElement("path", {
    d: "M165.666 39.2722C166.624 34.911 167.364 30.5046 167.883 26.0695C168.252 22.3405 168.521 19.149 168.521 16.5622C168.591 15.6677 168.591 14.7691 168.521 13.8746C168.496 13.0959 168.406 12.3206 168.252 11.5566C169.932 11.2878 171.612 11.0527 173.762 10.9183C175.912 10.7839 177.625 10.6495 179.171 10.6495C182.149 10.679 185.117 10.9827 188.04 11.5566C188.621 13.2426 188.916 15.014 188.913 16.7974C188.914 19.0465 188.745 21.2924 188.409 23.5163C188.04 26.0695 187.502 28.925 186.998 31.8477L176.08 88.9586C175.86 90.2691 175.736 91.5941 175.71 92.9227C175.675 94.152 175.893 95.3753 176.349 96.5174C176.728 97.3307 177.305 98.0355 178.028 98.5666C178.703 99.0762 179.505 99.39 180.346 99.4737C181.19 99.626 182.043 99.7158 182.9 99.7424C183.269 99.7424 183.941 99.7424 185.083 99.4737C186.042 99.3502 186.987 99.1365 187.905 98.8354C188.435 100.558 188.817 102.322 189.047 104.11C189.406 106.014 189.575 107.95 189.551 109.888C189.615 110.614 189.615 111.345 189.551 112.072C189.518 112.805 189.428 113.535 189.283 114.255C187.489 114.878 185.646 115.35 183.773 115.666C181.272 116.043 178.744 116.211 176.214 116.17C170.713 116.501 165.279 114.817 160.929 111.433C158.96 109.492 157.444 107.138 156.492 104.542C155.539 101.946 155.173 99.1711 155.419 96.4166C155.419 95.14 155.419 93.729 155.688 92.1837C155.84 90.6226 156.098 89.0737 156.461 87.5476L165.666 39.2722ZM212.396 57.514H203.392C203.447 57.2142 203.447 56.9068 203.392 56.607V55.5655C203.383 53.2367 203.642 50.9144 204.165 48.645C204.675 46.3405 205.407 44.0904 206.349 41.9261H235.106L221.903 115.666C218.479 116.21 215.022 116.513 211.556 116.573C208.365 116.573 205.182 116.269 202.049 115.666L212.396 57.514ZM216.494 29.7985C216.368 26.5711 216.582 23.3394 217.133 20.1568C217.754 16.9404 218.573 13.7653 219.585 10.6495C221.37 10.3153 223.178 10.1244 224.994 10.0784C226.909 10.0784 228.588 9.80968 230.134 9.80968C231.679 9.80968 233.493 9.80968 235.139 10.0784C236.871 10.1907 238.591 10.4492 240.279 10.8511C240.289 13.9773 239.974 17.096 239.339 20.1568C238.772 23.3518 237.918 26.4889 236.785 29.5297C235.015 29.9037 233.218 30.1396 231.41 30.2352H221.399C219.752 30.289 218.105 30.1423 216.494 29.7985V29.7985ZM245.789 42.0941C249.267 41.5379 252.782 41.2347 256.304 41.187C260.041 41.1657 263.773 41.4692 267.457 42.0941L272.967 96.0134L289.025 61.2094C290.693 57.7366 292.032 54.1149 293.023 50.392C293.48 48.1798 293.739 45.9312 293.795 43.673V41.9933C295.475 41.7246 297.155 41.4894 299.204 41.355C301.253 41.2206 303.168 41.0863 305.251 41.0863C309.079 41.033 312.902 41.3366 316.673 41.9933V42.766C316.601 45.5434 316.032 48.2854 314.994 50.8623C313.331 55.0468 311.401 59.1201 309.215 63.0571L280.425 115.666C278.512 115.962 276.582 116.13 274.647 116.17H264.232C262.333 116.167 260.44 115.953 258.588 115.532L245.789 42.0941ZM339.215 87.9507C339.436 91.7468 341.037 95.3312 343.717 98.0291C346.771 100.446 350.614 101.643 354.501 101.389C357.896 101.456 361.285 101.072 364.579 100.246C367.718 99.2978 370.803 98.1763 373.818 96.8869C375.403 98.9036 376.465 101.281 376.909 103.807C377.437 106.643 377.696 109.523 377.681 112.408C375.853 113.229 373.967 113.914 372.037 114.457C369.831 115.109 367.588 115.625 365.318 116.002C363 116.372 360.682 116.775 358.599 117.044C356.558 117.279 354.506 117.402 352.452 117.413C347.405 117.505 342.377 116.767 337.569 115.23C333.747 113.978 330.24 111.915 327.289 109.183C324.533 106.55 322.458 103.288 321.242 99.6753C319.845 95.7127 319.107 91.5476 319.059 87.346C319.093 81.5329 320.092 75.7658 322.015 70.28C323.958 64.8272 326.821 59.748 330.481 55.2632C334.178 50.8249 338.753 47.1991 343.919 44.6137C349.406 41.8481 355.478 40.4425 361.623 40.5152C364.573 40.4899 367.513 40.8743 370.358 41.6574C372.896 42.3333 375.288 43.4722 377.412 45.0168C379.426 46.5418 381.049 48.522 382.149 50.7951C383.334 53.2778 383.91 56.0073 383.829 58.757C383.887 62.6758 382.864 66.5348 380.873 69.9104C378.786 73.1655 376.039 75.9465 372.81 78.0739C369.297 80.3574 365.503 82.1755 361.522 83.4827C357.215 84.9195 352.784 85.9541 348.286 86.5734L339.215 87.9507ZM347.312 73.3035C350.341 72.9122 353.316 72.1797 356.181 71.1198C358.121 70.4099 359.944 69.4134 361.589 68.1635C362.741 67.2745 363.662 66.1225 364.277 64.8041C364.762 63.7491 365.025 62.6056 365.05 61.4446C365.077 60.6293 364.929 59.8177 364.616 59.0644C364.303 58.311 363.832 57.6335 363.236 57.0773C361.913 55.9604 360.229 55.3632 358.499 55.3976C356.152 55.3731 353.839 55.9515 351.78 57.0773C349.732 58.2007 347.901 59.6795 346.371 61.4446C344.803 63.3239 343.472 65.3886 342.407 67.5924C341.287 69.8276 340.462 72.1991 339.954 74.6473L347.312 73.3035ZM450.078 117.581C440.313 117.581 433.124 115.017 428.51 109.888C423.619 103.996 421.146 96.4685 421.589 88.8242C421.629 82.9993 422.489 77.2091 424.143 71.6238C425.736 66.0232 428.344 60.7626 431.836 56.1031C435.291 51.4972 439.66 47.6544 444.669 44.8153C450.211 41.7818 456.46 40.2746 462.776 40.448C472.653 40.448 479.842 43.0012 484.478 48.2755C489.337 54.2374 491.804 61.7935 491.399 69.4737C491.422 75.34 490.596 81.1788 488.947 86.8085C487.322 92.3407 484.765 97.5554 481.388 102.228C477.942 106.832 473.511 110.608 468.42 113.281C462.791 116.303 456.464 117.786 450.078 117.581ZM451.992 102.161C455.351 102.28 458.62 101.073 461.097 98.8018C463.634 96.3917 465.687 93.518 467.144 90.336C468.723 86.9476 469.852 83.3675 470.503 79.6865C471.126 76.3613 471.475 72.9904 471.545 69.6081C471.545 60.8735 467.95 56.5062 460.895 56.5062C459.228 56.4519 457.567 56.7433 456.017 57.3619C454.468 57.9805 453.063 58.913 451.892 60.1008C449.364 62.5663 447.394 65.5447 446.113 68.8354C444.548 72.2759 443.42 75.8986 442.754 79.6193C442.175 82.9481 441.872 86.319 441.847 89.6977C441.948 97.9619 445.274 102.06 452.093 102.06L451.992 102.161ZM508.062 73.9082C509.103 67.8612 509.876 62.6204 510.38 57.9843C510.824 54.4055 511.082 50.806 511.153 47.2005V44.5129C511.217 43.7416 511.217 42.9662 511.153 42.1949C514.247 41.6385 517.382 41.3351 520.525 41.2878C523.549 41.3013 526.564 41.6051 529.529 42.1949C529.529 42.9676 529.898 43.8746 530.033 44.8825C530.22 46.4543 530.31 48.0363 530.302 49.6193C530.37 50.4353 530.37 51.2556 530.302 52.0717C530.279 53.0228 530.155 53.9687 529.932 54.8936C532.313 50.6283 535.793 47.0787 540.01 44.6137C544.498 41.848 549.655 40.3611 554.926 40.3136C557.825 40.1331 560.726 40.6488 563.385 41.8177C566.044 42.9865 568.385 44.7746 570.212 47.0325C574.188 52.8327 576.093 59.8035 575.621 66.8197C575.598 72.8651 574.693 78.8748 572.933 84.6585C571.165 90.7504 568.12 96.3963 564.002 101.221C559.884 106.046 554.786 109.939 549.047 112.643C541.833 115.882 533.972 117.422 526.069 117.144C524.872 117.227 523.671 117.227 522.474 117.144C521.701 117.144 521.063 117.144 520.559 116.876L514.915 149.227C513.129 149.593 511.323 149.851 509.506 150H499.764C498.035 149.859 496.318 149.601 494.624 149.227L508.062 73.9082ZM523.583 100.112C524.532 100.449 525.532 100.62 526.539 100.616C527.736 100.68 528.936 100.68 530.134 100.616C533.939 100.695 537.685 99.6684 540.917 97.6596C543.92 95.7507 546.467 93.2045 548.375 90.2016C550.326 87.1677 551.757 83.8296 552.608 80.3248C553.509 76.891 553.983 73.3593 554.019 69.8097C554.116 66.8114 553.409 63.8417 551.97 61.2094C551.253 60.0056 550.21 59.0293 548.962 58.3932C547.713 57.7571 546.31 57.4872 544.915 57.6148C542.739 57.6193 540.593 58.1175 538.638 59.0718C536.683 60.0262 534.969 61.4118 533.627 63.1243C529.888 68.5797 527.577 74.8867 526.908 81.467L523.583 100.112ZM596.013 57.514H585.094C585.067 54.9852 585.235 52.458 585.598 49.9552C585.999 47.2656 586.732 44.6362 587.782 42.1277H598.7L599.607 37.8948C600.086 35.6824 600.389 33.4358 600.514 31.1759V25.7671C603.344 24.0532 606.483 22.9118 609.753 22.4077C613.143 21.7679 616.583 21.4194 620.033 21.3662C620.599 23.1115 620.86 24.9411 620.805 26.775C620.805 28.4057 620.681 30.034 620.436 31.6462C620.167 33.4603 619.932 35.3752 619.529 37.4245L618.622 42.1613H636.326C636.348 44.7905 636.089 47.4146 635.553 49.9888C635.001 52.5421 634.317 55.0651 633.504 57.5476H615.8L610.794 85.6663C610.794 86.9429 610.425 88.2195 610.29 89.3953C610.136 90.509 610.046 91.6307 610.022 92.7548C609.888 94.8181 610.482 96.8628 611.701 98.533C612.547 99.3429 613.559 99.9579 614.668 100.335C615.776 100.712 616.954 100.843 618.118 100.717C619.538 100.745 620.957 100.621 622.351 100.347L625.71 99.5745C627.075 102.999 627.694 106.676 627.524 110.358V112.676C627.589 113.448 627.589 114.223 627.524 114.994C622.76 116.326 617.823 116.937 612.877 116.809C604.915 116.809 599.002 115.398 595.173 112.441C591.343 109.485 589.394 104.614 589.394 97.6932C589.394 96.2822 589.394 94.7368 589.663 93.3259C589.814 91.6426 590.072 89.9707 590.436 88.3203L596.013 57.514ZM652.116 57.514H643.112C643.167 57.2142 643.167 56.9068 643.112 56.607C643.048 56.2628 643.048 55.9097 643.112 55.5655C643.102 53.2367 643.362 50.9144 643.885 48.645C644.395 46.3405 645.127 44.0904 646.068 41.9261H674.825L661.724 115.666C658.322 116.207 654.887 116.51 651.444 116.573C648.253 116.573 645.07 116.269 641.936 115.666L652.116 57.514ZM656.348 29.7985C656.223 26.5711 656.437 23.3394 656.987 20.1568C657.608 16.9404 658.427 13.7653 659.439 10.6495C661.213 10.3171 663.01 10.1261 664.814 10.0784C666.729 10.0784 668.409 9.80968 669.954 9.80968C671.5 9.80968 673.314 9.80968 674.96 10.0784C676.735 10.2001 678.499 10.4584 680.234 10.8511C680.255 13.9761 679.951 17.0948 679.327 20.1568C678.761 23.3518 677.906 26.4889 676.774 29.5297C674.987 29.8378 673.178 30.0063 671.365 30.0336H661.354C659.682 30.1617 658.001 30.0827 656.348 29.7985V29.7985ZM732.272 98.3315C733.419 100.245 734.28 102.316 734.825 104.479C735.577 107.545 735.927 110.696 735.867 113.852C732.779 115.18 729.541 116.127 726.225 116.674C722.49 117.257 718.717 117.56 714.937 117.581C704.154 117.581 696.192 114.894 691.186 109.619C685.908 103.662 683.192 95.8641 683.627 87.9171C683.627 82.2001 684.581 76.523 686.449 71.1198C688.23 65.562 691.02 60.3802 694.68 55.8343C698.36 51.2736 702.933 47.5125 708.118 44.7817C713.786 41.8693 720.09 40.4145 726.46 40.5487C729.601 40.5402 732.737 40.7987 735.833 41.3214C738.811 41.8204 741.735 42.5965 744.568 43.6395C744.427 46.3313 743.999 49.0004 743.291 51.6014C742.524 54.4716 741.311 57.2036 739.697 59.6977C737.709 58.8433 735.652 58.1578 733.549 57.6484C731.349 57.1158 729.093 56.8563 726.83 56.8757C723.449 56.766 720.106 57.6163 717.188 59.3281C714.467 61.027 712.113 63.2546 710.268 65.8791C708.369 68.7425 706.982 71.9139 706.169 75.252C705.24 78.8173 704.766 82.4859 704.758 86.1702C704.562 88.2675 704.813 90.3826 705.497 92.3751C706.18 94.3676 707.28 96.1919 708.722 97.7268C711.481 100.214 715.088 101.548 718.801 101.456C720.861 101.478 722.919 101.31 724.949 100.952C726.595 100.28 729.148 99.5073 732.272 98.3315V98.3315ZM767.681 83.3147C766.065 82.7471 764.512 82.0154 763.045 81.131C761.472 80.2314 760.045 79.0987 758.812 77.7716C757.489 76.3026 756.442 74.6069 755.721 72.766C754.917 70.5028 754.53 68.1125 754.579 65.7111C754.507 62.0287 755.301 58.3809 756.897 55.0616C758.418 51.9164 760.649 49.1677 763.414 47.0325C766.374 44.8065 769.724 43.1543 773.291 42.1613C777.249 40.9941 781.36 40.4279 785.486 40.4816C787.031 40.4816 788.846 40.4816 790.492 40.7503C792.138 41.0191 794.086 41.1199 796.001 41.3886C797.828 41.6451 799.635 42.0268 801.41 42.5308C803.055 42.9905 804.644 43.6328 806.147 44.4457C805.988 46.9368 805.514 49.3977 804.736 51.7693C803.934 54.3443 802.805 56.8056 801.376 59.093C799.055 57.931 796.593 57.0729 794.053 56.5398C791.401 55.8931 788.686 55.5438 785.956 55.4983C784.915 55.4983 783.773 55.4983 782.597 55.7671C781.35 55.9166 780.136 56.2684 779.002 56.8085C777.882 57.2688 776.907 58.0233 776.18 58.9922C775.386 60.0173 774.981 61.2911 775.038 62.5868C775.128 64.1305 775.697 65.6078 776.667 66.8123C777.636 68.0168 778.958 68.8885 780.447 69.3057L785.956 71.7581C787.778 72.5246 789.54 73.4229 791.231 74.4457C792.893 75.426 794.409 76.6361 795.732 78.0403C797.145 79.4926 798.283 81.1885 799.092 83.0459C799.903 85.1907 800.291 87.4724 800.234 89.7648C800.366 94.0486 799.394 98.2942 797.412 102.094C795.435 105.588 792.69 108.586 789.383 110.862C785.95 113.309 782.069 115.056 777.961 116.002C773.383 117.161 768.674 117.726 763.952 117.682C760.573 117.668 757.201 117.364 753.874 116.775C750.413 116.242 747.029 115.294 743.795 113.953C744.013 108.558 745.461 103.283 748.028 98.533C750.902 99.8402 753.926 100.788 757.031 101.355C759.961 101.857 762.928 102.116 765.9 102.128C767.453 102.123 769.003 101.999 770.537 101.758C772.058 101.522 773.532 101.046 774.904 100.347C776.245 99.7064 777.401 98.7353 778.263 97.5252C779.203 96.265 779.699 94.7295 779.674 93.1579C779.72 92.2785 779.559 91.4006 779.203 90.5952C778.847 89.7898 778.306 89.0796 777.625 88.5218C776.001 87.0864 774.135 85.9491 772.115 85.1624L767.681 83.3147Z",
    fill: "#097DB9"
  }));
};

const SearchIcon$2 = props => {
  return React__default.createElement("svg", _extends$3({
    "data-testid": "search-icon",
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M147.827 135.523L116.133 103.843C126.063 90.7972 130.667 74.4668 129.015 58.1553C127.363 41.8438 119.578 26.7685 107.234 15.9788C94.8898 5.18902 78.909 -0.509102 62.5232 0.0357615C46.1373 0.580625 30.5697 7.32801 18.9697 18.9139C7.36968 30.4999 0.603194 46.0593 0.0384212 62.4445C-0.526352 78.8297 5.15267 94.8173 15.9274 107.174C26.7021 119.532 41.7679 127.336 58.0774 129.008C74.3868 130.68 90.7228 126.095 103.78 116.18L135.475 147.86C137.112 149.499 139.333 150.419 141.649 150.419C143.964 150.42 146.186 149.501 147.824 147.864C149.462 146.227 150.383 144.007 150.384 141.691C150.384 139.375 149.464 137.154 147.827 135.516V135.523ZM17.8381 64.9329C17.8307 55.6351 20.5807 46.5437 25.7409 38.8093C30.9011 31.0748 38.2394 25.0443 46.8274 21.4811C55.4153 17.9178 64.8664 16.9819 73.9865 18.7913C83.1065 20.6006 91.4858 25.0743 98.063 31.6462C104.64 38.2181 109.121 46.5931 110.937 55.7117C112.754 64.8303 111.825 74.2828 108.268 82.8736C104.712 91.4644 98.6879 98.8074 90.9576 103.974C83.2273 109.14 74.1382 111.898 64.8404 111.898C52.3886 111.888 40.4484 106.941 31.6388 98.1409C22.8291 89.3412 17.8693 77.4066 17.8454 64.9549L17.8381 64.9329Z"
  }));
};

const Container$7 = newStyled.div`
  height: 80px;
  width: 80px;
  position: relative;
`;
const Path$3 = newStyled.path`
  fill: #cecece;
`;
const OuterRing$1 = newStyled.div`
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  animation: spin-clockwise 5000ms linear infinite;

  @keyframes spin-clockwise {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const InnerRing$1 = newStyled.div`
  width: 45px;
  height: 45px;
  position: absolute;
  top: 22%;
  left: 23%;
  animation: spin-counter-clockwise 5000ms linear infinite;

  @keyframes spin-counter-clockwise {
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;
const ChartLoadingIcon = props => {
  return React__default.createElement(Container$7, {
    "data-testid": props.testIdentifier
  }, React__default.createElement(OuterRing$1, null, React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.19 37.81"
  }, React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React__default.createElement(Path$3, {
    d: "M11.71,30.27a13.35,13.35,0,0,1-2.63-2.18L5,31.6A18.63,18.63,0,0,0,9,35Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$3, {
    d: "M16.8,37.72l.46-5.39A13.08,13.08,0,0,1,12.86,31l-2.68,4.7A19,19,0,0,0,16.8,37.72Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$3, {
    d: "M29.14,28A13.65,13.65,0,0,1,23,31.83a14.13,14.13,0,0,1-4,.61h-.46l-.46,5.39a18.75,18.75,0,0,0,6.46-.8,19.1,19.1,0,0,0,8.71-5.54Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$3, {
    d: "M37.28,24.57a20.06,20.06,0,0,0,.92-5.24H32.77a12.66,12.66,0,0,1-.57,3.36Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$3, {
    d: "M32.16,14.79A15.65,15.65,0,0,1,32.73,18h5.43a20.48,20.48,0,0,0-.8-4.78,17.59,17.59,0,0,0-.73-2l-4.89,2.33A9.14,9.14,0,0,1,32.16,14.79Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$3, {
    d: "M22.07,5.43a13,13,0,0,1,3.44,1.3,13.49,13.49,0,0,1,5.62,5.62L36,10A19.32,19.32,0,0,0,23,0Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$3, {
    d: "M7,12.31l.46-.8L3,8.43c-.27.42-.54.88-.8,1.34A19,19,0,0,0,1,24.69l5-1.87A13.55,13.55,0,0,1,7,12.31Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$3, {
    d: "M12.78,6.57a12,12,0,0,1,2.29-.92L16,5.43,15,.08c-.5.11-1,.23-1.53.38A21.38,21.38,0,0,0,10,1.87Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$3, {
    d: "M8.24,10.36A14.52,14.52,0,0,1,11.6,7.23L8.89,2.56a18.76,18.76,0,0,0-5.12,4.7Z",
    transform: "translate(-0.01 -0.04)"
  })))), React__default.createElement(InnerRing$1, null, React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.28 24.28"
  }, React__default.createElement(Path$3, {
    d: "M27.73,21.13l3,1.07a11.87,11.87,0,0,0,.5-2.83H28A13,13,0,0,1,27.73,21.13Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$3, {
    d: "M29.75,24.43a4.69,4.69,0,0,0,.46-1l-3-1.07c-.08.19-.19.38-.27.57a8.13,8.13,0,0,1-.61,1l2.45,2A7.61,7.61,0,0,0,29.75,24.43Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$3, {
    d: "M25.51,25a9.15,9.15,0,0,1-3.82,2.33,8.56,8.56,0,0,1-2.6.38h0l-.27,3.17a12.08,12.08,0,0,0,3.86-.54A12.57,12.57,0,0,0,28,27Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$3, {
    d: "M20,9.82l.54-3.13c-.46,0-.92-.08-1.38-.08a9.49,9.49,0,0,0-1.54.08l.57,3.13A13.49,13.49,0,0,1,20,9.82Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$3, {
    d: "M15.19,10.7a7.6,7.6,0,0,1,1.3-.5l.34-.11L16.26,7c-.23.08-.5.11-.73.19a9.84,9.84,0,0,0-2,.8Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$3, {
    d: "M21.27,10a10.16,10.16,0,0,1,2,.8,8.66,8.66,0,0,1,3.55,3.48L29.71,13a11.93,11.93,0,0,0-4.93-4.9,12.21,12.21,0,0,0-3-1.11Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$3, {
    d: "M11.18,14.52c.08-.11.11-.23.19-.34l-2.6-1.75c-.11.23-.27.42-.38.65a12.09,12.09,0,0,0-.92,9.21h0l3-1.11A8.89,8.89,0,0,1,11.18,14.52Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$3, {
    d: "M12.71,25,10.3,27.1a11.56,11.56,0,0,0,2.22,1.83l1.57-2.75A6.85,6.85,0,0,1,12.71,25Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$3, {
    d: "M9.38,26.06,11.79,24a7.56,7.56,0,0,1-.88-1.57L8,23.58A14.57,14.57,0,0,0,9.38,26.06Z",
    transform: "translate(-6.95 -6.61)"
  }))));
};

const ServerClusterIcon = props => {
  return React__default.createElement("svg", _extends$3({
    fill: "#4694ce",
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M100 130H50V32.0713H100V130ZM66.6429 97.3571V113.714H83.2857V97.3571H66.6429ZM58.3571 64.7142V72.8572H91.7143V64.7142H58.3571ZM58.3571 48.3572V56.4928H91.7143V48.3572H58.3571ZM150 113.671H108.329V23.8716H100V15.7143H150V113.671ZM116.643 80.9927V97.3571H133.286V81.0001L116.643 80.9927ZM108.357 48.3572V56.4928H141.714V48.3572H108.357ZM108.357 32.0643V40.2073H141.714V32.0643H108.357ZM41.6642 113.671H0V15.7143H50V23.8786H41.6714V32.0713H8.35713V40.2142H41.6642V32.0713H41.7143V40.2073H41.6642V48.3498H8.35713V56.4858H41.6642V48.3572H41.7143V56.4858H41.6642V113.629V113.671ZM16.6642 80.9927V97.3571H33.3V81.0001L16.6642 80.9927Z"
  }));
};

const DataCenterIcon = props => {
  return React__default.createElement("svg", _extends$3({
    fill: "#4694ce",
    width: "24px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("g", null, React__default.createElement("path", {
    d: "M122.546 20.2504L99.6245 14.6944V135.306L122.546 129.75V20.2504Z"
  }), React__default.createElement("path", {
    d: "M150 26.18L132.564 21.9505V128.041L150 123.811V26.18Z"
  }), React__default.createElement("path", {
    d: "M56.3898 5.23256V144.767L88.3847 137.015V12.9858L56.3898 5.23256Z"
  }), React__default.createElement("path", {
    d: "M42.8015 5.23256L0 15.611V134.399L42.8015 144.767V5.23256Z"
  })));
};

const HypervisorIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    fill: "#4694ce",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M150 131.349H0V79.3578H150V131.349ZM123.525 96.6308V113.986H132.375V96.6308H123.525ZM105.9 96.6308V113.986H114.75V96.6308H105.9ZM88.2 96.6308V113.986H97.05V96.6308H88.2ZM17.625 96.6308V113.986H35.25V96.6308H17.625ZM79.4175 79.35H70.59V70.6798H17.6475V53.3995H0V18.6508H44.1V53.3545H26.4676V61.9871H70.5825V53.3619H52.95V18.6508H97.05V53.3545H79.41V61.9871H123.525V53.3619H105.9V18.6508H150V53.3545H132.353V70.6349H79.41V79.2977L79.4175 79.35ZM114.683 27.3137V44.6692H141.158V27.3137H114.683ZM61.8075 27.3137V44.6692H88.2825V27.3137H61.8075ZM8.84995 27.3137V44.6692H35.3251V27.3137H8.84995Z"
  }));
};

const FolderIcon = props => React__default.createElement("svg", _extends$3({
  width: "24px",
  fill: "#4694ce",
  viewBox: "0 0 150 150",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React__default.createElement("path", {
  d: "M8.4153 131.115C7.81851 131.178 7.2159 131.077 6.67225 130.822C6.12859 130.568 5.66446 130.17 5.32982 129.672C4.99518 129.174 4.80264 128.593 4.77296 127.994C4.74328 127.394 4.8776 126.798 5.16139 126.269L29.36 64.3818C29.9725 63.0046 30.9531 61.8232 32.1938 60.9681C33.4345 60.113 34.8871 59.6173 36.3914 59.5356H146.22C146.828 59.4791 147.439 59.5843 147.993 59.8405C148.546 60.0967 149.022 60.4948 149.373 60.9944C149.723 61.494 149.935 62.0773 149.987 62.6853C150.04 63.2933 149.93 63.9044 149.671 64.4566L128.38 126.203C127.833 127.591 126.899 128.791 125.688 129.662C124.478 130.533 123.043 131.037 121.554 131.115H8.4153ZM0 98.5107V42.3775C0.138485 38.9988 1.02977 35.6938 2.60873 32.7039L8.07866 23.3484C8.93453 22.0487 10.0818 20.9668 11.4291 20.1888C12.7764 19.4109 14.2866 18.9583 15.8394 18.8671H60.6649C63.9007 19.0578 66.9472 20.4568 69.2017 22.7871L73.9516 28.2787C76.1995 30.613 79.2448 32.0129 82.4791 32.1987H126.491C127.088 32.1346 127.691 32.234 128.236 32.4864C128.78 32.7387 129.246 33.1345 129.583 33.6314C129.92 34.1283 130.116 34.7074 130.15 35.3071C130.183 35.9067 130.053 36.5042 129.773 37.0355L127.735 42.3214C127.13 43.6984 126.155 44.8804 124.918 45.736C123.682 46.5915 122.232 47.087 120.731 47.1675H25.7134C24.2177 47.2432 22.7741 47.7413 21.5496 48.6039C20.325 49.4665 19.3697 50.6585 18.7942 52.0418L1.76724 98.8756C1.29972 100.157 0.832155 100.794 0.560996 100.794C0.289837 100.794 0 99.989 0 98.5014V98.5107Z"
}));

const DatabaseIcon = () => {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.84",
    height: "20",
    viewBox: "0 0 18.84 20"
  }, React__default.createElement("path", {
    d: "M16.139,11.013v1.5c0,1.174-3.127,2.127-6.72,2.127S2.7,13.687,2.7,12.513v-1.5c1.625,1.06,4.706,1.375,6.72,1.375S14.52,12.07,16.139,11.013Zm-6.72-2.08c-2.019,0-5.1-.32-6.72-1.375V9.043c0,1.175,3.128,2.127,6.72,2.127s6.72-.953,6.72-2.127V7.56c-1.624,1.059-4.706,1.375-6.72,1.375ZM9.42,0C5.83,0,2.7.953,2.7,2.128S5.828,4.255,9.42,4.255s6.72-.953,6.72-2.127S13.012,0,9.421,0Zm0,5.474c-2.019,0-5.1-.32-6.72-1.375V5.588c0,1.175,3.128,2.127,6.72,2.127s6.72-.953,6.72-2.127V4.1C14.516,5.157,11.434,5.474,9.42,5.474Zm2.74,11.8H10.4V15.16h-2v2.111H6.64a.518.518,0,0,0-.54.491v1.747A.518.518,0,0,0,6.64,20h5.52a.517.517,0,0,0,.54-.491V17.762A.518.518,0,0,0,12.16,17.271Zm-7.44.96H.445c-.246,0-.445.144-.445.32v.637c0,.178.2.32.445.32H4.72Zm9.4,1.28H18.4c.246,0,.445-.144.445-.32v-.639c0-.178-.2-.32-.445-.32H14.12Z"
  }));
};

const Container$6 = newStyled.div`
  height: 80px;
  width: 80px;
  position: relative;
`;
const Path$2 = newStyled.path`
  fill: #cecece;
`;
const OuterRing = newStyled.div`
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  animation: spin-clockwise 5000ms linear infinite;

  @keyframes spin-clockwise {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const InnerRing = newStyled.div`
  width: 45px;
  height: 45px;
  position: absolute;
  top: 22%;
  left: 23%;
  animation: spin-counter-clockwise 5000ms linear infinite;

  @keyframes spin-counter-clockwise {
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;

const TableLoadingIcon = props => {
  return React__default.createElement(Container$6, {
    "data-testid": props.testIdentifier
  }, React__default.createElement(OuterRing, null, React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.19 37.81"
  }, React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React__default.createElement(Path$2, {
    d: "M11.71,30.27a13.35,13.35,0,0,1-2.63-2.18L5,31.6A18.63,18.63,0,0,0,9,35Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$2, {
    d: "M16.8,37.72l.46-5.39A13.08,13.08,0,0,1,12.86,31l-2.68,4.7A19,19,0,0,0,16.8,37.72Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$2, {
    d: "M29.14,28A13.65,13.65,0,0,1,23,31.83a14.13,14.13,0,0,1-4,.61h-.46l-.46,5.39a18.75,18.75,0,0,0,6.46-.8,19.1,19.1,0,0,0,8.71-5.54Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$2, {
    d: "M37.28,24.57a20.06,20.06,0,0,0,.92-5.24H32.77a12.66,12.66,0,0,1-.57,3.36Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$2, {
    d: "M32.16,14.79A15.65,15.65,0,0,1,32.73,18h5.43a20.48,20.48,0,0,0-.8-4.78,17.59,17.59,0,0,0-.73-2l-4.89,2.33A9.14,9.14,0,0,1,32.16,14.79Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$2, {
    d: "M22.07,5.43a13,13,0,0,1,3.44,1.3,13.49,13.49,0,0,1,5.62,5.62L36,10A19.32,19.32,0,0,0,23,0Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$2, {
    d: "M7,12.31l.46-.8L3,8.43c-.27.42-.54.88-.8,1.34A19,19,0,0,0,1,24.69l5-1.87A13.55,13.55,0,0,1,7,12.31Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$2, {
    d: "M12.78,6.57a12,12,0,0,1,2.29-.92L16,5.43,15,.08c-.5.11-1,.23-1.53.38A21.38,21.38,0,0,0,10,1.87Z",
    transform: "translate(-0.01 -0.04)"
  }), React__default.createElement(Path$2, {
    d: "M8.24,10.36A14.52,14.52,0,0,1,11.6,7.23L8.89,2.56a18.76,18.76,0,0,0-5.12,4.7Z",
    transform: "translate(-0.01 -0.04)"
  })))), React__default.createElement(InnerRing, null, React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.28 24.28"
  }, React__default.createElement(Path$2, {
    d: "M27.73,21.13l3,1.07a11.87,11.87,0,0,0,.5-2.83H28A13,13,0,0,1,27.73,21.13Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$2, {
    d: "M29.75,24.43a4.69,4.69,0,0,0,.46-1l-3-1.07c-.08.19-.19.38-.27.57a8.13,8.13,0,0,1-.61,1l2.45,2A7.61,7.61,0,0,0,29.75,24.43Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$2, {
    d: "M25.51,25a9.15,9.15,0,0,1-3.82,2.33,8.56,8.56,0,0,1-2.6.38h0l-.27,3.17a12.08,12.08,0,0,0,3.86-.54A12.57,12.57,0,0,0,28,27Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$2, {
    d: "M20,9.82l.54-3.13c-.46,0-.92-.08-1.38-.08a9.49,9.49,0,0,0-1.54.08l.57,3.13A13.49,13.49,0,0,1,20,9.82Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$2, {
    d: "M15.19,10.7a7.6,7.6,0,0,1,1.3-.5l.34-.11L16.26,7c-.23.08-.5.11-.73.19a9.84,9.84,0,0,0-2,.8Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$2, {
    d: "M21.27,10a10.16,10.16,0,0,1,2,.8,8.66,8.66,0,0,1,3.55,3.48L29.71,13a11.93,11.93,0,0,0-4.93-4.9,12.21,12.21,0,0,0-3-1.11Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$2, {
    d: "M11.18,14.52c.08-.11.11-.23.19-.34l-2.6-1.75c-.11.23-.27.42-.38.65a12.09,12.09,0,0,0-.92,9.21h0l3-1.11A8.89,8.89,0,0,1,11.18,14.52Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$2, {
    d: "M12.71,25,10.3,27.1a11.56,11.56,0,0,0,2.22,1.83l1.57-2.75A6.85,6.85,0,0,1,12.71,25Z",
    transform: "translate(-6.95 -6.61)"
  }), React__default.createElement(Path$2, {
    d: "M9.38,26.06,11.79,24a7.56,7.56,0,0,1-.88-1.57L8,23.58A14.57,14.57,0,0,0,9.38,26.06Z",
    transform: "translate(-6.95 -6.61)"
  }))));
};

const PerformanceIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "24px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M17.721 9.56a6.4 6.4 0 00-.578-1.326l2.741-1.182a9.34 9.34 0 01.577 1.326zM2.49 8.519a9.387 9.387 0 01.556-1.335l2.759 1.138a6.354 6.354 0 00-.556 1.336zm2.841-4.231l2.111 2.1A6.545 6.545 0 006.415 7.41l-2.111-2.1a9.552 9.552 0 011.027-1.022zm3.183-1.8l1.155 2.744a6.457 6.457 0 00-1.338.559L7.176 3.048a9.471 9.471 0 011.338-.555zm3.028 9.224l3.469-3.832-1.592 4.91a2.215 2.215 0 01.026 2.265 2.24 2.24 0 11-1.9-3.344zm-.768-9.674a9.404 9.404 0 011.452 0v2.974a6.612 6.612 0 00-1.452 0zm3.675.439a9.508 9.508 0 011.341.554l-1.144 2.748a6.5 6.5 0 00-1.341-.554zm4.246 2.83l-2.111 2.1a6.551 6.551 0 00-1.027-1.022l2.111-2.1a9.6 9.6 0 011.027 1.026zm4.3 6.144a11.5 11.5 0 10-20.887 6.682h4.176a6.173 6.173 0 0010.422 0h4.176A11.568 11.568 0 0023 11.454z"
  }));
};

const GraphsIcon = props => {
  return React__default.createElement("svg", _extends$3({
    width: "18.84",
    viewBox: "0 0 18.84 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M14.582 0a1.318 1.318 0 00-1.344 1.291 1.259 1.259 0 00.367.884l-1.179 2.757a1.4 1.4 0 00-.69.184L9.325 3.379a1.259 1.259 0 00.044-.324 1.364 1.364 0 00-2.726 0 1.268 1.268 0 00.26.767L5.16 6.543a1.428 1.428 0 00-.215-.018 1.31 1.31 0 101.363 1.309 1.268 1.268 0 00-.26-.767l1.743-2.721a1.43 1.43 0 00.215.018A1.4 1.4 0 008.7 4.18l2.411 1.737a1.254 1.254 0 00-.044.324 1.364 1.364 0 002.725 0 1.28 1.28 0 00-.4-.929L14.56 2.58h.023a1.292 1.292 0 100-2.581z"
  }), React__default.createElement("path", {
    "data-name": "Op component 1",
    d: "M16.307 12.283h-.566v-.7a.323.323 0 00-.646 0v.7h-2.932v-.7a.323.323 0 00-.646 0v.7H8.59v-.7a.324.324 0 00-.647 0v.7H5.012v-.7a.324.324 0 00-.647 0v.7H1.357V9.39h.727a.311.311 0 100-.621h-.727V5.953h.727a.311.311 0 100-.621h-.727V2.516h.727a.311.311 0 100-.621h-.727v-.669a.678.678 0 00-1.354 0v11.7a.664.664 0 00.677.651h15.631a.651.651 0 100-1.3z"
  }));
};

const LogoWrapper$2 = newStyled.div`
  position: relative;
  width: 250px;
  height: 250px;
`;
const LogoSVG$1 = newStyled.svg`
  position: absolute;
  width: 250px;
  height: 250px;
  &.l-1 {
    animation: rotating 7200ms linear infinite;
    transform-origin: 50% 50%;
  }

  &.l-2 {
    animation: rotating 7200ms linear reverse infinite;
    transform-origin: 50% 50%;
  }
  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
const logoColors = {
  orange: '#FAA819',
  green: '#7ABA43',
  blue: '#4794D0',
  grey: '#cecece'
};
const LoadingPlaceholderIcon = props => {
  return React__default.createElement(LogoWrapper$2, {
    style: {
      width: props.width,
      height: props.height
    }
  }, React__default.createElement(LogoSVG$1, _extends$3({
    className: "l-2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 250 250"
  }, props), React__default.createElement("path", {
    fill: props.colored ? logoColors.orange : logoColors.grey,
    d: "M178.888 140.265l18.731 6.784a75.813 75.813 0 003.119-17.928h-19.929a82.906 82.906 0 01-1.921 11.144zM191.615 161.343a29.877 29.877 0 002.882-6.3l-18.731-6.783c-.48 1.212-1.201 2.423-1.681 3.635a51.54 51.54 0 01-3.847 6.057l15.369 12.84a48.27 48.27 0 006.008-9.449zM164.96 164.735a57.437 57.437 0 01-24.015 14.778 53.393 53.393 0 01-16.33 2.423h-.24l-1.68 20.108a75.307 75.307 0 0024.255-3.392 78.876 78.876 0 0033.619-21.082l-15.609-12.835z"
  }), React__default.createElement("path", {
    fill: props.colored ? logoColors.green : logoColors.grey,
    d: "M129.739 68.55l3.362-19.865c-2.882-.243-5.764-.485-8.646-.485-3.119 0-6.244.242-9.365.485l3.602 19.866a84.034 84.034 0 0111.047 0zM99.96 74.126a47.486 47.486 0 018.166-3.146l2.161-.727-3.602-19.87c-1.441.485-3.119.727-4.563 1.212a61.512 61.512 0 00-12.487 5.088L99.96 74.126zM138.143 70.007a63.496 63.496 0 0112.727 5.088 54.635 54.635 0 0122.333 22.047l18.011-8.48c-7.048-13.209-17.833-24.003-30.981-31.01a76.272 76.272 0 00-18.731-7.027l-3.359 19.382z"
  }), React__default.createElement("path", {
    fill: props.colored ? logoColors.blue : logoColors.grey,
    d: "M74.746 98.352c.48-.726.72-1.453 1.2-2.18L59.618 84.786c-.72 1.453-1.68 2.665-2.401 4.118a77.11 77.11 0 00-8.642 28.615 77.257 77.257 0 002.878 29.772l18.731-7.027a56.777 56.777 0 014.563-41.912zM84.351 164.977l-15.129 13.082a72.81 72.81 0 0013.932 11.629l9.845-17.444a43.129 43.129 0 01-8.648-7.267zM63.46 171.519l15.129-13.083a48.04 48.04 0 01-5.524-9.69l-18.731 7.026a92.603 92.603 0 009.126 15.747z"
  })), React__default.createElement(LogoSVG$1, _extends$3({
    className: "l-1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 250 250"
  }, props), React__default.createElement("g", null, React__default.createElement("path", {
    fill: props.colored ? logoColors.orange : logoColors.grey,
    d: "M78.743 196.877a84.024 84.024 0 01-16.57-13.809l-25.936 22.289a117.29 117.29 0 0025.696 21.562l16.81-30.042zM110.681 244.12l2.882-34.16a81.642 81.642 0 01-27.617-8.722l-16.81 29.799a118.703 118.703 0 0041.545 13.083zM188.247 182.583a85.694 85.694 0 01-38.422 24.229 88.058 88.058 0 01-24.975 3.88h-2.882l-2.881 34.155a116.886 116.886 0 0040.584-5.088c21.101-6.416 40.044-18.57 54.75-35.129l-26.174-22.047z"
  }), React__default.createElement("path", {
    fill: props.colored ? logoColors.green : logoColors.grey,
    d: "M239.236 160.779a128.215 128.215 0 005.764-33.19l-34.1.242a80.94 80.94 0 01-3.602 21.32l31.938 11.628zM207.058 98.758a100.015 100.015 0 013.602 20.593l34.1-.242a130.93 130.93 0 00-5.043-30.283 112.18 112.18 0 00-4.563-12.6l-30.738 14.779a58.278 58.278 0 012.642 7.753zM143.66 39.16a81.159 81.159 0 0121.613 8.237c15.042 8.029 27.342 20.438 35.3 35.614l30.738-14.778a122.208 122.208 0 00-34.065-40.871A120.917 120.917 0 00149.18 5l-5.52 34.16z"
  }), React__default.createElement("path", {
    fill: props.colored ? logoColors.blue : logoColors.grey,
    d: "M49.205 83.01l2.882-5.087L24.23 58.299c-1.681 2.665-3.363 5.572-5.044 8.48A121.259 121.259 0 005.45 113.295a121.472 121.472 0 005.573 48.21l31.938-11.871a86.603 86.603 0 01-3.574-33.95 86.44 86.44 0 019.819-32.673zM85.466 46.67a74.814 74.814 0 0114.408-5.814l5.764-1.454-6.004-33.917c-3.119.726-6.484 1.453-9.605 2.422a133.656 133.656 0 00-21.853 8.965l17.29 29.798zM56.89 70.654a91.587 91.587 0 0121.132-19.866l-17.05-29.556a118.253 118.253 0 00-32.18 29.799L56.89 70.654z"
  }))));
};

const ServerIcon = props => {
  return React__default.createElement("svg", _extends$3({
    fill: "#4694ce",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.75 15.98"
  }, props), React__default.createElement("defs", null), React__default.createElement("path", {
    d: "M17.75 15.98H0v-4.56h17.75v4.56zm-2.22-3.43v2.28h1.11v-2.28zm-2.22 0v2.28h1.11v-2.28zm-2.21 0v2.28h1.1v-2.28zm-2.22 0v2.28h1.1v-2.28zm-7.77 0v2.28h2.22v-2.28zm16.64-2.28H0V5.71h17.75v4.56zm-2.22-3.43v2.29h1.11V6.84zm-2.22 0v2.29h1.11V6.84zm-2.21 0v2.29h1.1V6.84zm-2.22 0v2.29h1.1V6.84zm-7.77 0v2.29h2.22V6.84zm16.64-2.28H0V0h17.75v4.56zm-2.22-3.42v2.29h1.11V1.14zm-2.22 0v2.29h1.11V1.14zm-2.21 0v2.29h1.1V1.14zm-2.22 0v2.29h1.1V1.14zm-7.77 0v2.29h2.22V1.14z"
  }));
};

const UploadIcon = props => {
  return React__default.createElement("svg", {
    width: "2rem",
    height: "2rem",
    viewBox: "0 0 21 16"
  }, React__default.createElement("path", {
    d: "M14,8.36a.36.36,0,0,1-.35.36H11.2v4a.37.37,0,0,1-.35.36H8.75a.37.37,0,0,1-.35-.36v-4H5.95a.35.35,0,0,1-.35-.36.43.43,0,0,1,.11-.27l3.84-4A.36.36,0,0,1,9.8,4a.34.34,0,0,1,.25.1l3.85,4A.39.39,0,0,1,14,8.36Zm7,3.27a4.34,4.34,0,0,0-3.25-4.25,2.93,2.93,0,0,0,.45-1.57,2.86,2.86,0,0,0-2.8-2.91,2.71,2.71,0,0,0-1.82.7A5.61,5.61,0,0,0,8.4,0,5.71,5.71,0,0,0,2.8,5.82c0,.16,0,.32,0,.49A5.09,5.09,0,0,0,0,10.91,5,5,0,0,0,4.9,16H16.8A4.29,4.29,0,0,0,21,11.64Z"
  }));
};

const CounterIncrementIcon = props => {
  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8.67",
    height: "5.164",
    viewBox: "0 0 8.67 5.164"
  }, props), React__default.createElement("path", {
    id: "angle-up",
    d: "M4.54,160.77l4.009,3.977a.325.325,0,0,1,0,.46l-.536.536a.325.325,0,0,1-.461,0l-3.243-3.21-3.243,3.21a.325.325,0,0,1-.461,0l-.536-.536a.325.325,0,0,1,0-.46L4.08,160.77A.325.325,0,0,1,4.54,160.77Z",
    transform: "translate(0.025 -160.675)",
    fill: "#0076ce"
  }));
};

const CounterDecrementIcon = props => {
  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8.67",
    height: "5.164",
    viewBox: "0 0 8.67 5.164"
  }, props), React__default.createElement("path", {
    id: "angle-down",
    d: "M4.565.1,8.574,4.072a.325.325,0,0,1,0,.46l-.536.536a.325.325,0,0,1-.461,0L4.335,1.859,1.092,5.069a.325.325,0,0,1-.461,0L.1,4.533a.325.325,0,0,1,0-.46L4.1.1A.325.325,0,0,1,4.565.1Z",
    transform: "translate(8.67 5.164) rotate(180)",
    fill: "#0076ce"
  }));
};

const LogoSVG = newStyled.svg`
  position: absolute;
  width: ${props => props.width ? props => props.width : '8.729rem'};
  height: ${props => props.height ? props => props.width : '8.652rem'};
  &.l-1 {
    animation: rotating 7200ms linear infinite;
    transform-origin: 50% 50%;
  }

  &.l-2 {
    animation: rotating 7200ms linear reverse infinite;
    transform-origin: 50% 50%;
  }
  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
const LogoWrapper$1 = newStyled.div`
  position: relative;
`;
const GraphsIconColor = Props => {
  return React__default.createElement(LogoWrapper$1, null, React__default.createElement(LogoSVG, {
    width: Props.width,
    height: Props.height,
    className: "l-2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 250 250"
  }, React__default.createElement("path", {
    fill: "#FAA819",
    d: "M178.888 140.265l18.731 6.784a75.813 75.813 0 003.119-17.928h-19.929a82.906 82.906 0 01-1.921 11.144zM191.615 161.343a29.877 29.877 0 002.882-6.3l-18.731-6.783c-.48 1.212-1.201 2.423-1.681 3.635a51.54 51.54 0 01-3.847 6.057l15.369 12.84a48.27 48.27 0 006.008-9.449zM164.96 164.735a57.437 57.437 0 01-24.015 14.778 53.393 53.393 0 01-16.33 2.423h-.24l-1.68 20.108a75.307 75.307 0 0024.255-3.392 78.876 78.876 0 0033.619-21.082l-15.609-12.835z"
  }), React__default.createElement("path", {
    fill: "#7ABA43",
    d: "M129.739 68.55l3.362-19.865c-2.882-.243-5.764-.485-8.646-.485-3.119 0-6.244.242-9.365.485l3.602 19.866a84.034 84.034 0 0111.047 0zM99.96 74.126a47.486 47.486 0 018.166-3.146l2.161-.727-3.602-19.87c-1.441.485-3.119.727-4.563 1.212a61.512 61.512 0 00-12.487 5.088L99.96 74.126zM138.143 70.007a63.496 63.496 0 0112.727 5.088 54.635 54.635 0 0122.333 22.047l18.011-8.48c-7.048-13.209-17.833-24.003-30.981-31.01a76.272 76.272 0 00-18.731-7.027l-3.359 19.382z"
  }), React__default.createElement("path", {
    fill: "#4794D0",
    d: "M74.746 98.352c.48-.726.72-1.453 1.2-2.18L59.618 84.786c-.72 1.453-1.68 2.665-2.401 4.118a77.11 77.11 0 00-8.642 28.615 77.257 77.257 0 002.878 29.772l18.731-7.027a56.777 56.777 0 014.563-41.912zM84.351 164.977l-15.129 13.082a72.81 72.81 0 0013.932 11.629l9.845-17.444a43.129 43.129 0 01-8.648-7.267zM63.46 171.519l15.129-13.083a48.04 48.04 0 01-5.524-9.69l-18.731 7.026a92.603 92.603 0 009.126 15.747z"
  })), React__default.createElement(LogoSVG, {
    width: Props.width,
    height: Props.height,
    className: "l-1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 250 250"
  }, React__default.createElement("g", null, React__default.createElement("path", {
    fill: "#FAA819",
    d: "M78.743 196.877a84.024 84.024 0 01-16.57-13.809l-25.936 22.289a117.29 117.29 0 0025.696 21.562l16.81-30.042zM110.681 244.12l2.882-34.16a81.642 81.642 0 01-27.617-8.722l-16.81 29.799a118.703 118.703 0 0041.545 13.083zM188.247 182.583a85.694 85.694 0 01-38.422 24.229 88.058 88.058 0 01-24.975 3.88h-2.882l-2.881 34.155a116.886 116.886 0 0040.584-5.088c21.101-6.416 40.044-18.57 54.75-35.129l-26.174-22.047z"
  }), React__default.createElement("path", {
    fill: "#7ABA43",
    d: "M239.236 160.779a128.215 128.215 0 005.764-33.19l-34.1.242a80.94 80.94 0 01-3.602 21.32l31.938 11.628zM207.058 98.758a100.015 100.015 0 013.602 20.593l34.1-.242a130.93 130.93 0 00-5.043-30.283 112.18 112.18 0 00-4.563-12.6l-30.738 14.779a58.278 58.278 0 012.642 7.753zM143.66 39.16a81.159 81.159 0 0121.613 8.237c15.042 8.029 27.342 20.438 35.3 35.614l30.738-14.778a122.208 122.208 0 00-34.065-40.871A120.917 120.917 0 00149.18 5l-5.52 34.16z"
  }), React__default.createElement("path", {
    fill: "#4794D0",
    d: "M49.205 83.01l2.882-5.087L24.23 58.299c-1.681 2.665-3.363 5.572-5.044 8.48A121.259 121.259 0 005.45 113.295a121.472 121.472 0 005.573 48.21l31.938-11.871a86.603 86.603 0 01-3.574-33.95 86.44 86.44 0 019.819-32.673zM85.466 46.67a74.814 74.814 0 0114.408-5.814l5.764-1.454-6.004-33.917c-3.119.726-6.484 1.453-9.605 2.422a133.656 133.656 0 00-21.853 8.965l17.29 29.798zM56.89 70.654a91.587 91.587 0 0121.132-19.866l-17.05-29.556a118.253 118.253 0 00-32.18 29.799L56.89 70.654z"
  }))));
};

class ModalPortal extends Component {
  render() {
    let modalRoot = document.getElementById('modal-root');

    if (!modalRoot) {
      modalRoot = document.createElement('div');
      modalRoot.setAttribute('id', 'modal-root');
      document.body.appendChild(modalRoot);
    }

    const portal = createPortal(this.props.children, document.getElementById('modal-root'));
    return portal;
  }

}

const Overlay$3 = newStyled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${s => s.showModal ? 'rgba(86, 96, 114, 0.5)' : 'rgba(86, 96, 114, 0)'};
  transition: background-color 0.45s ease-in;
  z-index: 100;
`;
const ModalBody$6 = newStyled.div`
  flex: 1 1 auto;
  opacity: ${s => s.showModal ? '1' : '0.3'};
  max-width: 815px;
  min-height: 100px;
  background: #fff;
  border: 1px solid #bdcad2;
  transition: all 0.25s ease-in;
  padding: 0 0 1rem 0;
`;
const ModalHeader$1 = newStyled.div`
  height: 60px;
  background: #f2f2f2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 2rem;

  & > span {
    color: #bdcad2;
    cursor: pointer;
    font-size: 0.8em;
  }
`;
const ModalTitle$1 = newStyled.div`
  display: flex;
  justify-content: space-between;
  color: #566072;
  font-size: 1.45rem;

  span {
    margin-right: 10px;
  }

  span > svg {
    font-size: 0.9em;
  }
`;
class Modal extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      showModal: false
    });

    _defineProperty$2(this, "_isMounted", false);

    _defineProperty$2(this, "closeModal", () => {
      this.setState({
        showModal: false
      });
      setTimeout(() => {
        this.props.closeFn();
      }, 500);
    });
  }

  componentDidMount() {
    this._isMounted = true;
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({
          showModal: true
        });
      }
    }, 50);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState({
      showModal: false
    });
  }

  render() {
    return React__default.createElement(ModalPortal, null, React__default.createElement(Overlay$3, {
      showModal: this.state.showModal
    }, React__default.createElement(ModalBody$6, {
      showModal: this.state.showModal
    }, React__default.createElement(ModalHeader$1, null, React__default.createElement(ModalTitle$1, null, this.props.modalIcon && React__default.createElement("span", null, this.props.modalIcon), React__default.createElement("span", null, this.props.modalTitle)), React__default.createElement("span", {
      onClick: this.closeModal
    }, React__default.createElement(CloseIcon$2, null))), this.props.children)));
  }

}

const Overlay$2 = newStyled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.showModal ? 'rgba(86, 96, 114, 0.5)' : 'rgba(86, 96, 114, 0)'};
  transition: background-color 0.45s ease-in;
  z-index: 100;
`;
const ModalContainer = newStyled.div`
  flex: 1 1 auto;
  opacity: ${props => props.showModal ? '1' : '0.3'};
  max-width: ${props => props.maxWidth ? props.maxWidth : '540px'};
  min-height: 224px;
  background: ${Color$1.white};
  border: 1px solid ${Color$1.navy800};
  transition: all 0.25s ease-in;
  padding: 0 0 0 0;
  font-family: 'open sans', sans-serif;
`;
const ModalHeader = newStyled.div`
  height: 60px;
  border-bottom: 1px solid ${Color$1.grey400};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;

  & > span {
    color: ${Color$1.navy800};
    cursor: pointer;
    font-size: 12px;

    & > svg {
      width: 16px;
    }
  }
`;
const ModalTitle = newStyled.div`
  display: flex;
  justify-content: space-between;
  color: ${Color$1.navy700};
  font-size: 20px;
  vertical-align: 'middle', span {
    display: flex;
    text-align: center;
  }

  span {
    display: flex;
    align-items: center;
    svg {
      font-size: 14px;
      margin-right: 10px;
    }
  }
`;
class SmallBasicModal extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      showModal: false
    });

    _defineProperty$2(this, "_isMounted", false);

    _defineProperty$2(this, "closeModal", () => {
      this.setState({
        showModal: false
      });
      let timeout = this.props.closeDelayMiliseconds;

      if (typeof timeout === 'undefined' || timeout === null) {
        timeout = -1;
      }

      timeout = timeout < 0 ? 500 : timeout;

      if (timeout > 0) {
        setTimeout(() => {
          this.props.onClose();
        }, timeout);
      } else {
        this.props.onClose();
      }
    });
  }

  componentDidMount() {
    this._isMounted = true;
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({
          showModal: true
        });
      }
    }, 50);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState({
      showModal: false
    });
  }

  render() {
    return React__default.createElement(ModalPortal, null, React__default.createElement(Overlay$2, {
      showModal: this.state.showModal
    }, React__default.createElement(ModalContainer, {
      showModal: this.state.showModal,
      maxWidth: this.props.maxWidth
    }, React__default.createElement(ModalHeader, null, React__default.createElement(ModalTitle, null, this.props.modalIcon && React__default.createElement("span", null, this.props.modalIcon), React__default.createElement("span", null, this.props.modalTitle)), React__default.createElement("span", {
      onClick: this.closeModal
    }, React__default.createElement(CloseIcon$2, {
      color: Color$1.coolGray300,
      fill: Color$1.coolGray300
    }))), this.props.children)));
  }

}

const ModalBodyContainer$2 = newStyled.div`
  position: relative;
  flex-direction: column;
  min-height: 120px;
  margin-bottom: 24px;
`;
const ModalBody$5 = newStyled.div`
  margin: ${s => s.secondaryButton ? '18px 25px 40px 25px' : '18px 25px 45px 25px'};
  font-size: 14px;
  letter-spacing: 0;
  min-height: 33px;
  color: ${Color$1.navy700};
  font-family: 'open sans', sans-serif;
  opacity: 1;
  overflow-wrap: break-word;
`;
const ModalAction$2 = newStyled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 25px;
  vertical-align: bottom;
  a {
    margin-right: 24px;
    padding-bottom: 10px;
  }
`;
const ModalPrimaryActionWrapper$1 = newStyled.div`
  margin-top: ${s => s.secondaryButton ? '5px' : '0px;'};
`;
const SuccessModal = props => {
  const {
    title,
    successMessage,
    children,
    primaryButtonName,
    secondaryButtonName,
    closeDelayMiliseconds,
    onClose,
    onPrimaryClick,
    onSecondaryClick
  } = props;
  const secondaryButton = secondaryButtonName && onSecondaryClick ? true : false;
  return React__default.createElement(SmallBasicModal, {
    onClose: onClose,
    modalTitle: title,
    modalIcon: React__default.createElement(CheckIcon, {
      fill: Color$1.green400,
      color: Color$1.green400,
      height: '21px',
      width: '21px'
    }),
    closeDelayMiliseconds: closeDelayMiliseconds
  }, React__default.createElement(ModalBodyContainer$2, null, React__default.createElement(ModalBody$5, {
    "data-testid": "success-message",
    secondaryButton: secondaryButton
  }, children ? children : successMessage), React__default.createElement(ModalAction$2, null, secondaryButtonName && onSecondaryClick && React__default.createElement(TextButton, {
    clickFn: onSecondaryClick
  }, secondaryButtonName), React__default.createElement(ModalPrimaryActionWrapper$1, {
    secondaryButton: secondaryButton
  }, React__default.createElement(PrimaryButton, {
    clickFn: onPrimaryClick
  }, primaryButtonName)))));
};

const ModalBodyContainer$1 = newStyled.div`
    position: relative;
    flex-direction: column;
    min-height: 7.5rem;
    margin-bottom: 1.5rem;
    font-family: 'open sans', sans-serif;
`;
const ModalBody$4 = newStyled.div`
    margin: 1.125rem 1.5625rem 2.813rem 1.5625rem;
    font-size: 0.875rem;
    letter-spacing: 0;
    min-height: 2.0625rem;
    color: ${Color$1.navy700};
    opacity: 1;
`;
const ModalAction$1 = newStyled.div`
    display: flex;
    vertical-Align: bottom;
    justify-content: flex-end;
    padding-right: 1.5625rem;
    a {
        margin-right: 1.5rem;
        padding-bottom: 1.688rem;
    }
`;
const ErrorModal = props => {
  const {
    title,
    errorMessage,
    primaryButtonName,
    closeDelayMiliseconds,
    onClose,
    onPrimaryClick
  } = props;
  return React__default.createElement(SmallBasicModal, {
    onClose: onClose,
    modalTitle: title,
    modalIcon: React__default.createElement(ErrorIcon, {
      height: "1.313rem",
      width: "1.313rem",
      fill: Color$1.red500
    }),
    closeDelayMiliseconds: closeDelayMiliseconds
  }, React__default.createElement(ModalBodyContainer$1, null, React__default.createElement(ModalBody$4, {
    "data-testid": "error-message"
  }, errorMessage), React__default.createElement(ModalAction$1, null, React__default.createElement(PrimaryButton, {
    clickFn: onPrimaryClick
  }, primaryButtonName))));
};

const ModalBodyContainer = newStyled.div`
  position: relative;
  flex-direction: column;
  display: flex;
  max-height: ${s => s.maxHeight == null ? '30.75rem' : s.maxHeight};
  min-height: 8.25rem;
  margin-bottom: 1.438rem;
`;
const ModalBody$3 = newStyled.div`
  margin: ${s => s.secondaryButton ? '18px 25px 24px 25px' : '18px 25px 24px 25px'};
  font-size: 14px;
  letter-spacing: 0;
  min-height: 3.375rem;
  color: ${Color$1.navy700};
  font-family: 'open sans', sans-serif;
  opacity: 1;
`;
const ModalAction = newStyled.div`
  display: flex;
  justify-content: flex-end;
  align-self:  flex-end;
  align-items:flex-end;
  padding-right: 1.563rem;
  vertical-align: bottom;
  a {
    min-height: 3.188rem;
    margin-right: 1.5rem;
    padding-bottom: 0.625rem;
  }
  div {
    padding-bottom: 0.063rem;
  }
`;
const ModalPrimaryActionWrapper = newStyled.div`
  margin-top: ${s => s.secondaryButton ? '5px' : '0px;'};
`;
const DynamicModal = props => {
  const {
    title,
    children,
    icon,
    primaryButtonName,
    secondaryButtonName,
    closeDelayMiliseconds,
    onClose,
    maxWidth,
    maxHeight,
    onPrimaryClick,
    onSecondaryClick
  } = props;
  const secondaryButton = secondaryButtonName && onSecondaryClick ? true : false;
  return React__default.createElement(SmallBasicModal, {
    onClose: onClose,
    modalTitle: title,
    modalIcon: icon,
    closeDelayMiliseconds: closeDelayMiliseconds,
    maxWidth: maxWidth
  }, React__default.createElement(ModalBodyContainer, {
    maxHeight: maxHeight
  }, React__default.createElement(ModalBody$3, {
    "data-testid": "DynamicModal-message",
    secondaryButton: secondaryButton,
    maxHeight: maxHeight
  }, children), React__default.createElement(ModalAction, null, secondaryButtonName && onSecondaryClick && React__default.createElement(TextButton, {
    clickFn: onSecondaryClick
  }, secondaryButtonName), React__default.createElement(ModalPrimaryActionWrapper, {
    secondaryButton: secondaryButton
  }, React__default.createElement(PrimaryButton, {
    clickFn: onPrimaryClick
  }, primaryButtonName)))));
};

const PopoverContainer$1 = newStyled.div`
  position: absolute;
  display: block;
  width: auto;
  transform: translate(${s => s.position.left}, ${s => s.position.top});
  visibility: ${s => s.visible ? 'visible' : 'hidden'};
  box-shadow: rgba(0, 0, 0, 0.3) 0 0.4rem 1rem 0rem;
  border-radius: 0.3125rem;
  z-index: 25;
  top: 0px;
  left: 0px;
`;
const TextContainer$1 = newStyled.div`
  position: relative;
  background: #fff;
  bottom: 0;
  padding: 1rem;
  max-width: 300px;
  color: #566072;
  font-size: 0.8rem;
  line-height: 1.2rem;
  border-radius: 0.3125rem;
  width: auto;
  z-index: 25;

  &:after {
    position: absolute;
    content: '\\25BC';
    display: block;
    color: #fff;
    margin-top: 1.1rem;
    z-index: 25;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }
`;
const Text$3 = newStyled.div`
  margin: 0;
  padding: 0;
`;
const ToggleTarget = newStyled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  max-width: 22px;
`;
const HideTarget = newStyled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;

  svg {
    height: 0.6rem;
    width: 0.6rem;
    fill: #bdcad2;
  }
`;
const RelativeWrapper = newStyled.div`
  position: relative;
  flex: 1;
`;
const Popover$1 = props => {
  const offScreen = '-99999px';
  const defaultPosition = {
    top: offScreen,
    left: offScreen
  };
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState(defaultPosition);
  let toggleTarget = null;
  let popoverContainer = null;

  const toggle = () => {
    if (toggleTarget && popoverContainer) {
      const targetMidpoint = toggleTarget.clientWidth / 2;
      const leftMostPopoverPosition = toggleTarget.offsetLeft + targetMidpoint;
      const popoverOffset = popoverContainer.clientWidth / 2;
      const popoverMidpoint = leftMostPopoverPosition - popoverOffset;
      const pseudoElementPadding = 10;
      const height = popoverContainer.clientHeight + pseudoElementPadding;
      const top = `${-height}px`;
      const left = `${popoverMidpoint}px`;
      setVisible(prev => !prev);
      setPosition(prev => {
        return {
          top: prev.top === top ? offScreen : top,
          left: prev.left === left ? offScreen : left
        };
      });
    } else {
      throw new Error('Popover elements not found');
    }
  };

  const hide = () => {
    setVisible(prev => !prev);
    setPosition(defaultPosition);
  };

  function createMarkup(html) {
    return {
      __html: html
    };
  }

  const haveContent = props.text !== undefined || props.content !== undefined;
  const content = haveContent ? props.text || props.content : undefined;
  return React__default.createElement(RelativeWrapper, null, React__default.createElement(ToggleTarget, {
    ref: el => toggleTarget = el,
    onClick: toggle,
    "data-testid": "popover-click-target"
  }, props.children), React__default.createElement(PopoverContainer$1, {
    ref: el => popoverContainer = el,
    position: position,
    visible: visible,
    "data-testid": "popover-text-container"
  }, React__default.createElement(TextContainer$1, null, React__default.createElement(HideTarget, {
    onClick: hide
  }, React__default.createElement(CloseIcon$2, null)), haveContent && React__default.createElement(Text$3, {
    "data-testid": "popover-text"
  }, content), props.rawHtml && React__default.createElement(Text$3, {
    "data-testid": "popover-raw-html",
    dangerouslySetInnerHTML: createMarkup(props.rawHtml)
  }))));
};

const TooltipWrapper$1 = newStyled.div`
  position: relative;
  display: inline-block;

  /* Show the tooltip text when you mouse over the tooltip container */
  &:hover > div {
    visibility: visible;
  }
`;
const TooltipContent = newStyled.div`
  visibility: hidden;
  width: 176px;
  text-align: center;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  line-height: 1rem;
  background-color: #4694ce;
  color: #ffffff;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 10px);
  &:before {
    content: '';
    width: 12px;
    height: 12px;
    left: 50%;
    z-index: 0;
    transform: translate(-50%, -50%) rotate(45deg);
    position: absolute;
    pointer-events: none;
    display: flex;
    background: #4694ce;
    top: 0;
  }
`;

const Tooltip$1 = props => {
  if (props.text) {
    return React__default.createElement(TooltipWrapper$1, null, props.children, React__default.createElement(TooltipContent, null, props.text));
  }

  return React__default.createElement(Fragment$1, null, props.children);
};

newStyled.a`
  color: #4694ce;
  text-decoration: none;
  height: 100%;
  width: 100%;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: #fff;
    text-decoration: none;
  }
`;
const Label$1 = newStyled.li`
  border-left: 1px solid #e4e4e4;
  list-style: none;
  line-height: 1em;
  cursor: pointer;
  & > div {
    padding: 0 0.8rem 0 0.4rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const ItemContent = newStyled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  color: ${p => p.isDisabled ? '#878787' : '#4694ce'};

  :hover {
    background-color: ${p => p.isDisabled ? 'unset' : '#4694ce'};
    border-bottom: ${p => p.isDisabled ? 'unset' : '1px solid #e4e4e4;'};
    color: ${p => p.isDisabled ? '#878787' : '#ffffff'};
  }
  > span {
    margin-left: 0.5rem;
  }

  > a > span {
    margin-left: 0.5rem;
  }

  :hover span {
    color: ${p => p.isDisabled ? '#878787' : '#ffffff'};
  }
`;
const ResponsiveIconWrapper = newStyled.span`
  display: none;

  @media (min-width: 66.5rem) {
    display: inline-block;
  }
`;
const ToolbarItem$1 = props => {
  const onClick = ev => {
    if (props.disabled) {
      return;
    }

    if ('link' in props) {
      return window.open(props.link, '_blank');
    }

    if ('clickFn' in props && props.clickFn) {
      return props.clickFn(ev);
    }
  };

  return React__default.createElement(Label$1, {
    onClick: onClick
  }, React__default.createElement(Tooltip$1, {
    text: props.disabled ? props.disabledText : undefined
  }, React__default.createElement(ItemContent, {
    isDisabled: props.disabled ? 1 : 0
  }, React__default.createElement(ResponsiveIconWrapper, null, props.icon), React__default.createElement("span", null, props.text))));
};

const ModalBody$2 = newStyled.div`
  background: #fff;
  padding: 10px 2rem;
  display: flex;
  flex-direction: column;
`;
const ButtonGroup = newStyled.div`
  display: flex;
  justify-content: flex-end;

  a {
    margin-right: 1.5rem;
  }
`;
class DeleteModal extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      error: false
    });
  }

  render() {
    const deleteProject = async () => {
      const url = this.props.apiUrl ? `${this.props.apiUrl}/api/projects/${this.props.projectId}` : `/api/projects/${this.props.projectId}`;
      const response = await fetch(url, {
        credentials: 'same-origin',
        method: 'DELETE'
      });

      if (response.status === 200) {
        window.location.href = '/projects';
      } else {
        this.setState({
          error: true
        });
      }
    };

    const errorBody = React__default.createElement(React__default.Fragment, null, React__default.createElement("p", null, "Something has gone wrong. Please try again."), React__default.createElement("p", null, "Contact ", React__default.createElement("a", {
      href: "https://support.liveoptics.com/"
    }, "support"), " if the issue persists."));
    const body = React__default.createElement(React__default.Fragment, null, React__default.createElement("p", null, "Are you sure you want to delete this project?"), React__default.createElement(ButtonGroup, null, React__default.createElement(TextButton, {
      clickFn: this.props.closeFn
    }, "Cancel"), React__default.createElement(DangerButton, {
      testId: "delete-modal-confirm",
      clickFn: deleteProject
    }, "Delete")));
    return this.state.error ? React__default.createElement(ModalBody$2, {
      "data-testid": "delete-modal-error"
    }, errorBody) : React__default.createElement(ModalBody$2, {
      "data-testid": "delete-modal-info"
    }, body);
  }

}

class DeleteAction extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      showModal: false
    });

    _defineProperty$2(this, "shareIcon", React__default.createElement(DeleteBinIcon, null));

    _defineProperty$2(this, "openModal", () => {
      this.setState(state => {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          showModal: true
        });
      });
    });

    _defineProperty$2(this, "closeModal", () => {
      this.setState(state => {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          showModal: false
        });
      });
    });
  }

  render() {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(ToolbarItem$1, {
      text: "Delete",
      clickFn: this.openModal,
      icon: React__default.createElement(DeleteBinIcon, {
        width: "18px"
      })
    }), this.state.showModal && React__default.createElement(Modal, {
      closeFn: this.closeModal,
      modalTitle: 'Delete Project'
    }, React__default.createElement(DeleteModal, {
      projectId: this.props.projectId,
      closeFn: this.closeModal,
      apiUrl: this.props.apiUrl
    })));
  }

}

const IconWrapper$8 = newStyled.span`
  color: #bdcad2;
`;
const Svg$3 = newStyled.svg`
  width: 1.5em;
  height: 1.5em;
`;
const SearchIcon$1 = () => {
  return React__default.createElement(IconWrapper$8, null, React__default.createElement(Svg$3, {
    viewBox: "0 0 20.002 19.989"
  }, React__default.createElement("path", {
    d: "M1411.663,1335l-4.226-4.224a8.623,8.623,0,1,0-1.647,1.645l4.226,4.224a1.164,1.164,0,0,0,1.647-1.646Zm-17.332-9.412a6.267,6.267,0,1,1,6.267,6.262A6.271,6.271,0,0,1,1394.332,1325.591Z",
    transform: "translate(-1392.002 -1317.001)"
  })));
};

const IconWrapper$7 = newStyled.span`
  color: #4694ce;
`;
const Svg$2 = newStyled.svg`
  width: 1.2em;
  height: 1.2em;
`;
const DeleteCrossIcon = () => {
  return React__default.createElement(IconWrapper$7, null, React__default.createElement(Svg$2, {
    viewBox: "0 0 16 16"
  }, React__default.createElement("path", {
    d: "M1678,1371a8,8,0,1,0,8,8A8,8,0,0,0,1678,1371Zm2.495,12.29-2.391-2.48-2.346,2.522-1.705-1.585,2.432-2.615-2.479-2.57,1.676-1.617,2.391,2.479,2.346-2.522,1.705,1.586-2.432,2.615,2.479,2.571Z",
    transform: "translate(-1670 -1371)"
  })));
};

class RecentContactTransformer {
  static from(contactData) {
    return {
      email: contactData.Email
    };
  }

}

class ShareContactTransformer {
  static from(contactData) {
    return {
      recentContacts: contactData.recentContacts.map(x => RecentContactTransformer.from(x))
    };
  }

}

class SearchResultsTransformer {
  static from(searchData) {
    return {
      emailList: searchData.searchResults.map(x => RecentContactTransformer.from(x))
    };
  }

}

const ListPanel = newStyled.div`
  position: absolute;
  width: 100%;
  min-height: 30px;
  background: #fff;
  top: 73px;
  border: 2px solid #4694ce;
`;
const List$1 = newStyled.ul`
  list-style: none;
  margin: 0px;
  padding: 0px 0.5rem;
  cursor: pointer;

  li {
    height: 42px;
    border-bottom: 1px solid #f2f2f2;
    padding: 0.7rem 0.3rem;

    &:hover {
      background: #f5fbff;
    }
  }
`;
const TextInput$2 = newStyled.input`
  padding-left: 35px;
  height: 45px;
  border: 2px solid #bdcad2;

  &:focus {
    background-color: #f5fbff;
  }
`;
const Message$2 = newStyled.span`
  padding: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
`;

class ShareInputField extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      showListPanel: false,
      typeAheadLoading: false,
      emailList: [],
      showRecentRecipients: false,
      recentRecipientsList: []
    });

    _defineProperty$2(this, "focused", () => {
      this.setState(state => {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          showListPanel: true,
          showRecentRecipients: true,
          emailList: state.recentRecipientsList
        });
      });
    });

    _defineProperty$2(this, "blur", () => {
      this.setState(state => {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          showListPanel: false
        });
      });
      this.refs.emailInput.value = '';
    });

    _defineProperty$2(this, "keyUp", async () => {
      const value = this.refs.emailInput.value;

      if (!value) {
        this.setState(state => {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            typeAhead: [],
            showListPanel: false
          });
        });
      } else {
        const response = await fetch(`/modal/autocomplete/?email=${value}&isIokitUpload=null&isTeamMemberSearch=null`);
        const json = await response.json();
        const data = SearchResultsTransformer.from(json).emailList;
        this.setState(state => {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            emailList: data,
            typeAheadLoading: false,
            showListPanel: true,
            showRecentRecipients: false
          });
        });
      }
    });

    _defineProperty$2(this, "listItemClick", key => {
      const list = this.refs.list;
      const selected = list.children[key].innerText;
      this.props.listItemClick(selected);
      this.refs.emailInput.value = '';
      this.setState(state => {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          showListPanel: false
        });
      });
    });
  }

  async componentDidMount() {
    const url = this.props.apiUrl ? `${this.props.apiUrl}/modal/ShareProjectModel?projectid=${this.props.projectId}` : `/modal/ShareProjectModel?projectid=${this.props.projectId}`;
    const response = await fetch(url);
    const json = await response.json();
    const data = ShareContactTransformer.from(json).recentContacts;
    this.setState(state => {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        recentRecipientsList: data
      });
    });
  }

  render() {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(TextInput$2, {
      ref: "emailInput",
      type: "text",
      placeholder: "Enter email address",
      onKeyUp: this.keyUp,
      onFocus: this.focused,
      onBlur: this.blur
    }), this.state.showListPanel && React__default.createElement(ListPanel, null, this.state.showRecentRecipients && React__default.createElement(Message$2, null, "Recent Recipients"), this.state.typeAheadLoading && React__default.createElement(Message$2, null, "Searching..."), !this.state.typeAheadLoading && React__default.createElement(List$1, {
      ref: "list"
    }, this.state.emailList.length > 0 && this.state.emailList.map((d, i) => {
      return React__default.createElement("li", {
        key: i,
        onMouseDown: e => {
          if (e.button === 0) this.listItemClick(i);
        }
      }, d.email);
    }), this.state.emailList.length === 0 && React__default.createElement(Message$2, null, "No Results Found"))));
  }

}

const TextInput$1 = newStyled.input`
  padding-left: 10px;
  height: 45px;
  width: 80%;
  border: 2px solid #bdcad2;

  &:focus {
    background-color: #f5fbff;
  }

  &:invalid {
    border: 2px solid red;
  }
`;
const InputForm = newStyled.form`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
class ShareStandardInputField extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      email: '',
      disabled: true
    });

    _defineProperty$2(this, "addEmailClick", e => {
      e.preventDefault();
      const emailValue = this.refs.emailInput.value;

      if (emailValue) {
        this.props.addItemClick(emailValue);
        this.refs.emailInput.value = '';
      }
    });

    _defineProperty$2(this, "validateEmail", () => {
      const formValidity = this.refs.inputForm.checkValidity();
      const emailValue = this.refs.emailInput.value;
      this.setState(_objectSpread2(_objectSpread2({}, this.state), {}, {
        disabled: !formValidity || emailValue === ''
      }));
    });
  }

  render() {
    return React__default.createElement(InputForm, {
      ref: "inputForm"
    }, React__default.createElement(TextInput$1, {
      ref: "emailInput",
      type: "email",
      placeholder: "Enter email address",
      onKeyUp: this.validateEmail
    }), React__default.createElement(PrimaryButton, {
      disabled: this.state.disabled,
      clickFn: e => {
        return e && this.addEmailClick(e);
      }
    }, "Add"));
  }

}

const ModalBody$1 = newStyled.div`
  background: #fff;
  padding: 10px 2rem;
  display: flex;
  flex-direction: column;
`;
const BodyHeading = newStyled.div`
  color: #007db8;
  font-size: 1.1rem;
  font-weight: 500;
  width: 100%;
  border-bottom: 1px solid #bdcad2;
`;
const TabTitle = newStyled.h4`
  width: 33%;
  border-bottom: 3px solid #007db8;
  padding-top: 6px;
  padding-left: 6px;
  margin: 0px;
  font-weight: 600;
  padding-bottom: 11px;
`;
const Panel$2 = newStyled.div`
  display: flex;
  flex-direction: column;
  height: 70%;
  justify-content: space-between;
  font-size: 0.9rem;

  & > div {
    display: flex;
    flex-direction: column;
    & > label {
      font-size: 1rem;
      font-weight: 500;
      margin-bottom: 10px;
    }
    & > input[type='text'] {
      height: 45px;
      border: 2px solid #bdcad2;
    }
  }
`;
const BodyContent = newStyled.div`
  font-size: 0.8rem;
  color: #566072;
  height: auto;
`;
const BodyFooter = newStyled.div`
  text-align: right;
  height: 80px;
  padding-top: 20px;
`;
const SearchInput = newStyled.div`
  position: relative;
  & > span:nth-of-type(1) {
    position: absolute;
    top: 40px;
    left: 10px;
  }
`;
const UserChip = newStyled.div`
  background: #eeeeee;
  color: #007db8;
  height: 30px;
  border-radius: 100px;
  font-size: 0.75rem;
  text-align: center;
  padding: 0.45rem;
  margin-right: 0.3rem;
  margin-bottom: 0.3rem;

  label {
    margin-left: 5px;
  }

  span {
    cursor: pointer;
  }
`;
const SelectedList = newStyled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
`;
const SharedMessage = newStyled.section`
  display: flex;
  flex-direction: column;
  min-height: 180px;
  justify-content: space-evenly;

  span {
    margin-top: 5px;
  }

  button {
    align-self: flex-end;
  }
`;

class ShareModal extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      showFirstTab: true,
      typeAhead: [],
      selectedEmail: [],
      recentRecipientList: [],
      invalidEmails: '',
      showSharedMessage: false,
      showErrorMessage: false
    });

    _defineProperty$2(this, "showRecentRecipients", () => {
      this.setState(state => {
        return _objectSpread2({}, state);
      });
    });

    _defineProperty$2(this, "addRecipientToList", selected => {
      const selectedList = this.state.selectedEmail.concat(selected);
      this.setState(state => {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          typeAhead: [],
          selectedEmail: selectedList
        });
      });
    });

    _defineProperty$2(this, "removeRecipientFromlist", key => {
      const list = this.state.selectedEmail.filter((d, i) => i !== key);
      this.setState(state => {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          selectedEmail: list
        });
      });
    });

    _defineProperty$2(this, "share", async () => {
      const url = this.props.apiUrl ? `${this.props.apiUrl}/api/projects/share` : `/api/projects/share`;
      const payload = {
        projectId: this.props.projectId,
        ShareType: 'link',
        Name: '',
        Anonymize: false,
        EmailAddresses: this.state.selectedEmail,
        ConcierageSelected: false
      };
      const settings = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      };
      const response = await fetch(url, settings);
      const json = await response.json();

      if (response.status === 200 && json.Data.PartialErrorsList.length === 0) {
        this.setState(state => {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            showSharedMessage: true
          });
        });
      } else if (response.status === 200 && json.Data.PartialErrorsList.length > 0) {
        const invalidEmails = json.Data.PartialErrorsList.map(d => {
          return d.ObjectDisplayName;
        }).join(', ');
        this.setState(state => {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            showErrorMessage: true,
            invalidEmails: invalidEmails
          });
        });
      } else {
        this.setState(state => {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            showErrorMessage: true
          });
        });
      }
    });
  }

  render() {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(ModalBody$1, null, !this.state.showSharedMessage && !this.state.showErrorMessage && React__default.createElement(React__default.Fragment, null, React__default.createElement(BodyHeading, null, React__default.createElement(TabTitle, null, "Give access to this project")), React__default.createElement(BodyContent, null, React__default.createElement(Panel$2, null, React__default.createElement("p", null, "Changes can be overwritten by any users with access to the project."), React__default.createElement(SearchInput, null, React__default.createElement("label", null, "Select recipients"), this.props.userIsAdmin && React__default.createElement(React__default.Fragment, null, React__default.createElement(SearchIcon$1, null), React__default.createElement(ShareInputField, {
      apiUrl: this.props.apiUrl,
      projectId: this.props.projectId,
      listItemClick: this.addRecipientToList
    })), !this.props.userIsAdmin && React__default.createElement(ShareStandardInputField, {
      projectId: this.props.projectId,
      addItemClick: this.addRecipientToList
    }), this.state.selectedEmail.length > 0 && React__default.createElement(SelectedList, null, this.state.selectedEmail.map((d, i) => {
      return React__default.createElement(UserChip, {
        key: i,
        onClick: () => {
          this.removeRecipientFromlist(i);
        }
      }, d, " ", React__default.createElement(DeleteCrossIcon, null));
    }))))), React__default.createElement(BodyFooter, null, React__default.createElement(PrimaryButton, {
      clickFn: this.share,
      disabled: this.state.selectedEmail.length === 0
    }, "Share"))), this.state.showSharedMessage && React__default.createElement(SharedMessage, null, "The following users received copies of this project:", this.state.selectedEmail.map((d, i) => {
      return React__default.createElement("span", {
        key: i
      }, d);
    }), React__default.createElement(PrimaryButton, {
      clickFn: this.props.closeFn
    }, "Ok")), this.state.showErrorMessage && this.state.invalidEmails.length === 0 && React__default.createElement(SharedMessage, null, React__default.createElement("p", null, "Something has gone wrong. Please try again."), React__default.createElement("p", null, "Contact ", React__default.createElement("a", {
      href: "https://support.liveoptics.com/"
    }, "support"), " if the issue persists."), React__default.createElement(PrimaryButton, {
      clickFn: this.props.closeFn
    }, "Ok")), this.state.showErrorMessage && this.state.invalidEmails.length > 0 && React__default.createElement(SharedMessage, null, React__default.createElement("h3", null, "User not found"), React__default.createElement("p", null, "Could not share project with the following emails: ", this.state.invalidEmails, ". A project can only be shared with another user. Check the spelling of the entered email address and ensure it is a valid user."), React__default.createElement(PrimaryButton, {
      clickFn: this.props.closeFn
    }, "Ok"))));
  }

}

class ShareAction extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      showModal: false
    });

    _defineProperty$2(this, "shareIcon", React__default.createElement(ShareIcon, {
      fill: "#007db8"
    }));

    _defineProperty$2(this, "openModal", () => {
      this.setState(state => {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          showModal: true
        });
      });
    });

    _defineProperty$2(this, "closeModal", () => {
      this.setState(state => {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          showModal: false
        });
      });
    });
  }

  render() {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(ToolbarItem$1, {
      text: "Share",
      clickFn: this.openModal,
      icon: React__default.createElement(ShareIcon, {
        width: "18px"
      })
    }), this.state.showModal && React__default.createElement(Modal, {
      closeFn: this.closeModal,
      modalTitle: 'Share Project',
      modalIcon: this.shareIcon
    }, React__default.createElement(ShareModal, {
      projectId: this.props.projectId,
      closeFn: this.closeModal,
      apiUrl: this.props.apiUrl,
      userIsAdmin: this.props.userIsAdmin
    })));
  }

}

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _objectWithoutPropertiesLoose$1 = unwrapExports(objectWithoutPropertiesLoose);

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _extends$2 = unwrapExports(_extends_1);

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _assertThisInitialized$1 = unwrapExports(assertThisInitialized);

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(setPrototypeOf);

var inheritsLoose = createCommonjsModule(function (module) {
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _inheritsLoose = unwrapExports(inheritsLoose);

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x$1=b?Symbol.for("react.responder"):60118,y$1=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x$1||a.$$typeof===y$1||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
reactIs_development.AsyncMode;
reactIs_development.ConcurrentMode;
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
reactIs_development.isValidElementType;
reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$3;

var printWarning$3 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1$1;
  var loggedTypeFailures$1 = {};
  var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$3 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$3(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$3(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures$1[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$3(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1 = {};
  }
};

var checkPropTypes_1$1 = checkPropTypes$1;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull$1() {
  return null;
}

var factoryWithTypeCheckers$1 = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$2(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$2(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$2('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$2(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$2('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$2(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull$1;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction$1() {}
function emptyFunctionWithReset$1() {}
emptyFunctionWithReset$1.resetWarningCache = emptyFunction$1;

var factoryWithThrowingShims$1 = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset$1,
    resetWarningCache: emptyFunction$1
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes$1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims$1();
}
});

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now$1 = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now$1();

  function tick() {
    if (now$1() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}

var size = -1; // This utility copied from "dom-helpers" package.

function getScrollbarSize$1(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (size === -1 || recalculate) {
    var div = document.createElement('div');
    var style = div.style;
    style.width = '50px';
    style.height = '50px';
    style.overflow = 'scroll';
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }

  return size;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;

      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }

    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

var IS_SCROLLING_DEBOUNCE_INTERVAL = 150;

var defaultItemKey = function defaultItemKey(_ref) {
  var columnIndex = _ref.columnIndex;
      _ref.data;
      var rowIndex = _ref.rowIndex;
  return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsOverscanCount = null;
var devWarningsOverscanRowsColumnsCount = null;
var devWarningsTagName = null;

if (process.env.NODE_ENV !== 'production') {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsOverscanCount =
    /*#__PURE__*/
    new WeakSet();
    devWarningsOverscanRowsColumnsCount =
    /*#__PURE__*/
    new WeakSet();
    devWarningsTagName =
    /*#__PURE__*/
    new WeakSet();
  }
}

function createGridComponent(_ref2) {
  var _class, _temp;

  var getColumnOffset = _ref2.getColumnOffset,
      getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset,
      getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex,
      getColumnWidth = _ref2.getColumnWidth,
      getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight,
      getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth,
      getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment,
      getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment,
      getRowHeight = _ref2.getRowHeight,
      getRowOffset = _ref2.getRowOffset,
      getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset,
      getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex,
      initInstanceProps = _ref2.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref2.validateProps;
  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inheritsLoose$1(Grid, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function Grid(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, _assertThisInitialized(_assertThisInitialized(_this)));
      _this._resetIsScrollingTimeoutId = null;
      _this._outerRef = void 0;
      _this.state = {
        instance: _assertThisInitialized(_assertThisInitialized(_this)),
        isScrolling: false,
        horizontalScrollDirection: 'forward',
        scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
        scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
        scrollUpdateWasRequested: false,
        verticalScrollDirection: 'forward'
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoizeOne(function (overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
        return _this.props.onItemsRendered({
          overscanColumnStartIndex: overscanColumnStartIndex,
          overscanColumnStopIndex: overscanColumnStopIndex,
          overscanRowStartIndex: overscanRowStartIndex,
          overscanRowStopIndex: overscanRowStopIndex,
          visibleColumnStartIndex: visibleColumnStartIndex,
          visibleColumnStopIndex: visibleColumnStopIndex,
          visibleRowStartIndex: visibleRowStartIndex,
          visibleRowStopIndex: visibleRowStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoizeOne(function (scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          horizontalScrollDirection: horizontalScrollDirection,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          verticalScrollDirection: verticalScrollDirection,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (rowIndex, columnIndex) {
        var _this$props = _this.props,
            columnWidth = _this$props.columnWidth,
            direction = _this$props.direction,
            rowHeight = _this$props.rowHeight;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);

        var key = rowIndex + ":" + columnIndex;
        var style;

        if (itemStyleCache.hasOwnProperty(key)) {
          style = itemStyleCache[key];
        } else {
          var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);

          var isRtl = direction === 'rtl';
          itemStyleCache[key] = style = {
            position: 'absolute',
            left: isRtl ? undefined : _offset,
            right: isRtl ? _offset : undefined,
            top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
            height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
            width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoizeOne(function (_, __, ___) {
        return {};
      });

      _this._onScroll = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientHeight = _event$currentTarget.clientHeight,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollTop = _event$currentTarget.scrollTop,
            scrollHeight = _event$currentTarget.scrollHeight,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
          // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
          // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
          // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.

          var calculatedScrollLeft = scrollLeft;

          if (direction === 'rtl') {
            switch (getRTLOffsetType()) {
              case 'negative':
                calculatedScrollLeft = -scrollLeft;
                break;

              case 'positive-descending':
                calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
          var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
            scrollLeft: calculatedScrollLeft,
            scrollTop: calculatedScrollTop,
            verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1);
        });
      };

      return _this;
    }

    Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = Grid.prototype;

    _proto.scrollTo = function scrollTo(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;

      if (scrollLeft !== undefined) {
        scrollLeft = Math.max(0, scrollLeft);
      }

      if (scrollTop !== undefined) {
        scrollTop = Math.max(0, scrollTop);
      }

      this.setState(function (prevState) {
        if (scrollLeft === undefined) {
          scrollLeft = prevState.scrollLeft;
        }

        if (scrollTop === undefined) {
          scrollTop = prevState.scrollTop;
        }

        if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
          return null;
        }

        return {
          horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          scrollUpdateWasRequested: true,
          verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(_ref4) {
      var _ref4$align = _ref4.align,
          align = _ref4$align === void 0 ? 'auto' : _ref4$align,
          columnIndex = _ref4.columnIndex,
          rowIndex = _ref4.rowIndex;
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          height = _this$props2.height,
          rowCount = _this$props2.rowCount,
          width = _this$props2.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;
      var scrollbarSize = getScrollbarSize$1();

      if (columnIndex !== undefined) {
        columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
      }

      if (rowIndex !== undefined) {
        rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
      }

      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
      // to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.

      var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
      var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
      this.scrollTo({
        scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
        scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
      });
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          initialScrollLeft = _this$props3.initialScrollLeft,
          initialScrollTop = _this$props3.initialScrollTop;

      if (this._outerRef != null) {
        var outerRef = this._outerRef;

        if (typeof initialScrollLeft === 'number') {
          outerRef.scrollLeft = initialScrollLeft;
        }

        if (typeof initialScrollTop === 'number') {
          outerRef.scrollTop = initialScrollTop;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var direction = this.props.direction;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollTop = _this$state2.scrollTop,
          scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
        // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
        // So we need to determine which browser behavior we're dealing with, and mimic it.
        var outerRef = this._outerRef;

        if (direction === 'rtl') {
          switch (getRTLOffsetType()) {
            case 'negative':
              outerRef.scrollLeft = -scrollLeft;
              break;

            case 'positive-ascending':
              outerRef.scrollLeft = scrollLeft;
              break;

            default:
              var clientWidth = outerRef.clientWidth,
                  scrollWidth = outerRef.scrollWidth;
              outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
              break;
          }
        } else {
          outerRef.scrollLeft = Math.max(0, scrollLeft);
        }

        outerRef.scrollTop = Math.max(0, scrollTop);
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          columnCount = _this$props4.columnCount,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey : _this$props4$itemKey,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          rowCount = _this$props4.rowCount,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling;

      var _this$_getHorizontalR = this._getHorizontalRangeToRender(),
          columnStartIndex = _this$_getHorizontalR[0],
          columnStopIndex = _this$_getHorizontalR[1];

      var _this$_getVerticalRan = this._getVerticalRangeToRender(),
          rowStartIndex = _this$_getVerticalRan[0],
          rowStopIndex = _this$_getVerticalRan[1];

      var items = [];

      if (columnCount > 0 && rowCount) {
        for (var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++) {
          for (var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++) {
            items.push(createElement(children, {
              columnIndex: _columnIndex,
              data: itemData,
              isScrolling: useIsScrolling ? isScrolling : undefined,
              key: itemKey({
                columnIndex: _columnIndex,
                data: itemData,
                rowIndex: _rowIndex
              }),
              rowIndex: _rowIndex,
              style: this._getItemStyle(_rowIndex, _columnIndex)
            }));
          }
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
      return createElement(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: _extends$1({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, createElement(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: estimatedTotalHeight,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: estimatedTotalWidth
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      var _this$props5 = this.props,
          columnCount = _this$props5.columnCount,
          onItemsRendered = _this$props5.onItemsRendered,
          onScroll = _this$props5.onScroll,
          rowCount = _this$props5.rowCount;

      if (typeof onItemsRendered === 'function') {
        if (columnCount > 0 && rowCount > 0) {
          var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(),
              _overscanColumnStartIndex = _this$_getHorizontalR2[0],
              _overscanColumnStopIndex = _this$_getHorizontalR2[1],
              _visibleColumnStartIndex = _this$_getHorizontalR2[2],
              _visibleColumnStopIndex = _this$_getHorizontalR2[3];

          var _this$_getVerticalRan2 = this._getVerticalRangeToRender(),
              _overscanRowStartIndex = _this$_getVerticalRan2[0],
              _overscanRowStopIndex = _this$_getVerticalRan2[1],
              _visibleRowStartIndex = _this$_getVerticalRan2[2],
              _visibleRowStopIndex = _this$_getVerticalRan2[3];

          this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
        }
      }

      if (typeof onScroll === 'function') {
        var _this$state3 = this.state,
            _horizontalScrollDirection = _this$state3.horizontalScrollDirection,
            _scrollLeft = _this$state3.scrollLeft,
            _scrollTop = _this$state3.scrollTop,
            _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested,
            _verticalScrollDirection = _this$state3.verticalScrollDirection;

        this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
      }
    }; // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.


    _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
      var _this$props6 = this.props,
          columnCount = _this$props6.columnCount,
          overscanColumnCount = _this$props6.overscanColumnCount,
          overscanColumnsCount = _this$props6.overscanColumnsCount,
          overscanCount = _this$props6.overscanCount,
          rowCount = _this$props6.rowCount;
      var _this$state4 = this.state,
          horizontalScrollDirection = _this$state4.horizontalScrollDirection,
          isScrolling = _this$state4.isScrolling,
          scrollLeft = _this$state4.scrollLeft;
      var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
      var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
      var _this$props7 = this.props,
          columnCount = _this$props7.columnCount,
          overscanCount = _this$props7.overscanCount,
          overscanRowCount = _this$props7.overscanRowCount,
          overscanRowsCount = _this$props7.overscanRowsCount,
          rowCount = _this$props7.rowCount;
      var _this$state5 = this.state,
          isScrolling = _this$state5.isScrolling,
          verticalScrollDirection = _this$state5.verticalScrollDirection,
          scrollTop = _this$state5.scrollTop;
      var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
      var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return Grid;
  }(PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    useIsScrolling: false
  }, _temp;
}

var validateSharedProps = function validateSharedProps(_ref5, _ref6) {
  var children = _ref5.children,
      direction = _ref5.direction,
      height = _ref5.height,
      innerTagName = _ref5.innerTagName,
      outerTagName = _ref5.outerTagName,
      overscanColumnsCount = _ref5.overscanColumnsCount,
      overscanCount = _ref5.overscanCount,
      overscanRowsCount = _ref5.overscanRowsCount,
      width = _ref5.width;
  var instance = _ref6.instance;

  if (process.env.NODE_ENV !== 'production') {
    if (typeof overscanCount === 'number') {
      if (devWarningsOverscanCount && !devWarningsOverscanCount.has(instance)) {
        devWarningsOverscanCount.add(instance);
        console.warn('The overscanCount prop has been deprecated. ' + 'Please use the overscanColumnCount and overscanRowCount props instead.');
      }
    }

    if (typeof overscanColumnsCount === 'number' || typeof overscanRowsCount === 'number') {
      if (devWarningsOverscanRowsColumnsCount && !devWarningsOverscanRowsColumnsCount.has(instance)) {
        devWarningsOverscanRowsColumnsCount.add(instance);
        console.warn('The overscanColumnsCount and overscanRowsCount props have been deprecated. ' + 'Please use the overscanColumnCount and overscanRowCount props instead.');
      }
    }

    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName && !devWarningsTagName.has(instance)) {
        devWarningsTagName.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }

    switch (direction) {
      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    if (typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Grids must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    }

    if (typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Grids must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};

var DEFAULT_ESTIMATED_ITEM_SIZE = 50;

var getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
  var rowCount = _ref.rowCount;
  var rowMetadataMap = _ref2.rowMetadataMap,
      estimatedRowHeight = _ref2.estimatedRowHeight,
      lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredRowIndex >= rowCount) {
    lastMeasuredRowIndex = rowCount - 1;
  }

  if (lastMeasuredRowIndex >= 0) {
    var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
  var columnCount = _ref3.columnCount;
  var columnMetadataMap = _ref4.columnMetadataMap,
      estimatedColumnWidth = _ref4.estimatedColumnWidth,
      lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredColumnIndex >= columnCount) {
    lastMeasuredColumnIndex = columnCount - 1;
  }

  if (lastMeasuredColumnIndex >= 0) {
    var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
  var itemMetadataMap, itemSize, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    itemSize = props.columnWidth;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    itemSize = props.rowHeight;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    if (itemType === 'column') {
      instanceProps.lastMeasuredColumnIndex = index;
    } else {
      instanceProps.lastMeasuredRowIndex = index;
    }
  }

  return itemMetadataMap[index];
};

var findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
  var itemMetadataMap, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata(itemType, props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
  var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata(itemType, props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
  var size = itemType === 'column' ? props.width : props.height;
  var itemMetadata = getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
  // To ensure it reflects actual measurements instead of just estimates.

  var estimatedTotalSize = itemType === 'column' ? getEstimatedTotalWidth(props, instanceProps) : getEstimatedTotalHeight(props, instanceProps);
  var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
  var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);

  if (align === 'smart') {
    if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
      align = 'auto';
    } else {
      align = 'center';
    }
  }

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return Math.round(minOffset + (maxOffset - minOffset) / 2);

    case 'auto':
    default:
      if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
        return scrollOffset;
      } else if (minOffset > maxOffset) {
        // Because we only take into account the scrollbar size when calculating minOffset
        // this value can be larger than maxOffset when at the end of the list
        return minOffset;
      } else if (scrollOffset < minOffset) {
        return minOffset;
      } else {
        return maxOffset;
      }

  }
};

var VariableSizeGrid =
/*#__PURE__*/
createGridComponent({
  getColumnOffset: function getColumnOffset(props, index, instanceProps) {
    return getItemMetadata('column', props, index, instanceProps).offset;
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
    return findNearestItem('column', props, instanceProps, scrollLeft);
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
    var columnCount = props.columnCount,
        width = props.width;
    var itemMetadata = getItemMetadata('column', props, startIndex, instanceProps);
    var maxOffset = scrollLeft + width;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < columnCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('column', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  getColumnWidth: function getColumnWidth(props, index, instanceProps) {
    return instanceProps.columnMetadataMap[index].size;
  },
  getEstimatedTotalHeight: getEstimatedTotalHeight,
  getEstimatedTotalWidth: getEstimatedTotalWidth,
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getRowOffset: function getRowOffset(props, index, instanceProps) {
    return getItemMetadata('row', props, index, instanceProps).offset;
  },
  getRowHeight: function getRowHeight(props, index, instanceProps) {
    return instanceProps.rowMetadataMap[index].size;
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
    return findNearestItem('row', props, instanceProps, scrollTop);
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
    var rowCount = props.rowCount,
        height = props.height;
    var itemMetadata = getItemMetadata('row', props, startIndex, instanceProps);
    var maxOffset = scrollTop + height;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < rowCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('row', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref5 = props,
        estimatedColumnWidth = _ref5.estimatedColumnWidth,
        estimatedRowHeight = _ref5.estimatedRowHeight;
    var instanceProps = {
      columnMetadataMap: {},
      estimatedColumnWidth: estimatedColumnWidth || DEFAULT_ESTIMATED_ITEM_SIZE,
      estimatedRowHeight: estimatedRowHeight || DEFAULT_ESTIMATED_ITEM_SIZE,
      lastMeasuredColumnIndex: -1,
      lastMeasuredRowIndex: -1,
      rowMetadataMap: {}
    };

    instance.resetAfterColumnIndex = function (columnIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        columnIndex: columnIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterRowIndex = function (rowIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        rowIndex: rowIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterIndices = function (_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex,
          _ref6$shouldForceUpda = _ref6.shouldForceUpdate,
          shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;

      if (typeof columnIndex === 'number') {
        instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
      }

      if (typeof rowIndex === 'number') {
        instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
      } // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.


      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref7) {
    var columnWidth = _ref7.columnWidth,
        rowHeight = _ref7.rowHeight;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof columnWidth !== 'function') {
        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (columnWidth === null ? 'null' : typeof columnWidth) + "\" was specified."));
      } else if (typeof rowHeight !== 'function') {
        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (rowHeight === null ? 'null' : typeof rowHeight) + "\" was specified."));
      }
    }
  }
});

if (process.env.NODE_ENV !== 'production') ;

var FixedSizeGrid =
/*#__PURE__*/
createGridComponent({
  getColumnOffset: function getColumnOffset(_ref, index) {
    var columnWidth = _ref.columnWidth;
    return index * columnWidth;
  },
  getColumnWidth: function getColumnWidth(_ref2, index) {
    var columnWidth = _ref2.columnWidth;
    return columnWidth;
  },
  getRowOffset: function getRowOffset(_ref3, index) {
    var rowHeight = _ref3.rowHeight;
    return index * rowHeight;
  },
  getRowHeight: function getRowHeight(_ref4, index) {
    var rowHeight = _ref4.rowHeight;
    return rowHeight;
  },
  getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
    var rowCount = _ref5.rowCount,
        rowHeight = _ref5.rowHeight;
    return rowHeight * rowCount;
  },
  getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
    var columnCount = _ref6.columnCount,
        columnWidth = _ref6.columnWidth;
    return columnWidth * columnCount;
  },
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
    var columnCount = _ref7.columnCount,
        columnWidth = _ref7.columnWidth,
        width = _ref7.width;
    var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
    var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
    var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);

    if (align === 'smart') {
      if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(width / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) {
          return lastColumnOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollLeft >= minOffset && scrollLeft <= maxOffset) {
          return scrollLeft;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollLeft < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
    var rowHeight = _ref8.rowHeight,
        height = _ref8.height,
        rowCount = _ref8.rowCount;
    var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
    var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
    var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);

    if (align === 'smart') {
      if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(height / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastRowOffset + Math.floor(height / 2)) {
          return lastRowOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollTop >= minOffset && scrollTop <= maxOffset) {
          return scrollTop;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollTop < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
    var columnWidth = _ref9.columnWidth,
        columnCount = _ref9.columnCount;
    return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
    var columnWidth = _ref10.columnWidth,
        columnCount = _ref10.columnCount,
        width = _ref10.width;
    var left = startIndex * columnWidth;
    var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
    return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
    ));
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
    var rowHeight = _ref11.rowHeight,
        rowCount = _ref11.rowCount;
    return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
    var rowHeight = _ref12.rowHeight,
        rowCount = _ref12.rowCount,
        height = _ref12.height;
    var top = startIndex * rowHeight;
    var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
    return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref13) {
    var columnWidth = _ref13.columnWidth,
        rowHeight = _ref13.rowHeight;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof columnWidth !== 'number') {
        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (columnWidth === null ? 'null' : typeof columnWidth) + "\" was specified."));
      }

      if (typeof rowHeight !== 'number') {
        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (rowHeight === null ? 'null' : typeof rowHeight) + "\" was specified."));
      }
    }
  }
});

var TableHeader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(TableHeader, _React$PureComponent);

  function TableHeader(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.renderHeaderRow = _this.renderHeaderRow.bind(_assertThisInitialized$1(_this));
    _this.renderFrozenRow = _this.renderFrozenRow.bind(_assertThisInitialized$1(_this));
    _this._setRef = _this._setRef.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  var _proto = TableHeader.prototype;

  _proto.scrollTo = function scrollTo(offset) {
    if (this.headerRef) this.headerRef.scrollLeft = offset;
  };

  _proto.renderHeaderRow = function renderHeaderRow(height, index) {
    var _this$props = this.props,
        columns = _this$props.columns,
        headerRenderer = _this$props.headerRenderer;
    if (height <= 0) return null;
    var style = {
      width: '100%',
      height: height
    };
    return headerRenderer({
      style: style,
      columns: columns,
      headerIndex: index
    });
  };

  _proto.renderFrozenRow = function renderFrozenRow(rowData, index) {
    var _this$props2 = this.props,
        columns = _this$props2.columns,
        rowHeight = _this$props2.rowHeight,
        rowRenderer = _this$props2.rowRenderer;
    var style = {
      width: '100%',
      height: rowHeight
    }; // for frozen row the `rowIndex` is negative

    var rowIndex = -index - 1;
    return rowRenderer({
      style: style,
      columns: columns,
      rowData: rowData,
      rowIndex: rowIndex
    });
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        className = _this$props3.className,
        width = _this$props3.width,
        height = _this$props3.height,
        rowWidth = _this$props3.rowWidth,
        headerHeight = _this$props3.headerHeight,
        frozenData = _this$props3.frozenData;
    if (height <= 0) return null;
    var style = {
      width: width,
      height: height,
      position: 'relative',
      overflow: 'hidden'
    };
    var innerStyle = {
      width: rowWidth,
      height: height
    };
    var rowHeights = Array.isArray(headerHeight) ? headerHeight : [headerHeight];
    return React__default.createElement("div", {
      role: "grid",
      ref: this._setRef,
      className: className,
      style: style
    }, React__default.createElement("div", {
      role: "rowgroup",
      style: innerStyle
    }, rowHeights.map(this.renderHeaderRow), frozenData.map(this.renderFrozenRow)));
  };

  _proto._setRef = function _setRef(ref) {
    this.headerRef = ref;
  };

  return TableHeader;
}(React__default.PureComponent);

TableHeader.propTypes = {
  className: propTypes$1.string,
  width: propTypes$1.number.isRequired,
  height: propTypes$1.number.isRequired,
  headerHeight: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.arrayOf(propTypes$1.number)]).isRequired,
  rowWidth: propTypes$1.number.isRequired,
  rowHeight: propTypes$1.number.isRequired,
  columns: propTypes$1.arrayOf(propTypes$1.object).isRequired,
  data: propTypes$1.array.isRequired,
  frozenData: propTypes$1.array,
  headerRenderer: propTypes$1.func.isRequired,
  rowRenderer: propTypes$1.func.isRequired
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function renderElement(renderer, props) {
  if (React__default.isValidElement(renderer)) {
    if (!props) return renderer;
    return React__default.cloneElement(renderer, props);
  } else if (typeof renderer === 'function') {
    if (renderer.prototype && renderer.prototype.isReactComponent) {
      return React__default.createElement(renderer, props);
    } else if (renderer.defaultProps) {
      return renderer(_objectSpread$7({}, renderer.defaultProps, {}, props));
    }

    return renderer(props);
  } else {
    return null;
  }
}
function normalizeColumns(elements) {
  var columns = [];
  React__default.Children.forEach(elements, function (element) {
    if (React__default.isValidElement(element) && element.key) {
      var column = _objectSpread$7({}, element.props, {
        key: element.key
      });

      columns.push(column);
    }
  });
  return columns;
}
function isObjectEqual(objA, objB, ignoreFunction) {
  if (ignoreFunction === void 0) {
    ignoreFunction = true;
  }

  if (objA === objB) return true;
  if (objA === null && objB === null) return true;
  if (objA === null || objB === null) return false;
  if (typeof objA !== 'object' || typeof objB !== 'object') return false;
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    var key = keysA[i];

    if (key === '_owner' && objA.$$typeof) {
      // React-specific: avoid traversing React elements' _owner.
      //  _owner contains circular references
      // and is not needed when comparing the actual elements (and not their owners)
      continue;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    var valueAType = typeof valueA;
    if (valueAType !== typeof valueB) return false;
    if (valueAType === 'function' && ignoreFunction) continue;

    if (valueAType === 'object') {
      if (!isObjectEqual(valueA, valueB, ignoreFunction)) return false;else continue;
    }

    if (valueA !== valueB) return false;
  }

  return true;
}
function callOrReturn(funcOrValue) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return typeof funcOrValue === 'function' ? funcOrValue.apply(void 0, args) : funcOrValue;
}
function hasChildren(data) {
  return Array.isArray(data.children) && data.children.length > 0;
}
function flattenOnKeys(tree, keys, depthMap, dataKey) {
  if (depthMap === void 0) {
    depthMap = {};
  }

  if (dataKey === void 0) {
    dataKey = 'id';
  }

  if (!keys || !keys.length) return tree;
  var array = [];
  var keysSet = new Set();
  keys.forEach(function (x) {
    return keysSet.add(x);
  });
  var stack = [].concat(tree);
  stack.forEach(function (x) {
    return depthMap[x[dataKey]] = 0;
  });

  var _loop = function _loop() {
    var item = stack.shift();
    array.push(item);

    if (keysSet.has(item[dataKey]) && Array.isArray(item.children) && item.children.length > 0) {
      stack = [].concat(item.children, stack);
      item.children.forEach(function (x) {
        return depthMap[x[dataKey]] = depthMap[item[dataKey]] + 1;
      });
    }
  };

  while (stack.length > 0) {
    _loop();
  }

  return array;
} // Babel7 changed the behavior of @babel/plugin-transform-spread in https://github.com/babel/babel/pull/6763
// [...array] is transpiled to array.concat() while it was [].concat(array) before
// this change breaks immutable array(seamless-immutable), [...array] should always return mutable array

function cloneArray(array) {
  if (!Array.isArray(array)) return [];
  return [].concat(array);
}
function noop$2() {}
function toString(value) {
  if (typeof value === 'string') return value;
  if (value === null || value === undefined) return '';
  return value.toString ? value.toString() : '';
}

function getPathSegments(path) {
  var pathArray = path.split('.');
  var parts = [];

  for (var i = 0; i < pathArray.length; i++) {
    var p = pathArray[i];

    while (p[p.length - 1] === '\\' && pathArray[i + 1] !== undefined) {
      p = p.slice(0, -1) + '.';
      p += pathArray[++i];
    }

    parts.push(p);
  }

  return parts;
} // changed from https://github.com/sindresorhus/dot-prop/blob/master/index.js


function getValue(object, path, defaultValue) {
  if (object === null || typeof object !== 'object' || typeof path !== 'string') {
    return defaultValue;
  }

  var pathArray = getPathSegments(path);

  for (var i = 0; i < pathArray.length; i++) {
    if (!Object.prototype.propertyIsEnumerable.call(object, pathArray[i])) {
      return defaultValue;
    }

    object = object[pathArray[i]];

    if (object === undefined || object === null) {
      if (i !== pathArray.length - 1) {
        return defaultValue;
      }

      break;
    }
  }

  return object;
} // copied from https://www.30secondsofcode.org/js/s/debounce

var debounce = function debounce(fn, ms) {
  if (ms === void 0) {
    ms = 0;
  }

  var timeoutId;
  return function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return fn.apply(_this, args);
    }, ms);
  };
}; // copied from https://www.30secondsofcode.org/js/s/throttle

var throttle = function throttle(fn, wait) {
  var inThrottle, lastFn, lastTime;
  return function () {
    var context = this,
        args = arguments;

    if (!inThrottle) {
      fn.apply(context, args);
      lastTime = Date.now();
      inThrottle = true;
    } else {
      clearTimeout(lastFn);
      lastFn = setTimeout(function () {
        if (Date.now() - lastTime >= wait) {
          fn.apply(context, args);
          lastTime = Date.now();
        }
      }, Math.max(wait - (Date.now() - lastTime), 0));
    }
  };
}; // copied from https://github.com/react-bootstrap/dom-helpers

var scrollbarSize;
function getScrollbarSize(recalculate) {
  if (!scrollbarSize && scrollbarSize !== 0 || recalculate) {
    if (typeof window !== 'undefined' && window.document && window.document.createElement) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return scrollbarSize;
}
function addClassName(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)" + className + "(?!\\S)"))) {
      el.className += " " + className;
    }
  }
}
function removeClassName(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)" + className + "(?!\\S)", 'g'), '');
  }
}
function getEstimatedTotalRowsHeight(data, estimatedRowHeight) {
  return typeof estimatedRowHeight === 'function' ? data.reduce(function (height, rowData, rowIndex) {
    return height + estimatedRowHeight({
      rowData: rowData,
      rowIndex: rowIndex
    });
  }, 0) : data.length * estimatedRowHeight;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * A wrapper of the Grid for internal only
 */

var GridTable =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(GridTable, _React$PureComponent);

  function GridTable(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this._setHeaderRef = _this._setHeaderRef.bind(_assertThisInitialized$1(_this));
    _this._setBodyRef = _this._setBodyRef.bind(_assertThisInitialized$1(_this));
    _this._setInnerRef = _this._setInnerRef.bind(_assertThisInitialized$1(_this));
    _this._itemKey = _this._itemKey.bind(_assertThisInitialized$1(_this));
    _this._getBodyWidth = _this._getBodyWidth.bind(_assertThisInitialized$1(_this));
    _this._handleItemsRendered = _this._handleItemsRendered.bind(_assertThisInitialized$1(_this));
    _this._resetColumnWidthCache = memoizeOne(function (bodyWidth) {
      if (!_this.props.estimatedRowHeight) return;
      _this.bodyRef && _this.bodyRef.resetAfterColumnIndex(0, false);
    });
    _this._getEstimatedTotalRowsHeight = memoizeOne(getEstimatedTotalRowsHeight);
    _this.renderRow = _this.renderRow.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  var _proto = GridTable.prototype;

  _proto.resetAfterRowIndex = function resetAfterRowIndex(rowIndex, shouldForceUpdate) {
    if (rowIndex === void 0) {
      rowIndex = 0;
    }

    if (!this.props.estimatedRowHeight) return;
    this.bodyRef && this.bodyRef.resetAfterRowIndex(rowIndex, shouldForceUpdate);
  };

  _proto.forceUpdateTable = function forceUpdateTable() {
    this.headerRef && this.headerRef.forceUpdate();
    this.bodyRef && this.bodyRef.forceUpdate();
  };

  _proto.scrollToPosition = function scrollToPosition(args) {
    this.headerRef && this.headerRef.scrollTo(args.scrollLeft);
    this.bodyRef && this.bodyRef.scrollTo(args);
  };

  _proto.scrollToTop = function scrollToTop(scrollTop) {
    this.bodyRef && this.bodyRef.scrollTo({
      scrollTop: scrollTop
    });
  };

  _proto.scrollToLeft = function scrollToLeft(scrollLeft) {
    this.headerRef && this.headerRef.scrollTo(scrollLeft);
    this.bodyRef && this.bodyRef.scrollToPosition({
      scrollLeft: scrollLeft
    });
  };

  _proto.scrollToRow = function scrollToRow(rowIndex, align) {
    if (rowIndex === void 0) {
      rowIndex = 0;
    }

    if (align === void 0) {
      align = 'auto';
    }

    this.bodyRef && this.bodyRef.scrollToItem({
      rowIndex: rowIndex,
      align: align
    });
  };

  _proto.getTotalRowsHeight = function getTotalRowsHeight() {
    var _this$props = this.props,
        data = _this$props.data,
        rowHeight = _this$props.rowHeight,
        estimatedRowHeight = _this$props.estimatedRowHeight;

    if (estimatedRowHeight) {
      return this.innerRef && this.innerRef.clientHeight || this._getEstimatedTotalRowsHeight(data, estimatedRowHeight);
    }

    return data.length * rowHeight;
  };

  _proto.renderRow = function renderRow(args) {
    var _this$props2 = this.props,
        data = _this$props2.data,
        columns = _this$props2.columns,
        rowRenderer = _this$props2.rowRenderer;
    var rowData = data[args.rowIndex];
    return rowRenderer(_objectSpread$6({}, args, {
      columns: columns,
      rowData: rowData
    }));
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        containerStyle = _this$props3.containerStyle,
        classPrefix = _this$props3.classPrefix,
        className = _this$props3.className,
        data = _this$props3.data,
        frozenData = _this$props3.frozenData,
        width = _this$props3.width,
        height = _this$props3.height,
        rowHeight = _this$props3.rowHeight,
        estimatedRowHeight = _this$props3.estimatedRowHeight,
        getRowHeight = _this$props3.getRowHeight,
        headerWidth = _this$props3.headerWidth,
        bodyWidth = _this$props3.bodyWidth,
        useIsScrolling = _this$props3.useIsScrolling,
        onScroll = _this$props3.onScroll,
        hoveredRowKey = _this$props3.hoveredRowKey,
        overscanRowCount = _this$props3.overscanRowCount;
        _this$props3.style;
        _this$props3.onScrollbarPresenceChange;
        var rest = _objectWithoutPropertiesLoose$1(_this$props3, ["containerStyle", "classPrefix", "className", "data", "frozenData", "width", "height", "rowHeight", "estimatedRowHeight", "getRowHeight", "headerWidth", "bodyWidth", "useIsScrolling", "onScroll", "hoveredRowKey", "overscanRowCount", "style", "onScrollbarPresenceChange"]);

    var headerHeight = this._getHeaderHeight();

    var frozenRowCount = frozenData.length;
    var frozenRowsHeight = rowHeight * frozenRowCount;
    var cls = classnames(classPrefix + "__table", className);
    var containerProps = containerStyle ? {
      style: containerStyle
    } : null;
    var Grid = estimatedRowHeight ? VariableSizeGrid : FixedSizeGrid;

    this._resetColumnWidthCache(bodyWidth);

    return React__default.createElement("div", _extends$2({
      role: "table",
      className: cls
    }, containerProps), React__default.createElement(Grid, _extends$2({}, rest, {
      className: classPrefix + "__body",
      ref: this._setBodyRef,
      innerRef: this._setInnerRef,
      itemKey: this._itemKey,
      data: data,
      frozenData: frozenData,
      width: width,
      height: Math.max(height - headerHeight - frozenRowsHeight, 0),
      rowHeight: estimatedRowHeight ? getRowHeight : rowHeight,
      estimatedRowHeight: typeof estimatedRowHeight === 'function' ? undefined : estimatedRowHeight,
      rowCount: data.length,
      overscanRowCount: overscanRowCount,
      columnWidth: estimatedRowHeight ? this._getBodyWidth : bodyWidth,
      columnCount: 1,
      overscanColumnCount: 0,
      useIsScrolling: useIsScrolling,
      hoveredRowKey: hoveredRowKey,
      onScroll: onScroll,
      onItemsRendered: this._handleItemsRendered,
      children: this.renderRow
    })), headerHeight + frozenRowsHeight > 0 && // put header after body and reverse the display order via css
    // to prevent header's shadow being covered by body
    React__default.createElement(TableHeader, _extends$2({}, rest, {
      className: classPrefix + "__header",
      ref: this._setHeaderRef,
      data: data,
      frozenData: frozenData,
      width: width,
      height: Math.min(headerHeight + frozenRowsHeight, height),
      rowWidth: headerWidth,
      rowHeight: rowHeight,
      headerHeight: this.props.headerHeight,
      headerRenderer: this.props.headerRenderer,
      rowRenderer: this.props.rowRenderer,
      hoveredRowKey: frozenRowCount > 0 ? hoveredRowKey : null
    })));
  };

  _proto._setHeaderRef = function _setHeaderRef(ref) {
    this.headerRef = ref;
  };

  _proto._setBodyRef = function _setBodyRef(ref) {
    this.bodyRef = ref;
  };

  _proto._setInnerRef = function _setInnerRef(ref) {
    this.innerRef = ref;
  };

  _proto._itemKey = function _itemKey(_ref) {
    var rowIndex = _ref.rowIndex;
    var _this$props4 = this.props,
        data = _this$props4.data,
        rowKey = _this$props4.rowKey;
    return data[rowIndex][rowKey];
  };

  _proto._getHeaderHeight = function _getHeaderHeight() {
    var headerHeight = this.props.headerHeight;

    if (Array.isArray(headerHeight)) {
      return headerHeight.reduce(function (sum, height) {
        return sum + height;
      }, 0);
    }

    return headerHeight;
  };

  _proto._getBodyWidth = function _getBodyWidth() {
    return this.props.bodyWidth;
  };

  _proto._handleItemsRendered = function _handleItemsRendered(_ref2) {
    var overscanRowStartIndex = _ref2.overscanRowStartIndex,
        overscanRowStopIndex = _ref2.overscanRowStopIndex,
        visibleRowStartIndex = _ref2.visibleRowStartIndex,
        visibleRowStopIndex = _ref2.visibleRowStopIndex;
    this.props.onRowsRendered({
      overscanStartIndex: overscanRowStartIndex,
      overscanStopIndex: overscanRowStopIndex,
      startIndex: visibleRowStartIndex,
      stopIndex: visibleRowStopIndex
    });
  };

  return GridTable;
}(React__default.PureComponent);

GridTable.propTypes = {
  containerStyle: propTypes$1.object,
  classPrefix: propTypes$1.string,
  className: propTypes$1.string,
  width: propTypes$1.number.isRequired,
  height: propTypes$1.number.isRequired,
  headerHeight: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.arrayOf(propTypes$1.number)]).isRequired,
  headerWidth: propTypes$1.number.isRequired,
  bodyWidth: propTypes$1.number.isRequired,
  rowHeight: propTypes$1.number.isRequired,
  estimatedRowHeight: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.number]),
  getRowHeight: propTypes$1.func,
  columns: propTypes$1.arrayOf(propTypes$1.object).isRequired,
  data: propTypes$1.array.isRequired,
  frozenData: propTypes$1.array,
  rowKey: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,
  useIsScrolling: propTypes$1.bool,
  overscanRowCount: propTypes$1.number,
  hoveredRowKey: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]),
  style: propTypes$1.object,
  onScrollbarPresenceChange: propTypes$1.func,
  onScroll: propTypes$1.func,
  onRowsRendered: propTypes$1.func,
  headerRenderer: propTypes$1.func.isRequired,
  rowRenderer: propTypes$1.func.isRequired
};

/**
 * HeaderRow component for BaseTable
 */

var TableHeaderRow = function TableHeaderRow(_ref) {
  var className = _ref.className,
      style = _ref.style,
      columns = _ref.columns,
      headerIndex = _ref.headerIndex,
      cellRenderer = _ref.cellRenderer,
      headerRenderer = _ref.headerRenderer,
      expandColumnKey = _ref.expandColumnKey,
      ExpandIcon = _ref.expandIcon,
      Tag = _ref.tagName,
      rest = _objectWithoutPropertiesLoose$1(_ref, ["className", "style", "columns", "headerIndex", "cellRenderer", "headerRenderer", "expandColumnKey", "expandIcon", "tagName"]);

  var cells = columns.map(function (column, columnIndex) {
    return cellRenderer({
      columns: columns,
      column: column,
      columnIndex: columnIndex,
      headerIndex: headerIndex,
      expandIcon: column.key === expandColumnKey && React__default.createElement(ExpandIcon, null)
    });
  });

  if (headerRenderer) {
    cells = renderElement(headerRenderer, {
      cells: cells,
      columns: columns,
      headerIndex: headerIndex
    });
  }

  return React__default.createElement(Tag, _extends$2({}, rest, {
    className: className,
    style: style
  }), cells);
};

TableHeaderRow.defaultProps = {
  tagName: 'div'
};
TableHeaderRow.propTypes = {
  isScrolling: propTypes$1.bool,
  className: propTypes$1.string,
  style: propTypes$1.object,
  columns: propTypes$1.arrayOf(propTypes$1.object).isRequired,
  headerIndex: propTypes$1.number,
  cellRenderer: propTypes$1.func,
  headerRenderer: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element]),
  expandColumnKey: propTypes$1.string,
  expandIcon: propTypes$1.func,
  tagName: propTypes$1.elementType
};

/**
 * Row component for BaseTable
 */

var TableRow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(TableRow, _React$PureComponent);

  function TableRow(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      measured: false
    };
    _this._setRef = _this._setRef.bind(_assertThisInitialized$1(_this));
    _this._handleExpand = _this._handleExpand.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  var _proto = TableRow.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.estimatedRowHeight && this.props.rowIndex >= 0 && this._measureHeight(true);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;

    if (this.props.estimatedRowHeight && this.props.rowIndex >= 0 && // should not re-measure if it's updated after measured and reset
    !this.props.getIsResetting() && this.state.measured && prevState.measured) {
      this.setState({
        measured: false
      }, function () {
        return _this2._measureHeight();
      });
    }
  };

  _proto.render = function render() {
    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        isScrolling = _this$props.isScrolling,
        className = _this$props.className,
        style = _this$props.style,
        columns = _this$props.columns,
        rowIndex = _this$props.rowIndex,
        rowData = _this$props.rowData,
        expandColumnKey = _this$props.expandColumnKey,
        depth = _this$props.depth,
        rowEventHandlers = _this$props.rowEventHandlers,
        estimatedRowHeight = _this$props.estimatedRowHeight,
        rowRenderer = _this$props.rowRenderer,
        cellRenderer = _this$props.cellRenderer,
        expandIconRenderer = _this$props.expandIconRenderer,
        Tag = _this$props.tagName;
        _this$props.rowKey;
        _this$props.getIsResetting;
        _this$props.onRowHover;
        _this$props.onRowExpand;
        _this$props.onRowHeightChange;
        var rest = _objectWithoutPropertiesLoose$1(_this$props, ["isScrolling", "className", "style", "columns", "rowIndex", "rowData", "expandColumnKey", "depth", "rowEventHandlers", "estimatedRowHeight", "rowRenderer", "cellRenderer", "expandIconRenderer", "tagName", "rowKey", "getIsResetting", "onRowHover", "onRowExpand", "onRowHeightChange"]);
    /* eslint-enable no-unused-vars */


    var expandIcon = expandIconRenderer({
      rowData: rowData,
      rowIndex: rowIndex,
      depth: depth,
      onExpand: this._handleExpand
    });
    var cells = columns.map(function (column, columnIndex) {
      return cellRenderer({
        isScrolling: isScrolling,
        columns: columns,
        column: column,
        columnIndex: columnIndex,
        rowData: rowData,
        rowIndex: rowIndex,
        expandIcon: column.key === expandColumnKey && expandIcon
      });
    });

    if (rowRenderer) {
      cells = renderElement(rowRenderer, {
        isScrolling: isScrolling,
        cells: cells,
        columns: columns,
        rowData: rowData,
        rowIndex: rowIndex,
        depth: depth
      });
    }

    var eventHandlers = this._getEventHandlers(rowEventHandlers);

    if (estimatedRowHeight && rowIndex >= 0) {
      style.height;
          var otherStyles = _objectWithoutPropertiesLoose$1(style, ["height"]);

      return React__default.createElement(Tag, _extends$2({}, rest, {
        ref: this._setRef,
        className: className,
        style: this.state.measured ? style : otherStyles
      }, this.state.measured && eventHandlers), cells);
    }

    return React__default.createElement(Tag, _extends$2({}, rest, {
      className: className,
      style: style
    }, eventHandlers), cells);
  };

  _proto._setRef = function _setRef(ref) {
    this.ref = ref;
  };

  _proto._handleExpand = function _handleExpand(expanded) {
    var _this$props2 = this.props,
        onRowExpand = _this$props2.onRowExpand,
        rowData = _this$props2.rowData,
        rowIndex = _this$props2.rowIndex,
        rowKey = _this$props2.rowKey;
    onRowExpand && onRowExpand({
      expanded: expanded,
      rowData: rowData,
      rowIndex: rowIndex,
      rowKey: rowKey
    });
  };

  _proto._measureHeight = function _measureHeight(initialMeasure) {
    if (!this.ref) return;
    var _this$props3 = this.props,
        style = _this$props3.style,
        rowKey = _this$props3.rowKey,
        onRowHeightChange = _this$props3.onRowHeightChange,
        rowIndex = _this$props3.rowIndex,
        columns = _this$props3.columns;
    var height = this.ref.getBoundingClientRect().height;
    this.setState({
      measured: true
    }, function () {
      if (initialMeasure || height !== style.height) onRowHeightChange(rowKey, height, rowIndex, columns[0] && !columns[0].__placeholder__ && columns[0].frozen);
    });
  };

  _proto._getEventHandlers = function _getEventHandlers(handlers) {
    if (handlers === void 0) {
      handlers = {};
    }

    var _this$props4 = this.props,
        rowData = _this$props4.rowData,
        rowIndex = _this$props4.rowIndex,
        rowKey = _this$props4.rowKey,
        onRowHover = _this$props4.onRowHover;
    var eventHandlers = {};
    Object.keys(handlers).forEach(function (eventKey) {
      var callback = handlers[eventKey];

      if (typeof callback === 'function') {
        eventHandlers[eventKey] = function (event) {
          callback({
            rowData: rowData,
            rowIndex: rowIndex,
            rowKey: rowKey,
            event: event
          });
        };
      }
    });

    if (onRowHover) {
      var mouseEnterHandler = eventHandlers['onMouseEnter'];

      eventHandlers['onMouseEnter'] = function (event) {
        onRowHover({
          hovered: true,
          rowData: rowData,
          rowIndex: rowIndex,
          rowKey: rowKey,
          event: event
        });
        mouseEnterHandler && mouseEnterHandler(event);
      };

      var mouseLeaveHandler = eventHandlers['onMouseLeave'];

      eventHandlers['onMouseLeave'] = function (event) {
        onRowHover({
          hovered: false,
          rowData: rowData,
          rowIndex: rowIndex,
          rowKey: rowKey,
          event: event
        });
        mouseLeaveHandler && mouseLeaveHandler(event);
      };
    }

    return eventHandlers;
  };

  return TableRow;
}(React__default.PureComponent);

TableRow.defaultProps = {
  tagName: 'div'
};
TableRow.propTypes = {
  isScrolling: propTypes$1.bool,
  className: propTypes$1.string,
  style: propTypes$1.object,
  columns: propTypes$1.arrayOf(propTypes$1.object).isRequired,
  rowData: propTypes$1.object.isRequired,
  rowIndex: propTypes$1.number.isRequired,
  rowKey: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]),
  expandColumnKey: propTypes$1.string,
  depth: propTypes$1.number,
  rowEventHandlers: propTypes$1.object,
  rowRenderer: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element]),
  cellRenderer: propTypes$1.func,
  expandIconRenderer: propTypes$1.func,
  estimatedRowHeight: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.func]),
  getIsResetting: propTypes$1.func,
  onRowHover: propTypes$1.func,
  onRowExpand: propTypes$1.func,
  onRowHeightChange: propTypes$1.func,
  tagName: propTypes$1.elementType
};

/**
 * HeaderCell component for BaseTable
 */

var TableHeaderCell = function TableHeaderCell(_ref) {
  var className = _ref.className,
      column = _ref.column;
      _ref.columnIndex;
  return React__default.createElement("div", {
    className: className
  }, column.title);
};

TableHeaderCell.propTypes = {
  className: propTypes$1.string,
  column: propTypes$1.object,
  columnIndex: propTypes$1.number
};

/**
 * Cell component for BaseTable
 */

var TableCell = function TableCell(_ref) {
  var className = _ref.className,
      cellData = _ref.cellData;
      _ref.column;
      _ref.columnIndex;
      _ref.rowData;
      _ref.rowIndex;
  return React__default.createElement("div", {
    className: className
  }, React__default.isValidElement(cellData) ? cellData : toString(cellData));
};

TableCell.propTypes = {
  className: propTypes$1.string,
  cellData: propTypes$1.any,
  column: propTypes$1.object,
  columnIndex: propTypes$1.number,
  rowData: propTypes$1.object,
  rowIndex: propTypes$1.number
};

var Alignment = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
var FrozenDirection = {
  LEFT: 'left',
  RIGHT: 'right',
  DEFAULT: true,
  NONE: false
};
/**
 * Column for BaseTable
 */

var Column =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Column, _React$Component);

  function Column() {
    return _React$Component.apply(this, arguments) || this;
  }

  return Column;
}(React__default.Component);

Column.propTypes = {
  /**
   * Class name for the column cell, could be a callback to return the class name
   * The callback is of the shape of `({ cellData, columns, column, columnIndex, rowData, rowIndex }) => string`
   */
  className: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),

  /**
   * Class name for the column header, could be a callback to return the class name
   * The callback is of the shape of `({ columns, column, columnIndex, headerIndex }) => string`
   */
  headerClassName: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),

  /**
   * Custom style for the column cell, including the header cells
   */
  style: propTypes$1.object,

  /**
   * Title for the column header
   */
  title: propTypes$1.string,

  /**
   * Data key for the column cell, could be "a.b.c"
   */
  dataKey: propTypes$1.string,

  /**
   * Custom cell data getter
   * The handler is of the shape of `({ columns, column, columnIndex, rowData, rowIndex }) => node`
   */
  dataGetter: propTypes$1.func,

  /**
   * Alignment of the column cell
   */
  align: propTypes$1.oneOf(['left', 'center', 'right']),

  /**
   * Flex grow style, defaults to 0
   */
  flexGrow: propTypes$1.number,

  /**
   * Flex shrink style, defaults to 1 for flexible table and 0 for fixed table
   */
  flexShrink: propTypes$1.number,

  /**
   * The width of the column, gutter width is not included
   */
  width: propTypes$1.number.isRequired,

  /**
   * Maximum width of the column, used if the column is resizable
   */
  maxWidth: propTypes$1.number,

  /**
   * Minimum width of the column, used if the column is resizable
   */
  minWidth: propTypes$1.number,

  /**
   * Whether the column is frozen and what's the frozen side
   */
  frozen: propTypes$1.oneOf(['left', 'right', true, false]),

  /**
   * Whether the column is hidden
   */
  hidden: propTypes$1.bool,

  /**
   * Whether the column is resizable, defaults to false
   */
  resizable: propTypes$1.bool,

  /**
   * Whether the column is sortable, defaults to false
   */
  sortable: propTypes$1.bool,

  /**
   * Custom column cell renderer
   * The renderer receives props `{ cellData, columns, column, columnIndex, rowData, rowIndex, container, isScrolling }`
   */
  cellRenderer: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element]),

  /**
   * Custom column header renderer
   * The renderer receives props `{ columns, column, columnIndex, headerIndex, container }`
   */
  headerRenderer: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element])
};
Column.Alignment = Alignment;
Column.FrozenDirection = FrozenDirection;

/**
 * Sort order for BaseTable
 */
var SortOrder$1 = {
  /**
   * Sort data in ascending order
   */
  ASC: 'asc',

  /**
   * Sort data in descending order
   */
  DESC: 'desc'
};

/**
 * default ExpandIcon for BaseTable
 */

var ExpandIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ExpandIcon, _React$PureComponent);

  function ExpandIcon(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this._handleClick = _this._handleClick.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  var _proto = ExpandIcon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        expandable = _this$props.expandable,
        expanded = _this$props.expanded,
        indentSize = _this$props.indentSize,
        depth = _this$props.depth,
        onExpand = _this$props.onExpand,
        rest = _objectWithoutPropertiesLoose$1(_this$props, ["expandable", "expanded", "indentSize", "depth", "onExpand"]);

    if (!expandable && indentSize === 0) return null;
    var cls = classnames('BaseTable__expand-icon', {
      'BaseTable__expand-icon--expanded': expanded
    });
    return React__default.createElement("div", _extends$2({}, rest, {
      className: cls,
      onClick: expandable && onExpand ? this._handleClick : null,
      style: {
        fontFamily: 'initial',
        cursor: 'pointer',
        userSelect: 'none',
        width: '16px',
        minWidth: '16px',
        height: '16px',
        lineHeight: '16px',
        fontSize: '16px',
        textAlign: 'center',
        transition: 'transform 0.15s ease-out',
        transform: "rotate(" + (expandable && expanded ? 90 : 0) + "deg)",
        marginLeft: depth * indentSize
      }
    }), expandable && "\u25B8");
  };

  _proto._handleClick = function _handleClick(e) {
    e.stopPropagation();
    e.preventDefault();
    var _this$props2 = this.props,
        onExpand = _this$props2.onExpand,
        expanded = _this$props2.expanded;
    onExpand(!expanded);
  };

  return ExpandIcon;
}(React__default.PureComponent);

ExpandIcon.defaultProps = {
  depth: 0,
  indentSize: 16
};
ExpandIcon.propTypes = {
  expandable: propTypes$1.bool,
  expanded: propTypes$1.bool,
  indentSize: propTypes$1.number,
  depth: propTypes$1.number,
  onExpand: propTypes$1.func
};

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * default SortIndicator for BaseTable
 */

var SortIndicator = function SortIndicator(_ref) {
  var sortOrder = _ref.sortOrder,
      className = _ref.className,
      style = _ref.style;
  var cls = classnames('BaseTable__sort-indicator', className, {
    'BaseTable__sort-indicator--descending': sortOrder === SortOrder$1.DESC
  });
  return React__default.createElement("div", {
    className: cls,
    style: _objectSpread$5({
      userSelect: 'none',
      width: '16px',
      height: '16px',
      lineHeight: '16px',
      textAlign: 'center'
    }, style)
  }, sortOrder === SortOrder$1.DESC ? "\u2193" : "\u2191");
};

SortIndicator.propTypes = {
  sortOrder: propTypes$1.oneOf([SortOrder$1.ASC, SortOrder$1.DESC]),
  className: propTypes$1.string,
  style: propTypes$1.object
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var INVALID_VALUE = null; // copied from https://github.com/mzabriskie/react-draggable/blob/master/lib/utils/domFns.js

function addUserSelectStyles(doc) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');

  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }

  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}
function removeUserSelectStyles(doc) {
  if (!doc) return;

  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');

    if (doc.selection) {
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      var selection = (doc.defaultView || window).getSelection();

      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {// probably IE
  }
}
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
};
var dragEventFor = eventsFor.mouse;
/**
 * ColumnResizer for BaseTable
 */

var ColumnResizer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ColumnResizer, _React$PureComponent);

  function ColumnResizer(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.isDragging = false;
    _this.lastX = INVALID_VALUE;
    _this.width = 0;
    _this._setHandleRef = _this._setHandleRef.bind(_assertThisInitialized$1(_this));
    _this._handleClick = _this._handleClick.bind(_assertThisInitialized$1(_this));
    _this._handleMouseDown = _this._handleMouseDown.bind(_assertThisInitialized$1(_this));
    _this._handleMouseUp = _this._handleMouseUp.bind(_assertThisInitialized$1(_this));
    _this._handleTouchStart = _this._handleTouchStart.bind(_assertThisInitialized$1(_this));
    _this._handleTouchEnd = _this._handleTouchEnd.bind(_assertThisInitialized$1(_this));
    _this._handleDragStart = _this._handleDragStart.bind(_assertThisInitialized$1(_this));
    _this._handleDragStop = _this._handleDragStop.bind(_assertThisInitialized$1(_this));
    _this._handleDrag = _this._handleDrag.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  var _proto = ColumnResizer.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.handleRef) {
      var ownerDocument = this.handleRef.ownerDocument;
      ownerDocument.removeEventListener(eventsFor.mouse.move, this._handleDrag);
      ownerDocument.removeEventListener(eventsFor.mouse.stop, this._handleDragStop);
      ownerDocument.removeEventListener(eventsFor.touch.move, this._handleDrag);
      ownerDocument.removeEventListener(eventsFor.touch.stop, this._handleDragStop);
      removeUserSelectStyles(ownerDocument);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        style = _this$props.style;
        _this$props.column;
        _this$props.onResizeStart;
        _this$props.onResize;
        _this$props.onResizeStop;
        _this$props.minWidth;
        var rest = _objectWithoutPropertiesLoose$1(_this$props, ["style", "column", "onResizeStart", "onResize", "onResizeStop", "minWidth"]);

    return React__default.createElement("div", _extends$2({}, rest, {
      ref: this._setHandleRef,
      onClick: this._handleClick,
      onMouseDown: this._handleMouseDown,
      onMouseUp: this._handleMouseUp,
      onTouchStart: this._handleTouchStart,
      onTouchEnd: this._handleTouchEnd,
      style: _objectSpread$4({
        userSelect: 'none',
        touchAction: 'none',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        cursor: 'col-resize'
      }, style)
    }));
  };

  _proto._setHandleRef = function _setHandleRef(ref) {
    this.handleRef = ref;
  };

  _proto._handleClick = function _handleClick(e) {
    e.stopPropagation();
  };

  _proto._handleMouseDown = function _handleMouseDown(e) {
    dragEventFor = eventsFor.mouse;

    this._handleDragStart(e);
  };

  _proto._handleMouseUp = function _handleMouseUp(e) {
    dragEventFor = eventsFor.mouse;

    this._handleDragStop(e);
  };

  _proto._handleTouchStart = function _handleTouchStart(e) {
    dragEventFor = eventsFor.touch;

    this._handleDragStart(e);
  };

  _proto._handleTouchEnd = function _handleTouchEnd(e) {
    dragEventFor = eventsFor.touch;

    this._handleDragStop(e);
  };

  _proto._handleDragStart = function _handleDragStart(e) {
    if (typeof e.button === 'number' && e.button !== 0) return;
    this.isDragging = true;
    this.lastX = INVALID_VALUE;
    this.width = this.props.column.width;
    this.props.onResizeStart(this.props.column);
    var ownerDocument = this.handleRef.ownerDocument;
    addUserSelectStyles(ownerDocument);
    ownerDocument.addEventListener(dragEventFor.move, this._handleDrag);
    ownerDocument.addEventListener(dragEventFor.stop, this._handleDragStop);
  };

  _proto._handleDragStop = function _handleDragStop(e) {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.props.onResizeStop(this.props.column);
    var ownerDocument = this.handleRef.ownerDocument;
    removeUserSelectStyles(ownerDocument);
    ownerDocument.removeEventListener(dragEventFor.move, this._handleDrag);
    ownerDocument.removeEventListener(dragEventFor.stop, this._handleDragStop);
  };

  _proto._handleDrag = function _handleDrag(e) {
    var clientX = e.clientX;

    if (e.type === eventsFor.touch.move) {
      e.preventDefault();
      if (e.targetTouches && e.targetTouches[0]) clientX = e.targetTouches[0].clientX;
    }

    var offsetParent = this.handleRef.offsetParent;
    var offsetParentRect = offsetParent.getBoundingClientRect();
    var x = clientX + offsetParent.scrollLeft - offsetParentRect.left;

    if (this.lastX === INVALID_VALUE) {
      this.lastX = x;
      return;
    }

    var _this$props2 = this.props,
        column = _this$props2.column,
        MIN_WIDTH = _this$props2.minWidth;
    var width = column.width,
        maxWidth = column.maxWidth,
        _column$minWidth = column.minWidth,
        minWidth = _column$minWidth === void 0 ? MIN_WIDTH : _column$minWidth;
    var movedX = x - this.lastX;
    if (!movedX) return;
    this.width = this.width + movedX;
    this.lastX = x;
    var newWidth = this.width;

    if (maxWidth && newWidth > maxWidth) {
      newWidth = maxWidth;
    } else if (newWidth < minWidth) {
      newWidth = minWidth;
    }

    if (newWidth === width) return;
    this.props.onResize(column, newWidth);
  };

  return ColumnResizer;
}(React__default.PureComponent);

ColumnResizer.defaultProps = {
  onResizeStart: noop$2,
  onResize: noop$2,
  onResizeStop: noop$2,
  minWidth: 30
};
ColumnResizer.propTypes = {
  /**
   * Custom style for the drag handler
   */
  style: propTypes$1.object,

  /**
   * The column object to be dragged
   */
  column: propTypes$1.object,

  /**
   * A callback function when resizing started
   * The callback is of the shape of `(column) => *`
   */
  onResizeStart: propTypes$1.func,

  /**
   * A callback function when resizing the column
   * The callback is of the shape of `(column, width) => *`
   */
  onResize: propTypes$1.func,

  /**
   * A callback function when resizing stopped
   * The callback is of the shape of `(column) => *`
   */
  onResizeStop: propTypes$1.func,

  /**
   * Minimum width of the column could be resized to if the column's `minWidth` is not set
   */
  minWidth: propTypes$1.number
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ColumnManager =
/*#__PURE__*/
function () {
  function ColumnManager(columns, fixed) {
    this._origColumns = [];
    this.reset(columns, fixed);
  }

  var _proto = ColumnManager.prototype;

  _proto._cache = function _cache(key, fn) {
    if (key in this._cached) return this._cached[key];
    this._cached[key] = fn();
    return this._cached[key];
  };

  _proto.reset = function reset(columns, fixed) {
    var _this = this;

    this._columns = columns.map(function (column) {
      var width = column.width;

      if (column.resizable) {
        // don't reset column's `width` if `width` prop doesn't change
        var idx = _this._origColumns.findIndex(function (x) {
          return x.key === column.key;
        });

        if (idx >= 0 && _this._origColumns[idx].width === column.width) {
          width = _this._columns[idx].width;
        }
      }

      return _objectSpread$3({}, column, {
        width: width
      });
    });
    this._origColumns = columns;
    this._fixed = fixed;
    this._cached = {};
    this._columnStyles = this.recomputeColumnStyles();
  };

  _proto.resetCache = function resetCache() {
    this._cached = {};
  };

  _proto.getOriginalColumns = function getOriginalColumns() {
    return this._origColumns;
  };

  _proto.getColumns = function getColumns() {
    return this._columns;
  };

  _proto.getVisibleColumns = function getVisibleColumns() {
    var _this2 = this;

    return this._cache('visibleColumns', function () {
      return _this2._columns.filter(function (column) {
        return !column.hidden;
      });
    });
  };

  _proto.hasFrozenColumns = function hasFrozenColumns() {
    var _this3 = this;

    return this._cache('hasFrozenColumns', function () {
      return _this3._fixed && _this3.getVisibleColumns().some(function (column) {
        return !!column.frozen;
      });
    });
  };

  _proto.hasLeftFrozenColumns = function hasLeftFrozenColumns() {
    var _this4 = this;

    return this._cache('hasLeftFrozenColumns', function () {
      return _this4._fixed && _this4.getVisibleColumns().some(function (column) {
        return column.frozen === FrozenDirection.LEFT || column.frozen === true;
      });
    });
  };

  _proto.hasRightFrozenColumns = function hasRightFrozenColumns() {
    var _this5 = this;

    return this._cache('hasRightFrozenColumns', function () {
      return _this5._fixed && _this5.getVisibleColumns().some(function (column) {
        return column.frozen === FrozenDirection.RIGHT;
      });
    });
  };

  _proto.getMainColumns = function getMainColumns() {
    var _this6 = this;

    return this._cache('mainColumns', function () {
      var columns = _this6.getVisibleColumns();

      if (!_this6.hasFrozenColumns()) return columns;
      var mainColumns = [];

      _this6.getLeftFrozenColumns().forEach(function (column) {
        var _objectSpread2;

        //columns placeholder for the fixed table above them
        mainColumns.push(_objectSpread$3({}, column, (_objectSpread2 = {}, _objectSpread2[ColumnManager.PlaceholderKey] = true, _objectSpread2)));
      });

      _this6.getVisibleColumns().forEach(function (column) {
        if (!column.frozen) mainColumns.push(column);
      });

      _this6.getRightFrozenColumns().forEach(function (column) {
        var _objectSpread3;

        mainColumns.push(_objectSpread$3({}, column, (_objectSpread3 = {}, _objectSpread3[ColumnManager.PlaceholderKey] = true, _objectSpread3)));
      });

      return mainColumns;
    });
  };

  _proto.getLeftFrozenColumns = function getLeftFrozenColumns() {
    var _this7 = this;

    return this._cache('leftFrozenColumns', function () {
      if (!_this7._fixed) return [];
      return _this7.getVisibleColumns().filter(function (column) {
        return column.frozen === FrozenDirection.LEFT || column.frozen === true;
      });
    });
  };

  _proto.getRightFrozenColumns = function getRightFrozenColumns() {
    var _this8 = this;

    return this._cache('rightFrozenColumns', function () {
      if (!_this8._fixed) return [];
      return _this8.getVisibleColumns().filter(function (column) {
        return column.frozen === FrozenDirection.RIGHT;
      });
    });
  };

  _proto.getColumn = function getColumn(key) {
    var idx = this._columns.findIndex(function (column) {
      return column.key === key;
    });

    return this._columns[idx];
  };

  _proto.getColumnsWidth = function getColumnsWidth() {
    var _this9 = this;

    return this._cache('columnsWidth', function () {
      return _this9.recomputeColumnsWidth(_this9.getVisibleColumns());
    });
  };

  _proto.getLeftFrozenColumnsWidth = function getLeftFrozenColumnsWidth() {
    var _this10 = this;

    return this._cache('leftFrozenColumnsWidth', function () {
      return _this10.recomputeColumnsWidth(_this10.getLeftFrozenColumns());
    });
  };

  _proto.getRightFrozenColumnsWidth = function getRightFrozenColumnsWidth() {
    var _this11 = this;

    return this._cache('rightFrozenColumnsWidth', function () {
      return _this11.recomputeColumnsWidth(_this11.getRightFrozenColumns());
    });
  };

  _proto.recomputeColumnsWidth = function recomputeColumnsWidth(columns) {
    return columns.reduce(function (width, column) {
      return width + column.width;
    }, 0);
  };

  _proto.setColumnWidth = function setColumnWidth(key, width) {
    var column = this.getColumn(key);
    column.width = width;
    this._cached = {};
    this._columnStyles[column.key] = this.recomputeColumnStyle(column);
  };

  _proto.getColumnStyle = function getColumnStyle(key) {
    return this._columnStyles[key];
  };

  _proto.getColumnStyles = function getColumnStyles() {
    return this._columnStyles;
  };

  _proto.recomputeColumnStyle = function recomputeColumnStyle(column) {
    var flexGrow = 0;
    var flexShrink = 0;

    if (!this._fixed) {
      flexGrow = typeof column.flexGrow === 'number' ? column.flexGrow : 0;
      flexShrink = typeof column.flexShrink === 'number' ? column.flexShrink : 1;
    } // workaround for Flex bug on IE: https://github.com/philipwalton/flexbugs#flexbug-7


    var flexValue = flexGrow + " " + flexShrink + " auto";

    var style = _objectSpread$3({}, column.style, {
      flex: flexValue,
      msFlex: flexValue,
      WebkitFlex: flexValue,
      width: column.width,
      overflow: 'hidden'
    });

    if (!this._fixed && column.maxWidth) {
      style.maxWidth = column.maxWidth;
    }

    if (!this._fixed && column.minWidth) {
      style.minWidth = column.minWidth;
    }

    return style;
  };

  _proto.recomputeColumnStyles = function recomputeColumnStyles() {
    var _this12 = this;

    return this._columns.reduce(function (styles, column) {
      styles[column.key] = _this12.recomputeColumnStyle(column);
      return styles;
    }, {});
  };

  return ColumnManager;
}();
ColumnManager.PlaceholderKey = '__placeholder__';

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var getColumns = memoizeOne(function (columns, children) {
  return columns || normalizeColumns(children);
});

var getContainerStyle = function getContainerStyle(width, maxWidth, height) {
  return {
    width: width,
    maxWidth: maxWidth,
    height: height,
    overflow: 'hidden'
  };
};

var DEFAULT_COMPONENTS = {
  TableCell: TableCell,
  TableHeaderCell: TableHeaderCell,
  ExpandIcon: ExpandIcon,
  SortIndicator: SortIndicator
};
var RESIZE_THROTTLE_WAIT = 50; // used for memoization

var EMPTY_ARRAY = [];
/**
 * React table component
 */

var BaseTable =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(BaseTable, _React$PureComponent);

  function BaseTable(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    var columns = props.columns,
        children = props.children,
        defaultExpandedRowKeys = props.defaultExpandedRowKeys;
    _this.state = {
      scrollbarSize: 0,
      hoveredRowKey: null,
      resizingKey: null,
      resizingWidth: 0,
      expandedRowKeys: cloneArray(defaultExpandedRowKeys)
    };
    _this.columnManager = new ColumnManager(getColumns(columns, children), props.fixed);
    _this._setContainerRef = _this._setContainerRef.bind(_assertThisInitialized$1(_this));
    _this._setMainTableRef = _this._setMainTableRef.bind(_assertThisInitialized$1(_this));
    _this._setLeftTableRef = _this._setLeftTableRef.bind(_assertThisInitialized$1(_this));
    _this._setRightTableRef = _this._setRightTableRef.bind(_assertThisInitialized$1(_this));
    _this.renderExpandIcon = _this.renderExpandIcon.bind(_assertThisInitialized$1(_this));
    _this.renderRow = _this.renderRow.bind(_assertThisInitialized$1(_this));
    _this.renderRowCell = _this.renderRowCell.bind(_assertThisInitialized$1(_this));
    _this.renderHeader = _this.renderHeader.bind(_assertThisInitialized$1(_this));
    _this.renderHeaderCell = _this.renderHeaderCell.bind(_assertThisInitialized$1(_this));
    _this._handleScroll = _this._handleScroll.bind(_assertThisInitialized$1(_this));
    _this._handleVerticalScroll = _this._handleVerticalScroll.bind(_assertThisInitialized$1(_this));
    _this._handleRowsRendered = _this._handleRowsRendered.bind(_assertThisInitialized$1(_this));
    _this._handleRowHover = _this._handleRowHover.bind(_assertThisInitialized$1(_this));
    _this._handleRowExpand = _this._handleRowExpand.bind(_assertThisInitialized$1(_this));
    _this._handleColumnResize = throttle(_this._handleColumnResize.bind(_assertThisInitialized$1(_this)), RESIZE_THROTTLE_WAIT);
    _this._handleColumnResizeStart = _this._handleColumnResizeStart.bind(_assertThisInitialized$1(_this));
    _this._handleColumnResizeStop = _this._handleColumnResizeStop.bind(_assertThisInitialized$1(_this));
    _this._handleColumnSort = _this._handleColumnSort.bind(_assertThisInitialized$1(_this));
    _this._handleFrozenRowHeightChange = _this._handleFrozenRowHeightChange.bind(_assertThisInitialized$1(_this));
    _this._handleRowHeightChange = _this._handleRowHeightChange.bind(_assertThisInitialized$1(_this));
    _this._getLeftTableContainerStyle = memoizeOne(getContainerStyle);
    _this._getRightTableContainerStyle = memoizeOne(getContainerStyle);
    _this._flattenOnKeys = memoizeOne(function (tree, keys, dataKey) {
      _this._depthMap = {};
      return flattenOnKeys(tree, keys, _this._depthMap, dataKey);
    });
    _this._resetColumnManager = memoizeOne(function (columns, fixed) {
      _this.columnManager.reset(columns, fixed);

      if (_this.props.estimatedRowHeight && fixed) {
        if (!_this.columnManager.hasLeftFrozenColumns()) {
          _this._leftRowHeightMap = {};
        }

        if (!_this.columnManager.hasRightFrozenColumns()) {
          _this._rightRowHeightMap = {};
        }
      }
    }, function (newArgs, lastArgs) {
      return isObjectEqual(newArgs, lastArgs, _this.props.ignoreFunctionInColumnCompare);
    });
    _this._isResetting = false;
    _this._resetIndex = null;
    _this._rowHeightMap = {};
    _this._rowHeightMapBuffer = {};
    _this._mainRowHeightMap = {};
    _this._leftRowHeightMap = {};
    _this._rightRowHeightMap = {};
    _this._getEstimatedTotalRowsHeight = memoizeOne(getEstimatedTotalRowsHeight);
    _this._getRowHeight = _this._getRowHeight.bind(_assertThisInitialized$1(_this));
    _this._updateRowHeights = debounce(function () {
      _this._isResetting = true;
      _this._rowHeightMap = _objectSpread$2({}, _this._rowHeightMap, {}, _this._rowHeightMapBuffer);

      _this.resetAfterRowIndex(_this._resetIndex, false);

      _this._rowHeightMapBuffer = {};
      _this._resetIndex = null;

      _this.forceUpdateTable();

      _this.forceUpdate();

      _this._isResetting = false;
    }, 0);
    _this._scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    _this._scrollHeight = 0;
    _this._lastScannedRowIndex = -1;
    _this._hasDataChangedSinceEndReached = true;
    _this._data = props.data;
    _this._depthMap = {};
    _this._horizontalScrollbarSize = 0;
    _this._verticalScrollbarSize = 0;
    _this._scrollbarPresenceChanged = false;
    return _this;
  }
  /**
   * Get the DOM node of the table
   */


  var _proto = BaseTable.prototype;

  _proto.getDOMNode = function getDOMNode() {
    return this.tableNode;
  }
  /**
   * Get the column manager
   */
  ;

  _proto.getColumnManager = function getColumnManager() {
    return this.columnManager;
  }
  /**
   * Get internal `expandedRowKeys` state
   */
  ;

  _proto.getExpandedRowKeys = function getExpandedRowKeys() {
    var expandedRowKeys = this.props.expandedRowKeys;
    return expandedRowKeys !== undefined ? expandedRowKeys || EMPTY_ARRAY : this.state.expandedRowKeys;
  }
  /**
   * Get the expanded state, fallback to normal state if not expandable.
   */
  ;

  _proto.getExpandedState = function getExpandedState() {
    return {
      expandedData: this._data,
      expandedRowKeys: this.getExpandedRowKeys(),
      expandedDepthMap: this._depthMap
    };
  }
  /**
   * Get the total height of all rows, including expanded rows.
   */
  ;

  _proto.getTotalRowsHeight = function getTotalRowsHeight() {
    var _this$props = this.props,
        rowHeight = _this$props.rowHeight,
        estimatedRowHeight = _this$props.estimatedRowHeight;

    if (estimatedRowHeight) {
      return this.table ? this.table.getTotalRowsHeight() : this._getEstimatedTotalRowsHeight(this._data, estimatedRowHeight);
    }

    return this._data.length * rowHeight;
  }
  /**
   * Get the total width of all columns.
   */
  ;

  _proto.getTotalColumnsWidth = function getTotalColumnsWidth() {
    return this.columnManager.getColumnsWidth();
  }
  /**
   * Forcefully re-render the inner Grid component.
   *
   * Calling `forceUpdate` on `Table` may not re-render the inner Grid since it uses `shallowCompare` as a performance optimization.
   * Use this method if you want to manually trigger a re-render.
   * This may be appropriate if the underlying row data has changed but the row sizes themselves have not.
   */
  ;

  _proto.forceUpdateTable = function forceUpdateTable() {
    this.table && this.table.forceUpdateTable();
    this.leftTable && this.leftTable.forceUpdateTable();
    this.rightTable && this.rightTable.forceUpdateTable();
  }
  /**
   * Reset cached offsets for positioning after a specific rowIndex, should be used only in dynamic mode(estimatedRowHeight is provided)
   *
   * @param {number} rowIndex
   * @param {boolean} shouldForceUpdate
   */
  ;

  _proto.resetAfterRowIndex = function resetAfterRowIndex(rowIndex, shouldForceUpdate) {
    if (rowIndex === void 0) {
      rowIndex = 0;
    }

    if (shouldForceUpdate === void 0) {
      shouldForceUpdate = true;
    }

    if (!this.props.estimatedRowHeight) return;
    this.table && this.table.resetAfterRowIndex(rowIndex, shouldForceUpdate);
    this.leftTable && this.leftTable.resetAfterRowIndex(rowIndex, shouldForceUpdate);
    this.rightTable && this.rightTable.resetAfterRowIndex(rowIndex, shouldForceUpdate);
  }
  /**
   * Reset row height cache, useful if `data` changed entirely, should be used only in dynamic mode(estimatedRowHeight is provided)
   */
  ;

  _proto.resetRowHeightCache = function resetRowHeightCache() {
    if (!this.props.estimatedRowHeight) return;
    this._resetIndex = null;
    this._rowHeightMapBuffer = {};
    this._rowHeightMap = {};
    this._mainRowHeightMap = {};
    this._leftRowHeightMap = {};
    this._rightRowHeightMap = {};
  }
  /**
   * Scroll to the specified offset.
   * Useful for animating position changes.
   *
   * @param {object} offset
   */
  ;

  _proto.scrollToPosition = function scrollToPosition(offset) {
    this._scroll = offset;
    this.table && this.table.scrollToPosition(offset);
    this.leftTable && this.leftTable.scrollToTop(offset.scrollTop);
    this.rightTable && this.rightTable.scrollToTop(offset.scrollTop);
  }
  /**
   * Scroll to the specified offset vertically.
   *
   * @param {number} scrollTop
   */
  ;

  _proto.scrollToTop = function scrollToTop(scrollTop) {
    this._scroll.scrollTop = scrollTop;
    this.table && this.table.scrollToPosition(this._scroll);
    this.leftTable && this.leftTable.scrollToTop(scrollTop);
    this.rightTable && this.rightTable.scrollToTop(scrollTop);
  }
  /**
   * Scroll to the specified offset horizontally.
   *
   * @param {number} scrollLeft
   */
  ;

  _proto.scrollToLeft = function scrollToLeft(scrollLeft) {
    this._scroll.scrollLeft = scrollLeft;
    this.table && this.table.scrollToPosition(this._scroll);
  }
  /**
   * Scroll to the specified row.
   * By default, the table will scroll as little as possible to ensure the row is visible.
   * You can control the alignment of the row though by specifying an align property. Acceptable values are:
   *
   * - `auto` (default) - Scroll as little as possible to ensure the row is visible.
   * - `smart` - Same as `auto` if it is less than one viewport away, or it's the same as`center`.
   * - `center` - Center align the row within the table.
   * - `end` - Align the row to the bottom side of the table.
   * - `start` - Align the row to the top side of the table.
   *
   * @param {number} rowIndex
   * @param {string} align
   */
  ;

  _proto.scrollToRow = function scrollToRow(rowIndex, align) {
    if (rowIndex === void 0) {
      rowIndex = 0;
    }

    if (align === void 0) {
      align = 'auto';
    }

    this.table && this.table.scrollToRow(rowIndex, align);
    this.leftTable && this.leftTable.scrollToRow(rowIndex, align);
    this.rightTable && this.rightTable.scrollToRow(rowIndex, align);
  }
  /**
   * Set `expandedRowKeys` manually.
   * This method is available only if `expandedRowKeys` is uncontrolled.
   *
   * @param {array} expandedRowKeys
   */
  ;

  _proto.setExpandedRowKeys = function setExpandedRowKeys(expandedRowKeys) {
    // if `expandedRowKeys` is controlled
    if (this.props.expandedRowKeys !== undefined) return;
    this.setState({
      expandedRowKeys: cloneArray(expandedRowKeys)
    });
  };

  _proto.renderExpandIcon = function renderExpandIcon(_ref) {
    var rowData = _ref.rowData,
        rowIndex = _ref.rowIndex,
        depth = _ref.depth,
        onExpand = _ref.onExpand;
    var _this$props2 = this.props,
        rowKey = _this$props2.rowKey,
        expandColumnKey = _this$props2.expandColumnKey,
        expandIconProps = _this$props2.expandIconProps;
    if (!expandColumnKey) return null;
    var expandable = rowIndex >= 0 && hasChildren(rowData);
    var expanded = rowIndex >= 0 && this.getExpandedRowKeys().indexOf(rowData[rowKey]) >= 0;
    var extraProps = callOrReturn(expandIconProps, {
      rowData: rowData,
      rowIndex: rowIndex,
      depth: depth,
      expandable: expandable,
      expanded: expanded
    });

    var ExpandIcon = this._getComponent('ExpandIcon');

    return React__default.createElement(ExpandIcon, _extends$2({
      depth: depth,
      expandable: expandable,
      expanded: expanded
    }, extraProps, {
      onExpand: onExpand
    }));
  };

  _proto.renderRow = function renderRow(_ref2) {
    var _cn;

    var isScrolling = _ref2.isScrolling,
        columns = _ref2.columns,
        rowData = _ref2.rowData,
        rowIndex = _ref2.rowIndex,
        style = _ref2.style;
    var _this$props3 = this.props,
        rowClassName = _this$props3.rowClassName,
        rowRenderer = _this$props3.rowRenderer,
        rowEventHandlers = _this$props3.rowEventHandlers,
        expandColumnKey = _this$props3.expandColumnKey,
        estimatedRowHeight = _this$props3.estimatedRowHeight;
    var rowClass = callOrReturn(rowClassName, {
      columns: columns,
      rowData: rowData,
      rowIndex: rowIndex
    });
    var extraProps = callOrReturn(this.props.rowProps, {
      columns: columns,
      rowData: rowData,
      rowIndex: rowIndex
    });
    var rowKey = rowData[this.props.rowKey];
    var depth = this._depthMap[rowKey] || 0;
    var className = classnames(this._prefixClass('row'), rowClass, (_cn = {}, _cn[this._prefixClass("row--depth-" + depth)] = !!expandColumnKey && rowIndex >= 0, _cn[this._prefixClass('row--expanded')] = !!expandColumnKey && this.getExpandedRowKeys().indexOf(rowKey) >= 0, _cn[this._prefixClass('row--hovered')] = !isScrolling && rowKey === this.state.hoveredRowKey, _cn[this._prefixClass('row--frozen')] = depth === 0 && rowIndex < 0, _cn[this._prefixClass('row--customized')] = rowRenderer, _cn));
    var hasFrozenColumns = this.columnManager.hasFrozenColumns();

    var rowProps = _objectSpread$2({}, extraProps, {
      role: 'row',
      key: "row-" + rowKey,
      isScrolling: isScrolling,
      className: className,
      style: style,
      columns: columns,
      rowIndex: rowIndex,
      rowData: rowData,
      rowKey: rowKey,
      expandColumnKey: expandColumnKey,
      depth: depth,
      rowEventHandlers: rowEventHandlers,
      rowRenderer: rowRenderer,
      // for frozen rows we use fixed rowHeight
      estimatedRowHeight: rowIndex >= 0 ? estimatedRowHeight : undefined,
      getIsResetting: this._getIsResetting,
      cellRenderer: this.renderRowCell,
      expandIconRenderer: this.renderExpandIcon,
      onRowExpand: this._handleRowExpand,
      // for fixed table, we need to sync the hover state across the inner tables
      onRowHover: hasFrozenColumns ? this._handleRowHover : null,
      onRowHeightChange: hasFrozenColumns ? this._handleFrozenRowHeightChange : this._handleRowHeightChange
    });

    return React__default.createElement(TableRow, rowProps);
  };

  _proto.renderRowCell = function renderRowCell(_ref3) {
    var _cn2;

    var isScrolling = _ref3.isScrolling,
        columns = _ref3.columns,
        column = _ref3.column,
        columnIndex = _ref3.columnIndex,
        rowData = _ref3.rowData,
        rowIndex = _ref3.rowIndex,
        expandIcon = _ref3.expandIcon;

    if (column[ColumnManager.PlaceholderKey]) {
      return React__default.createElement("div", {
        key: "row-" + rowData[this.props.rowKey] + "-cell-" + column.key + "-placeholder",
        className: this._prefixClass('row-cell-placeholder'),
        style: this.columnManager.getColumnStyle(column.key)
      });
    }

    var className = column.className,
        dataKey = column.dataKey,
        dataGetter = column.dataGetter,
        cellRenderer = column.cellRenderer;

    var TableCell = this._getComponent('TableCell');

    var cellData = dataGetter ? dataGetter({
      columns: columns,
      column: column,
      columnIndex: columnIndex,
      rowData: rowData,
      rowIndex: rowIndex
    }) : getValue(rowData, dataKey);
    var cellProps = {
      isScrolling: isScrolling,
      cellData: cellData,
      columns: columns,
      column: column,
      columnIndex: columnIndex,
      rowData: rowData,
      rowIndex: rowIndex,
      container: this
    };
    var cell = renderElement(cellRenderer || React__default.createElement(TableCell, {
      className: this._prefixClass('row-cell-text')
    }), cellProps);
    var cellCls = callOrReturn(className, {
      cellData: cellData,
      columns: columns,
      column: column,
      columnIndex: columnIndex,
      rowData: rowData,
      rowIndex: rowIndex
    });
    var cls = classnames(this._prefixClass('row-cell'), cellCls, (_cn2 = {}, _cn2[this._prefixClass('row-cell--align-center')] = column.align === Alignment.CENTER, _cn2[this._prefixClass('row-cell--align-right')] = column.align === Alignment.RIGHT, _cn2));
    var extraProps = callOrReturn(this.props.cellProps, {
      columns: columns,
      column: column,
      columnIndex: columnIndex,
      rowData: rowData,
      rowIndex: rowIndex
    });

    var _ref4 = extraProps || {},
        tagName = _ref4.tagName,
        rest = _objectWithoutPropertiesLoose$1(_ref4, ["tagName"]);

    var Tag = tagName || 'div';
    return React__default.createElement(Tag, _extends$2({
      role: "gridcell",
      key: "row-" + rowData[this.props.rowKey] + "-cell-" + column.key
    }, rest, {
      className: cls,
      style: this.columnManager.getColumnStyle(column.key)
    }), expandIcon, cell);
  };

  _proto.renderHeader = function renderHeader(_ref5) {
    var _cn3;

    var columns = _ref5.columns,
        headerIndex = _ref5.headerIndex,
        style = _ref5.style;
    var _this$props4 = this.props,
        headerClassName = _this$props4.headerClassName,
        headerRenderer = _this$props4.headerRenderer;
    var headerClass = callOrReturn(headerClassName, {
      columns: columns,
      headerIndex: headerIndex
    });
    var extraProps = callOrReturn(this.props.headerProps, {
      columns: columns,
      headerIndex: headerIndex
    });
    var className = classnames(this._prefixClass('header-row'), headerClass, (_cn3 = {}, _cn3[this._prefixClass('header-row--resizing')] = !!this.state.resizingKey, _cn3[this._prefixClass('header-row--customized')] = headerRenderer, _cn3));

    var headerProps = _objectSpread$2({}, extraProps, {
      role: 'row',
      key: "header-" + headerIndex,
      className: className,
      style: style,
      columns: columns,
      headerIndex: headerIndex,
      headerRenderer: headerRenderer,
      cellRenderer: this.renderHeaderCell,
      expandColumnKey: this.props.expandColumnKey,
      expandIcon: this._getComponent('ExpandIcon')
    });

    return React__default.createElement(TableHeaderRow, headerProps);
  };

  _proto.renderHeaderCell = function renderHeaderCell(_ref6) {
    var _cn4, _cn5;

    var columns = _ref6.columns,
        column = _ref6.column,
        columnIndex = _ref6.columnIndex,
        headerIndex = _ref6.headerIndex,
        expandIcon = _ref6.expandIcon;

    if (column[ColumnManager.PlaceholderKey]) {
      return React__default.createElement("div", {
        key: "header-" + headerIndex + "-cell-" + column.key + "-placeholder",
        className: this._prefixClass('header-cell-placeholder'),
        style: this.columnManager.getColumnStyle(column.key)
      });
    }

    var headerClassName = column.headerClassName,
        headerRenderer = column.headerRenderer;
    var _this$props5 = this.props,
        sortBy = _this$props5.sortBy,
        sortState = _this$props5.sortState,
        headerCellProps = _this$props5.headerCellProps;

    var TableHeaderCell = this._getComponent('TableHeaderCell');

    var SortIndicator = this._getComponent('SortIndicator');

    var cellProps = {
      columns: columns,
      column: column,
      columnIndex: columnIndex,
      headerIndex: headerIndex,
      container: this
    };
    var cell = renderElement(headerRenderer || React__default.createElement(TableHeaderCell, {
      className: this._prefixClass('header-cell-text')
    }), cellProps);
    var sorting, sortOrder;

    if (sortState) {
      var order = sortState[column.key];
      sorting = order === SortOrder$1.ASC || order === SortOrder$1.DESC;
      sortOrder = sorting ? order : SortOrder$1.ASC;
    } else {
      sorting = column.key === sortBy.key;
      sortOrder = sorting ? sortBy.order : SortOrder$1.ASC;
    }

    var cellCls = callOrReturn(headerClassName, {
      columns: columns,
      column: column,
      columnIndex: columnIndex,
      headerIndex: headerIndex
    });
    var cls = classnames(this._prefixClass('header-cell'), cellCls, (_cn4 = {}, _cn4[this._prefixClass('header-cell--align-center')] = column.align === Alignment.CENTER, _cn4[this._prefixClass('header-cell--align-right')] = column.align === Alignment.RIGHT, _cn4[this._prefixClass('header-cell--sortable')] = column.sortable, _cn4[this._prefixClass('header-cell--sorting')] = sorting, _cn4[this._prefixClass('header-cell--resizing')] = column.key === this.state.resizingKey, _cn4));
    var extraProps = callOrReturn(headerCellProps, {
      columns: columns,
      column: column,
      columnIndex: columnIndex,
      headerIndex: headerIndex
    });

    var _ref7 = extraProps || {},
        tagName = _ref7.tagName,
        rest = _objectWithoutPropertiesLoose$1(_ref7, ["tagName"]);

    var Tag = tagName || 'div';
    return React__default.createElement(Tag, _extends$2({
      role: "gridcell",
      key: "header-" + headerIndex + "-cell-" + column.key,
      onClick: column.sortable ? this._handleColumnSort : null
    }, rest, {
      className: cls,
      style: this.columnManager.getColumnStyle(column.key),
      "data-key": column.key
    }), expandIcon, cell, column.sortable && React__default.createElement(SortIndicator, {
      sortOrder: sortOrder,
      className: classnames(this._prefixClass('sort-indicator'), (_cn5 = {}, _cn5[this._prefixClass('sort-indicator--descending')] = sortOrder === SortOrder$1.DESC, _cn5))
    }), column.resizable && React__default.createElement(ColumnResizer, {
      className: this._prefixClass('column-resizer'),
      column: column,
      onResizeStart: this._handleColumnResizeStart,
      onResizeStop: this._handleColumnResizeStop,
      onResize: this._handleColumnResize
    }));
  };

  _proto.renderMainTable = function renderMainTable() {
    var _this$props6 = this.props,
        width = _this$props6.width,
        headerHeight = _this$props6.headerHeight,
        rowHeight = _this$props6.rowHeight,
        fixed = _this$props6.fixed,
        estimatedRowHeight = _this$props6.estimatedRowHeight,
        rest = _objectWithoutPropertiesLoose$1(_this$props6, ["width", "headerHeight", "rowHeight", "fixed", "estimatedRowHeight"]);

    var height = this._getTableHeight();

    var tableWidth = width - this._verticalScrollbarSize;

    if (fixed) {
      var columnsWidth = this.columnManager.getColumnsWidth(); // make sure `scrollLeft` is always integer to fix a sync bug when scrolling to end horizontally

      tableWidth = Math.max(Math.round(columnsWidth), tableWidth);
    }

    return React__default.createElement(GridTable, _extends$2({}, rest, this.state, {
      className: this._prefixClass('table-main'),
      ref: this._setMainTableRef,
      data: this._data,
      columns: this.columnManager.getMainColumns(),
      width: width,
      height: height,
      headerHeight: headerHeight,
      rowHeight: rowHeight,
      estimatedRowHeight: estimatedRowHeight,
      getRowHeight: estimatedRowHeight ? this._getRowHeight : undefined,
      headerWidth: tableWidth + (fixed ? this._verticalScrollbarSize : 0),
      bodyWidth: tableWidth,
      headerRenderer: this.renderHeader,
      rowRenderer: this.renderRow,
      onScroll: this._handleScroll,
      onRowsRendered: this._handleRowsRendered
    }));
  };

  _proto.renderLeftTable = function renderLeftTable() {
    if (!this.columnManager.hasLeftFrozenColumns()) return null;

    var _this$props7 = this.props,
        width = _this$props7.width,
        headerHeight = _this$props7.headerHeight,
        rowHeight = _this$props7.rowHeight,
        estimatedRowHeight = _this$props7.estimatedRowHeight,
        rest = _objectWithoutPropertiesLoose$1(_this$props7, ["width", "headerHeight", "rowHeight", "estimatedRowHeight"]);

    var containerHeight = this._getFrozenContainerHeight();

    var offset = this._verticalScrollbarSize || 20;
    var columnsWidth = this.columnManager.getLeftFrozenColumnsWidth();
    return React__default.createElement(GridTable, _extends$2({}, rest, this.state, {
      containerStyle: this._getLeftTableContainerStyle(columnsWidth, width, containerHeight),
      className: this._prefixClass('table-frozen-left'),
      ref: this._setLeftTableRef,
      data: this._data,
      columns: this.columnManager.getLeftFrozenColumns(),
      initialScrollTop: this._scroll.scrollTop,
      width: columnsWidth + offset,
      height: containerHeight,
      headerHeight: headerHeight,
      rowHeight: rowHeight,
      estimatedRowHeight: estimatedRowHeight,
      getRowHeight: estimatedRowHeight ? this._getRowHeight : undefined,
      headerWidth: columnsWidth + offset,
      bodyWidth: columnsWidth + offset,
      headerRenderer: this.renderHeader,
      rowRenderer: this.renderRow,
      onScroll: this._handleVerticalScroll,
      onRowsRendered: noop$2
    }));
  };

  _proto.renderRightTable = function renderRightTable() {
    if (!this.columnManager.hasRightFrozenColumns()) return null;

    var _this$props8 = this.props,
        width = _this$props8.width,
        headerHeight = _this$props8.headerHeight,
        rowHeight = _this$props8.rowHeight,
        estimatedRowHeight = _this$props8.estimatedRowHeight,
        rest = _objectWithoutPropertiesLoose$1(_this$props8, ["width", "headerHeight", "rowHeight", "estimatedRowHeight"]);

    var containerHeight = this._getFrozenContainerHeight();

    var columnsWidth = this.columnManager.getRightFrozenColumnsWidth();
    var scrollbarWidth = this._verticalScrollbarSize;
    return React__default.createElement(GridTable, _extends$2({}, rest, this.state, {
      containerStyle: this._getLeftTableContainerStyle(columnsWidth + scrollbarWidth, width, containerHeight),
      className: this._prefixClass('table-frozen-right'),
      ref: this._setRightTableRef,
      data: this._data,
      columns: this.columnManager.getRightFrozenColumns(),
      initialScrollTop: this._scroll.scrollTop,
      width: columnsWidth + scrollbarWidth,
      height: containerHeight,
      headerHeight: headerHeight,
      rowHeight: rowHeight,
      estimatedRowHeight: estimatedRowHeight,
      getRowHeight: estimatedRowHeight ? this._getRowHeight : undefined,
      headerWidth: columnsWidth + scrollbarWidth,
      bodyWidth: columnsWidth,
      headerRenderer: this.renderHeader,
      rowRenderer: this.renderRow,
      onScroll: this._handleVerticalScroll,
      onRowsRendered: noop$2
    }));
  };

  _proto.renderResizingLine = function renderResizingLine() {
    var _this$props9 = this.props,
        width = _this$props9.width,
        fixed = _this$props9.fixed;
    var resizingKey = this.state.resizingKey;
    if (!fixed || !resizingKey) return null;
    var columns = this.columnManager.getMainColumns();
    var idx = columns.findIndex(function (column) {
      return column.key === resizingKey;
    });
    var column = columns[idx];
    var columnWidth = column.width,
        frozen = column.frozen;
    var leftWidth = this.columnManager.recomputeColumnsWidth(columns.slice(0, idx));
    var left = leftWidth + columnWidth;

    if (!frozen) {
      left -= this._scroll.scrollLeft;
    } else if (frozen === FrozenDirection.RIGHT) {
      var rightWidth = this.columnManager.recomputeColumnsWidth(columns.slice(idx + 1));

      if (rightWidth + columnWidth > width - this._verticalScrollbarSize) {
        left = columnWidth;
      } else {
        left = width - this._verticalScrollbarSize - rightWidth;
      }
    }

    var style = {
      left: left,
      height: this._getTableHeight() - this._horizontalScrollbarSize
    };
    return React__default.createElement("div", {
      className: this._prefixClass('resizing-line'),
      style: style
    });
  };

  _proto.renderFooter = function renderFooter() {
    var _this$props10 = this.props,
        footerHeight = _this$props10.footerHeight,
        footerRenderer = _this$props10.footerRenderer;
    if (footerHeight === 0) return null;
    return React__default.createElement("div", {
      className: this._prefixClass('footer'),
      style: {
        height: footerHeight
      }
    }, renderElement(footerRenderer));
  };

  _proto.renderEmptyLayer = function renderEmptyLayer() {
    var _this$props11 = this.props,
        data = _this$props11.data,
        frozenData = _this$props11.frozenData,
        footerHeight = _this$props11.footerHeight,
        emptyRenderer = _this$props11.emptyRenderer;
    if (data && data.length || frozenData && frozenData.length) return null;

    var headerHeight = this._getHeaderHeight();

    return React__default.createElement("div", {
      className: this._prefixClass('empty-layer'),
      style: {
        top: headerHeight,
        bottom: footerHeight
      }
    }, renderElement(emptyRenderer));
  };

  _proto.renderOverlay = function renderOverlay() {
    var overlayRenderer = this.props.overlayRenderer;
    return React__default.createElement("div", {
      className: this._prefixClass('overlay')
    }, !!overlayRenderer && renderElement(overlayRenderer));
  };

  _proto.render = function render() {
    var _cn6;

    var _this$props12 = this.props,
        columns = _this$props12.columns,
        children = _this$props12.children,
        width = _this$props12.width,
        fixed = _this$props12.fixed,
        data = _this$props12.data,
        frozenData = _this$props12.frozenData,
        expandColumnKey = _this$props12.expandColumnKey,
        disabled = _this$props12.disabled,
        className = _this$props12.className,
        style = _this$props12.style,
        footerHeight = _this$props12.footerHeight,
        classPrefix = _this$props12.classPrefix,
        estimatedRowHeight = _this$props12.estimatedRowHeight;

    this._resetColumnManager(getColumns(columns, children), fixed);

    var _data = expandColumnKey ? this._flattenOnKeys(data, this.getExpandedRowKeys(), this.props.rowKey) : data;

    if (this._data !== _data) {
      this.resetAfterRowIndex(0, false);
      this._data = _data;
    } // should be after `this._data` assigned


    this._calcScrollbarSizes();

    this._totalRowsHeight = this.getTotalRowsHeight();

    var containerStyle = _objectSpread$2({}, style, {
      width: width,
      height: this._getTableHeight() + footerHeight,
      position: 'relative'
    });

    var cls = classnames(classPrefix, className, (_cn6 = {}, _cn6[classPrefix + "--fixed"] = fixed, _cn6[classPrefix + "--expandable"] = !!expandColumnKey, _cn6[classPrefix + "--empty"] = data.length === 0, _cn6[classPrefix + "--has-frozen-rows"] = frozenData.length > 0, _cn6[classPrefix + "--has-frozen-columns"] = this.columnManager.hasFrozenColumns(), _cn6[classPrefix + "--disabled"] = disabled, _cn6[classPrefix + "--dynamic"] = !!estimatedRowHeight, _cn6));
    return React__default.createElement("div", {
      ref: this._setContainerRef,
      className: cls,
      style: containerStyle
    }, this.renderFooter(), this.renderMainTable(), this.renderLeftTable(), this.renderRightTable(), this.renderResizingLine(), this.renderEmptyLayer(), this.renderOverlay());
  };

  _proto.componentDidMount = function componentDidMount() {
    var scrollbarSize = this.props.getScrollbarSize();

    if (scrollbarSize > 0) {
      this.setState({
        scrollbarSize: scrollbarSize
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props13 = this.props,
        data = _this$props13.data,
        height = _this$props13.height,
        maxHeight = _this$props13.maxHeight,
        estimatedRowHeight = _this$props13.estimatedRowHeight;

    if (data !== prevProps.data) {
      this._lastScannedRowIndex = -1;
      this._hasDataChangedSinceEndReached = true;
    }

    if (maxHeight !== prevProps.maxHeight || height !== prevProps.height) {
      this._maybeCallOnEndReached();
    }

    this._maybeScrollbarPresenceChange();

    if (estimatedRowHeight) {
      if (this.getTotalRowsHeight() !== this._totalRowsHeight) {
        this.forceUpdate();
      }
    }
  };

  _proto._prefixClass = function _prefixClass(className) {
    return this.props.classPrefix + "__" + className;
  };

  _proto._setContainerRef = function _setContainerRef(ref) {
    this.tableNode = ref;
  };

  _proto._setMainTableRef = function _setMainTableRef(ref) {
    this.table = ref;
  };

  _proto._setLeftTableRef = function _setLeftTableRef(ref) {
    this.leftTable = ref;
  };

  _proto._setRightTableRef = function _setRightTableRef(ref) {
    this.rightTable = ref;
  };

  _proto._getComponent = function _getComponent(name) {
    if (this.props.components && this.props.components[name]) return this.props.components[name];
    return DEFAULT_COMPONENTS[name];
  } // for dynamic row height
  ;

  _proto._getRowHeight = function _getRowHeight(rowIndex) {
    var _this$props14 = this.props,
        estimatedRowHeight = _this$props14.estimatedRowHeight,
        rowKey = _this$props14.rowKey;
    return this._rowHeightMap[this._data[rowIndex][rowKey]] || callOrReturn(estimatedRowHeight, {
      rowData: this._data[rowIndex],
      rowIndex: rowIndex
    });
  };

  _proto._getIsResetting = function _getIsResetting() {
    return this._isResetting;
  };

  _proto._getHeaderHeight = function _getHeaderHeight() {
    var headerHeight = this.props.headerHeight;

    if (Array.isArray(headerHeight)) {
      return headerHeight.reduce(function (sum, height) {
        return sum + height;
      }, 0);
    }

    return headerHeight;
  };

  _proto._getFrozenRowsHeight = function _getFrozenRowsHeight() {
    var _this$props15 = this.props,
        frozenData = _this$props15.frozenData,
        rowHeight = _this$props15.rowHeight;
    return frozenData.length * rowHeight;
  };

  _proto._getTableHeight = function _getTableHeight() {
    var _this$props16 = this.props,
        height = _this$props16.height,
        maxHeight = _this$props16.maxHeight,
        footerHeight = _this$props16.footerHeight;
    var tableHeight = height - footerHeight;

    if (maxHeight > 0) {
      var frozenRowsHeight = this._getFrozenRowsHeight();

      var totalRowsHeight = this.getTotalRowsHeight();

      var headerHeight = this._getHeaderHeight();

      var totalHeight = headerHeight + frozenRowsHeight + totalRowsHeight + this._horizontalScrollbarSize;
      tableHeight = Math.min(totalHeight, maxHeight - footerHeight);
    }

    return tableHeight;
  };

  _proto._getBodyHeight = function _getBodyHeight() {
    return this._getTableHeight() - this._getHeaderHeight() - this._getFrozenRowsHeight();
  };

  _proto._getFrozenContainerHeight = function _getFrozenContainerHeight() {
    var maxHeight = this.props.maxHeight;
    var tableHeight = this._getTableHeight() - (this._data.length > 0 ? this._horizontalScrollbarSize : 0); // in auto height mode tableHeight = totalHeight

    if (maxHeight > 0) return tableHeight;

    var totalHeight = this.getTotalRowsHeight() + this._getHeaderHeight() + this._getFrozenRowsHeight();

    return Math.min(tableHeight, totalHeight);
  };

  _proto._calcScrollbarSizes = function _calcScrollbarSizes() {
    var _this$props17 = this.props,
        fixed = _this$props17.fixed,
        width = _this$props17.width;
    var scrollbarSize = this.state.scrollbarSize;
    var totalRowsHeight = this.getTotalRowsHeight();
    var totalColumnsWidth = this.getTotalColumnsWidth();
    var prevHorizontalScrollbarSize = this._horizontalScrollbarSize;
    var prevVerticalScrollbarSize = this._verticalScrollbarSize;

    if (scrollbarSize === 0) {
      this._horizontalScrollbarSize = 0;
      this._verticalScrollbarSize = 0;
    } else {
      // we have to set `this._horizontalScrollbarSize` before calling `this._getBodyHeight`
      if (!fixed || totalColumnsWidth <= width - scrollbarSize) {
        this._horizontalScrollbarSize = 0;
        this._verticalScrollbarSize = totalRowsHeight > this._getBodyHeight() ? scrollbarSize : 0;
      } else {
        if (totalColumnsWidth > width) {
          this._horizontalScrollbarSize = scrollbarSize;
          this._verticalScrollbarSize = totalRowsHeight > this._getBodyHeight() - this._horizontalScrollbarSize ? scrollbarSize : 0;
        } else {
          this._horizontalScrollbarSize = 0;
          this._verticalScrollbarSize = 0;

          if (totalRowsHeight > this._getBodyHeight()) {
            this._horizontalScrollbarSize = scrollbarSize;
            this._verticalScrollbarSize = scrollbarSize;
          }
        }
      }
    }

    if (prevHorizontalScrollbarSize !== this._horizontalScrollbarSize || prevVerticalScrollbarSize !== this._verticalScrollbarSize) {
      this._scrollbarPresenceChanged = true;
    }
  };

  _proto._maybeScrollbarPresenceChange = function _maybeScrollbarPresenceChange() {
    if (this._scrollbarPresenceChanged) {
      var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
      this._scrollbarPresenceChanged = false;
      onScrollbarPresenceChange({
        size: this.state.scrollbarSize,
        horizontal: this._horizontalScrollbarSize > 0,
        vertical: this._verticalScrollbarSize > 0
      });
    }
  };

  _proto._maybeCallOnEndReached = function _maybeCallOnEndReached() {
    var _this$props18 = this.props,
        onEndReached = _this$props18.onEndReached,
        onEndReachedThreshold = _this$props18.onEndReachedThreshold;
    var scrollTop = this._scroll.scrollTop;
    var scrollHeight = this.getTotalRowsHeight();

    var clientHeight = this._getBodyHeight();

    if (!onEndReached || !clientHeight || !scrollHeight) return;
    var distanceFromEnd = scrollHeight - scrollTop - clientHeight + this._horizontalScrollbarSize;

    if (this._lastScannedRowIndex >= 0 && distanceFromEnd <= onEndReachedThreshold && (this._hasDataChangedSinceEndReached || scrollHeight !== this._scrollHeight)) {
      this._hasDataChangedSinceEndReached = false;
      this._scrollHeight = scrollHeight;
      onEndReached({
        distanceFromEnd: distanceFromEnd
      });
    }
  };

  _proto._handleScroll = function _handleScroll(args) {
    var lastScrollTop = this._scroll.scrollTop;
    this.scrollToPosition(args);
    this.props.onScroll(args);
    if (args.scrollTop > lastScrollTop) this._maybeCallOnEndReached();
  };

  _proto._handleVerticalScroll = function _handleVerticalScroll(_ref8) {
    var scrollTop = _ref8.scrollTop;
    var lastScrollTop = this._scroll.scrollTop;
    if (scrollTop !== lastScrollTop) this.scrollToTop(scrollTop);
    if (scrollTop > lastScrollTop) this._maybeCallOnEndReached();
  };

  _proto._handleRowsRendered = function _handleRowsRendered(args) {
    this.props.onRowsRendered(args);

    if (args.overscanStopIndex > this._lastScannedRowIndex) {
      this._lastScannedRowIndex = args.overscanStopIndex;

      this._maybeCallOnEndReached();
    }
  };

  _proto._handleRowHover = function _handleRowHover(_ref9) {
    var hovered = _ref9.hovered,
        rowKey = _ref9.rowKey;
    this.setState({
      hoveredRowKey: hovered ? rowKey : null
    });
  };

  _proto._handleRowExpand = function _handleRowExpand(_ref10) {
    var expanded = _ref10.expanded,
        rowData = _ref10.rowData,
        rowIndex = _ref10.rowIndex,
        rowKey = _ref10.rowKey;
    var expandedRowKeys = cloneArray(this.getExpandedRowKeys());

    if (expanded) {
      if (!expandedRowKeys.indexOf(rowKey) >= 0) expandedRowKeys.push(rowKey);
    } else {
      var index = expandedRowKeys.indexOf(rowKey);

      if (index > -1) {
        expandedRowKeys.splice(index, 1);
      }
    } // if `expandedRowKeys` is uncontrolled, update internal state


    if (this.props.expandedRowKeys === undefined) {
      this.setState({
        expandedRowKeys: expandedRowKeys
      });
    }

    this.props.onRowExpand({
      expanded: expanded,
      rowData: rowData,
      rowIndex: rowIndex,
      rowKey: rowKey
    });
    this.props.onExpandedRowsChange(expandedRowKeys);
  };

  _proto._handleColumnResize = function _handleColumnResize(_ref11, width) {
    var key = _ref11.key;
    this.columnManager.setColumnWidth(key, width);
    this.setState({
      resizingWidth: width
    });
    var column = this.columnManager.getColumn(key);
    this.props.onColumnResize({
      column: column,
      width: width
    });
  };

  _proto._handleColumnResizeStart = function _handleColumnResizeStart(_ref12) {
    var key = _ref12.key;
    this.setState({
      resizingKey: key
    });
  };

  _proto._handleColumnResizeStop = function _handleColumnResizeStop() {
    var _this$state = this.state,
        resizingKey = _this$state.resizingKey,
        resizingWidth = _this$state.resizingWidth;
    this.setState({
      resizingKey: null,
      resizingWidth: 0
    });
    if (!resizingKey || !resizingWidth) return;
    var column = this.columnManager.getColumn(resizingKey);
    this.props.onColumnResizeEnd({
      column: column,
      width: resizingWidth
    });
  };

  _proto._handleColumnSort = function _handleColumnSort(event) {
    var key = event.currentTarget.dataset.key;
    var _this$props19 = this.props,
        sortBy = _this$props19.sortBy,
        sortState = _this$props19.sortState,
        onColumnSort = _this$props19.onColumnSort;
    var order = SortOrder$1.ASC;

    if (sortState) {
      order = sortState[key] === SortOrder$1.ASC ? SortOrder$1.DESC : SortOrder$1.ASC;
    } else if (key === sortBy.key) {
      order = sortBy.order === SortOrder$1.ASC ? SortOrder$1.DESC : SortOrder$1.ASC;
    }

    var column = this.columnManager.getColumn(key);
    onColumnSort({
      column: column,
      key: key,
      order: order
    });
  };

  _proto._handleFrozenRowHeightChange = function _handleFrozenRowHeightChange(rowKey, size, rowIndex, frozen) {
    if (!frozen) {
      this._mainRowHeightMap[rowKey] = size;
    } else if (frozen === FrozenDirection.RIGHT) {
      this._rightRowHeightMap[rowKey] = size;
    } else {
      this._leftRowHeightMap[rowKey] = size;
    }

    var height = Math.max(this._mainRowHeightMap[rowKey] || 0, this._leftRowHeightMap[rowKey] || 0, this._rightRowHeightMap[rowKey] || 0);

    if (this._rowHeightMap[rowKey] !== height) {
      this._handleRowHeightChange(rowKey, height, rowIndex);
    }
  };

  _proto._handleRowHeightChange = function _handleRowHeightChange(rowKey, size, rowIndex) {
    if (this._resetIndex === null) this._resetIndex = rowIndex;else if (this._resetIndex > rowIndex) this._resetIndex = rowIndex;
    this._rowHeightMapBuffer[rowKey] = size;

    this._updateRowHeights();
  };

  return BaseTable;
}(React__default.PureComponent);

BaseTable.Column = Column;
BaseTable.PlaceholderKey = ColumnManager.PlaceholderKey;
BaseTable.defaultProps = {
  classPrefix: 'BaseTable',
  rowKey: 'id',
  data: [],
  frozenData: [],
  fixed: false,
  headerHeight: 50,
  rowHeight: 50,
  footerHeight: 0,
  defaultExpandedRowKeys: [],
  sortBy: {},
  useIsScrolling: false,
  overscanRowCount: 1,
  onEndReachedThreshold: 500,
  getScrollbarSize: getScrollbarSize,
  ignoreFunctionInColumnCompare: true,
  onScroll: noop$2,
  onRowsRendered: noop$2,
  onScrollbarPresenceChange: noop$2,
  onRowExpand: noop$2,
  onExpandedRowsChange: noop$2,
  onColumnSort: noop$2,
  onColumnResize: noop$2,
  onColumnResizeEnd: noop$2
};
BaseTable.propTypes = {
  /**
   * Prefix for table's inner className
   */
  classPrefix: propTypes$1.string,

  /**
   * Class name for the table
   */
  className: propTypes$1.string,

  /**
   * Custom style for the table
   */
  style: propTypes$1.object,

  /**
   * A collection of Column
   */
  children: propTypes$1.node,

  /**
   * Columns for the table
   */
  columns: propTypes$1.arrayOf(propTypes$1.shape(Column.propTypes)),

  /**
   * The data for the table
   */
  data: propTypes$1.array.isRequired,

  /**
   * The data be frozen to top, `rowIndex` is negative and started from `-1`
   */
  frozenData: propTypes$1.array,

  /**
   * The key field of each data item
   */
  rowKey: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,

  /**
   * The width of the table
   */
  width: propTypes$1.number.isRequired,

  /**
   * The height of the table, will be ignored if `maxHeight` is set
   */
  height: propTypes$1.number,

  /**
   * The max height of the table, the table's height will auto change when data changes,
   * will turns to vertical scroll if reaches the max height
   */
  maxHeight: propTypes$1.number,

  /**
   * The height of each table row, will be only used by frozen rows if `estimatedRowHeight` is set
   */
  rowHeight: propTypes$1.number,

  /**
   * Estimated row height, the real height will be measure dynamically according to the content
   * The callback is of the shape of `({ rowData, rowIndex }) => number`
   */
  estimatedRowHeight: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.func]),

  /**
   * The height of the table header, set to 0 to hide the header, could be an array to render multi headers.
   */
  headerHeight: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.arrayOf(propTypes$1.number)]).isRequired,

  /**
   * The height of the table footer
   */
  footerHeight: propTypes$1.number,

  /**
   * Whether the width of the columns are fixed or flexible
   */
  fixed: propTypes$1.bool,

  /**
   * Whether the table is disabled
   */
  disabled: propTypes$1.bool,

  /**
   * Custom renderer on top of the table component
   */
  overlayRenderer: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element]),

  /**
   * Custom renderer when the length of data is 0
   */
  emptyRenderer: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element]),

  /**
   * Custom footer renderer, available only if `footerHeight` is larger then 0
   */
  footerRenderer: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element]),

  /**
   * Custom header renderer
   * The renderer receives props `{ cells, columns, headerIndex }`
   */
  headerRenderer: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element]),

  /**
   * Custom row renderer
   * The renderer receives props `{ isScrolling, cells, columns, rowData, rowIndex, depth }`
   */
  rowRenderer: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element]),

  /**
   * Class name for the table header, could be a callback to return the class name
   * The callback is of the shape of `({ columns, headerIndex }) => string`
   */
  headerClassName: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),

  /**
   * Class name for the table row, could be a callback to return the class name
   * The callback is of the shape of `({ columns, rowData, rowIndex }) => string`
   */
  rowClassName: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),

  /**
   * Extra props applied to header element
   * The handler is of the shape of `({ columns, headerIndex }) object`
   */
  headerProps: propTypes$1.oneOfType([propTypes$1.object, propTypes$1.func]),

  /**
   * Extra props applied to header cell element
   * The handler is of the shape of `({ columns, column, columnIndex, headerIndex }) => object`
   */
  headerCellProps: propTypes$1.oneOfType([propTypes$1.object, propTypes$1.func]),

  /**
   * Extra props applied to row element
   * The handler is of the shape of `({ columns, rowData, rowIndex }) => object`
   */
  rowProps: propTypes$1.oneOfType([propTypes$1.object, propTypes$1.func]),

  /**
   * Extra props applied to row cell element
   * The handler is of the shape of `({ columns, column, columnIndex, rowData, rowIndex }) => object`
   */
  cellProps: propTypes$1.oneOfType([propTypes$1.object, propTypes$1.func]),

  /**
   * Extra props applied to ExpandIcon component
   * The handler is of the shape of `({ rowData, rowIndex, depth, expandable, expanded }) => object`
   */
  expandIconProps: propTypes$1.oneOfType([propTypes$1.object, propTypes$1.func]),

  /**
   * The key for the expand column which render the expand icon if the data is a tree
   */
  expandColumnKey: propTypes$1.string,

  /**
   * Default expanded row keys when initialize the table
   */
  defaultExpandedRowKeys: propTypes$1.arrayOf(propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number])),

  /**
   * Controlled expanded row keys
   */
  expandedRowKeys: propTypes$1.arrayOf(propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number])),

  /**
   * A callback function when expand or collapse a tree node
   * The handler is of the shape of `({ expanded, rowData, rowIndex, rowKey }) => *`
   */
  onRowExpand: propTypes$1.func,

  /**
   * A callback function when the expanded row keys changed
   * The handler is of the shape of `(expandedRowKeys) => *`
   */
  onExpandedRowsChange: propTypes$1.func,

  /**
   * The sort state for the table, will be ignored if `sortState` is set
   */
  sortBy: propTypes$1.shape({
    /**
     * Sort key
     */
    key: propTypes$1.string,

    /**
     * Sort order
     */
    order: propTypes$1.oneOf([SortOrder$1.ASC, SortOrder$1.DESC])
  }),

  /**
   * Multiple columns sort state for the table
   *
   * example:
   * ```js
   * {
   *   'column-0': SortOrder.ASC,
   *   'column-1': SortOrder.DESC,
   * }
   * ```
   */
  sortState: propTypes$1.object,

  /**
   * A callback function for the header cell click event
   * The handler is of the shape of `({ column, key, order }) => *`
   */
  onColumnSort: propTypes$1.func,

  /**
   * A callback function when resizing the column width
   * The handler is of the shape of `({ column, width }) => *`
   */
  onColumnResize: propTypes$1.func,

  /**
   * A callback function when resizing the column width ends
   * The handler is of the shape of `({ column, width }) => *`
   */
  onColumnResizeEnd: propTypes$1.func,

  /**
   * Adds an additional isScrolling parameter to the row renderer.
   * This parameter can be used to show a placeholder row while scrolling.
   */
  useIsScrolling: propTypes$1.bool,

  /**
   * Number of rows to render above/below the visible bounds of the list
   */
  overscanRowCount: propTypes$1.number,

  /**
   * Custom scrollbar size measurement
   */
  getScrollbarSize: propTypes$1.func,

  /**
   * A callback function when scrolling the table
   * The handler is of the shape of `({ scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested }) => *`
   *
   * `scrollLeft` and `scrollTop` are numbers.
   *
   * `horizontalDirection` and `verticalDirection` are either `forward` or `backward`.
   *
   * `scrollUpdateWasRequested` is a boolean. This value is true if the scroll was caused by `scrollTo*`,
   * and false if it was the result of a user interaction in the browser.
   */
  onScroll: propTypes$1.func,

  /**
   * A callback function when scrolling the table within `onEndReachedThreshold` of the bottom
   * The handler is of the shape of `({ distanceFromEnd }) => *`
   */
  onEndReached: propTypes$1.func,

  /**
   * Threshold in pixels for calling `onEndReached`.
   */
  onEndReachedThreshold: propTypes$1.number,

  /**
   * A callback function with information about the slice of rows that were just rendered
   * The handler is of the shape of `({ overscanStartIndex, overscanStopIndex, startIndex， stopIndex }) => *`
   */
  onRowsRendered: propTypes$1.func,

  /**
   * A callback function when the scrollbar presence state changed
   * The handler is of the shape of `({ size, vertical, horizontal }) => *`
   */
  onScrollbarPresenceChange: propTypes$1.func,

  /**
   * A object for the row event handlers
   * Each of the keys is row event name, like `onClick`, `onDoubleClick` and etc.
   * Each of the handlers is of the shape of `({ rowData, rowIndex, rowKey, event }) => *`
   */
  rowEventHandlers: propTypes$1.object,

  /**
   * whether to ignore function properties while comparing column definition
   */
  ignoreFunctionInColumnCompare: propTypes$1.bool,

  /**
   * A object for the custom components, like `ExpandIcon` and `SortIndicator`
   */
  components: propTypes$1.shape({
    TableCell: propTypes$1.func,
    TableHeaderCell: propTypes$1.func,
    ExpandIcon: propTypes$1.func,
    SortIndicator: propTypes$1.func
  })
};

/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var expandTrigger = doc.createElement('div');
        expandTrigger.className = 'expand-trigger';
        expandTrigger.appendChild(doc.createElement('div'));
        var contractTrigger = doc.createElement('div');
        contractTrigger.className = 'contract-trigger';
        element.__resizeTriggers__.appendChild(expandTrigger);
        element.__resizeTriggers__.appendChild(contractTrigger);
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var AutoSizer = function (_React$PureComponent) {
  inherits(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = createDetectElementResize(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      // Avoid rendering children before the initial measurements have been collected.
      // At best this would just be wasting cycles.
      var bailoutOnChildren = false;

      if (!disableHeight) {
        if (height === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        if (width === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.width = 0;
        childParams.width = width;
      }

      return createElement(
        'div',
        {
          className: className,
          ref: this._setRef,
          style: _extends({}, outerStyle, style) },
        !bailoutOnChildren && children(childParams)
      );
    }
  }]);
  return AutoSizer;
}(PureComponent);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};

({
  /**
   * Class name for the component
   */
  className: propTypes$1.string,

  /**
   * the width of the component, will be the container's width if not set
   */
  width: propTypes$1.number,

  /**
   * the height of the component, will be the container's width if not set
   */
  height: propTypes$1.number,

  /**
   * A callback function to render the children component
   * The handler is of the shape of `({ width, height }) => node`
   */
  children: propTypes$1.func.isRequired,

  /**
   * A callback function when the size of the table container changed if the width and height are not set
   * The handler is of the shape of `({ width, height }) => *`
   */
  onResize: propTypes$1.func
});

const Overlay$1 = newStyled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  padding: 5px 15px;
  border-radius: 10px;
`;
const LoadingContainer = newStyled.div`
  display: flex;
  flex-direction: row;
  height: 12.5rem;
  width: inherit;
  justify-content: center;
  align-items: center;
`;
function TableLoadingOverlay() {
  return React__default.createElement(Overlay$1, null, React__default.createElement(LoadingContainer, null, React__default.createElement(TableLoadingIcon, {
    testIdentifier: "table-loading-icon"
  })));
}

const SearchIcon = props => {
  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "112",
    viewBox: "0 0 112 112"
  }, props), React__default.createElement("g", {
    id: "Group_1733",
    "data-name": "Group 1733",
    transform: "translate(-733 -398)"
  }, React__default.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: "56",
    cy: "56",
    r: "56",
    transform: "translate(733 398)",
    fill: "#fff"
  }), React__default.createElement("path", {
    id: "search",
    d: "M59.766,55.112,45.5,40.843a1.4,1.4,0,0,0-1-.411H42.947a24.442,24.442,0,1,0-2.515,2.515V44.5a1.445,1.445,0,0,0,.411,1L55.112,59.766a1.412,1.412,0,0,0,2,0l2.656-2.656A1.412,1.412,0,0,0,59.766,55.112ZM24.447,43.252A18.805,18.805,0,1,1,43.252,24.447,18.8,18.8,0,0,1,24.447,43.252Z",
    transform: "translate(759 424)",
    fill: "#aaa"
  })));
};

const Empty$1 = newStyled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  color: #F5F6FB;
  height: 90%;
  background-color: #F5F6FB;
  margin: 1.25rem;
`;
const IconContainer = newStyled.div`
  margin-top: 60px;
  width: 100%;
  text-align: center;
`;
const TextContainer = newStyled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-context: center;
  margin-top: 23px;
  text-align: center;
`;
const CenterTextBold = newStyled.span`
  font-weight: bold;
  font: 'Open Sans', Bold;
  font-size: 25px;
  color: #566072;
  letter-spacing: 0.5px;
  text-align: center
`;
const CenterText = newStyled.span`
  font: 'Open Sans', Regular;
  font-size: 14px;
  color: #566072;
  text-align: center;
  margin-top: 23px;
`;
const CenterTextSearchText = newStyled.span`
  font-weight: bold;
  font: 'Open Sans', Bold;
  font-size: 14px;
  color: #566072;
`;
const TableEmptyOverlay = props => {
  return React__default.createElement(Empty$1, {
    "data-testid": 'table-empty-overlay'
  }, React__default.createElement(IconContainer, null, React__default.createElement(SearchIcon, null)), React__default.createElement(TextContainer, null, React__default.createElement(CenterTextBold, null, "No Results Found"), props.searchTerm && React__default.createElement(React__default.Fragment, null, React__default.createElement(CenterText, null, "We couldn't find a match for", React__default.createElement(CenterTextSearchText, null, " \"", props.searchTerm, "\". "), "Please try another search"))));
};

const Empty = newStyled.div`
  display: flex;
  flex-direction: column;
  color: #aaaaaa;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
const Title$1 = newStyled.h2`
  margin-top: 0.8rem;
  font-weight: 500;
  font-size: 1.6rem;
  text-align: center;
`;
const WarningContainer = newStyled.p`
  text-align: center;
  height: 2rem;
  margin: 0px;
`;
function TableErrorOverlay() {
  return React__default.createElement(Empty, null, React__default.createElement(WarningContainer, {
    "data-testid": 'table-error-overlay'
  }, React__default.createElement(WarningIcon, null)), React__default.createElement(Title$1, {
    "data-testid": "error-message"
  }, "An error occurred processing this table. ", React__default.createElement("br", null), "Please\xA0", React__default.createElement("a", {
    target: "_blank",
    rel: "noreferrer noopener",
    href: "https://support.liveoptics.com/hc/en-us/requests/new"
  }, "open a support ticket"), ' ', "to have this issued investigated."));
}

const IconWrapper$6 = newStyled.div`
  color: #ffa800;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1rem;
  width: 1rem;
`;
const Svg$1 = newStyled.svg`
  width: 0.625rem;
  height: 0.625rem;
`;

const SortIndicatorUpIcon = () => {
  return React__default.createElement(IconWrapper$6, null, React__default.createElement(Svg$1, {
    viewBox: "0 0 10.004 13.019"
  }, React__default.createElement("path", {
    d: "M699.583,1199.925a.99.99,0,0,0-1.461,0l-2.2,2.341v-8.177a1.035,1.035,0,1,0-2.066,0v8.178l-2.206-2.341a.99.99,0,0,0-1.461,0,1.145,1.145,0,0,0,0,1.551l3.97,4.214a1.033,1.033,0,0,0,.335.236.963.963,0,0,0,.79,0,1.035,1.035,0,0,0,.335-.236l3.968-4.214A1.145,1.145,0,0,0,699.583,1199.925Z",
    transform: "translate(699.886 1206.011) rotate(180)",
    fill: "#4694ce"
  })));
};

const IconWrapper$5 = newStyled.div`
  color: #ffa800;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1rem;
  width: 1rem;
`;
const Svg = newStyled.svg`
  width: 0.625rem;
  height: 0.625rem;
`;

const SortIndicatorDownIcon = () => {
  return React__default.createElement(IconWrapper$5, null, React__default.createElement(Svg, {
    viewBox: "0 0 10.004 13.019"
  }, React__default.createElement("path", {
    d: "M699.583,1199.925a.99.99,0,0,0-1.461,0l-2.2,2.341v-8.177a1.035,1.035,0,1,0-2.066,0v8.178l-2.206-2.341a.99.99,0,0,0-1.461,0,1.145,1.145,0,0,0,0,1.551l3.97,4.214a1.033,1.033,0,0,0,.335.236.963.963,0,0,0,.79,0,1.035,1.035,0,0,0,.335-.236l3.968-4.214A1.145,1.145,0,0,0,699.583,1199.925Z",
    transform: "translate(-689.882 -1192.992)",
    fill: "#4694ce"
  })));
};

var SortOrder;

(function (SortOrder) {
  SortOrder["ASC"] = "asc";
  SortOrder["DESC"] = "desc";
})(SortOrder || (SortOrder = {}));

const CustomSortIndicator = function CustomSortIndicator(_ref) {
  const sortOrder = _ref.sortOrder,
        className = _ref.className;
  const cls = classnames('BaseTable__sort-indicator', className, {
    'BaseTable__sort-indicator--descending': sortOrder === SortOrder.DESC
  });
  return React__default.createElement('div', {
    className: cls,
    style: {}
  }, sortOrder === SortOrder.DESC ? React__default.createElement(SortIndicatorDownIcon, null) : React__default.createElement(SortIndicatorUpIcon, null));
};

const LOTable$1 = newStyled(BaseTable)`
  .BaseTable {
    box-shadow: 0 2px 4px 0 #eeeeee;
    background-color: #ffffff;
    position: relative;
    box-sizing: border-box;
    font-size: 13px;
  }

  .BaseTable--disabled {
    opacity: 0.7;
    pointer-events: none;
  }

  .BaseTable__table {
    background-color: #ffffff;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column-reverse;
  }

  .BaseTable__table-main {
    outline: 1px solid #eeeeee;
    left: 0;
  }

  .BaseTable__table-main .BaseTable__header-cell:first-of-type,
  .BaseTable__table-main .BaseTable__row-cell:first-of-type {
    padding-left: 15px;
  }

  .BaseTable__table-main .BaseTable__header-cell:last-child,
  .BaseTable__table-main .BaseTable__row-cell:last-child {
    padding-right: 15px;
  }

  .BaseTable__table-main .BaseTable__header {
    background-color: #f8f8f8;
  }

  .BaseTable__table-frozen-left .BaseTable__header,
  .BaseTable__table-frozen-left .BaseTable__body,
  .BaseTable__table-frozen-right .BaseTable__header,
  .BaseTable__table-frozen-right .BaseTable__body {
    overflow: hidden !important;
  }

  .BaseTable__table-frozen-left {
    box-shadow: 2px 0 4px 0 #eeeeee;
    top: 0;
    left: 0;
  }

  .BaseTable__table-frozen-left .BaseTable__header-cell:first-of-type,
  .BaseTable__table-frozen-left .BaseTable__row-cell:first-of-type {
    padding-left: 15px;
  }

  .BaseTable__table-frozen-left .BaseTable__header-row,
  .BaseTable__table-frozen-left .BaseTable__row {
    padding-right: 0 !important;
  }

  .BaseTable__table-frozen-left .BaseTable__body {
    overflow-y: auto !important;
  }

  .BaseTable__table-frozen-right {
    box-shadow: -2px 0 4px 0 #eeeeee;
    top: 0;
    right: 0;
  }

  .BaseTable__table-frozen-right .BaseTable__header-cell:last-child,
  .BaseTable__table-frozen-right .BaseTable__row-cell:last-child {
    padding-right: 15px;
  }

  .BaseTable__table-frozen-right .BaseTable__header-row,
  .BaseTable__table-frozen-right .BaseTable__row {
    padding-left: 0 !important;
  }

  .BaseTable__table-frozen-right .BaseTable__body {
    overflow-y: auto !important;
  }

  .BaseTable__header {
    overflow: hidden !important;
  }

  .BaseTable .BaseTable__header,
  .BaseTable .BaseTable__body {
    outline: none;
  }

  .BaseTable__header-row,
  .BaseTable__row {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
  }

  .BaseTable__header-row {
    background-color: #f8f8f8;
    font-weight: 700;
  }

  .BaseTable__row {
    background-color: #ffffff;
  }

  .BaseTable__row:hover,
  .BaseTable__row--hovered {
    background-color: #f3f3f3;
  }

  .BaseTable__row-expanded {
    border-bottom: 1px solid #eeeeee;
  }

  .BaseTable__header-cell,
  .BaseTable__row-cell {
    min-width: 0;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 7.5px;
    box-sizing: border-box;
    border-right: 1px solid #f5f6fb;
  }

  .BaseTable__header-cell--align-center,
  .BaseTable__row-cell--align-center {
    justify-content: center;
    text-align: center;
  }

  .BaseTable__header-cell--align-right,
  .BaseTable__row-cell--align-right {
    justify-content: flex-end;
    text-align: right;
  }

  .BaseTable__header-cell-text,
  .BaseTable__row-cell-text {
    overflow: hidden;
    overflow-wrap: anywhere;
  }

  .BaseTable__header-cell {
    position: relative;
    cursor: default;
    background: #fff;
    border-right: 1px solid #f5f6fb;
    color: #566072;
    font-size: 12px;
    border-bottom: 2px solid #e4e4e4;
  }

  .BaseTable__header-cell:hover .BaseTable__column-resizer {
    visibility: visible;
    opacity: 0.5;
  }

  .BaseTable__header-cell:hover .BaseTable__column-resizer:hover {
    opacity: 1;
  }

  .BaseTable__header-cell .BaseTable__sort-indicator {
    display: none;
  }

  .BaseTable__header-cell--sortable:hover {
    background-color: #f3f3f3;
    cursor: pointer;
  }

  .BaseTable__sort-indicator {
    font-size: 18px;
    color: #4694ce;
  }

  .BaseTable__header-cell--sortable:not(.BaseTable__header-cell--sorting):hover
    .BaseTable__sort-indicator {
    display: block;
    color: #4694ce;
  }

  .BaseTable__header-cell--sorting .BaseTable__sort-indicator,
  .BaseTable__header-cell--sorting:hover .BaseTable__sort-indicator {
    display: block;
  }

  .BaseTable__header-cell--resizing .BaseTable__column-resizer {
    visibility: visible;
    opacity: 1;
  }

  .BaseTable__header-cell--resizing .BaseTable__column-resizer::after {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    content: '';
    left: -9999px;
  }

  .BaseTable__header-cell-text {
    overflow: hidden;
    white-space: normal;
    line-height: 2;
  }

  .BaseTable__header-row--resizing .BaseTable__header-cell {
    background-color: transparent;
    cursor: col-resize;
  }

  .BaseTable__header-row--resizing
    .BaseTable__header-cell:not(.BaseTable__header-cell--sorting)
    .BaseTable__sort-indicator {
    display: none;
  }

  .BaseTable__header-row--resizing
    .BaseTable__header-cell:not(.BaseTable__header-cell--resizing)
    .BaseTable__column-resizer {
    visibility: hidden;
  }

  .BaseTable__column-resizer {
    width: 3px;
    visibility: hidden;
    background-color: #cccccc;
  }

  .BaseTable__column-resizer:hover {
    visibility: visible;
    opacity: 1;
  }

  .BaseTable__footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background-color: #ffffff;
  }

  .BaseTable__resizing-line {
    cursor: col-resize;
    position: absolute;
    top: 0;
    background-color: #cccccc;
    width: 3px;
    transform: translateX(-100%);
  }

  .BaseTable__empty-layer {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    background-color: #ffffff;
  }

  .BaseTable__overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
  }

  .BaseTable__overlay > * {
    pointer-events: auto;
  }
`;
const Table = props => {
  const {
    data,
    columnConfig,
    height,
    width,
    loading,
    error,
    sortBy,
    isTableEmpty
  } = props;
  const [sortedData, setSortedData] = useState([]);
  const [sort, setSort] = useState(sortBy);
  useEffect(() => {
    let keyedData = [];

    if (data && data.length) {
      keyedData = data.map((d, i) => {
        return _objectSpread2(_objectSpread2({}, d), {}, {
          id: `row-${i}`
        });
      });
    }

    setSortedData(keyedData);
  }, [data]);

  function onColumnSort(sortBy) {
    const sortData = sortedData.sort(sortBy.column.sortComparator(sortBy));
    setSortedData(sortData);
    setSort(sortBy);
  }

  const emptyRenderer = () => {
    if (error) {
      return React__default.createElement(TableErrorOverlay, null);
    }

    if (loading) {
      return React__default.createElement(TableLoadingOverlay, null);
    }

    if (isTableEmpty) {
      return React__default.createElement(TableEmptyOverlay, null);
    }

    return React__default.createElement(Fragment$1, null);
  };

  return React__default.createElement(LOTable$1, _extends$3({}, props, {
    data: sortedData,
    columns: columnConfig,
    height: height,
    width: width,
    emptyRenderer: emptyRenderer,
    sortBy: sort,
    onColumnSort: onColumnSort,
    components: _objectSpread2({
      SortIndicator: CustomSortIndicator
    }, props.components)
  }));
};
newStyled(Table)``;

function stringComparator(sortBy) {
  return (prev, next) => {
    return sortBy.order === 'desc' ? -String(prev[sortBy.key]).localeCompare(String(next[sortBy.key])) : String(prev[sortBy.key]).localeCompare(String(next[sortBy.key]));
  };
}
function numberComparator(sortBy) {
  return (prev, next) => {
    return sortBy.order === 'desc' ? -(+prev[sortBy.key] - +next[sortBy.key]) : +prev[sortBy.key] - +next[sortBy.key];
  };
}

const CustomTableHeaderCounter = function CustomTableHeaderCounter(parentClassToAppend, elementIdWithValue) {
  var element = document.getElementById(elementIdWithValue);

  if (element) {
    var valueToShow = element.value;
    return React__default.createElement("span", {
      className: "custom-table-header-counter-label"
    }, valueToShow);
  }
};

const SelectionCell = props => {
  const {
    rowData,
    column,
    rowIndex
  } = props;

  const _handleChange = e => {
    const {
      onChange
    } = column;
    onChange({
      selected: e.target.checked,
      rowData,
      rowIndex
    });
  };

  return React__default.createElement("label", {
    className: "container"
  }, React__default.createElement("input", {
    type: "checkbox",
    className: props.rowData.isSelected ? 'checked' : '',
    checked: props.rowData.isSelected,
    onChange: _handleChange
  }), React__default.createElement("span", {
    className: "checkmark"
  }));
};

var HeaderCheckBoxState;

(function (HeaderCheckBoxState) {
  HeaderCheckBoxState["NONE"] = "NONE";
  HeaderCheckBoxState["ANY"] = "ANY";
  HeaderCheckBoxState["ALL"] = "ALL";
})(HeaderCheckBoxState || (HeaderCheckBoxState = {}));

const SelectionCellAll = props => {
  const {
    column,
    container
  } = props;
  const [checkBoxState, setCheckBoxState] = useState();
  useEffect(() => {
    setCheckBoxState(getCheckBoxState());
  }, [column]);

  function getCheckBoxState() {
    if (column.isAllSelected) {
      return HeaderCheckBoxState.ALL;
    }

    return column.isAnySelected ? HeaderCheckBoxState.ANY : HeaderCheckBoxState.NONE;
  }

  const _handleChange = e => {
    setCheckBoxState(e.target.checked ? HeaderCheckBoxState.ALL : HeaderCheckBoxState.NONE);
    const all = container._data;
    const {
      onChangeAllRow,
      onChangeAll
    } = column;

    for (let i = 0; i < all.length; i++) {
      onChangeAllRow({
        selected: e.target.checked,
        rowData: all[i],
        rowIndex: i
      });
    }

    onChangeAll(e.target.checked);
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement("label", {
    className: "container"
  }, React__default.createElement("input", {
    type: "checkbox",
    checked: checkBoxState === HeaderCheckBoxState.ALL,
    onChange: _handleChange,
    className: `header-checked-${checkBoxState}`
  }), React__default.createElement("span", {
    className: checkBoxState === HeaderCheckBoxState.ANY ? 'header-checkmark-partial' : 'header-checkmark'
  })));
};

const checkboxWidth = 40;
const LOTable = newStyled(BaseTable)`
  .BaseTable {
    box-shadow: 0 2px 4px 0 #eeeeee;
    background-color: #ffffff;
    position: relative;
    box-sizing: border-box;
  }

  .BaseTable__row-cell-text {
    font-family: 'Open Sans', Regular;
    font-size: 14px;
    color: #566072;
    opacity: 1;
  }

  .BaseTable--disabled {
    opacity: 0.7;
    pointer-events: none;
  }

  .BaseTable__table {
    background-color: #ffffff;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column-reverse;
  }

  .BaseTable__table-main {
    outline: 1px solid #eeeeee;
    left: 0;
  }

  .BaseTable__table-main .BaseTable__header-cell:first-of-type,
  .BaseTable__table-main .BaseTable__row-cell:first-of-type {
    padding-left: 15px;
  }

  .BaseTable__table-main .BaseTable__header-cell:last-child,
  .BaseTable__table-main .BaseTable__row-cell:last-child {
    padding-right: 15px;
  }

  .BaseTable__table-main .BaseTable__header {
    background-color: #f8f8f8;
  }

  .BaseTable__table-frozen-left .BaseTable__header,
  .BaseTable__table-frozen-left .BaseTable__body,
  .BaseTable__table-frozen-right .BaseTable__header,
  .BaseTable__table-frozen-right .BaseTable__body {
    overflow: hidden !important;
  }

  .BaseTable__table-frozen-left {
    box-shadow: 2px 0 4px 0 #eeeeee;
    top: 0;
    left: 0;
  }

  .BaseTable__table-frozen-left .BaseTable__header-cell:first-of-type,
  .BaseTable__table-frozen-left .BaseTable__row-cell:first-of-type {
    padding-left: 15px;
  }

  .BaseTable__table-frozen-left .BaseTable__header-row,
  .BaseTable__table-frozen-left .BaseTable__row {
    padding-right: 0 !important;
  }

  .BaseTable__table-frozen-left .BaseTable__body {
    overflow-y: auto !important;
  }

  .BaseTable__table-frozen-right {
    box-shadow: -2px 0 4px 0 #eeeeee;
    top: 0;
    right: 0;
  }

  .BaseTable__table-frozen-right .BaseTable__header-cell:last-child,
  .BaseTable__table-frozen-right .BaseTable__row-cell:last-child {
    padding-right: 15px;
  }

  .BaseTable__table-frozen-right .BaseTable__header-row,
  .BaseTable__table-frozen-right .BaseTable__row {
    padding-left: 0 !important;
  }

  .BaseTable__table-frozen-right .BaseTable__body {
    overflow-y: auto !important;
  }

  .BaseTable__header {
    overflow: hidden !important;
  }

  .BaseTable .BaseTable__header,
  .BaseTable .BaseTable__body {
    outline: none;
  }

  .BaseTable__header-row,
  .BaseTable__row {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
  }

  .BaseTable__header-row {
    background-color: #f8f8f8;
    font-weight: 700;
  }

  .BaseTable__row {
    background-color: #ffffff;
  }

  .BaseTable__row:hover,
  .BaseTable__row--hovered {
    background-color: #f3f3f3;
  }

  .BaseTable__row-expanded {
    border-bottom: 1px solid #eeeeee;
  }

  .BaseTable__header-cell,
  .BaseTable__row-cell {
    min-width: 0;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 7.5px;
    box-sizing: border-box;
    border-right: 1px solid #f5f6fb;
    font-size: 14px;
  }

  .BaseTable__row-cell input[type='checkbox']:checked {
    background-color: #7ab800;
  }

  .BaseTable__row-cell input[type='checkbox']:after {
    content: '';
    position: absolute;
    display: none;
  }

  .BaseTable__row-cell input[type='checkbox']:after {
    display: block;
  }

  .BaseTable__row-cell input[type='checkbox']:after {
    left: 8px;
    bottom: 5px;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 4px 4px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .BaseTable__header-cell--align-center,
  .BaseTable__row-cell--align-center {
    justify-content: center;
    text-align: center;
  }

  .BaseTable__header-cell--align-right,
  .BaseTable__row-cell--align-right {
    justify-content: flex-end;
    text-align: right;
  }

  .BaseTable__header-cell-text,
  .BaseTable__row-cell-text {
    overflow: hidden;
    overflow-wrap: anywhere;
    font-size: 14px;
  }

  .BaseTable__header-cell {
    position: relative;
    cursor: default;
    background: #fff;
    border-right: 1px solid #f5f6fb;
    color: #566072;
    font-family: 'Open Sans', SemiBold;
    font-size: 14px;
    border-bottom: 2px solid #e4e4e4;
  }

  .BaseTable__header-cell:hover .BaseTable__column-resizer {
    visibility: visible;
    opacity: 0.5;
  }

  .BaseTable__header-cell:hover .BaseTable__column-resizer:hover {
    opacity: 1;
  }

  .BaseTable__header-cell .BaseTable__sort-indicator {
    display: none;
  }

  .BaseTable__header-cell--sortable:hover {
    background-color: #f3f3f3;
    cursor: pointer;
  }

  .BaseTable__sort-indicator {
    font-size: 18px;
    color: #4694ce;
  }

  .BaseTable__header-cell--sortable:not(.BaseTable__header-cell--sorting):hover
    .BaseTable__sort-indicator {
    display: block;
    color: #4694ce;
  }

  .BaseTable__header-cell--sorting .BaseTable__sort-indicator,
  .BaseTable__header-cell--sorting:hover .BaseTable__sort-indicator {
    display: block;
  }

  .BaseTable__header-cell--resizing .BaseTable__column-resizer {
    visibility: visible;
    opacity: 1;
  }

  .BaseTable__header-cell--resizing .BaseTable__column-resizer::after {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    content: '';
    left: -9999px;
  }

  .BaseTable__header-cell-text {
    overflow: hidden;
    white-space: normal;
    line-height: 2;
    font-family: 'Open Sans', SemiBold;
    font-size: 14px;
  }

  .BaseTable__header-row--resizing .BaseTable__header-cell {
    background-color: transparent;
    cursor: col-resize;
  }

  .BaseTable__header-row--resizing
    .BaseTable__header-cell:not(.BaseTable__header-cell--sorting)
    .BaseTable__sort-indicator {
    display: none;
  }

  .BaseTable__header-row--resizing
    .BaseTable__header-cell:not(.BaseTable__header-cell--resizing)
    .BaseTable__column-resizer {
    visibility: hidden;
  }

  .BaseTable__column-resizer {
    width: 3px;
    visibility: hidden;
    background-color: #cccccc;
  }

  .BaseTable__column-resizer:hover {
    visibility: visible;
    opacity: 1;
  }

  .BaseTable__footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background-color: #ffffff;
  }

  .BaseTable__resizing-line {
    cursor: col-resize;
    position: absolute;
    top: 0;
    background-color: #cccccc;
    width: 3px;
    transform: translateX(-100%);
  }

  .BaseTable__empty-layer {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    background-color: #ffffff;
  }

  .BaseTable__overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
  }

  .BaseTable__overlay > * {
    pointer-events: auto;
  }

  .container {
    display: block;
    position: relative;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark,
  .header-checkmark,
  .header-checkmark-partial {
    position: absolute;
    top: -6px;
    left: -6px;
    height: 22px;
    width: 22px;
    border: solid #aaaaaa;
    border-width: 2px 2px 2px 2px;
    border-radius: 3px;
    opacity: 1;
  }

  /* When the checkbox is checked, add a green background */
  .container input:checked ~ .checkmark,
  .container input:checked ~ .header-checkmark {
    background-color: #7ab800;
    border: solid #7ab800;
    left: -6px;
    top: -6px;
  }

  .container input ~ .header-checkmark-partial {
    background-color: white;
    border: solid #7ab800;
    border-width: 3px 3px 3px 3px;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after,
  .header-checkmark:after,
  .header-checkmark-partial:after {
    content: '';
    position: relative;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after,
  .container input:checked ~ .header-checkmark:after {
    display: block;
  }

  .container input ~ .header-checkmark-partial:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 30%;
    top: 12%;
    width: 7px;
    height: 11px;
    border: solid white;
    border-radius: 2px;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .container .header-checkmark:after {
    left: 30%;
    top: 12%;
    width: 7px;
    height: 11px;
    border: solid white;
    border-radius: 2px;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .container .header-checkmark-partial:after {
    left: 3px;
    top: 3px;
    width: 10px;
    height: 10px;
    border: solid #7ab800;
    border-radius: 2px;
    border-width: 3px 3px 3px 3px;
    background-color: #7ab800;
  }
`;
const SelectableTable = props => {
  const {
    data,
    columnConfig,
    height,
    width,
    loading,
    error,
    sortBy,
    isTableEmpty
  } = props;
  let searchTerm = '';

  if (props.searchTerm) {
    searchTerm = props.searchTerm;
  }

  const [sortedData, setSortedData] = useState([]);
  const [sort, setSort] = useState(sortBy);
  useEffect(() => {
    setSortedData(data || []);
  }, [data]);

  function onColumnSort(sortBy) {
    const sortData = sortedData.sort(sortBy.column.sortComparator(sortBy));
    setSortedData(sortData);
    setSort(sortBy);
    props.onColumnSorted(sort);
  }

  const emptyRenderer = () => {
    if (error) {
      return React__default.createElement(TableErrorOverlay, null);
    }

    if (loading) {
      return React__default.createElement(TableLoadingOverlay, null);
    }

    if (isTableEmpty) {
      return React__default.createElement(TableEmptyOverlay, {
        searchTerm: searchTerm
      });
    }

    return React__default.createElement(Fragment$1, null);
  };

  const _handleSelectChange = ({
    selected,
    rowData,
    rowIndex
  }) => {
    rowData.isSelected = selected;
    props.onRowSelect({
      selected,
      rowData,
      rowIndex
    });
  };

  const _handleSelectAllChange = selected => {
    props.onSelectAll({
      selected: selected,
      sort: sort
    });
  };

  const _handleSelectAllRowChange = ({
    selected,
    rowData,
    rowIndex
  }) => {
    rowData.isSelected = selected;
  };

  const {
    children,
    selectable
  } = props;

  let _columns = columnConfig || normalizeColumns([children]);

  if (selectable) {
    const selectionColumn = {
      width: checkboxWidth,
      flexShrink: 0,
      resizable: false,
      frozen: Column.FrozenDirection.LEFT,
      cellRenderer: SelectionCell,
      headerRenderer: SelectionCellAll,
      key: '__selection__',
      rowKey: props.rowKey,
      onChange: _handleSelectChange,
      onChangeAllRow: _handleSelectAllRowChange,
      onChangeAll: _handleSelectAllChange,
      isAllSelected: data.length && data.every(e => {
        return e.isSelected;
      }),
      isAnySelected: data.length && data.some(e => {
        return e.isSelected;
      })
    };
    _columns = [selectionColumn, ..._columns];
  }

  return React__default.createElement(LOTable, _extends$3({}, props, {
    fixed: false,
    columns: _columns,
    data: sortedData,
    height: height,
    width: width != null ? width - checkboxWidth / 2 : width,
    emptyRenderer: emptyRenderer,
    sortBy: sort,
    onColumnSort: onColumnSort,
    components: _objectSpread2({
      SortIndicator: CustomSortIndicator
    }, props.components)
  }));
};
newStyled(SelectableTable)``;

const WarningRowContainer = newStyled.div`
    width: auto;
    height: auto;
    font: normal normal normal 14px/20px Open Sans;
    letter-spacing: 0.14px;
    color: ${Color$1.coolGray700};
    border-bottom-style: solid;
    border-width: 1px;
    border-color: ${Color$1.lameGrey300};
    min-height: 56px;
    padding: 0px 0px 0px 10px;
    display: flex;
    align-items: center;
    justify-content: left;
`;
const ProjectWarningRow = props => {
  return React__default.createElement(WarningRowContainer, null, props.warningObj.Message);
};
newStyled(ProjectWarningRow)``;

const WarningTableContainer = newStyled.div`
    width: auto;
    overflow: auto;
    min-height: ${s => s.minHeight == null ? 'auto' : s.minHeight};
`;
const HeadderRow = newStyled.div`
    font: normal normal 600 14px/22px Open Sans;
    letter-spacing: 0.14px;
    color: ${Color$1.coolGray700};
    border-bottom-style: solid;
    border-width: 1px;
    padding: 2.5px 0px 5px 10px;
    border-color: ${Color$1.lameGrey300};
`;
const ScrollableContainer = newStyled.div`
    max-height: ${s => s.maxHeight == null ? 'auto' : s.maxHeight};
    overflow: auto;
`;
const ProjectWarningTable = props => {
  return React__default.createElement(WarningTableContainer, {
    minHeight: props.minHeight
  }, React__default.createElement(HeadderRow, null, "Description"), React__default.createElement(ScrollableContainer, {
    maxHeight: props.maxHeight
  }, props.data.length > 0 && props.data.map((item, i) => React__default.createElement(ProjectWarningRow, {
    warningObj: item
  }))));
};
newStyled(ProjectWarningTable)``;

const WarningModal = props => {
  return React__default.createElement(DynamicModal, {
    onClose: props.onClose,
    onPrimaryClick: props.onClose,
    title: "Warnings",
    primaryButtonName: "Close",
    icon: React__default.createElement(WarningIcon, {
      fill: Color$1.yellow500,
      color: Color$1.yellow500,
      height: '21px',
      width: '21px'
    }),
    closeDelayMiliseconds: 500,
    maxWidth: "60rem"
  }, React__default.createElement(ProjectWarningTable, {
    minHeight: "5.531rem",
    maxHeight: "20.532rem",
    data: props.data
  }));
};

const Delete = props => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteSpinner, setShowDeleteSpinner] = useState(false);

  const deleteAction = async () => {
    setShowDeleteModal(true);
    setShowDeleteSpinner(true);
  };

  return React__default.createElement(React__default.Fragment, null, showDeleteModal && React__default.createElement(Modal, {
    closeFn: () => {
      setShowDeleteModal(false);
      setShowDeleteSpinner(false);
    },
    modalTitle: 'Delete Project'
  }, React__default.createElement(DeleteModal, {
    projectId: props.id,
    apiUrl: props.apiUrl,
    closeFn: () => {
      setShowDeleteModal(false);
      setShowDeleteSpinner(false);
    }
  })), React__default.createElement(PrimaryButton, {
    testId: "delete-button",
    clickFn: deleteAction,
    disabled: false,
    loading: showDeleteSpinner
  }, "Delete"));
};

const ModalBody = newStyled.div`
  background: #fff;
  padding: 10px 2rem;
  display: flex;
  flex-direction: column;
`;
const ButtonLayout = newStyled.div`
  display: flex;
  justify-content: flex-end;
`;

const RetryModal = props => {
  return React__default.createElement(ModalBody, null, "Retry for this project has been initiated.", React__default.createElement(ButtonLayout, null, React__default.createElement(PrimaryButton, {
    clickFn: props.closeFn
  }, "Ok")));
};

const Retry = props => {
  const [showRetryModal, setShowRetryModal] = useState(false);
  const [showRetrySpinner, setShowRetrySpinner] = useState(false);

  const retry = async () => {
    setShowRetrySpinner(true);

    if (props.onRetryClick) {
      props.onRetryClick();
    }

    const url = props.apiUrl ? `${props.apiUrl}/api/project/${props.id}/retry` : `/api/project/${props.id}/retry`;
    const request = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (request.status === 200) {
      setShowRetryModal(true);
    }
  };

  return React__default.createElement(React__default.Fragment, null, showRetryModal && React__default.createElement(Modal, {
    closeFn: () => {
      setShowRetryModal(false);
      setShowRetrySpinner(false);
    },
    modalTitle: 'Project Retry'
  }, React__default.createElement(RetryModal, {
    closeFn: () => {
      setShowRetryModal(false);
      setShowRetrySpinner(false);
    }
  })), React__default.createElement(PrimaryButton, {
    clickFn: retry,
    disabled: false,
    loading: showRetrySpinner
  }, "Retry"));
};

const DownloadRawFiles = props => {
  const downloadFiles = () => {
    const url = props.apiUrl ? `${props.apiUrl}/project/DownloadRawFiles?id=${props.id}` : `/project/DownloadRawFiles?id=${props.id}`;
    window.open(url, '_blank');
  };

  return React__default.createElement(PrimaryButton, {
    clickFn: downloadFiles,
    disabled: false
  }, "Download Raw Files");
};

const AdminContainer = newStyled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 100%;

  @media (max-width: 1740px) {
    max-width: 59.75rem;
  }

  @media (max-width: 1245px) {
    max-width: 29.125rem;
  }
`;
const ButtonContainer = newStyled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 1rem;

  & > button:not(:last-child) {
    margin-right: 1rem;
  }

  @media (max-width: 1245px) {
    max-width: 29.125rem;
    flex-direction: column;

    & > button:not(:last-child) {
      margin-right: 0;
      margin-bottom: 1rem;
    }
  }
`;
const AdminTitle = newStyled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0;
    margin-right: 1rem;
  }
`;
const AdminPanel = props => {
  const {
    status,
    errorDetails,
    apiUrl,
    id
  } = props;

  const handleRetryClick = () => {
    if (props.onRetryClick) {
      props.onRetryClick();
    }
  };

  const adminTitle = React__default.createElement(AdminTitle, null, React__default.createElement("p", null, "Admin Controls"), " ", React__default.createElement(StatusBadge, {
    status: status
  }));
  return React__default.createElement(AdminContainer, null, React__default.createElement(CollapsiblePanel, {
    title: adminTitle,
    expanded: false
  }, React__default.createElement(ButtonContainer, null, React__default.createElement(DownloadRawFiles, {
    id: id,
    apiUrl: apiUrl
  }), React__default.createElement(Retry, {
    id: id,
    apiUrl: apiUrl,
    onRetryClick: handleRetryClick
  }), React__default.createElement(Delete, {
    id: id,
    apiUrl: apiUrl
  })), status === StatusType.ERROR && React__default.createElement(ErrorDetails, {
    details: errorDetails ? errorDetails : ''
  })));
};

const StatusBarWrapper = newStyled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-flex-group: border-box;
  width: 100%;
  min-height: 52px;
  padding: 0.25rem 1rem;
  margin-bottom: 1.25rem;
  color: #ffffff;
  /* This is an official work around for centering flex items with "min-height" without a set height 
    obtained from https://github.com/philipwalton/flexbugs/issues/231#issuecomment-362790042
  */
  &:after {
    content: '';
    min-height: inherit;
    font-size: 0;
  }
  & button {
    flex: 0 0 auto;
    margin-left: 1.5rem;
  }
  & > div {
    flex: 0 0 auto;
    margin-left: 1.5rem;
  }
  & svg {
    flex: 0 0 1.5rem;
    height: 24px;
  }
  p {
    font-size: 0.875rem;
    line-height: 1.25em;
    margin: 0;
    font-weight: 600;
    margin-left: 1rem;
  }
`;

const InProgressStatusBarWrapper = newStyled(StatusBarWrapper)`
  background-color: #57a8e6;
`;
const InProgressStatusBar = props => {
  return React__default.createElement(InProgressStatusBarWrapper, {
    "data-testid": "in-progress-status-bar"
  }, React__default.createElement(FilledInfoIcon, null), React__default.createElement("p", null, props.message !== undefined ? props.message : 'This project may take a few minutes to fully process. The page will automatically refresh to show updated data.'), props.status !== undefined && !props.hideBadge && React__default.createElement(StatusBadge, {
    status: props.status
  }));
};

const ErrorStatusBarWrapper = newStyled(StatusBarWrapper)`
  background-color: ${defaultTheme.colors.error};

  & button {
    font-size: 0.75rem;
    font-weight: 600;
  }
`;
const openSupportTicketURL = 'https://support.liveoptics.com/hc/en-us/requests/new';

const openSupportTicketPage = () => {
  window.open(openSupportTicketURL, '_blank');
};

const ErrorStatusBar = () => {
  return React__default.createElement(ErrorStatusBarWrapper, {
    "data-testid": "error-status-bar"
  }, React__default.createElement(ErrorIcon, null), React__default.createElement("p", null, "This project is in an error state. No further processing will be done automatically. We recommend opening a ticket with Live Optics Support."), React__default.createElement(PrimaryButton, {
    clickFn: openSupportTicketPage
  }, "Open Support Ticket"));
};

const IncompleteStatusBarWrapper = newStyled(StatusBarWrapper)`
  background-color: #ef9d00;
`;
const IncompleteStatusBar = () => {
  return React__default.createElement(IncompleteStatusBarWrapper, {
    "data-testid": "incomplete-status-bar"
  }, React__default.createElement(FilledInfoIcon, null), React__default.createElement("p", null, "This project is incomplete."));
};

function isProcessing(status) {
  return status === StatusType.PROCESSING || status === StatusType.IN_QUEUE || status === StatusType.PENDING_UPLOAD || status === StatusType.INITIALIZING || status === StatusType.UNPACKING || status === StatusType.PENDING_REPORT_GENERATION;
}

function StatusBar(props) {
  if (props.status === StatusType.ERROR) {
    return React__default.createElement(ErrorStatusBar, null);
  }

  if (props.status === StatusType.INCOMPLETE) {
    return React__default.createElement(IncompleteStatusBar, null);
  }

  if (isProcessing(props.status)) {
    return React__default.createElement(InProgressStatusBar, {
      status: props.status,
      hideBadge: props.hideBadge,
      message: props.message
    });
  }

  return React__default.createElement(React__default.Fragment, null);
}

const Container$5 = newStyled.div`
  display: flex;
  flex-direction: row;
  color: ${p => p.color || ''};
  align-items: center;
  background-color: ${p => p.bgColor || defaultTheme.colors.white};
  width: 100%;
  height: 64px;
  min-height: 64px;
  margin-bottom: 20px;
  padding: 0 16px;
  box-shadow: 0 0 1px 1px rgba(173, 173, 173, 0.2);
`;
const IconButtonWrapper$1 = newStyled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: ${p => p.color};
  fill: ${p => p.color};
  align-items: center;
`;
const ButtonWrapper$1 = newStyled.div`
  font-size: 16px;
  margin-left: 16px;
  & button {
    min-width: 112px;
  }
`;
const Message$1 = newStyled.p`
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 0 16px;
  color: ${p => p.textColor || ''};
  padding: 0;
`;

const Notification = props => {
  return React__default.createElement(Container$5, {
    color: props.textColor || '',
    bgColor: props.bgColor || ''
  }, React__default.createElement(IconButtonWrapper$1, {
    color: props.iconColor || ''
  }, React__default.createElement(FilledInfoIcon, null), React__default.createElement(ButtonWrapper$1, null, props.button)), React__default.createElement(Message$1, {
    textColor: props.textColor || ''
  }, props.message));
};

const CancelIcon = props => {
  return React__default.createElement("svg", _extends$3({
    "data-testid": "cancelIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.8",
    height: "18.8",
    viewBox: "0 0 18.8 18.8"
  }, props), React__default.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M11.5,9.4l6.8-6.8a1.5,1.5,0,0,0,.4-1.1A2.1,2.1,0,0,0,18.3.4a1.777,1.777,0,0,0-1-.4,2.1,2.1,0,0,0-1.1.4L9.4,7.3,2.6.4A2.1,2.1,0,0,0,1.5,0,2.1,2.1,0,0,0,.4.4,2.1,2.1,0,0,0,0,1.5,2.1,2.1,0,0,0,.4,2.6L7.2,9.4.4,16.2A2.1,2.1,0,0,0,0,17.3a2.1,2.1,0,0,0,.4,1.1,1.366,1.366,0,0,0,1.1.4,2.1,2.1,0,0,0,1.1-.4l6.8-6.8,6.8,6.8a1.5,1.5,0,0,0,1.1.4,2.1,2.1,0,0,0,1.1-.4,1.5,1.5,0,0,0,.4-1.1,2.1,2.1,0,0,0-.4-1.1Z",
    fill: "#fff"
  }));
};

const Container$4 = newStyled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${p => p.color || ''};
  align-items: center;
  background-color: ${p => p.bgColor || '#ffffff'};
  width: 100%;
  height: 64px;
  min-height: 64px;
  padding: 0 20px 0 16px;
  box-shadow: 0 0 1px 1px rgba(173, 173, 173, 0.2);
  margin-bottom: 19px;
  margin-top: 28px;
`;
const IconButtonWrapper = newStyled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: ${p => p.color};
  fill: ${p => p.color};
  align-items: center;
`;
const ButtonWrapper = newStyled.div`
  font-size: 12px;
  margin-left: 16px;
  & button {
    min-width: 92px;
    height: 35px;
    background: #0076ce 0% 0% no-repeat padding-box;
  }
`;
const Message = newStyled.p`
  font-size: 14px;
  font-family: 'Open Sans', SemiBold;
  font-weight: 500;
  color: ${p => p.textColor || ''};
  padding: 0;
  display: flex;
  align-items: center;
  margin-left: ${p => p.marginLeft}px;
  letter-spacing: 0.28px;
`;
const MessageBold = newStyled.p`
  font-size: 14px;
  font-family: 'Open Sans', Bold;
  font-weight: 600;
  color: ${p => p.textColor || ''};
  padding: 0;
  display: flex;
  align-items: center;
  margin-left: 5px;
  letter-spacing: 0.28px;
`;
const MessageSecondPart = newStyled.p`
  font-size: 14px;
  font-family: Open Sans, SemiBold;
  font-weight: 500;
  color: ${p => p.textColor || ''};
  padding: 0;
  display: flex;
  align-items: center;
  letter-spacing: 0.28px;
`;
const DivLeft = newStyled.div`
  display: flex;
  flex-direction: row;
`;
const DivRight = newStyled.div``;

const NotificationWithCancel = props => {
  const handleCancelClicked = () => {
    if (props.onCancelClick) {
      return props.onCancelClick();
    }
  };

  return React__default.createElement(Container$4, {
    color: props.textColor || '',
    bgColor: props.bgColor || ''
  }, React__default.createElement(DivLeft, null, React__default.createElement(IconButtonWrapper, {
    color: props.iconColor || ''
  }, React__default.createElement(FilledInfoIcon, null), React__default.createElement(ButtonWrapper, null, props.button)), React__default.createElement(Message, {
    textColor: props.textColor || '',
    marginLeft: props.marginLeft
  }, props.message), React__default.createElement(MessageBold, {
    textColor: props.textColor || ''
  }, props.messageBold), React__default.createElement(MessageSecondPart, {
    textColor: props.textColor || ''
  }, props.messageSecondPart)), (props.isShowCancelButton === undefined || props.isShowCancelButton === true) && React__default.createElement(DivRight, {
    onClick: handleCancelClicked
  }, React__default.createElement(CancelIcon, null)));
};

const UnorderedList$3 = newStyled.ul`
  display: inline-flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
  list-style-type: none;
  white-space: nowrap;
`;
const ListItem$9 = newStyled.li`
  font-size: 0.75rem;
  font-weight: 600;
`;
const ListLink$1 = newStyled.a`
  color: #0085c3;
  text-decoration: none;
  margin-left: 1.5rem;

  :hover {
    text-decoration: underline;
  }
`;

const FooterLinks = () => {
  return React__default.createElement(UnorderedList$3, null, React__default.createElement(ListItem$9, null, React__default.createElement(ListLink$1, {
    href: "https://www.liveoptics.com/privacy",
    target: "_blank",
    rel: "noopener"
  }, "Privacy Policy")), React__default.createElement(ListItem$9, null, React__default.createElement(ListLink$1, {
    href: "https://www.dell.com/learn/us/en/uscorp1/policies-cookies",
    target: "_blank",
    rel: "noopener"
  }, "Cookies")), React__default.createElement(ListItem$9, null, React__default.createElement(ListLink$1, {
    href: "https://www.dell.com/learn/us/en/uscorp1/policies-ads-and-emails",
    target: "_blank",
    rel: "noopener"
  }, "Ads & Email")), React__default.createElement(ListItem$9, null, React__default.createElement(ListLink$1, {
    href: "https://www.liveoptics.com/telemetry",
    target: "_blank",
    rel: "noopener"
  }, "Telemetry")), React__default.createElement(ListItem$9, null, React__default.createElement(ListLink$1, {
    href: "/EULA"
  }, "EULA")), React__default.createElement(ListItem$9, null, React__default.createElement(ListLink$1, {
    href: "https://support.liveoptics.com/",
    target: "_blank",
    rel: "noopener"
  }, "Support")));
};

const UnorderedList$2 = newStyled.ul`
  display: inline-flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
  list-style-type: none;
  white-space: nowrap;
`;
const ListItem$8 = newStyled.li`
  font-size: 0.75rem;
  font-weight: 600;
  color: #798699;
  margin-right: 1.5rem;
`;

const FooterInfo = props => {
  const year = new Date().getFullYear();
  const {
    appVersion
  } = props;
  return React__default.createElement(UnorderedList$2, null, React__default.createElement(ListItem$8, null, "Version: ", appVersion), React__default.createElement(ListItem$8, null, "\xA9 ", year, " Dell Inc. All Rights Reserved"), React__default.createElement(ListItem$8, null, "Powered by Live Optics, a Dell Technology"));
};

const Wrapper$5 = newStyled.footer`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 4.8rem;
  min-height: 4.8rem;
  background-color: white;
  justify-content: space-between;

  @media (max-width: 66.5rem) {
    padding: 1.25rem 0;
    flex-direction: column;
  }
`;
const Footer = props => {
  return React__default.createElement(Wrapper$5, null, React__default.createElement(FooterLinks, null), React__default.createElement(FooterInfo, {
    appVersion: props.appVersion
  }));
};

const Wrapper$4 = newStyled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const GridLayout = newStyled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 100%;
  max-width: 90.375rem;

  & > :not(:last-child) {
    margin-right: 1.5rem;
  }

  @media (max-width: 1740px) {
    max-width: 59.75rem;

    & > :not(:last-child) {
      margin-right: 0;
    }

    & > div:first-of-type {
      margin-right: 1.5rem;
    }
  }

  @media (max-width: 1245px) {
    max-width: 29.125rem;

    & > :not(:last-child) {
      margin-right: 0;
    }

    & > div:first-of-type {
      margin-right: 0rem;
    }
  }
`;
const Grid = props => {
  return React__default.createElement(Wrapper$4, null, React__default.createElement(GridLayout, null, props.children));
};

const GridColumnLayout = newStyled.div`
  display: flex;
  flex-direction: column;
`;
const GridColumn = props => {
  return React__default.createElement(GridColumnLayout, null, props.children);
};

const GridItemLayout = newStyled.div`
  // Fixed width necessary
  // for Masonry layout
  width: 29.125rem;
  margin-bottom: 1.5rem;
`;
const GridItem = props => {
  return React__default.createElement(GridItemLayout, null, props.children);
};

const TileLayout = newStyled.div`
  position: relative;

  // Needs to inherit width
  // to work with masonry layout.
  width: inherit;

  min-height: 7.5625rem;
  height: 100%;
  padding: 0.8rem 0 0 0;
  background: #fff;
  box-shadow: rgba(173, 173, 173, 0.2) 0px 1px 1px 1px;
`;
const PopoverWrapper$2 = newStyled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;
const PopoverContainer = newStyled.div`
  width: 29.125rem;
  margin-left: 95%;
`;
const Tile = props => {
  const {
    showPopover,
    popoverText,
    children
  } = props;
  return React__default.createElement(TileLayout, null, showPopover && React__default.createElement(PopoverWrapper$2, null, React__default.createElement(PopoverContainer, null, React__default.createElement(Popover$1, {
    content: popoverText
  }, React__default.createElement(InfoIcon, {
    preserveAspectRatio: "xMinYMin",
    height: "24"
  })))), children);
};

const WrapperLayout = newStyled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 2rem;
  padding-bottom: 1rem;
  background-color: #f5f6fb;
`;
const Wrapper$3 = props => {
  return React__default.createElement(WrapperLayout, null, props.children);
};

const Masthead$1 = newStyled.header`
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid #e4e4e4;
  background-color: #ffffff;
  height: 60px;

  @media (max-width: 700px) {
    flex-direction: column;
    height: auto;
  }
`;
const LogoLinkWrapper$1 = newStyled.a`
  padding-top: 8px;
  padding-bottom: 4px;
  padding-left: 0.75rem;
  align-items: center;
`;
const ActionItems$1 = newStyled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: left;
]  }
`;
const Header = props => {
  return React__default.createElement(Masthead$1, null, React__default.createElement(LogoLinkWrapper$1, {
    href: "/"
  }, React__default.createElement(Logo, {
    preserveAspectRatio: "xMinYMin"
  })), React__default.createElement(ActionItems$1, null, props.children));
};

const Wrapper$2 = newStyled.nav`
  height: 3rem;
  background: #fff;
  border-bottom: 1px solid #e4e4e4;
  width: 100%;
`;
const Toolbar = newStyled.div`
  color: ${s => s.projectColor};
  display: flex;
  height: 100%;
  align-items: center;
  padding-left: 0.75rem;
`;
const ToolbarItem = newStyled.div`
  flex: 1;
  height: 100%;
`;
const List = newStyled.ul`
  display: flex;
  justify-content: flex-end;
  font-size: 0.75rem;
  font-weight: 700;
  height: 100%;
  margin-bottom: 0;
  margin-top: 0;
`;
const ToolBarTitle = newStyled.p`
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  margin-left: 0.5rem;
`;
const ProjectName = newStyled.span`
  color: #566072;
  border-left: 1px solid #e4e4e4;
  margin-left: 1rem;
  font-weight: normal;
  font-size: 20px;
  padding-left: 0.8rem;
`;
const ViewerToolbar = props => {
  return React__default.createElement(Wrapper$2, null, React__default.createElement(Toolbar, {
    projectColor: props.projectColor
  }, props.assetIcon, React__default.createElement(ToolBarTitle, null, props.projectType, props.projectName && React__default.createElement(ProjectName, null, props.projectName)), React__default.createElement(ToolbarItem, null, React__default.createElement(List, null, props.children))));
};

const DashboardIcon = () => {
  return React__default.createElement("svg", {
    "data-testid": "dashboard-icon",
    viewBox: "0 0 19 19"
  }, React__default.createElement("path", {
    d: "M10.89 13.57H19v-2.71h-8.11zm0-13.57v2.71H19V0zm0 19H19v-2.71h-8.11zm0-10.86H19V5.43h-8.11zm-2.75 0H0V0h8.14zm0 10.86H0v-8.14h8.14z"
  }));
};

const RequestCaptureIcon = () => {
  return React__default.createElement("svg", {
    viewBox: "0 0 24 15.02"
  }, React__default.createElement("path", {
    d: "M23.83 11.34L20.55 8.5c-.38-.35-.76-.2-.76.25v1.3h-3.06a.52.52 0 0 0-.53.56v2.11a.52.52 0 0 0 .53.56h3.06v1.3c0 .45.38.6.76.25l3.28-2.84a.4.4 0 0 0 0-.65zM19.38.5a2.58 2.58 0 0 0-1.55-.5H2.27A2.57 2.57 0 0 0 .74.5l9.38 8.57zM.05 2.21a2.31 2.31 0 0 0 0 .46v8.6a2.45 2.45 0 0 0 .18.9l5.27-5zM16.5 9.04h2.17v-.29a1.42 1.42 0 0 1 1.43-1.46V2.67a2 2 0 0 0-.05-.42l-5.35 5zm-1.41 1.57a1.61 1.61 0 0 1 .06-.44L13.42 8.4l-2.68 2.47a.89.89 0 0 1-.62.24 1 1 0 0 1-.62-.23L6.75 8.35l-5.62 5.33a2.73 2.73 0 0 0 1.14.27H15.7a1.58 1.58 0 0 1-.57-1.23z"
  }));
};

const TeamsIcon = () => {
  return React__default.createElement("svg", {
    viewBox: "0 0 23.62 17"
  }, React__default.createElement("path", {
    d: "M23.62 11.1c-.2-.8-2.18-1.3-3.17-1.7-.1 0-.2-.2-.3-.3a.31.31 0 0 1-.1-.2c0-.2-.1-.4-.1-.6a1 1 0 0 0 .4-.5 2.78 2.78 0 0 0 .49-.9c.1 0 .2-.1.3-.2a3.92 3.92 0 0 0 .3-1.3c0-.1-.2-.1-.3-.1a2.77 2.77 0 0 0-.1-.9 2.35 2.35 0 0 0-2.28-2 2.42 2.42 0 0 0-2.28 2c0 .3-.1.5-.1.8a.37.37 0 0 0-.3.1 1.82 1.82 0 0 0 .3 1.3c.1.1.2.2.29.2a2.62 2.62 0 0 0 .5.9 1.21 1.21 0 0 0 .5.5.84.84 0 0 1-.2.7l-.1.1a1.87 1.87 0 0 0-.4.3 13.41 13.41 0 0 0-2.28.9c.2.1.4.1.6.2a7.94 7.94 0 0 1 4 3.3h3.58m-8.56-3.2c-.1 0-.29-.3-.39-.4a1.24 1.24 0 0 0-.2-.3 2.77 2.77 0 0 1-.1-.9 3.88 3.88 0 0 0 .59-.7 6.38 6.38 0 0 0 .8-1.4.51.51 0 0 0 .39-.3 3.8 3.8 0 0 0 .4-1.9c-.1-.2-.2-.2-.4-.2a6.82 6.82 0 0 0-.09-1.4 3.51 3.51 0 0 0-3.4-3 3.7 3.7 0 0 0-3.47 3.1c0 .2-.1.4-.1.6v-.4a3.75 3.75 0 0 0-.1 1.1.4.4 0 0 0-.4.2 3.8 3.8 0 0 0 .4 1.9.54.54 0 0 0 .4.3 4.46 4.46 0 0 0 .79 1.4 1.9 1.9 0 0 0 .69.8 3.61 3.61 0 0 1-.19 1.1.1.1 0 0 0-.1.1 4.68 4.68 0 0 0-.6.5c-1.29.4-4.27 2.4-4.66 3.6a5.25 5.25 0 0 0-.26 1.5A1.2 1.2 0 0 0 5.4 17h12.8a1.19 1.19 0 0 0 1.09-1.2 4.14 4.14 0 0 0-.29-1.5c-.14-1.4-3.12-3.2-4.69-3.8zM.6 13.9h3.71a8.74 8.74 0 0 1 4.56-3.6 13.09 13.09 0 0 0-2.28-.9c-.1 0-.2-.2-.3-.3a.33.33 0 0 1-.09-.2c0-.2-.1-.4-.1-.6a1 1 0 0 0 .39-.5 2.62 2.62 0 0 0 .5-.9c.1 0 .2-.1.3-.2a3.86 3.86 0 0 0 .29-1.3c0-.1-.19-.1-.29-.1a2.77 2.77 0 0 0-.1-.9 2.35 2.35 0 0 0-2.28-2 2.44 2.44 0 0 0-2.29 2c0 .3-.1.5-.1.9a.35.35 0 0 0-.29.1 1.86 1.86 0 0 0 .25 1.3c.1.1.2.2.3.2a2.62 2.62 0 0 0 .5.9 1.24 1.24 0 0 0 .49.5.87.87 0 0 1-.19.7l-.1.1a1.87 1.87 0 0 0-.4.3c-.89.3-2.78.9-3.08 1.7"
  }));
};

const CogIcon = () => {
  return React__default.createElement("svg", {
    viewBox: "0 0 19.99 18.99"
  }, React__default.createElement("path", {
    d: "M9.99 12.66A3.25 3.25 0 0 1 6.66 9.5a3.25 3.25 0 0 1 3.33-3.17 3.25 3.25 0 0 1 3.33 3.17 3.25 3.25 0 0 1-3.33 3.16zm10-1.89V8.22c-1.38-.47-2.25-.6-2.68-1.6-.44-1 .08-1.69.7-2.94l-1.9-1.8c-1.3.58-2 1.08-3.09.67-1.06-.42-1.19-1.25-1.68-2.55H8.65c-.49 1.29-.63 2.13-1.68 2.55-1 .41-1.77-.08-3.08-.67l-1.9 1.8c.62 1.25 1.14 1.93.7 2.94S1.36 7.75 0 8.22v2.55c1.36.46 2.24.6 2.68 1.6s-.09 1.71-.7 2.93l1.9 1.81c1.3-.59 2-1.09 3.08-.67 1 .42 1.19 1.25 1.68 2.55h2.69c.48-1.29.62-2.13 1.69-2.55 1.05-.42 1.76.08 3.08.67L18 15.3c-.62-1.23-1.14-1.92-.71-2.93s1.34-1.14 2.7-1.6z"
  }));
};

const ToolsIcon = () => {
  return React__default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, React__default.createElement("path", {
    d: "M15.62 4.42a.41.41 0 0 1 0-.59.41.41 0 0 1 .58 0 .41.41 0 0 1 0 .59.41.41 0 0 1-.58 0zM9.41 14.71L4.12 20 0 15.91l5.3-5.31 1.2 1.18-.59.59.59.59-.59.59-.59-.59-.59.59.59.59-.59.59-.59-.59-.64.59.58.59-.58.59-.59-.59-.59.59 1.76 1.77 4.13-4.13zM10.6 5.3L15.91 0 20 4.12l-5.29 5.29-1.16-1.16 4.13-4.13-1.77-1.76-1.77 1.76.59.59-.59.59-.59-.59-.59.59.59.59-.59.61-.59-.59-.58.59-1.18-1.18zm7.32 13.45a.84.84 0 0 1-.84-.83.85.85 0 0 1 .84-.84.84.84 0 0 1 .83.84.83.83 0 0 1-.83.83zm1.47-2.25l-9.95-10a2.24 2.24 0 0 1-.66-1.76A4.41 4.41 0 0 0 7.5 1.28 4.36 4.36 0 0 0 4.41 0a4.46 4.46 0 0 0-1.26.18l2.64 2.64c.29 1.33-1.63 3.27-3 3L.18 3.15A4.51 4.51 0 0 0 0 4.41a4.38 4.38 0 0 0 4.74 4.37 2.24 2.24 0 0 1 1.76.66l10 10a2.08 2.08 0 1 0 2.89-2.94z"
  }));
};

const SubNavLink = newStyled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.625rem 0.938rem 0.625rem 3.625rem;
  text-decoration: none;
  cursor: pointer;
  user-select: none;
  color: ${Color$1.blue200};
  overflow: visible;
  min-height: 51px;
  font-family: Open Sans;
  line-height: 1.375rem;

  :hover {
    background-color: ${Color$1.blue400};
    color: ${Color$1.white};
  }
`;

const SubNavItem = props => {
  return React__default.createElement(SubNavLink, {
    href: props.link
  }, props.linkText);
};

const ProjectsIcon = () => {
  return React__default.createElement("svg", {
    viewBox: "0 0 22.01 16"
  }, React__default.createElement("path", {
    d: "M21.5 5.8H5.34a1.2 1.2 0 0 0-1 .69L.76 15.31a.47.47 0 0 0 .48.69h16.6a1.14 1.14 0 0 0 1-.7l3.13-8.8a.5.5 0 0 0-.47-.7zM3.77 4.03h14a1.2 1.2 0 0 0 1-.69l.3-.76a.48.48 0 0 0-.49-.69H12.1a2 2 0 0 1-1.25-.55l-.69-.79A2 2 0 0 0 8.9 0H2.32a1.46 1.46 0 0 0-1.13.63L.38 1.97A3.17 3.17 0 0 0 0 3.35v8c0 .41.12.43.26.05l2.5-6.68a1.16 1.16 0 0 1 1.01-.69z"
  }));
};

let SubNavEnum;

(function (SubNavEnum) {
  SubNavEnum[SubNavEnum["NONE"] = 0] = "NONE";
  SubNavEnum[SubNavEnum["GENERIC"] = 1] = "GENERIC";
  SubNavEnum[SubNavEnum["PROJECTS"] = 2] = "PROJECTS";
  SubNavEnum[SubNavEnum["COLLECTORS"] = 3] = "COLLECTORS";
  SubNavEnum[SubNavEnum["CUSTOMERS"] = 4] = "CUSTOMERS";
})(SubNavEnum || (SubNavEnum = {}));

const CollectorsIcon = () => {
  return React__default.createElement("svg", {
    viewBox: "0 0 19 19"
  }, React__default.createElement("path", {
    d: "M17.5 0h-16A1.5 1.5 0 0 0 0 1.5v8.34h5.26l1.82-6.36a.86.86 0 0 1 1.66 0l1.94 8.06L12.29 7a.87.87 0 0 1 .71-.56.9.9 0 0 1 .83.44l1.66 3H19V1.5A1.5 1.5 0 0 0 17.5 0zM15 11.56a.86.86 0 0 1-.75-.44l-1-1.75-1.95 5.52a.86.86 0 0 1-.81.57.85.85 0 0 1-.79-.66L7.83 7.09l-1.1 3.85a.86.86 0 0 1-.83.62H0v5.94A1.5 1.5 0 0 0 1.5 19h16a1.5 1.5 0 0 0 1.5-1.5v-5.94h-4z"
  }));
};

const CustomersIcon = () => {
  return React__default.createElement("svg", {
    viewBox: "0 0 19.03 21.98"
  }, React__default.createElement("path", {
    d: "M5.57 9.87a8.52 8.52 0 0 0 1 1.88 3.22 3.22 0 0 0 .88 1 3.39 3.39 0 0 1-.3 1.45l-.16.14a4.66 4.66 0 0 0 2.52.7 4.75 4.75 0 0 0 2.46-.66 3.37 3.37 0 0 1-.2-.44 5.58 5.58 0 0 1-.13-1.23 3.41 3.41 0 0 0 .79-1 10.12 10.12 0 0 0 1-1.89.76.76 0 0 0 .5-.39 4.55 4.55 0 0 0 .51-2.53.46.46 0 0 0-.48-.28c.11-2.95-1.18-4.71-2.8-5.37A12.37 12.37 0 0 0 9.32.59C8.87.53 8.51.24 8.47 0c-.21 0-.76.81-.49 1.22 0 0-1.34-.07-1.56.85h.27a5.68 5.68 0 0 0-1.63 4.61.48.48 0 0 0-.49.28 4.54 4.54 0 0 0 .48 2.57.66.66 0 0 0 .52.34zm13.12 8.66c-.4-1.65-4.12-2.7-6.12-3.53a5.37 5.37 0 0 1-3 .89 5.28 5.28 0 0 1-3.3-1.07c-1.56.51-5.42 1.92-5.93 3.71a7.45 7.45 0 0 0-.34 1.9 1.52 1.52 0 0 0 1.44 1.54h16.13a1.52 1.52 0 0 0 1.44-1.54 7.83 7.83 0 0 0-.32-1.9z"
  }));
};

const AccessControl = props => {
  return React__default.createElement(React__default.Fragment, null, props.authorised && props.children);
};

const sideNavContext = React__default.createContext({});

class SideNavProvider extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      isSideNavOpen: false,
      openSubNav: SubNavEnum.NONE
    });

    _defineProperty$2(this, "toggleSideNav", () => {
      this.setState({
        isSideNavOpen: !this.state.isSideNavOpen,
        openSubNav: SubNavEnum.NONE
      });
    });

    _defineProperty$2(this, "closeFn", () => {
      if (this.state.isSideNavOpen) {
        this.setState({
          isSideNavOpen: false,
          openSubNav: SubNavEnum.NONE
        });
      }
    });

    _defineProperty$2(this, "setOpenSubNav", subNav => {
      const isSideNavOpen = this.state.isSideNavOpen;
      const openSubNav = this.state.openSubNav;

      if (isSideNavOpen === false) {
        this.setState({
          isSideNavOpen: true,
          openSubNav: subNav
        });
      }

      if (openSubNav === subNav) {
        this.setState({
          openSubNav: SubNavEnum.NONE
        });
      } else {
        this.setState({
          openSubNav: subNav
        });
      }
    });
  }

  render() {
    return React__default.createElement(sideNavContext.Provider, {
      value: {
        state: this.state,
        toggleSideNav: this.toggleSideNav,
        setOpenSubNav: this.setOpenSubNav,
        closeFn: this.closeFn
      }
    }, this.props.children);
  }

}

const ChevronIcon = () => {
  return React__default.createElement("svg", {
    viewBox: "0 0 24 14.48"
  }, React__default.createElement("path", {
    d: "M0 2.48L2.48 0l9.53 9.55L21.52 0 24 2.48l-11.99 12L0 2.48z"
  }));
};

const Container$3 = newStyled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(99%);
  background: ${s => s.activeLink ? Color$1.blueDell : Color$1.blue400};
  padding-right: 0.75rem;
  height: 100%;
  width: auto;
  color: #ffffff;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  align-items: center;
  padding-left: 0.2rem;
  line-height: 52px;
  z-index: 20;

  display: ${s => s.active ? 'block' : 'none'};
`;
const LabelWrapper = newStyled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    width: 13px;
    height: 8px;
    margin-top: 0.125rem;
    margin-left: 1rem;
    overflow: hidden;
    background: none;

    path {
      fill: #c8dff0;
    }

    display: ${s => s.active ? 'inline-block' : 'none'};
    transform: rotate(-90deg);
  }
`;
const Label = newStyled.p`
  white-space: nowrap;
  margin: 0;
  padding: 0;
  font-family: Open Sans;
`;
const HoverLabel = props => {
  return React__default.createElement(Container$3, {
    active: props.active,
    "data-testid": "hover-label-container",
    activeLink: props.activeLink
  }, React__default.createElement(LabelWrapper, {
    active: props.isParent
  }, React__default.createElement(Label, null, props.text), React__default.createElement(ChevronIcon, null)));
};

const NavLink = newStyled.a`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: Open Sans;
  min-height: 51px;

  padding: 0.85rem 0.75rem;
  border-bottom: 1px solid ${Color$1.blue400};
  text-decoration: none;
  color: ${s => s.active ? Color$1.white : Color$1.blue200};
  background-color: ${s => s.active ? Color$1.blueDell : ''};

  svg {
    path {
      fill: ${s => s.active ? Color$1.white + ' !important' : Color$1.blue200};
    }
  }

  :hover {
    background-color: ${s => s.active ? Color$1.blueDell : Color$1.blue400};
    color: ${Color$1.white};

    svg {
      path {
        fill: ${Color$1.white};
      }
    }
  }
`;
const NavLinkText = newStyled.span`
  white-space: nowrap;
  overflow: hidden;
  user-select: none;
  padding: 0.05rem 0;
`;
const IconWrapper$4 = newStyled.div`
  margin-right: 1rem;
  padding: 0.05rem 0;

  svg {
    width: 24px;
    max-width: 24px;
    max-height: 19px;

    path {
      fill: ${Color$1.blue200};
    }
  }
`;

class NavItem$3 extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      hover: false
    });

    _defineProperty$2(this, "handleMouseEnter", () => this.setState({
      hover: true
    }));

    _defineProperty$2(this, "handleMouseLeave", () => this.setState({
      hover: false
    }));

    _defineProperty$2(this, "activeLink", () => {
      if (this.props.link === '/') {
        if (window.location.pathname === '/' || window.location.pathname === '/home' || window.location.pathname === '/home/') return true;
      }

      return window.location.pathname === this.props.link;
    });
  }

  render() {
    return React__default.createElement(sideNavContext.Consumer, null, ({
      state
    }) => React__default.createElement(NavLink, {
      "data-testid": "navlink-container",
      target: this.props.openInNewTab ? '_blank' : '',
      href: this.props.link,
      onMouseEnter: !state.isSideNavOpen ? this.handleMouseEnter : () => null,
      onMouseLeave: !state.isSideNavOpen ? this.handleMouseLeave : () => null,
      active: this.activeLink()
    }, React__default.createElement(IconWrapper$4, null, this.props.children), React__default.createElement(NavLinkText, null, this.props.linkText), React__default.createElement(HoverLabel, {
      activeLink: this.activeLink(),
      active: !state.isSideNavOpen && this.state.hover,
      text: this.props.linkText
    })));
  }

}

const ToggleButton = newStyled.button`
  display: flex;
  justify-content: flex-end;
  border: none;
  border-bottom: 1px solid ${Color$1.blue400};
  width: 100%;
  background: none;
  color: inherit;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;
const SvgWrapper$1 = newStyled.div`
  svg {
    margin: 0.7rem 0;
    margin-right: 1rem;
    width: 1rem;
    height: 0.7rem;
    path {
      fill: #c8dff0;
    }

    transform: ${s => s.open ? 'rotate(90deg)' : 'rotate(-90deg)'};
  }
`;

const NavToggle = () => {
  return React__default.createElement(sideNavContext.Consumer, null, ({
    state,
    toggleSideNav
  }) => React__default.createElement(ToggleButton, {
    onClick: toggleSideNav
  }, React__default.createElement(SvgWrapper$1, {
    open: state.isSideNavOpen
  }, React__default.createElement(ChevronIcon, null))));
};

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);
  const observer = useMemo(() => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting)), [ref]);
  useEffect(() => {
    if (ref && ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);
  return isIntersecting;
}

const Container$2 = newStyled.nav`
  position: fixed;
  left: 0;
  top: 59px;
  background: ${Color$1.blue500};
  color: white;
  height: 100%;
  font-size: 0.95rem;
  min-width: 3.125rem;
  overflow: ${s => s.open ? 'hidden' : 'visible'};
  width: ${s => s.open ? '14.25rem' : '3.125rem'};
  will-change: transform, width;
  transition: width 250ms ease;
  z-index: 20;

  @media (max-width: 700px) {
    top: 208px;
  }
`;
const NavList = newStyled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: ${Color$1.blue200};
`;
const NavListContainer = newStyled.div`
  height: calc(100% - 5.75rem);
  overflow-x: ${s => s.isLastElementVisible ? '' : 'hidden'};
  overflow-y: ${s => s.isLastElementVisible ? '' : 'overlay'};

  :hover {
    ::-webkit-scrollbar {
      width: 0.313rem;
    }
  }

  ::-webkit-scrollbar {
    width: 0rem;
  }
    
  ::-webkit-scrollbar-thumb {
    background-color: ${Color$1.blue800};
    border-radius: 10rem;
  }

  ::-webkit-scrollbar-track {
    background: ${Color$1.blue800}4d; 
  }

  @media (max-width: 700px) {
    height: calc(100% - 15rem);
  }
`;

const NavPanel = props => {
  const ref = useRef(null);
  const context = useContext(sideNavContext);
  const lastElementRef = useRef(null);
  const isLastElementVisible = useOnScreen(lastElementRef);

  function handleOutsideClick(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      context.closeFn();
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [ref]);
  return React__default.createElement(sideNavContext.Consumer, null, ({
    state
  }) => React__default.createElement(Container$2, {
    "data-testid": "nav-panel-container",
    open: state.isSideNavOpen,
    ref: ref
  }, React__default.createElement(NavToggle, null), React__default.createElement(NavListContainer, {
    "data-testid": "nav-list-container",
    isLastElementVisible: isLastElementVisible
  }, React__default.createElement(NavList, null, props.children), React__default.createElement("div", {
    ref: lastElementRef
  }))));
};

const SvgWrapper = newStyled.div`
  overflow: hidden;
  background: none;

  svg {
    width: 13px;
    height: 8px;
    margin-top: -0.15rem;
    margin-right: 0.25rem;

    path {
      fill: #c8dff0;
    }

    display: ${s => s.sideNavOpen ? 'inline-block' : 'none'};
    transform: ${s => s.sideNavOpen && s.open ? 'rotate(0deg)' : 'rotate(-90deg)'};
    transition: transform 250ms ease;
  }
`;

const SubNavToggle = props => {
  return React__default.createElement(sideNavContext.Consumer, null, ({
    state
  }) => React__default.createElement(SvgWrapper, {
    sideNavOpen: state.isSideNavOpen,
    open: props.open
  }, React__default.createElement(ChevronIcon, null)));
};

const Container$1 = newStyled.a`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 0.85rem 0.75rem;
  border-bottom: 1px solid ${Color$1.blue400};
  text-decoration: none;
  color: ${Color$1.blue200};
  min-height: 51px;
  font-family: Open Sans;

  svg {
    width: 24px;
    max-width: 24px;
    max-height: 19px;

    path {
      fill: ${Color$1.blue200};
    }
  }

  :hover {
    background-color: ${Color$1.blue400};
    color: ${Color$1.white};

    svg {
      path {
        fill: ${Color$1.white};
      }
    }
  }
`;
const Constrainer = newStyled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  width: 100%;
  justify-content: space-between;
`;
const HiddenInner = newStyled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const IconWrapper$3 = newStyled.div`
  display: block;
  margin-right: 1rem;

  svg {
    width: 24px;
    max-width: 24px;
    max-height: 19px;

    path {
      fill: ${Color$1.blue200};
    }
  }
`;
const Text$2 = newStyled.span`
  white-space: nowrap;
  overflow: hidden;
  user-select: none;
  padding: 0.05rem 0;
`;
const SubNavList = newStyled.section`
  flex-direction: column;
  background: ${Color$1.blue500};
  color: white;
  height: 100%;
  width: 100%;
  overflow: hidden;

  border-bottom: ${s => s.visible ? '1px solid ' + Color$1.blue400 : ''};
  max-height: ${s => s.visible ? '30rem' : '0rem'};
  will-change: max-height;
  transition: max-height 250ms ease;
`;

class SubNavPanel extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      hover: false
    });

    _defineProperty$2(this, "SubNavIcon", this.props.icon);

    _defineProperty$2(this, "handleMouseEnter", () => this.setState({
      hover: true
    }));

    _defineProperty$2(this, "handleMouseLeave", () => this.setState({
      hover: false
    }));
  }

  render() {
    return React__default.createElement(sideNavContext.Consumer, null, ({
      state,
      setOpenSubNav
    }) => React__default.createElement(React__default.Fragment, null, React__default.createElement(Container$1, {
      "data-testid": "sub-nav-panel-container",
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      onClick: () => {
        setOpenSubNav(this.props.type);
      }
    }, React__default.createElement(Constrainer, null, React__default.createElement(HiddenInner, null, React__default.createElement(IconWrapper$3, null, React__default.createElement(this.SubNavIcon, null)), React__default.createElement(Text$2, null, this.props.text)), React__default.createElement(SubNavToggle, {
      open: state.openSubNav === this.props.type
    })), React__default.createElement(HoverLabel, {
      text: this.props.text,
      active: this.state.hover,
      isParent: true
    })), React__default.createElement(SubNavList, {
      "data-testid": "sub-nav-list",
      visible: state.isSideNavOpen && state.openSubNav === this.props.type
    }, this.props.children)));
  }

}

const PowerSizerIcon = () => {
  return React__default.createElement("svg", {
    viewBox: "0 0 22 18"
  }, React__default.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-725.263 -289)"
  }, React__default.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: "4",
    height: "18",
    rx: "2",
    transform: "translate(737.263 289)"
  }), React__default.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: "4",
    height: "14",
    rx: "2",
    transform: "translate(743.263 293)"
  }), React__default.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: "4",
    height: "14",
    rx: "2",
    transform: "translate(731.263 293)"
  }), React__default.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: "4",
    height: "8",
    rx: "2",
    transform: "translate(725.263 299)"
  })));
};

const SideNav = props => {
  const {
    navOptions
  } = props;
  return React__default.createElement(SideNavProvider, null, React__default.createElement(NavPanel, null, React__default.createElement(NavItem$3, {
    link: '/',
    linkText: 'Dashboard'
  }, React__default.createElement(DashboardIcon, null)), React__default.createElement(AccessControl, {
    authorised: navOptions.RequestDPACKCapture
  }, React__default.createElement(NavItem$3, {
    link: '/usermanagement/requestcapture',
    linkText: 'Request Capture'
  }, React__default.createElement(RequestCaptureIcon, null))), React__default.createElement(SubNavPanel, {
    type: SubNavEnum.PROJECTS,
    icon: ProjectsIcon,
    text: 'Projects'
  }, React__default.createElement(SubNavItem, {
    link: "/projects",
    linkText: 'Search Projects'
  }), React__default.createElement(AccessControl, {
    authorised: navOptions.UploadIokit
  }, React__default.createElement(SubNavItem, {
    link: "/collectorruns/Upload-Iokit",
    linkText: 'Upload SIOKIT & Files'
  })), React__default.createElement(AccessControl, {
    authorised: navOptions.ViewOpticalPrimeCollectorRuns
  }, React__default.createElement(SubNavItem, {
    link: "/collectorruns/search",
    linkText: 'Optical Prime Collector Runs'
  }))), React__default.createElement(AccessControl, {
    authorised: navOptions.ViewCollectors
  }, React__default.createElement(SubNavPanel, {
    type: SubNavEnum.COLLECTORS,
    icon: CollectorsIcon,
    text: 'Collectors'
  }, React__default.createElement(AccessControl, {
    authorised: navOptions.CanDownloadCollectors
  }, React__default.createElement(SubNavItem, {
    link: "/collector/download",
    linkText: 'Download Collector'
  })), React__default.createElement(AccessControl, {
    authorised: navOptions.CanDownloadDossier
  }, React__default.createElement(SubNavItem, {
    link: "/tools/dossier",
    linkText: 'Dossier'
  })), React__default.createElement(AccessControl, {
    authorised: navOptions.CanDownloadDataDomainLocalSummary
  }, React__default.createElement(SubNavItem, {
    link: "/collector/datadomain",
    linkText: 'Data Domain Local Summary'
  })), React__default.createElement(AccessControl, {
    authorised: navOptions.ManageCollectors
  }, React__default.createElement(SubNavItem, {
    link: "/collector/manage",
    linkText: 'Manage Collectors'
  })))), React__default.createElement(AccessControl, {
    authorised: navOptions.SearchManageUsers || navOptions.SearchCustomers
  }, React__default.createElement(SubNavPanel, {
    type: SubNavEnum.CUSTOMERS,
    icon: CustomersIcon,
    text: 'Customers'
  }, React__default.createElement(AccessControl, {
    authorised: navOptions.RequestDPACKCapture
  }, React__default.createElement(SubNavItem, {
    link: "/usermanagement/dpackcapture",
    linkText: 'Request Capture'
  })), React__default.createElement(AccessControl, {
    authorised: navOptions.CreateUser
  }, React__default.createElement(SubNavItem, {
    link: "/usermanagement/register",
    linkText: 'Register New User'
  })), React__default.createElement(AccessControl, {
    authorised: navOptions.CreateChannelPartner
  }, React__default.createElement(SubNavItem, {
    link: "/usermanagement/registerchannelpartner",
    linkText: 'Register New Partner User'
  })), React__default.createElement(AccessControl, {
    authorised: navOptions.SearchManageUsers || navOptions.SearchCustomers
  }, React__default.createElement(SubNavItem, {
    link: "/customers",
    linkText: 'Search & Manage Users'
  })), React__default.createElement(AccessControl, {
    authorised: navOptions.ApprovePromoSiteUsers
  }, React__default.createElement(SubNavItem, {
    link: "/usermanagement/UserApproval",
    linkText: 'Promo Site User Approval'
  })))), React__default.createElement(AccessControl, {
    authorised: navOptions.EditOwnTeam
  }, React__default.createElement(NavItem$3, {
    link: '/team/members',
    linkText: 'My Team'
  }, React__default.createElement(TeamsIcon, null))), React__default.createElement(AccessControl, {
    authorised: navOptions.SearchTeams
  }, React__default.createElement(NavItem$3, {
    link: '/Team/Search',
    linkText: 'Teams'
  }, React__default.createElement(TeamsIcon, null))), React__default.createElement(AccessControl, {
    authorised: navOptions.SiteAdministrator
  }, React__default.createElement(NavItem$3, {
    link: '/AdminPanel',
    linkText: 'Admin Panel'
  }, React__default.createElement(CogIcon, null))), React__default.createElement(NavItem$3, {
    link: '/account/myprofile',
    linkText: 'My Profile'
  }, React__default.createElement(CogIcon, null)), React__default.createElement(AccessControl, {
    authorised: navOptions.AccessToTools
  }, React__default.createElement(NavItem$3, {
    link: '/tools',
    linkText: 'Tools'
  }, React__default.createElement(ToolsIcon, null))), React__default.createElement(AccessControl, {
    authorised: navOptions.ViewPowerSizer
  }, React__default.createElement(NavItem$3, {
    openInNewTab: true,
    link: 'https://powersizer.dell.com',
    linkText: 'PowerSizer'
  }, React__default.createElement(PowerSizerIcon, null)))));
};

const LogoV2 = props => {
  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: "215",
    height: "41",
    viewBox: "0 0 215 41"
  }, props), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "clip-path"
  }, React__default.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: "215",
    height: "41",
    fill: "none"
  }))), React__default.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    "clip-path": "url(#clip-path)"
  }, React__default.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M19.073,75.455A11.981,11.981,0,0,1,16.706,73.5L13,76.656a16.722,16.722,0,0,0,3.671,3.054Z",
    transform: "translate(-8.539 -48.284)",
    fill: "#f2af00"
  }), React__default.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M32.636,87.072l.412-4.837A11.738,11.738,0,0,1,29.1,81l-2.4,4.22a17.065,17.065,0,0,0,5.936,1.853",
    transform: "translate(-17.539 -53.211)",
    fill: "#f2af00"
  }), React__default.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M57.381,73.3a12.257,12.257,0,0,1-5.489,3.431,12.681,12.681,0,0,1-3.568.549h-.411L47.5,82.117a16.836,16.836,0,0,0,5.8-.72,17.144,17.144,0,0,0,7.822-4.975Z",
    transform: "translate(-31.203 -48.153)",
    fill: "#f2af00"
  }), React__default.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M72.6,52.278l2.676.961a10.652,10.652,0,0,0,.446-2.539H72.875a11.653,11.653,0,0,1-.275,1.578",
    transform: "translate(-47.692 -33.306)",
    fill: "#f2af00"
  }), React__default.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M72.054,60.453a4.21,4.21,0,0,0,.412-.892L69.79,58.6c-.069.172-.172.343-.24.515a7.3,7.3,0,0,1-.549.858l2.2,1.818a6.831,6.831,0,0,0,.858-1.338",
    transform: "translate(-45.327 -38.496)",
    fill: "#f2af00"
  }), React__default.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M55.238,65.4a8.218,8.218,0,0,1-3.431,2.093,7.686,7.686,0,0,1-2.333.343h-.034L49.2,70.683a10.847,10.847,0,0,0,3.465-.48,11.284,11.284,0,0,0,4.8-2.985Z",
    transform: "translate(-32.32 -42.963)",
    fill: "#f2af00"
  }), React__default.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M88.863,55.3a18.01,18.01,0,0,0,.823-4.7l-4.872.034a11.366,11.366,0,0,1-.515,3.019Z",
    transform: "translate(-55.378 -33.241)",
    fill: "#7ab800"
  }), React__default.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M83.478,32.593a14.047,14.047,0,0,1,.515,2.917l4.872-.034a18.386,18.386,0,0,0-.72-4.288,15.794,15.794,0,0,0-.652-1.784L83.1,31.5a8.2,8.2,0,0,1,.377,1.1",
    transform: "translate(-54.59 -19.316)",
    fill: "#7ab800"
  }), React__default.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M57.8,4.837A11.656,11.656,0,0,1,60.888,6a12.114,12.114,0,0,1,5.043,5.043l4.391-2.093A17.343,17.343,0,0,0,58.59,0Z",
    transform: "translate(-37.969)",
    fill: "#7ab800"
  }), React__default.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M48.2,20.183l.48-2.813c-.412-.034-.823-.069-1.235-.069-.446,0-.892.034-1.338.069l.515,2.813a12.111,12.111,0,0,1,1.578,0",
    transform: "translate(-30.287 -11.366)",
    fill: "#7ab800"
  }), React__default.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M36.976,21.562a6.823,6.823,0,0,1,1.166-.446l.309-.1L37.936,18.2c-.206.069-.446.1-.652.172a8.833,8.833,0,0,0-1.784.72Z",
    transform: "translate(-23.32 -11.956)",
    fill: "#7ab800"
  }), React__default.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M55.7,21.045a9.119,9.119,0,0,1,1.819.72,7.774,7.774,0,0,1,3.191,3.122l2.573-1.2a10.705,10.705,0,0,0-4.425-4.391,10.957,10.957,0,0,0-2.676-.995Z",
    transform: "translate(-36.59 -12.022)",
    fill: "#7ab800"
  }), React__default.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M6.3,25.5l.412-.72L2.735,22c-.24.377-.48.789-.72,1.2A17.059,17.059,0,0,0,.848,36.615l4.563-1.681A12.162,12.162,0,0,1,6.3,25.5",
    transform: "translate(0.011 -14.452)",
    fill: "#4694ce"
  }), React__default.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M28.771,6.032a10.744,10.744,0,0,1,2.058-.823L31.652,5,30.795.2c-.446.1-.927.206-1.372.343A19.189,19.189,0,0,0,26.3,1.812Z",
    transform: "translate(-17.276 -0.131)",
    fill: "#4694ce"
  }), React__default.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M13.914,13.7a13.038,13.038,0,0,1,3.019-2.813L14.5,6.7a16.837,16.837,0,0,0-4.6,4.22Z",
    transform: "translate(-6.503 -4.401)",
    fill: "#4694ce"
  }), React__default.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M22.034,34.321c.069-.1.1-.206.172-.309L19.872,32.4c-.1.206-.24.377-.343.583a10.849,10.849,0,0,0-.823,8.268l2.676-.995a7.977,7.977,0,0,1,.652-5.935",
    transform: "translate(-11.98 -21.284)",
    fill: "#4694ce"
  }), React__default.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M29.162,65.5,27,67.353A10.377,10.377,0,0,0,28.99,69l1.407-2.47A6.15,6.15,0,0,1,29.162,65.5",
    transform: "translate(-17.736 -43.029)",
    fill: "#4694ce"
  }), React__default.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M22.1,62.025l2.161-1.853a6.79,6.79,0,0,1-.789-1.372l-2.676.995a13.083,13.083,0,0,0,1.3,2.23",
    transform: "translate(-13.663 -38.627)",
    fill: "#4694ce"
  }), React__default.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M123.779,15.949a35.791,35.791,0,0,0,.583-3.534c.1-.995.172-1.853.172-2.539a4.6,4.6,0,0,0-.034-.72,3.781,3.781,0,0,0-.069-.618c.446-.069.926-.137,1.475-.172s1.029-.069,1.441-.069a12.964,12.964,0,0,1,2.436.24,4.274,4.274,0,0,1,.206,1.441,11.983,11.983,0,0,1-.137,1.818c-.1.686-.24,1.441-.377,2.23l-2.916,15.3a7.247,7.247,0,0,0-.1,1.063,2.407,2.407,0,0,0,.172.961,1.432,1.432,0,0,0,.446.549,1.233,1.233,0,0,0,.618.24,4.65,4.65,0,0,0,.686.069c.1,0,.274-.034.583-.069a4.1,4.1,0,0,0,.755-.172,8.468,8.468,0,0,1,.309,1.407,7.83,7.83,0,0,1,.137,1.544,3.329,3.329,0,0,1-.034.583,3.819,3.819,0,0,1-.069.583,9.109,9.109,0,0,1-1.475.377,12.247,12.247,0,0,1-2.024.137,6.061,6.061,0,0,1-4.083-1.269A5.012,5.012,0,0,1,121,31.318c0-.343.034-.72.069-1.132a9.257,9.257,0,0,1,.206-1.235Z",
    transform: "translate(-79.487 -5.451)",
    fill: "#0076ce"
  }), React__default.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M160.246,20.362h-2.4a.67.67,0,0,0-.034-.24c0-.069-.034-.172-.034-.274a8.068,8.068,0,0,1,.206-1.853,9.817,9.817,0,0,1,.583-1.784h7.685L162.785,35.9a19.812,19.812,0,0,1-2.745.24,13.471,13.471,0,0,1-2.539-.24Zm1.1-7.41a12.309,12.309,0,0,1,.172-2.539,21.329,21.329,0,0,1,.652-2.539,9.1,9.1,0,0,1,1.441-.205c.515-.034.961-.069,1.372-.069s.858.034,1.338.069a8.232,8.232,0,0,1,1.372.206,12.038,12.038,0,0,1-.24,2.539,14.394,14.394,0,0,1-.686,2.5,9.34,9.34,0,0,1-1.441.137c-.48.034-.961.034-1.338.034s-.823,0-1.338-.034a5.432,5.432,0,0,1-1.3-.1",
    transform: "translate(-103.466 -4.993)",
    fill: "#0076ce"
  }), React__default.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M191.5,32.26a19.459,19.459,0,0,1,2.813-.24,17.235,17.235,0,0,1,2.985.24l1.475,14.409,4.289-9.3a16.441,16.441,0,0,0,1.063-2.882,10.132,10.132,0,0,0,.206-1.853v-.412c.446-.069.892-.137,1.441-.172.515-.034,1.063-.069,1.612-.069a16.457,16.457,0,0,1,3.054.24v.206a6.225,6.225,0,0,1-.446,2.161,28.085,28.085,0,0,1-1.544,3.259l-7.685,14.066a11.729,11.729,0,0,1-1.544.137c-.549.034-.961.034-1.338.034-.343,0-.823,0-1.441-.034a6.846,6.846,0,0,1-1.544-.172Z",
    transform: "translate(-125.801 -21.008)",
    fill: "#0076ce"
  }), React__default.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M251.951,44.254a3.612,3.612,0,0,0,4.083,3.6,10.247,10.247,0,0,0,2.676-.309,23.719,23.719,0,0,0,2.47-.858A4.156,4.156,0,0,1,262,48.542a12.191,12.191,0,0,1,.206,2.3,10.849,10.849,0,0,1-1.51.549,15,15,0,0,1-1.784.412c-.618.1-1.235.206-1.818.274a15.094,15.094,0,0,1-1.647.1,12.33,12.33,0,0,1-3.98-.583,7.459,7.459,0,0,1-2.744-1.613,6.318,6.318,0,0,1-1.612-2.539,10.259,10.259,0,0,1-.514-3.328,14.03,14.03,0,0,1,.789-4.563,13.526,13.526,0,0,1,2.264-4.013,11.2,11.2,0,0,1,3.568-2.847,10.242,10.242,0,0,1,4.735-1.1,8.52,8.52,0,0,1,2.333.309,5.7,5.7,0,0,1,1.887.926,4.27,4.27,0,0,1,1.269,1.544,4.626,4.626,0,0,1,.446,2.127,5.7,5.7,0,0,1-.789,2.985,7.389,7.389,0,0,1-2.127,2.127,12.942,12.942,0,0,1-3.019,1.441,19.644,19.644,0,0,1-3.534.823Zm2.161-3.911a10.822,10.822,0,0,0,2.367-.583,5.528,5.528,0,0,0,1.441-.789,2.435,2.435,0,0,0,.72-.892,2.264,2.264,0,0,0,.206-.926,1.523,1.523,0,0,0-.48-1.166,1.9,1.9,0,0,0-1.269-.446,3.662,3.662,0,0,0-1.818.446,5.256,5.256,0,0,0-1.441,1.166,7.986,7.986,0,0,0-1.063,1.647,7.7,7.7,0,0,0-.652,1.887Z",
    transform: "translate(-161.997 -20.753)",
    fill: "#0076ce"
  }), React__default.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M334.123,52.019q-3.911,0-5.764-2.058a8.121,8.121,0,0,1-1.853-5.626,16.594,16.594,0,0,1,.686-4.6,12.717,12.717,0,0,1,2.058-4.151,11.177,11.177,0,0,1,3.431-3.019,9.525,9.525,0,0,1,4.837-1.167c2.642,0,4.563.686,5.8,2.093a8.273,8.273,0,0,1,1.853,5.661,16.245,16.245,0,0,1-.652,4.632,13.553,13.553,0,0,1-2.025,4.117,10.323,10.323,0,0,1-3.465,2.95,9.7,9.7,0,0,1-4.906,1.166m.514-4.117a3.423,3.423,0,0,0,2.436-.926,7.322,7.322,0,0,0,1.612-2.264,11.466,11.466,0,0,0,.892-2.847,16.462,16.462,0,0,0,.275-2.71c0-2.333-.961-3.5-2.848-3.5a3.233,3.233,0,0,0-2.4.961,6.6,6.6,0,0,0-1.544,2.333,12.114,12.114,0,0,0-.858,2.882,16.436,16.436,0,0,0-.24,2.71c-.034,2.264.858,3.362,2.676,3.362",
    transform: "translate(-214.492 -20.628)",
    fill: "#0076ce"
  }), React__default.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M383.9,40.414c.274-1.612.48-3.019.618-4.254a27.873,27.873,0,0,0,.206-2.882v-.72a3.734,3.734,0,0,0-.034-.618,15.471,15.471,0,0,1,2.5-.24,12.625,12.625,0,0,1,2.4.24c.034.206.1.446.137.72a10.234,10.234,0,0,1,.069,1.269,3.939,3.939,0,0,1-.034.652,3.542,3.542,0,0,1-.1.755,7.3,7.3,0,0,1,2.676-2.745,7.733,7.733,0,0,1,4.083-1.1,4.866,4.866,0,0,1,4.083,1.818,8.576,8.576,0,0,1,1.441,5.283,16.586,16.586,0,0,1-.72,4.769,11.949,11.949,0,0,1-6.381,7.479,13.808,13.808,0,0,1-6.141,1.2,6.946,6.946,0,0,1-.961-.034c-.206-.034-.377-.034-.514-.069l-1.51,8.645a12.122,12.122,0,0,1-1.441.206c-.446.034-.892.034-1.3.034-.446,0-.858,0-1.3-.034a10.233,10.233,0,0,1-1.373-.206Zm4.151,7a2.333,2.333,0,0,0,.789.137,8.988,8.988,0,0,0,.961.034,5.251,5.251,0,0,0,2.882-.789,6.477,6.477,0,0,0,1.99-1.99,8.667,8.667,0,0,0,1.132-2.642,11.545,11.545,0,0,0,.377-2.813,4.472,4.472,0,0,0-.549-2.3,1.983,1.983,0,0,0-1.887-.961,3.845,3.845,0,0,0-3.019,1.475,10.553,10.553,0,0,0-1.818,4.906Z",
    transform: "translate(-249.829 -20.687)",
    fill: "#0076ce"
  }), React__default.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M453.711,26.209h-2.916a13.082,13.082,0,0,1,.137-2.024,8.766,8.766,0,0,1,.583-2.093h2.916l.24-1.132a11.509,11.509,0,0,0,.24-1.818c.034-.583.034-1.063.034-1.441a6.755,6.755,0,0,1,2.47-.926,16.151,16.151,0,0,1,2.745-.274,4.274,4.274,0,0,1,.206,1.441,8.686,8.686,0,0,1-.1,1.3c-.069.48-.137.995-.24,1.544l-.24,1.269h4.734a9.836,9.836,0,0,1-.206,2.093,20.233,20.233,0,0,1-.549,2.024h-4.734l-1.338,7.513c-.034.343-.1.686-.137,1a7.8,7.8,0,0,0-.069.892,2.363,2.363,0,0,0,.446,1.544,2.148,2.148,0,0,0,1.715.583,5.31,5.31,0,0,0,1.132-.1c.343-.069.618-.137.926-.206a6.922,6.922,0,0,1,.48,2.882v.618a3.731,3.731,0,0,1-.034.618,13.257,13.257,0,0,1-3.911.48,7.763,7.763,0,0,1-4.734-1.166,4.65,4.65,0,0,1-1.544-3.945c0-.377.034-.789.069-1.166a10.646,10.646,0,0,1,.206-1.338Z",
    transform: "translate(-296.137 -10.839)",
    fill: "#0076ce"
  }), React__default.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M501.746,20.358h-2.4a.67.67,0,0,0-.034-.24.756.756,0,0,1-.034-.274,8.069,8.069,0,0,1,.206-1.853,9.815,9.815,0,0,1,.583-1.784h7.685L504.285,35.9a19.812,19.812,0,0,1-2.745.24A13.47,13.47,0,0,1,499,35.9Zm1.132-7.41a12.311,12.311,0,0,1,.172-2.539,21.338,21.338,0,0,1,.652-2.539,9.105,9.105,0,0,1,1.441-.206c.514-.034.961-.069,1.372-.069s.858.034,1.338.069a9.258,9.258,0,0,1,1.407.206,12.04,12.04,0,0,1-.24,2.539,14.4,14.4,0,0,1-.686,2.5,9.339,9.339,0,0,1-1.441.137c-.48.034-.961.034-1.338.034s-.823,0-1.338-.034a5.438,5.438,0,0,1-1.338-.1",
    transform: "translate(-327.807 -4.988)",
    fill: "#0076ce"
  }), React__default.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M543.506,47.039a6.1,6.1,0,0,1,.686,1.647,9.732,9.732,0,0,1,.274,2.5,11.094,11.094,0,0,1-2.573.755,20.325,20.325,0,0,1-3.019.24c-2.882,0-5.009-.72-6.347-2.127a8.059,8.059,0,0,1-2.024-5.8,13.733,13.733,0,0,1,.755-4.494,12.689,12.689,0,0,1,2.2-4.083,11.5,11.5,0,0,1,3.568-2.95,10.253,10.253,0,0,1,4.906-1.132,14.8,14.8,0,0,1,2.5.206,12.948,12.948,0,0,1,2.333.618,10.121,10.121,0,0,1-.343,2.127,7.586,7.586,0,0,1-.961,2.161,10.3,10.3,0,0,0-1.647-.549A7.363,7.363,0,0,0,542,35.957a4.781,4.781,0,0,0-2.573.652,6.412,6.412,0,0,0-1.853,1.75,7.93,7.93,0,0,0-1.1,2.5,11.713,11.713,0,0,0-.377,2.916,3.967,3.967,0,0,0,1.063,3.088,3.88,3.88,0,0,0,2.71,1,8.893,8.893,0,0,0,1.647-.137c.48-.172,1.167-.377,1.99-.686",
    transform: "translate(-348.503 -20.759)",
    fill: "#0076ce"
  }), React__default.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M583.791,43.016a6.7,6.7,0,0,1-1.235-.583,4.792,4.792,0,0,1-1.132-.926,4.391,4.391,0,0,1-.823-1.338,5.309,5.309,0,0,1-.309-1.887,6.319,6.319,0,0,1,.617-2.847,6.023,6.023,0,0,1,1.75-2.093,7.922,7.922,0,0,1,2.642-1.3,11.011,11.011,0,0,1,3.259-.446c.412,0,.858.034,1.338.069s.961.1,1.475.172a10.8,10.8,0,0,1,1.441.309,6.128,6.128,0,0,1,1.269.515,7.883,7.883,0,0,1-.377,1.956,8.414,8.414,0,0,1-.926,1.955,8.1,8.1,0,0,0-1.955-.686,9.817,9.817,0,0,0-2.161-.274c-.274,0-.583.034-.926.069a3.091,3.091,0,0,0-.961.274,1.8,1.8,0,0,0-.755.583,1.467,1.467,0,0,0-.309.961,1.983,1.983,0,0,0,1.441,1.784l1.475.652a10.871,10.871,0,0,1,1.407.72,5.475,5.475,0,0,1,1.2.961,4.475,4.475,0,0,1,.858,1.338,4.737,4.737,0,0,1,.309,1.784,6.674,6.674,0,0,1-.755,3.293,7.078,7.078,0,0,1-2.058,2.333,8.573,8.573,0,0,1-3.054,1.372,14.7,14.7,0,0,1-3.739.446,15.835,15.835,0,0,1-2.71-.24,11.683,11.683,0,0,1-2.676-.755,9.469,9.469,0,0,1,1.132-4.117,10.26,10.26,0,0,0,2.4.755,14.407,14.407,0,0,0,2.367.206,8.166,8.166,0,0,0,1.235-.1,3.884,3.884,0,0,0,1.166-.377,2.34,2.34,0,0,0,.892-.755,1.9,1.9,0,0,0,.377-1.166,1.5,1.5,0,0,0-.549-1.235,4.918,4.918,0,0,0-1.475-.858Z",
    transform: "translate(-379.318 -20.75)",
    fill: "#0076ce"
  })));
};

const Masthead = newStyled.header`
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid #e4e4e4;
  background-color: #ffffff;
  height: 60px;

  @media (max-width: 700px) {
    flex-direction: column;
    height: auto;
  }
`;
const LogoLinkWrapper = newStyled.a`
  padding-top: 12px;
  padding-bottom: 7px;
  padding-left: 20px;
  align-items: center;
  height: 60px;

  @media (max-width: 700px) {
    height: auto;
  }
`;
const ActionItems = newStyled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: left;
]  }
`;
const HeaderV2 = props => {
  return React__default.createElement(Masthead, null, React__default.createElement(LogoLinkWrapper, {
    href: "/"
  }, React__default.createElement(LogoV2, {
    preserveAspectRatio: "xMinYMin"
  })), React__default.createElement(ActionItems, null, props.children));
};

const TabHeaderContainer$2 = newStyled.nav`
  width: 100%;
  height: 2.8125rem;
  background: #fff;
  display: flex;
`;
const NavItem$2 = newStyled.div`
  background-color: ${s => s.selected ? '#F5F6FB' : '#fff'};
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #e4e4e4;
  line-height: 1em;
  padding-right: 14px;
  font-size: 14px;
  cursor: pointer;
  color: #4694ce;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${p => p.selected ? '#F5F6FB' : '#e4e4e4'};
`;
const NavBorder = newStyled.div`
  background: #fff;
  border-bottom: 1px solid #e4e4e4;
  flex: 1;
`;
const IconWrapper$2 = newStyled.span`
  padding-left: 12px;
  padding-right: 8px;
`;
const TabContent$2 = newStyled.div`
  width: 100%;
  height: 100%;
  opacity: ${p => p.selected ? 1 : 0};
  height: ${p => p.selected ? 'auto' : 0};
  overflow-y: ${p => p.selected ? 'unset' : 'hidden'};
`;
const ViewerTabsContext = React__default.createContext({});
const ViewerTabs = ({
  children,
  initialTabIndex
}) => {
  if (!children) {
    throw new Error('Secondary Tabs requires children of Tab type.');
  }

  if (!children.length) {
    children = [children];
  }

  const [currentTabIndex, setCurrentTabIndex] = useState(initialTabIndex || 0);

  const changeTab = tabIndex => {
    setCurrentTabIndex(tabIndex);
  };

  return React__default.createElement(Fragment$1, null, React__default.createElement(ViewerTabsContext.Provider, {
    value: {
      changeTab,
      currentTabIndex
    }
  }, React__default.createElement(TabHeaderContainer$2, null, React__default.Children.count(children) && React__default.Children.map(children, (child, tabIndex) => {
    return React__default.createElement(NavItem$2, {
      selected: currentTabIndex === tabIndex,
      key: tabIndex,
      onClick: () => {
        changeTab(tabIndex);
      }
    }, React__default.createElement(IconWrapper$2, null, child && child.props.icon), React__default.createElement("span", null, child && child.props.title));
  }), React__default.createElement(NavBorder, null)), React__default.Children.map(children, (child, tabIndex) => {
    return React__default.createElement(TabContent$2, {
      selected: currentTabIndex === tabIndex
    }, child.props.children);
  })));
};
const useViewerTabsContext = () => {
  return React__default.useContext(ViewerTabsContext);
};

const TabHeaderContainer$1 = newStyled.nav`
  width: 100%;
  height: 35px;
  background: transparent;
  display: flex;
`;
const NavItem$1 = newStyled.div`
  background-color: transparent;
  display: flex;
  height: 100%;
  min-width: 128px;
  justify-content: center;
  align-items: center;
  line-height: 16px;
  font-size: 18px;
  cursor: pointer;
  color: ${s => s.selected ? '#0076CE' : '#809DC4'};
  font-weight: 600;
  border-bottom: ${p => p.selected ? '4px solid #0076CE ' : '4px solid transparent'};
  transition: border-color 0.5s ease;
`;
const IconWrapper$1 = newStyled.span`
  padding-right: 8px;
`;
const TabContent$1 = newStyled.div`
  width: 100%;
  height: 100%;
`;
const PrimaryTabs = ({
  children
}) => {
  if (!children) {
    throw new Error('Secondary Tabs requires children of Tab type.');
  }

  if (!children.length) {
    children = [children];
  }

  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  const changeTab = tabIndex => {
    setCurrentTabIndex(tabIndex);
  };

  const isBeforeSelected = tabIndex => {
    const distance = currentTabIndex - tabIndex;
    return distance === 1;
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(TabHeaderContainer$1, null, children && children.map((child, tabIndex) => {
    return React__default.createElement(NavItem$1, {
      selected: currentTabIndex === tabIndex,
      beforeSelected: isBeforeSelected(tabIndex),
      key: tabIndex,
      onClick: () => {
        changeTab(tabIndex);
      }
    }, React__default.createElement(IconWrapper$1, null, child && child.props.icon), child && child.props.title);
  })), React__default.createElement(TabContent$1, null, children[currentTabIndex].props.children));
};

const TabHeaderContainer = newStyled.nav`
  width: 100%;
  height: 35px;
  background: #fff;
  display: flex;
`;
const NavItem = newStyled.div`
  background-color: ${s => s.selected ? '#0076CE' : '#fff'};
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  line-height: 16px;
  font-size: 12px;
  cursor: pointer;
  color: ${s => s.selected ? '#fff' : '#0076CE'};
  font-weight: 600;
  border-style: solid;
  border-left: none;
  border-top-width: 1px;
  border-top-style: solid;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-right-width: ${p => p.beforeSelected ? '0' : '1px'};
  border-color: ${p => p.selected ? '#0076CE' : '#e4e4e4'};

  &:first-of-type {
    border-left-width: 1px;
    border-left-style: solid;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;
const TabContent = newStyled.div`
  width: 100%;
  height: 100%;
`;
const SecondaryTabs = ({
  children,
  changeTab: changeTabProps
}) => {
  if (!children || React__default.Children.count(children) === 0) {
    throw new Error('Secondary Tabs requires children of Tab type.');
  }

  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  const changeTab = tabIndex => {
    setCurrentTabIndex(tabIndex);

    if (changeTabProps) {
      changeTabProps(tabIndex);
    }
  };

  const isBeforeSelected = tabIndex => {
    const distance = currentTabIndex - tabIndex;
    return distance === 1;
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(TabHeaderContainer, null, React__default.Children.map(children, (child, tabIndex) => {
    return React__default.createElement(NavItem, {
      selected: currentTabIndex === tabIndex,
      beforeSelected: isBeforeSelected(tabIndex),
      key: tabIndex,
      onClick: () => {
        changeTab(tabIndex);
      }
    }, child && child.props && React__default.createElement("span", null, child && child.props.title));
  })), React__default.createElement(TabContent, null, children[currentTabIndex].props.children));
};

const Tab = ({
  children
}) => {
  return React__default.createElement(React__default.Fragment, null, children);
};

const ViewerTabsWithContext = props => {
  const context = useViewerTabsContext();
  return React.createElement(React.Fragment, null, props.render(_objectSpread2({}, context)));
};

const {
  Provider,
  Consumer
} = React__default.createContext({});

class UserMenuProvider extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      active: false
    });

    _defineProperty$2(this, "toggle", () => {
      this.setState(prevState => ({
        active: !prevState.active
      }));
    });
  }

  render() {
    return React__default.createElement(Provider, {
      value: {
        state: this.state,
        toggle: this.toggle
      }
    }, this.props.children);
  }

}

const OpenIcon$2 = newStyled.svg`
  width: 1rem;
  height: 1rem;
  display: block;
  display: ${p => p.active ? 'none' : 'inline-block'};
  color: ${p => p.active ? '#ffffff' : '#4694ce'};
`;

const MenuOpen = () => {
  return React__default.createElement(Consumer, null, ({
    state
  }) => React__default.createElement(OpenIcon$2, {
    "data-testid": "menu-open-open-icon",
    active: state.active,
    viewBox: "0 0 125 125"
  }, React__default.createElement("path", {
    d: "M62.5 114.58a52 52 0 0 1-40.36-19.22c1.35-3.06 4.08-5.18 9.72-6.49 11.69-2.7 23.22-5.11 17.67-15.34C33.11 43.23 44.86 26 62.5 26c17.3 0 29.34 16.55 13 47.49-5.43 10.21 5.69 12.63 17.63 15.39 5.64 1.3 8.39 3.41 9.74 6.46a52 52 0 0 1-40.37 19.24zM62.5 0A62.5 62.5 0 1 0 125 62.5 62.5 62.5 0 0 0 62.5 0z"
  })));
};

const CloseIcon$1 = newStyled.svg`
  width: 1rem;
  height: 1rem;
  display: ${p => p.active ? 'inline-block' : 'none'};
  color: ${p => p.active ? '#ffffff' : '#4694ce'};
`;

const MenuClose = () => {
  return React__default.createElement(Consumer, null, ({
    state
  }) => React__default.createElement(CloseIcon$1, {
    "data-testid": "menu-close-close-icon",
    active: state.active,
    viewBox: "0 0 20 20"
  }, React__default.createElement("path", {
    d: "M20 2.73L17.27 0 10 7.27 2.73 0 0 2.73 7.27 10 0 17.27 2.73 20 10 12.73 17.27 20 20 17.27 12.73 10z"
  })));
};

const Toggle$3 = newStyled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-left: 1px solid #e4e4e4;
  height: 100%;
  width: 11rem;
  background: none;
  color: inherit;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;

  background: ${p => p.active ? '#57a8e6' : '#ffffff'};

  :hover {
    transition: background 300ms ease;
    background: #57a8e6;
  }

  :hover svg path {
    fill: #ffffff;
  }

  :hover span {
    color: #ffffff;
  }

  @media (max-width: 700px) {
    border-left: none;
    padding:10px;
    width: 50px;
    justify-content: flex-start;
  }
`;
const UserSnippet$1 = newStyled.div`
  display: inline-flex;
  align-items: center;
`;
const UserName$1 = newStyled.span`
  font-size: 0.9rem;
  font-weight: 600;
  margin-left: 0.5rem;
  user-select: none;
  padding-bottom: 0.1rem;

  color: ${p => p.active ? '#ffffff' : '#4694ce'};
  display: ${p => p.active ? 'none' : 'inline-block'};
`;

const UserToggle = props => {
  return React__default.createElement(Consumer, null, ({
    state,
    toggle
  }) => React__default.createElement(Toggle$3, {
    "data-testid": "user-toggle-toggle",
    active: state.active,
    onClick: toggle
  }, React__default.createElement(UserSnippet$1, null, React__default.createElement(MenuOpen, null), React__default.createElement(UserName$1, {
    "data-testid": "user-toggle-username",
    active: state.active
  }, props.userName)), React__default.createElement(MenuClose, null)));
};

const Info$1 = newStyled.div`
  text-align: center;
  padding: 25px;
  background: #4694ce;
`;
const Icon$6 = newStyled.svg`
  width: 70px;
  height: 70px;

  path {
    fill: #daeaf5;
  }
`;
const Name$1 = newStyled.h5`
  color: #fff;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 15px;
  margin-top: 15px;
  padding: 0;
  user-select: none;
`;
const Role$1 = newStyled.p`
  color: #fff;
  padding: 0;
  margin: 0;
  user-select: none;
  font-size: 0.85rem;
`;

const UserHeader = props => {
  const {
    userName,
    userRole
  } = props;
  return React__default.createElement(Info$1, null, React__default.createElement(Icon$6, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 125"
  }, React__default.createElement("path", {
    d: "M62.5,114.58A52,52,0,0,1,22.14,95.36c1.35-3.06,4.08-5.18,9.72-6.49,11.69-2.7,23.22-5.11,17.67-15.34C33.11,43.23,44.86,26,62.5,26c17.3,0,29.34,16.55,13,47.49C70.07,83.7,81.19,86.12,93.13,88.88c5.64,1.3,8.39,3.41,9.74,6.46A52,52,0,0,1,62.5,114.58ZM62.5,0A62.5,62.5,0,1,0,125,62.5,62.5,62.5,0,0,0,62.5,0Z"
  })), React__default.createElement(Name$1, null, userName), React__default.createElement(Role$1, null, userRole));
};

const ListItem$7 = newStyled.li`
  padding: 15px 0;
  border-bottom: 1px solid #82bae5;

  :first-of-type {
    padding-bottom: 0px;
    :after {
      content: '';
      display: block;
      clear: both;
    }
  }
`;
const Action$1 = newStyled.a`
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  float: left;
  color: #fff;
  padding-bottom: 15px;
  user-select: none;

  :hover {
    text-decoration: none;
    border-bottom: 4px solid #fff;
    padding-bottom: 11px;
  }

  :last-of-type {
    float: right;
  }
`;

const UserActions = () => {
  return React__default.createElement(ListItem$7, null, React__default.createElement(Action$1, {
    href: "/account/myprofile"
  }, "My Profile"), React__default.createElement(Action$1, {
    href: "/account/logout"
  }, "Log Out"));
};

const ListItem$6 = newStyled.li`
  color: #fff;
  padding: 15px 0;
  border-bottom: 1px solid #82bae5;
`;
const Icon$5 = newStyled.svg`
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 44px;
  height: 44px;

  circle {
    fill: #fff;
  }

  path {
    fill: #4c96ce;
  }
`;
const Detail$2 = newStyled.div`
  display: inline-block;
  vertical-align: middle;
`;
const EmailHeading = newStyled.span`
  font-size: 12px;
  display: block;
  padding-bottom: 5px;
`;
const UserEmail = newStyled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
`;

const validate$2 = email => {
  return email && email !== '';
};

const EmailDetail = props => {
  const {
    email
  } = props;
  return React__default.createElement(ListItem$6, null, React__default.createElement(Icon$5, {
    viewBox: "0 0 44 44",
    "data-testid": "email-detail-email-icon"
  }, React__default.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "22"
  }), React__default.createElement("path", {
    d: "M22.5 25.74a.79.79 0 0 1-.5.26.8.8 0 0 1-.49-.21l-3-2.7-8 7.62a2.21 2.21 0 0 0 1.17.34h20.58a2.21 2.21 0 0 0 1.17-.34l-8-7.62zM9.5 14.8a2.27 2.27 0 0 0 0 .45v13.49a2.25 2.25 0 0 0 0 .38l7.66-7.32zm23.84-1.5a2.2 2.2 0 0 0-1.08-.3H11.74a2.2 2.2 0 0 0-1.12.31L22 23.72zm1.07 1.5l-7.65 7 7.66 7.32a2.26 2.26 0 0 0 0-.38V15.26a2.26 2.26 0 0 0 .03-.45z"
  })), React__default.createElement(Detail$2, null, validate$2(email) && React__default.createElement(React__default.Fragment, null, React__default.createElement(EmailHeading, null, "Email"), React__default.createElement(UserEmail, null, email))));
};

const ListItem$5 = newStyled.li`
  color: #fff;
  padding: 15px 0;
  border-bottom: 1px solid #82bae5;
`;
const Icon$4 = newStyled.svg`
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 44px;
  height: 44px;

  circle {
    fill: #fff;
  }

  path {
    fill: #d9427d;
  }
`;
const Detail$1 = newStyled.div`
  display: inline-block;
  vertical-align: middle;
`;
const TeamTitle = newStyled.span`
  font-size: 12px;
  display: block;
  padding-bottom: 5px;
`;
const TeamName$1 = newStyled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
`;

const validate$1 = teamName => {
  return teamName && teamName !== '';
};

const TeamDetail = props => {
  const {
    teamName
  } = props;
  return React__default.createElement(ListItem$5, null, React__default.createElement(Icon$4, {
    "data-testid": "team-detail-team-icon",
    viewBox: "0 0 44 44"
  }, React__default.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "22"
  }), React__default.createElement("path", {
    d: "M35.64 24c-.23-.85-2.36-1.41-3.5-1.84a1.34 1.34 0 0 1-.31-.31 1.5 1.5 0 0 1-.11-.23 2.65 2.65 0 0 1-.08-.65 1.9 1.9 0 0 0 .45-.52 5.13 5.13 0 0 0 .57-1 .42.42 0 0 0 .28-.21 2.28 2.28 0 0 0 .29-1.34.27.27 0 0 0-.27-.15 3.9 3.9 0 0 0-.08-1 2.49 2.49 0 0 0-4.92.07 3.87 3.87 0 0 0-.07.9.29.29 0 0 0-.3.15 2.28 2.28 0 0 0 .29 1.33.41.41 0 0 0 .31.21 4.86 4.86 0 0 0 .56 1 1.77 1.77 0 0 0 .5.55 1.65 1.65 0 0 1-.17.77l-.09.07-.45.34a12.87 12.87 0 0 0-2.47 1l.63.22a9 9 0 0 1 4.38 3.52H35a.83.83 0 0 0 .82-.82 11.21 11.21 0 0 0-.18-2.06zm-10.19-.63a2 2 0 0 1-.47-.47 2.3 2.3 0 0 1-.17-.36 4 4 0 0 1-.12-1 2.89 2.89 0 0 0 .69-.79 7.79 7.79 0 0 0 .87-1.52.64.64 0 0 0 .43-.32 3.47 3.47 0 0 0 .45-2 .41.41 0 0 0-.42-.23 5.92 5.92 0 0 0-.12-1.48 3.78 3.78 0 0 0-7.48.16A3.93 3.93 0 0 0 19 16a4.15 4.15 0 0 1 0-.46 5.8 5.8 0 0 0 0 1.1.42.42 0 0 0-.43.23 3.46 3.46 0 0 0 .45 2 .62.62 0 0 0 .47.31 7.41 7.41 0 0 0 .86 1.51 2.68 2.68 0 0 0 .77.83 2.51 2.51 0 0 1-.26 1.17l-.14.11-.68.52c-1.45.45-4.65 2.51-5.08 3.85a5.73 5.73 0 0 0-.29 1.56A1.26 1.26 0 0 0 15.86 30h14a1.26 1.26 0 0 0 1.24-1.24 6 6 0 0 0-.3-1.56c-.37-1.29-3.61-3.2-5.35-3.87zm-6-.24c-.77-.39-1.82-.7-2.52-1a1.35 1.35 0 0 1-.31-.31 1.51 1.51 0 0 1-.11-.23 2.66 2.66 0 0 1-.08-.65 1.9 1.9 0 0 0 .45-.52 5.12 5.12 0 0 0 .57-1 .42.42 0 0 0 .28-.21 2.28 2.28 0 0 0 .27-1.34.27.27 0 0 0-.27-.15 3.89 3.89 0 0 0-.08-1 2.49 2.49 0 0 0-4.92.07 3.87 3.87 0 0 0-.07.9.29.29 0 0 0-.3.15 2.27 2.27 0 0 0 .29 1.33.4.4 0 0 0 .31.21 4.86 4.86 0 0 0 .56 1 1.77 1.77 0 0 0 .5.55 1.65 1.65 0 0 1-.17.77l-.09.07-.45.34c-1 .3-3.06 1-3.34 1.83a10.39 10.39 0 0 0-.19 2.08.83.83 0 0 0 .82.82h4a9.23 9.23 0 0 1 4.87-3.75z"
  })), React__default.createElement(Detail$1, null, validate$1(teamName) && React__default.createElement(React__default.Fragment, null, React__default.createElement(TeamTitle, null, "Team"), React__default.createElement(TeamName$1, null, teamName))));
};

const ListItem$4 = newStyled.li`
  color: #fff;
  padding: 15px 0;
  border-bottom: 1px solid #82bae5;
`;
const Icon$3 = newStyled.svg`
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 44px;
  height: 44px;

  circle {
    fill: #fff;
  }

  path {
    fill: #7ab800;
  }
`;
const Detail = newStyled.div`
  display: inline-block;
  vertical-align: middle;
`;
const Country = newStyled.span`
  font-size: 12px;
  display: block;
  padding-bottom: 5px;
`;
const CountryName = newStyled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
`;

const validate = countryName => {
  return countryName && countryName !== '';
};

const CountryDetail = props => {
  const {
    countryName
  } = props;
  return React__default.createElement(ListItem$4, null, React__default.createElement(Icon$3, {
    viewBox: "0 0 44 44"
  }, React__default.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "22"
  }), React__default.createElement("path", {
    d: "M22.5 11c-5.8 0-11 4-11 9.56a8.64 8.64 0 0 0 1.87 5.37c.05 1.75-.94 4.26-1.82 6.08a25.6 25.6 0 0 0 7.3-2.42c8.46 2.15 14.62-3.25 14.62-9C33.49 15 28.27 11 22.5 11zm0 13.37H17v-1h5.5zM28 21.5H17v-1h11zm0-2.87H17v-1h11z"
  })), React__default.createElement(Detail, null, validate(countryName) && React__default.createElement(React__default.Fragment, null, React__default.createElement(Country, null, "Country"), React__default.createElement(CountryName, null, countryName))));
};

const Container = newStyled.div`
  padding: 1.25rem;
  background: #57a8e6;
  height: calc(100vh - 4.3125rem);
`;
const Panel$1 = newStyled.section`
  position: absolute;
  top: 3.75rem;
  right: 0;
  width: 25rem;
  max-width: 26.875rem;
  background: #57a8e6;
  transition: transform 300ms ease;
  z-index: 25;

  transform: ${p => p.active ? 'translate(0)' : 'translate(100%)'};
`;
const DetailList$1 = newStyled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  @media screen and (max-width: 540px) {
    text-align: left;
  }
`;

const UserPanel = props => {
  const {
    name,
    role,
    email,
    teamName,
    countryName
  } = props.userInfo;
  return React__default.createElement(Consumer, null, ({
    state
  }) => React__default.createElement(Panel$1, {
    "data-testid": "user-panel-panel",
    active: state.active
  }, React__default.createElement(UserHeader, {
    userName: name,
    userRole: role
  }), React__default.createElement(Container, null, React__default.createElement(DetailList$1, null, React__default.createElement(UserActions, null), email && React__default.createElement(EmailDetail, {
    email: email
  }), teamName && React__default.createElement(TeamDetail, {
    teamName: teamName
  }), countryName && React__default.createElement(CountryDetail, {
    countryName: countryName
  })))));
};

const UserMenu = props => {
  return React__default.createElement(UserMenuProvider, null, React__default.createElement(UserToggle, {
    userName: props.userInfo.name
  }), React__default.createElement(UserPanel, {
    userInfo: props.userInfo
  }));
};

const BaseStyles$1 = newStyled.div`
  .activated > div {
    background: #57a8e6;
  }

  .activated span:nth-of-type(1) svg {
    display: none;
  }

  .activated span:nth-of-type(2) svg {
    display: block;
  }

  .activated svg path {
    fill: #ffffff;
  }

  #SupportWidget {
    position: fixed;
    top: 70px;
    right: 0;
    height: calc(100vh - 70px);
    width: 400px;
    background: #fff;
    z-index: 25;
    box-shadow: -3px 0 3px 0 rgba(0, 0, 0, 0.07);
    -webkit-transform: translateX(120%);
    -ms-transform: translateX(120%);
    -moz-transform: translateX(120%);
    transform: translateX(120%);
    -webkit-transition: transform 500ms;
    -ms-transition: transform 500ms;
    -moz-transition: transform 500ms;
    transition: transform 500ms;
  }

  @media screen and (max-width: 540px) {
    #SupportWidget {
      width: 85%;
    }
  }

  #SupportWidget.support-visible {
    -webkit-transform: translateX(0%);
    -ms-transform: translateX(0%);
    -moz-transform: translateX(0%);
    transform: translateX(0%);
  }

  #SupportWidget a {
    font-weight: 600;
    color: #007db8;
    text-decoration: none;
    cursor: pointer;
  }

  #SupportWidget a:after {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    background: #57a8e6;
    opacity: 0;
    transform: translateY(0);
    transition: all 175ms;
  }

  #SupportWidget a:hover:after {
    opacity: 1;
    transform: translateY(3px);
  }

  #SupportWidget .controls {
    position: relative;
    padding: 30px 20px 70px 20px;
    background: #fff;
    color: #566072;
    border-bottom: 1px solid #e4e4e4;
    border-top: 6px solid #4694ce;
  }

  #SupportWidget .controls .inner {
    position: relative;
    z-index: 2;
  }

  #SupportWidget .controls h1 {
    margin: 0 0 10px 0;
    padding: 0;
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 20px;
    color: #566072;
  }

  #SupportWidget .controls .query-field {
    position: relative;
  }

  #SupportWidget .controls .query-field input[type='text'] {
    width: calc(100%);
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 40px;
    padding-right: 40px;
    font-size: 16px;
    color: #566072;
    border: 2px solid #bdcad2;
  }

  #SupportWidget .controls .query-field svg.search-ico {
    position: absolute;
    left: 10px;
    top: 12px;
  }

  #SupportWidget .controls .query-field svg.search-ico path {
    fill: #aaa;
  }

  #SupportWidget .controls .query-field .reset-support-query {
    position: absolute;
    right: 16px;
    top: 10px;
    width: 12px;
    height: 16px;
    cursor: pointer;
  }

  #SupportWidget .controls .query-field .reset-support-query svg {
    width: 12px;
    height: 12px;
  }

  #SupportWidget .controls .query-field .reset-support-query svg path {
    fill: #aaaaaa;
  }

  #SupportWidget .controls .query-field .reset-support-query:hover svg path {
    fill: #007db8;
  }

  #SupportWidget .controls .support-sites {
    position: absolute;
    padding: 0 20px;
    bottom: 20px;
    left: 0;
    width: calc(100%);
    z-index: 2;
  }

  #SupportWidget .controls .support-sites:after {
    content: '';
    display: block;
    clear: both;
  }

  #SupportWidget .controls .support-sites a {
    font-size: 15px;
    float: left;
  }

  #SupportWidget .controls .support-sites a + a {
    float: right;
  }

  #SupportWidget .support-search-results {
    padding-top: 5px;
    height: calc(100% - 198px);
    overflow-y: auto;
  }

  #SupportWidget .support-search-results p {
    padding: 50px 20px 20px 20px;
    font-size: 18px;
    color: #aaa;
    text-align: center;
  }

  #SupportWidget .support-search-results ul {
    list-style: none;
    padding: 0 20px;
    margin: 0;
  }

  #SupportWidget .support-search-results ul li {
    display: block;
    padding: 15px 0 10px 0;
    border-bottom: 1px solid #e4e4e4;
  }

  #SupportWidget .support-search-results ul li:first-of-type {
    padding-top: 10px;
  }

  #SupportWidget .support-search-results ul li a {
    display: inline-block;
    position: relative;
    font-size: 15px;
  }

  #SupportWidget .loading-bar {
    position: absolute;
    left: 0;
    width: 100%;
    height: 5px;
    opacity: 0;
    transition: opacity 300ms;
    position: absolute;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to right, #006aa1, #57a8e6, #9ad3fd, #57a8e6, #006aa1);
  }

  #SupportWidget .loading-bar:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to right, #9ad3fd, #57a8e6, #006aa1, #57a8e6, #9ad3fd);
  }

  #SupportWidget .loading-bar.showing {
    opacity: 1;
  }

  #SupportWidget .loading-bar.showing:after {
    animation: loadingbar 1250ms linear infinite;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    #SupportWidget .controls .query-field .reset-support-query {
      top: 7px;
    }
    #SupportWidget .controls .query-field input[type='text']::-ms-clear {
      display: none;
    }
  }

  @keyframes loadingbar {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
const Toggle$2 = newStyled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-left: 1px solid #e4e4e4;
  height: 100%;
  width: 3.5rem;
  cursor: pointer;

  :hover {
    transition: background 300ms;
    background: #57a8e6;
  }

  :hover svg path {
    fill: #ffffff;
  }

  @media (max-width: 700px) {
    border-left: none;
    padding: 15px 10px;
    padding-left: 20px;
    width: 50px;
    justify-content: flex-start;
  }
`;
const OpenIcon$1 = newStyled.svg`
  width: 1rem;
  height: 1rem;
  display: block;

  path {
    fill: #4694ce;
  }
`;
const CloseIcon = newStyled.svg`
  width: 1rem;
  height: 1rem;
  display: none;
`;
class SupportMenu extends Component {
  componentDidMount() {
    const dpackScript = document.createElement('script');
    dpackScript.innerText = 'var Dpack = {};';
    document.body.appendChild(dpackScript);
    const script = document.createElement('script');
    script.src = './support-menu.js';
    document.body.appendChild(script);
  }

  render() {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement("input", {
      type: "hidden",
      id: "current_dir_viewed",
      value: "dashboard"
    }), React__default.createElement("input", {
      type: "hidden",
      id: "current_page_viewed",
      value: "index"
    }), React__default.createElement(BaseStyles$1, {
      id: "widgetWrapper"
    }), React__default.createElement("div", {
      className: "support-toggle"
    }, React__default.createElement(Toggle$2, null, React__default.createElement("span", null, React__default.createElement(OpenIcon$1, {
      viewBox: "0 0 11.99 22.01"
    }, React__default.createElement("path", {
      d: "M1.21 4.07a1 1 0 0 0 .94.55 1.1 1.1 0 0 0 .56-.16l.66-.36a5.25 5.25 0 0 1 .9-.36 4.45 4.45 0 0 1 1.3-.16 2.3 2.3 0 0 1 1.6.53 1.81 1.81 0 0 1 .58 1.39 2.53 2.53 0 0 1-.31 1.28 4.1 4.1 0 0 1-.78 1 9.21 9.21 0 0 1-1 .81 12 12 0 0 0-1 .78 4 4 0 0 0-.78.9 2.08 2.08 0 0 0-.31 1.14v.36l.32 2.38H7l.41-2.07a1.57 1.57 0 0 1 .46-.83 9 9 0 0 1 .88-.75l1.08-.82a6 6 0 0 0 1-1 5.34 5.34 0 0 0 .79-1.42 5.51 5.51 0 0 0 .31-2 5.36 5.36 0 0 0-.42-2.15 4.64 4.64 0 0 0-1.2-1.66A5.41 5.41 0 0 0 8.48.36 7.89 7.89 0 0 0 6 0a9.33 9.33 0 0 0-1.85.17 8.61 8.61 0 0 0-1.59.47 9.28 9.28 0 0 0-1.38.7A10.31 10.31 0 0 0 0 2.2zm1.7 16.41a2.46 2.46 0 0 0 1.36 1.34 2.71 2.71 0 0 0 1 .19 2.67 2.67 0 0 0 1-.19 2.58 2.58 0 0 0 .83-.53 2.43 2.43 0 0 0 .55-.81 2.52 2.52 0 0 0 .2-1 2.45 2.45 0 0 0-.75-1.79 2.69 2.69 0 0 0-.83-.54 2.58 2.58 0 0 0-1-.2 2.6 2.6 0 0 0-1.85.74 2.51 2.51 0 0 0-.55.8 2.47 2.47 0 0 0-.2 1 2.52 2.52 0 0 0 .24.98z"
    }))), React__default.createElement("span", null, React__default.createElement(CloseIcon, {
      viewBox: "0 0 20 20"
    }, React__default.createElement("path", {
      d: "M20 2.73L17.27 0 10 7.27 2.73 0 0 2.73 7.27 10 0 17.27 2.73 20 10 12.73 17.27 20 20 17.27 12.73 10z"
    }))))));
  }

}

const DropdownSelect = newStyled.select`
  display: flex;
  align-items: center;
  height: 45px;
  max-width: 340px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px;
  border: 2px solid ${p => p.disabled ? Color$1.lameGrey400 : Color$1.coolGray300};
  font-size: 16px;
  color: ${p => p.disabled ? Color$1.lameGrey700 : Color$1.coolGray700};
  background-image: ${p => p.disabled ? `url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='${Color$1.lameGrey200.replace('#', '%23')}' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='${Color$1.lameGrey700.replace('#', '%23')}' /%3E%3C/svg%3E")` : `url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='%23fff' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='%234694CE'/%3E%3C/svg%3E")`} !important;
  background-repeat: no-repeat;
  background-position: right top 50%;
  background-size: auto auto;
  background-color: ${p => p.disabled ? Color$1.lameGrey200 : Color$1.white};
  appearance: none;
  pointer-events: ${p => p.disabled ? 'none' : 'unset'};
  outline-color: #4694ce;
  outline-width: 0;
  cursor: pointer;
  &:focus,
  &:hover {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='%234694CE' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='%23ffff'/%3E%3C/svg%3E") !important;
  }
  &:focus {
    border-color: #4694ce;
    background-color: #f5fbff;
  }
  & option:disabled {
    pointer-events: none;
  }

  &:disabled {
    background-image: ${`url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='%23fff' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='${Color$1.coolGray300.replace('#', '%23')}' /%3E%3C/svg%3E")`} !important;
    pointer-events: none;
  }
`;

const DropdownMenu = props => {
  const onChange = ev => {
    const option = ev.currentTarget.options[ev.currentTarget.selectedIndex];

    if (option.disabled) {
      ev.preventDefault();
      return;
    } else {
      if (props.onChange) {
        props.onChange(ev);
      }
    }
  };

  return React__default.createElement(DropdownSelect, _extends$3({}, props, {
    onChange: onChange
  }));
};

const backgroundImage = (opened, disabled) => {
  if (!opened && !disabled) return `url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='%23fff' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='%234694CE'/%3E%3C/svg%3E")`;
  if (disabled) return `url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='${Color$1.lameGrey200.replace('#', '%23')}' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='${Color$1.lameGrey700.replace('#', '%23')}' /%3E%3C/svg%3E")`;
  if (opened) return `url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='%234694CE' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='%23ffff'/%3E%3C/svg%3E")`;
};

const RichDropdownSelect = newStyled.div`
  height: 45px;
  position: relative;
  pointer-events: ${p => p.disabled ? 'none' : 'unset'};
  &:focus {
    > div {
      border-color: ${Color$1.blue500};
      background-color: ${Color$1.blue50};
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='%234694CE' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='%23ffff'/%3E%3C/svg%3E");
    }
  }
`;
const SelectedValueContainer = newStyled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  height: 45px;
  padding-left: 12px;
  background-image: ${p => backgroundImage(p.opened, p.disabled)};
  background-repeat: no-repeat;
  background-position: right top 50%;
  background-size: auto auto;
  background-color: ${p => p.disabled ? Color$1.lameGrey200 : Color$1.white};
  border: 2px solid ${p => p.disabled ? Color$1.lameGrey400 : Color$1.coolGray300};
  color: ${p => p.disabled ? Color$1.lameGrey700 : Color$1.coolGray700};
  font-size: 16px;
  cursor: pointer;
  &:hover {
    background-color: ${Color$1.blue50};
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='%234694CE' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='%23ffff'/%3E%3C/svg%3E");
  }
`;
const SelectedValue = newStyled.div`
  overflow: hidden;
  white-space: pre;
  text-overflow: ellipsis;
  -webkit-appearance: none;
  position: absolute;
  width: calc(100% - 50px);
`;
const RichDropdownOption = newStyled.li`
  min-height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: pre;
  text-overflow: ellipsis;
  -webkit-appearance: none;
  display: block;
  font-size: 14px;
  font-weight: ${p => p.selected && !p.disabled ? 600 : null};
  padding-left: 12px;
  align-items: center;
  color: ${Color$1.coolGray700};
  background-color: ${p => p.selected && !p.disabled ? Color$1.green100 : ''};
  color: ${p => p.disabled ? Color$1.lameGrey700 : ''};
  cursor: ${p => p.disabled ? 'not-allowed' : ''};
  &:hover {
    background-color: ${p => p.selected ? Color$1.green100 : Color$1.blue100};
    background-color: ${p => p.disabled ? 'white' : ''};
  }
`;
const RichDropdownOptionsMenu = newStyled.ul`
  width: 100%;
  position: absolute;
  visibility: ${props => props.opened ? '' : 'hidden'};
  background-color: white;
  border: 2px solid ${Color$1.blue500};
  border-top: none;
  box-sizing: border-box;
  max-height: 300px;
  z-index: 1000;
  overflow-y: scroll;
  padding: 5px;
  box-shadow: 0px 3px 7px #00000040;
  margin: 0px;
  top: 100%;
`;
const RichDropdownMenu = props => {
  const [isOpened, setIsOpened] = useState(false);
  const selected = props.options.find(op => op.value === props.value);

  function onOptionClick(option) {
    if (props.onChange && !option.disabled) {
      props.onChange(option);
    }
  }

  return React__default.createElement(RichDropdownSelect, {
    className: props.className,
    tabIndex: 0,
    disabled: props.disabled,
    onBlur: () => setIsOpened(false),
    onClick: () => setIsOpened(!isOpened),
    role: "listbox"
  }, React__default.createElement(SelectedValueContainer, {
    opened: isOpened,
    disabled: props.disabled
  }, React__default.createElement(SelectedValue, {
    title: selected ? selected.label : props.placeholder
  }, selected ? selected.label : props.placeholder)), React__default.createElement(RichDropdownOptionsMenu, {
    opened: isOpened
  }, props.disabled ? React__default.createElement(React__default.Fragment, null) : props.options.map(option => {
    return React__default.createElement(RichDropdownOption, {
      onClick: () => onOptionClick(option),
      selected: props.value ? option.value === props.value : false,
      disabled: option.disabled,
      role: "option",
      title: option.label
    }, option.label);
  })));
};

const AddUserIcon = props => {
  return React__default.createElement("svg", {
    width: "18.191",
    height: "18.191",
    viewBox: "0 0 18.191 18.191"
  }, React__default.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M22.314,11.316a9.1,9.1,0,1,0,9.125,9.1,9.1,9.1,0,0,0-9.125-9.1ZM27.27,21.811H23.743v3.557H20.827V21.811h-3.44V18.9h3.586V15.484h2.915v3.557h3.586v2.915Z",
    transform: "translate(-13.248 -11.316)"
  }));
};

const DownArrow = props => {
  return React__default.createElement("svg", {
    width: "11.326",
    height: "6.747",
    viewBox: "0 0 11.326 6.747"
  }, React__default.createElement("path", {
    id: "angle-down",
    d: "M5.337,167.3.1,162.1a.425.425,0,0,1,0-.6l.7-.7a.425.425,0,0,1,.6,0l4.236,4.194L9.874,160.8a.425.425,0,0,1,.6,0l.7.7a.425.425,0,0,1,0,.6l-5.238,5.2A.425.425,0,0,1,5.337,167.3Z",
    transform: "translate(0.025 -160.675)"
  }));
};

const Layout$1 = newStyled.div`
    height: 100%;
    border-left: 1px solid #ddd;
    position: relative;
    min-height: 60px;
    letter-spacing: 0.14px;
    min-width: 184px;

    & div: first-child{
        display:flex;
        justify-content: center;
        align-items: center;
        padding: 10px 16px;
        display: flex;
        font: normal normal normal 14px/24px Open Sans;
        color: #0076CE;
        cursor: pointer;
        height: 100%;
        text-align: center;

        &: hover{
            color: #fff;
            background-color: #0076CE;
    
            & svg{
                fill: #fff;
            }
        }

        @media (max-width: 700px) {
            width: 225px;
            justify-content: flex-start;
          }
    }

    & svg {
        margin: 0 8px;
    }

    
  @media (max-width: 700px) {
    border-left: none;
    width: 225px;
    justify-content: flex-start;
    padding: 0;
    min-height: auto;
  }
`;
const DropDown = newStyled.div`
    position: absolute;
    box-shadow: 0px 3px 7px #00000040;
    border: 1px solid #E4E4E4;
    display:flex;
    flex-direction: column;
    width: 225px;
    font: normal normal normal 14px/40px Open Sans;
    color: #0076CE;
    background-color: #fff;
    height: 102px;
    text-align: left;

    & a{
        cursor: pointer;
        padding: 5px 0px 4px 26px;
        text-decoration: none;
        color: #0076CE;
        user-select: none;
        
        &:hover{
            color: #fff;
            background-color: #0076CE;
        }
    }

    & hr {
        background-color: #ddd;
        margin:0;
        border: 0;
        height: 1px;
        width: 85%;
        margin-left: 15px;
    }

`;
const RegisterUser = () => {
  const [showDropDown, setShowDropDown] = useState(false);

  function handleClickOutside(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowDropDown(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const ref = useRef(null);
  handleClickOutside(ref);
  return React__default.createElement(Layout$1, {
    ref: ref
  }, React__default.createElement("div", {
    onClick: () => {
      setShowDropDown(!showDropDown);
    }
  }, React__default.createElement(AddUserIcon, null), "Register User", React__default.createElement(DownArrow, null)), showDropDown && React__default.createElement(DropDown, null, React__default.createElement("a", {
    href: "/usermanagement/registerchannelpartner"
  }, "Register New Partner User"), React__default.createElement("hr", null), React__default.createElement("a", {
    href: "/usermanagement/register"
  }, "Register New User")));
};

const Layout = newStyled.a`
    color: #0076CE;
    font: normal normal normal 14px/24px Open Sans;
    letter-spacing: 0.14px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    border-left: 1px solid #ddd;
    cursor: pointer;
    text-decoration: none;
    min-width: 143px;
    min-height: 60px;
    text-align: left;

    &:hover{
        background-color: #0076CE;
        color: #fff;
    }

    & svg{
        width: 24px;
        height: 17px;
        margin-right: 8px;
    }

    @media (max-width: 700px) {
        border-left: none;
        width: 210px;
        justify-content: flex-start;
        min-height: auto;
        padding-left: 20px;
        padding-bottom: 10px;
        padding-top: 10px;
    }
`;
const MyTeam = () => {
  return React__default.createElement(Layout, {
    href: "/team/members"
  }, React__default.createElement(TeamsIcon, null), "My Team");
};

const userContextV2 = React__default.createContext({});

class UserMenuProviderV2 extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty$2(this, "state", {
      active: false
    });

    _defineProperty$2(this, "toggle", () => {
      this.setState(prevState => ({
        active: !prevState.active
      }));
    });

    _defineProperty$2(this, "closeFn", () => {
      if (this.state.active) {
        this.setState({
          active: false
        });
      }
    });
  }

  render() {
    return React__default.createElement(userContextV2.Provider, {
      value: {
        state: this.state,
        toggle: this.toggle,
        closeFn: this.closeFn
      }
    }, this.props.children);
  }

}

const Toggle$1 = newStyled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-left: 1px solid #e4e4e4;
  height: 98%;
  width: 78px;
  background: none;
  color: inherit;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;

  background: ${p => p.active ? '#0076CE' : '#ffffff'};

  :hover {
    transition: background 300ms ease;
    background: #0076CE;
  }

  :hover #user-icon {
    background: #ffffff;
  }

  :hover span {
    color: #0076CE;
  }

  @media (max-width: 700px) {
    border-left: none;
    padding:10px;
    width: 50px;
    justify-content: flex-start;
  }
`;
const UserSnippet = newStyled.div`
  display: inline-flex;
  align-items: center;
`;
const UserIcon = newStyled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  background: ${p => p.active ? '#ffffff' : '#0076CE'};
`;
const UserName = newStyled.span`
  font: normal normal 600 16px/16px Open Sans;
  letter-spacing: 0.16px;
  opacity: 1;
  user-select: none;

  color: ${p => p.active ? '#0076CE' : '#ffffff'};
`;

const UserToggleV2 = props => {
  const getInitials = () => {
    if (props.userName) {
      return props.userName.split(" ").map(n => n[0].toUpperCase()).join("");
    }

    return "";
  };

  return React__default.createElement(userContextV2.Consumer, null, ({
    state,
    toggle
  }) => React__default.createElement(Toggle$1, {
    "data-testid": "user-toggle-toggle",
    active: state.active,
    onClick: toggle
  }, React__default.createElement(UserSnippet, null, React__default.createElement(UserIcon, {
    id: "user-icon",
    "data-testid": "user-icon",
    active: state.active
  }, React__default.createElement(UserName, {
    "data-testid": "user-toggle-username",
    active: state.active
  }, getInitials())))));
};

const Info = newStyled.div`
  background: #fff;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #DDDDDD;
`;
const Icon$2 = newStyled.svg`
  width: 36px;
  height: 36px;
  margin-right: 20px;

  path {
    fill: #0076CE;
  }
`;
const Name = newStyled.span`
  text-align: left;
  font: normal normal 600 20px/16px Open Sans;
  letter-spacing: 0.2px;
  color: #566072;
  opacity: 1;
  user-select: none;
  margin: 6px 0;
  height: 27px;
  display: flex;
  align-items: center;
`;
const Role = newStyled.span`
    text-align: left;
    font: normal normal normal 12px/16px Open Sans;
    letter-spacing: 0.12px;
    color: #777F8E;
    opacity: 1;
    user-select: none;
    margin: 0;
    height: 17px;
`;
const Email = newStyled.span`
  text-align: left;
  font: normal normal normal 14px/16px Open Sans;
  letter-spacing: 0.14px;
  color: #566072;
  opacity: 1;
  height: 19px;
`;
const UserDetails = newStyled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 21px;
`;

const UserHeaderV2 = props => {
  const {
    userName,
    userRole,
    userEmail
  } = props;
  return React__default.createElement(Info, null, React__default.createElement(Icon$2, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 125"
  }, React__default.createElement("path", {
    d: "M62.5,114.58A52,52,0,0,1,22.14,95.36c1.35-3.06,4.08-5.18,9.72-6.49,11.69-2.7,23.22-5.11,17.67-15.34C33.11,43.23,44.86,26,62.5,26c17.3,0,29.34,16.55,13,47.49C70.07,83.7,81.19,86.12,93.13,88.88c5.64,1.3,8.39,3.41,9.74,6.46A52,52,0,0,1,62.5,114.58ZM62.5,0A62.5,62.5,0,1,0,125,62.5,62.5,62.5,0,0,0,62.5,0Z"
  })), React__default.createElement(UserDetails, null, React__default.createElement(Role, null, userRole), React__default.createElement(Name, null, userName), React__default.createElement(Email, null, userEmail)));
};

const LogOutIcon = () => {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.196 17.189"
  }, React__default.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M1.228,17.189A1.228,1.228,0,0,1,0,15.961V1.228A1.228,1.228,0,0,1,1.228,0h4.3a.614.614,0,0,1,.614.614V1.842a.614.614,0,0,1-.614.614H2.456V14.734h3.07a.614.614,0,0,1,.614.614v1.228a.614.614,0,0,1-.614.614Zm9.192-2.743-.652-.652a.917.917,0,0,1,0-1.3l2.518-2.517H4.606a.919.919,0,0,1-.921-.921V8.134a.919.919,0,0,1,.921-.921h7.68L9.768,4.7a.916.916,0,0,1,0-1.3l.652-.652a.917.917,0,0,1,1.3,0l5.2,5.2a.917.917,0,0,1,0,1.3l-5.2,5.2a.91.91,0,0,1-.649.271A.92.92,0,0,1,10.42,14.446Z"
  }));
};

const ListItem$3 = newStyled.div`
   display: flex;
   flex-direction: row;
   margin-top: 20px;
`;
const Action = newStyled.a`
  text-decoration: none;
  font: normal normal 600 14px/16px Open Sans;
  letter-spacing: 0.14px;
  color: #0076CE;
  opacity: 1;
  height: 19px;

  &:hover, &:active {
    text-decoration: underline;
    text-decoration-thickness: 3px;
    text-decoration-skip-ink: none;
    text-underline-position: under;
  }

  &:active {
    color: #57a8e6;
  }
`;
const IconWrapper = newStyled.svg`
    width: 17px;
    height: 17px;
    margin-right: 14px;

    path {
      fill: #0076CE;
    }
`;

const UserActionsV2 = () => {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ListItem$3, null, React__default.createElement(IconWrapper, null, React__default.createElement(CogIcon, null)), React__default.createElement(Action, {
    href: "/account/myprofile"
  }, "My Profile")), React__default.createElement(ListItem$3, null, React__default.createElement(IconWrapper, null, React__default.createElement(LogOutIcon, null)), React__default.createElement(Action, {
    href: "/account/logout"
  }, "Log Out")));
};

const TeamIcon = () => {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.818 16.611",
    "data-testid": "team-detail-team-icon"
  }, React__default.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M16804.648,17450.609H16795v-.646a.391.391,0,0,1,.391-.393h.645v-10.605a.779.779,0,0,1,.781-.775h5.506v-3.412a.78.78,0,0,1,.777-.779h10.9a.779.779,0,0,1,.779.779v14.793h.645a.391.391,0,0,1,.393.393v.646Zm2.865-3.764v2.725h2.076v-2.725a.39.39,0,0,0-.391-.389h-1.3A.39.39,0,0,0,16807.514,17446.846Zm-8.361-3.078v1.3a.391.391,0,0,0,.391.393h1.3a.389.389,0,0,0,.387-.393v-1.3a.389.389,0,0,0-.387-.389h-1.3A.391.391,0,0,0,16799.152,17443.768Zm10.438-1.072v1.3a.388.388,0,0,0,.391.387h1.295a.39.39,0,0,0,.393-.387v-1.3a.392.392,0,0,0-.393-.389h-1.295A.39.39,0,0,0,16809.59,17442.7Zm-4.152,0v1.3a.385.385,0,0,0,.387.387h1.3a.387.387,0,0,0,.389-.387v-1.3a.388.388,0,0,0-.389-.389h-1.3A.387.387,0,0,0,16805.438,17442.7Zm-6.285-2.039v1.3a.388.388,0,0,0,.391.387h1.3a.386.386,0,0,0,.387-.387v-1.3a.39.39,0,0,0-.387-.391h-1.3A.392.392,0,0,0,16799.152,17440.656Zm10.438-1.078v1.3a.391.391,0,0,0,.391.389h1.295a.393.393,0,0,0,.393-.389v-1.3a.392.392,0,0,0-.393-.389h-1.295A.39.39,0,0,0,16809.59,17439.578Zm-4.152,0v1.3a.388.388,0,0,0,.387.389h1.3a.39.39,0,0,0,.389-.389v-1.3a.388.388,0,0,0-.389-.389h-1.3A.387.387,0,0,0,16805.438,17439.578Zm4.152-3.115v1.3a.39.39,0,0,0,.391.389h1.295a.392.392,0,0,0,.393-.389v-1.3a.391.391,0,0,0-.393-.387h-1.295A.39.39,0,0,0,16809.59,17436.463Zm-4.152,0v1.3a.387.387,0,0,0,.387.389h1.3a.388.388,0,0,0,.389-.389v-1.3a.388.388,0,0,0-.389-.387h-1.3A.386.386,0,0,0,16805.438,17436.463Z",
    transform: "translate(-16795 -17433.998)"
  }));
};

const ListItem$2 = newStyled.li`
  color: #fff;
  padding: 20px 0;
  border-bottom: 1px solid #DDD;
  display: flex;
  flex-direction: row;
`;
const Icon$1 = newStyled.svg`
  margin-right: 13px;
  width: 21px;
  height: 17px;

  path {
    fill: #0076CE;
  }
`;
const TeamName = newStyled.p`
  margin: 0;
  padding: 0;
  text-align: left;
  font: normal normal 600 14px/16px Open Sans;
  letter-spacing: 0.14px;
  color: #566072;
  opacity: 1;
  height: 19px;
`;

const TeamDetailV2 = props => {
  const {
    teamName
  } = props;
  return React__default.createElement(ListItem$2, null, React__default.createElement(Icon$1, null, React__default.createElement(TeamIcon, null)), React__default.createElement(TeamName, null, teamName));
};

const Panel = newStyled.section`
  padding: 22px;
  position: absolute;
  top: 3.6rem;
  right: 0;
  width: 345px;
  background: #fff;
  transition: transform 300ms ease;
  z-index: 25;
  box-shadow: 0px 5px 20px #00000033;
  border: 1px solid #00000000;
  border-top: 5px solid #0076CE;
  max-height: 281px;

  transform: ${p => p.active ? 'translate(0)' : 'translate(100%)'};
`;
const DetailList = newStyled.div`
  display: flex;
  flex-direction: column;
`;

const UserPanelV2 = props => {
  const {
    name,
    role,
    email,
    teamName,
    countryName,
    roleFormatted
  } = props.userInfo;
  return React__default.createElement(userContextV2.Consumer, null, ({
    state
  }) => React__default.createElement(Panel, {
    "data-testid": "user-panel-panel",
    active: state.active
  }, React__default.createElement(UserHeaderV2, {
    userName: name,
    userRole: roleFormatted,
    userEmail: email
  }), React__default.createElement(DetailList, null, teamName && React__default.createElement(TeamDetailV2, {
    teamName: teamName
  }), React__default.createElement(UserActionsV2, null))));
};

const MenuWrapper = newStyled.div`
   min-height: 60px;

   @media (max-width: 700px) {
    min-height: auto;
   }
`;

const UserSubMenuV2 = props => {
  const ref = useRef(null);
  const context = useContext(userContextV2);

  function handleOutsideClick(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      context.closeFn();
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [ref]);
  return React__default.createElement(userContextV2.Consumer, null, ({}) => React__default.createElement(MenuWrapper, {
    ref: ref
  }, React__default.createElement(UserToggleV2, {
    userName: props.userInfo.name
  }), React__default.createElement(UserPanelV2, {
    userInfo: props.userInfo
  })));
};

const UserMenuV2 = props => {
  return React__default.createElement(UserMenuProviderV2, null, React__default.createElement(UserSubMenuV2, {
    userInfo: props.userInfo
  }));
};

const BaseStyles = newStyled.div`
  min-height: 60px;

  .activated > div {
    background: #0076CE;
  }

  .activated svg path {
    fill: #ffffff;
  }

  .support-toggle {
    width: 63px;
    height: 100%;
    min-height: 60px;
  }

  #SupportWidget {
    position: fixed;
    top: 58px;
    right: 0;
    height: calc(100vh - 30px);
    width: 527px;
    background: #fff;
    z-index: 25;
    box-shadow: -3px 0 3px 0 rgba(0, 0, 0, 0.07);
    -webkit-transform: translateX(120%);
    -ms-transform: translateX(120%);
    -moz-transform: translateX(120%);
    transform: translateX(120%);
    -webkit-transition: transform 500ms;
    -ms-transition: transform 500ms;
    -moz-transition: transform 500ms;
    transition: transform 500ms;
  }

  @media screen and (max-width: 540px) {
    #SupportWidget {
      width: 85%;
    }
  }

  @media (max-width: 700px) {
    min-height: auto;

    .support-toggle {
      min-height: auto;
    }
  }

  #SupportWidget.support-visible {
    -webkit-transform: translateX(0%);
    -ms-transform: translateX(0%);
    -moz-transform: translateX(0%);
    transform: translateX(0%);
  }

  #SupportWidget a {
    font-family: 'Open Sans';
    font-weight: normal;
    letter-spacing: 0.14px;
    color: #0076CE;
    text-decoration: none;
    cursor: pointer;
  }

  #SupportWidget a:after {
    content: '';
    width: 100%;
    height: 3px;
    background: #57a8e6;
    opacity: 0;
    transform: translateY(0);
    transition: all 175ms;
  }

  #SupportWidget a:hover:after {
    opacity: 1;
    transform: translateY(3px);
  }

  #SupportWidget .controls {
    position: relative;
    padding: 15px 20px 15px 20px;
    background: #fff;
    color: #566072;
    border-top: 6px solid #0076CE;
  }

  #SupportWidget .controls .inner {
    position: relative;
    z-index: 2;
  }

  #SupportWidget .controls h1 {
    font: normal normal bold 20px/22px Open Sans;
    letter-spacing: 0px;
    color: #566072;
    opacity: 1;
    margin-bottom: 10px;
    height: 27px;
    text-align: left;
  }

  #SupportWidget .controls .query-field {
    position: relative;
    height: 45px;
  }

  #SupportWidget .controls .query-field input[type='text'] {
    width: calc(100%);
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 40px;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0px;
    color: #566072;
    opacity: 1;
    border: 2px solid #BDCAD2;

    ::placeholder {
      font-style: italic;
      color: #AAAAAA;
    }

    &:hover {
      background: #F5FBFF;
      border: 2px solid #BDCAD2;
    }

    &:focus-visible, &:active, &:focus, &:focus-within {
      background-color: #f5fbff !important;
      box-shadow: 0px 5px 8px #4694CE40 !important;
      border: 2px solid #4694CE !important;
      outline: #4694CE !important;
    }
  }

  #SupportWidget .controls .query-field svg.search-ico {
    position: absolute;
    right: 10px;
    top: 12px;
    width: 20px !important;
    height: 20px !important;

    path {
      fill: #0076CE !important;
    }
  }

  #SupportWidget .controls .query-field svg.search-ico path {
    fill: #aaa;
  }

  #SupportWidget .controls .query-field .reset-support-query {
    position: absolute;
    right: 16px;
    top: 10px;
    width: 12px;
    height: 16px;
    cursor: pointer;
  }

  #SupportWidget .controls .query-field .reset-support-query svg {
    width: 12px;
    height: 12px;
  }

  #SupportWidget .controls .query-field .reset-support-query svg path {
    fill: #aaaaaa;
  }

  #SupportWidget .controls .query-field .reset-support-query:hover svg path {
    fill: #007db8;
  }

  #SupportWidget .controls .support-sites {
    justify-content: flex-end;
    display: flex;
    margin-bottom: 32px;
    width: calc(100%);
    z-index: 2;
  }

  #SupportWidget .controls .support-sites:after {
    content: '';
    display: block;
    clear: both;
  }

  #SupportWidget .controls .support-sites svg {
    margin-right: 10px;
    margin-left: 40px;
  }

  #SupportWidget .controls .support-sites a {
    font: normal normal normal 16px/19px Open Sans;
    letter-spacing: 0.16px;
    color: #0076CE;
    opacity: 1;
    text-align: left;

    &:hover, &:active {
      text-decoration: underline;
      text-decoration-thickness: 3px;
      text-decoration-skip-ink: none;
      text-underline-position: under;
    }

    &:active {
      color: #57a8e6;
    }
  }

  #SupportWidget .controls .support-sites a + a {
    float: right;
  }

  #SupportWidget .support-search-results {
    padding-top: 3px;
    height: calc(100% - 198px);
    overflow-y: auto;
  }

  #SupportWidget .support-search-results p {
    padding: 0px 20px 20px 20px;
    font: italic normal normal 16px/22px Open Sans;
    letter-spacing: 0.16px;
    color: #AAAAAA;
    opacity: 1;
    text-align: center;
    margin-top: 13px;

    svg {
      margin-top: 16px;
    }
  }

  #SupportWidget .support-search-results ul {
    list-style: none;
    padding: 0 20px;
    margin: 0;
  }

  #SupportWidget .support-search-results ul li {
    display: block;
    padding: 10px 0 10px 0;
    border-bottom: 1px solid #e4e4e4;
  }

  #SupportWidget .support-search-results ul li {
    padding-left: 22px;
  }

  #SupportWidget .support-search-results ul li a {
    display: inline-block;
    position: relative;
    font-size: 14px;

    &:hover, &:active {
      text-decoration: underline;
      text-decoration-thickness: 3px;
      text-decoration-skip-ink: none;
      text-underline-position: under;
    }

    &:active {
      color: #57a8e6;
    }
  }

  #SupportWidget .loading-bar {
    position: absolute;
    left: 0;
    width: 100%;
    height: 5px;
    opacity: 0;
    transition: opacity 300ms;
    position: absolute;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to right, #006aa1, #57a8e6, #9ad3fd, #57a8e6, #006aa1);
  }

  #SupportWidget .loading-bar:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to right, #9ad3fd, #57a8e6, #006aa1, #57a8e6, #9ad3fd);
  }

  #SupportWidget .loading-bar.showing {
    opacity: 1;
  }

  #SupportWidget .loading-bar.showing:after {
    animation: loadingbar 1250ms linear infinite;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    #SupportWidget .controls .query-field .reset-support-query {
      top: 7px;
    }
    #SupportWidget .controls .query-field input[type='text']::-ms-clear {
      display: none;
    }
  }

  @keyframes loadingbar {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
const Toggle = newStyled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-left: 1px solid #e4e4e4;
  height: 98%;
  cursor: pointer;

  :hover {
    transition: background 300ms;
    background: #0076CE;
  }

  :hover svg path {
    fill: #ffffff;
  }

  @media (max-width: 700px) {
    border-left: none;
    padding: 15px 10px;
    padding-left: 20px;
    width: 50px;
    justify-content: flex-start;
  }
`;
const OpenIcon = newStyled.svg`
  width: 12px;
  height: 22px;
  display: block;

  path {
    fill: #0076CE;
  }
`;
class SupportMenuV2 extends Component {
  componentDidMount() {
    const dpackScript = document.createElement('script');
    dpackScript.innerText = 'var Dpack = {};';
    document.body.appendChild(dpackScript);
    const script = document.createElement('script');
    script.src = './support-menu-v2.js';
    document.body.appendChild(script);
  }

  render() {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement("input", {
      type: "hidden",
      id: "current_dir_viewed",
      value: "dashboard"
    }), React__default.createElement("input", {
      type: "hidden",
      id: "current_page_viewed",
      value: "index"
    }), React__default.createElement(BaseStyles, {
      id: "widgetWrapper"
    }, React__default.createElement("div", {
      className: "support-toggle"
    }, React__default.createElement(Toggle, {
      id: "toggle-test"
    }, React__default.createElement(OpenIcon, {
      viewBox: "0 0 11.99 22.01"
    }, React__default.createElement("path", {
      d: "M1.21 4.07a1 1 0 0 0 .94.55 1.1 1.1 0 0 0 .56-.16l.66-.36a5.25 5.25 0 0 1 .9-.36 4.45 4.45 0 0 1 1.3-.16 2.3 2.3 0 0 1 1.6.53 1.81 1.81 0 0 1 .58 1.39 2.53 2.53 0 0 1-.31 1.28 4.1 4.1 0 0 1-.78 1 9.21 9.21 0 0 1-1 .81 12 12 0 0 0-1 .78 4 4 0 0 0-.78.9 2.08 2.08 0 0 0-.31 1.14v.36l.32 2.38H7l.41-2.07a1.57 1.57 0 0 1 .46-.83 9 9 0 0 1 .88-.75l1.08-.82a6 6 0 0 0 1-1 5.34 5.34 0 0 0 .79-1.42 5.51 5.51 0 0 0 .31-2 5.36 5.36 0 0 0-.42-2.15 4.64 4.64 0 0 0-1.2-1.66A5.41 5.41 0 0 0 8.48.36 7.89 7.89 0 0 0 6 0a9.33 9.33 0 0 0-1.85.17 8.61 8.61 0 0 0-1.59.47 9.28 9.28 0 0 0-1.38.7A10.31 10.31 0 0 0 0 2.2zm1.7 16.41a2.46 2.46 0 0 0 1.36 1.34 2.71 2.71 0 0 0 1 .19 2.67 2.67 0 0 0 1-.19 2.58 2.58 0 0 0 .83-.53 2.43 2.43 0 0 0 .55-.81 2.52 2.52 0 0 0 .2-1 2.45 2.45 0 0 0-.75-1.79 2.69 2.69 0 0 0-.83-.54 2.58 2.58 0 0 0-1-.2 2.6 2.6 0 0 0-1.85.74 2.51 2.51 0 0 0-.55.8 2.47 2.47 0 0 0-.2 1 2.52 2.52 0 0 0 .24.98z"
    }))))));
  }

}

const Tooltip = newStyled.div`
  display: flex;
  position: absolute;
  top: -12px;
  left: 50%;
  z-index: 50;
  transform: translate(-50%, -100%);
  width: 22rem;
`;
const PopoverContent = newStyled.span`
  position: relative;
  padding: 1rem 1.25rem;
  left: 50%;
  transform: translate(-50%, 0%);
  max-width: 22rem;
  font-size: 12px;
  background-color: #fff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  word-wrap: normal;
  word-break: keep-all;
  /* Tooltip Arrow is basically a div box rotated 45 degrees */
  &:before {
    content: '';
    width: 12px;
    height: 12px;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    position: absolute;
    pointer-events: none;
    display: flex;
    background: #fff;
    top: 100%;
  }
`;
const TooltipCloseButton = newStyled(CloseIcon$2)`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  color: #bdcad2;
  width: 0.5rem;
  height: 0.5rem;
  cursor: pointer;
`;
const PopoverWrapper$1 = newStyled.div`
  position: relative;
  height: 24px;
  width: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;
  & svg {
    cursor: pointer;
  }
`;

const Popover = props => {
  return React__default.createElement(Tooltip, {
    style: {
      display: props.opened ? 'flex' : 'none'
    }
  }, React__default.createElement(PopoverContent, null, React__default.createElement(TooltipCloseButton, {
    onClick: () => props.onClose()
  }), props.children));
};

const ChartPopover = props => {
  const [isPopoverOpened, setIsPopoverOpened] = useState(false);
  return React__default.createElement(PopoverWrapper$1, null, React__default.createElement(InfoIcon, {
    onClick: () => setIsPopoverOpened(!isPopoverOpened)
  }), React__default.createElement(Popover, {
    onClose: () => setIsPopoverOpened(false),
    opened: isPopoverOpened
  }, props.children));
};

const ChartPlaceholderTitle = newStyled.h4`
  color: #566072;
  font-size: 1.25rem;
  font-weight: normal;
  margin: 0;
  padding-left: 1.5rem;
`;
const ChartPlaceholderMessage = newStyled.h4`
  color: #566072;
  font-size: 1rem;
  font-weight: normal;
  margin: 0;
  margin-left: 0.5rem;
  letter-spacing: 0.14px;

  & a {
    color: #007db8;
    font-weight: 500;
    text-decoration: none;
  }
`;
const ChartPlaceholderWrapper = newStyled.div`
  display: flex;
  background-color: #ffffff;
  align-items: flex-end;
  padding-top: 0.75rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f5f6fb;
`;
const PopoverWrapper = newStyled.span`
  color: #566072;
`;

const ChartPlaceholder = props => {
  return React__default.createElement(ChartPlaceholderWrapper, null, React__default.createElement(ChartPlaceholderTitle, null, props.title), React__default.createElement(ChartPopover, null, React__default.createElement(PopoverWrapper, null, props.popoverText)), React__default.createElement(ChartPlaceholderMessage, null, props.message));
};

const CHART_HEIGHT = 160;
const VM_CHART_HEIGHT = 320;
const SVG_TOP_BOTTOM_PADDING = 10;
const SVG_LEFT_RIGHT_PADDING = 4;
const PEAK_CIRCLE_RADIUS = 5;
const PEAK_CIRCLE_STROKEWIDTH = 2;
const MAX_VALUE_AXIS_WIDTH = 40;
const DEFAULT_PADDING = {
  top: SVG_TOP_BOTTOM_PADDING + PEAK_CIRCLE_RADIUS + PEAK_CIRCLE_STROKEWIDTH / 2,
  bottom: SVG_TOP_BOTTOM_PADDING,
  right: SVG_LEFT_RIGHT_PADDING,
  left: SVG_LEFT_RIGHT_PADDING
};
const GAUGE_CHART_RECT_HEIGHT = 25;
const GAUGE_CHART_VERTICAL_PADDING = 14;
const GAUGE_CHART_RECT_PADDING = 35;
const BAR_GAP$1 = 9;
({
  barsGap: 700,
  barsGapRatio: 1.5,
  barOffset: 240,
  paddingLeft: DEFAULT_PADDING.left + 3
});

const GraphLayoutTimeAxis = newStyled.svg`
  -ms-grid-column: 5;
  grid-column: 5;
  -ms-grid-row: 4;
  grid-row: 4;
`;
const GraphLayoutDateAxis = newStyled.svg`
  -ms-grid-column: 5;
  grid-column: 5;
  -ms-grid-row: 5;
  grid-row: 5;
`;
const GraphLayoutGrid = newStyled.div`
  display: -ms-grid;
  display: grid;
  overflow-wrap: normal;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 2px;
  grid-template-columns: ${`
    minmax(0.5rem, auto)
    0.25rem
    auto
    0.25rem
    1fr
    0.25rem
    auto
    0.25rem
    minmax(0.5rem, auto)
  `};
  -ms-grid-columns: ${`
    0.5rem
    0.25rem
    ${MAX_VALUE_AXIS_WIDTH}px
    0.25rem
    1fr
    0.25rem
    1rem
    ${MAX_VALUE_AXIS_WIDTH}px
    0.5rem
  `};
  grid-template-rows: auto auto 1fr 10px 10px auto;
  -ms-grid-rows: auto auto 1fr 10px 10px auto;
  border-bottom: 2px solid #f5f6fb;
  padding-bottom: 1rem;
  width: 100%;
`;
const GraphLayoutGraph = newStyled.div`
  -ms-grid-column: 5;
  grid-column: 5;
  -ms-grid-row: 3;
  grid-row: 3;
  /* width: 100%; */
  max-width: 100%;
  position: relative;
`;
const GraphLayoutLeftLabel = newStyled.div`
  position: relative;
  -ms-grid-column: 1;
  grid-column: 1;
  -ms-grid-row: 3;
  grid-row: 3;
  display: flex;
  width: 3.25rem;
  justify-content: center;
  align-items: center;
`;
const GraphLayoutLeftLabelText = newStyled.div`
  position: absolute;
  display: block;
  font-size: 1.25rem;
  line-height: 1;
  text-align: center;
  width: 150px;
  transform: translate(0.75rem) rotate(270deg);
  -ms-transform: translate(-4.75rem) rotate(270deg);
  margin: 0;
`;
const GraphLayoutBottomLabel = newStyled.div`
  -ms-grid-column: 5;
  grid-column: 5;
  position: relative;
  -ms-grid-row: 6;
  grid-row: 6;
`;
const GraphLayoutHeader = newStyled.div`
  padding-top: 1rem;
  padding-bottom: 0.75rem;
  padding-left: 1.5rem;
  grid-column-start: 1;
  grid-column-end: 6;
  -ms-grid-row: 1;
  -ms-grid-column: 1;
  -ms-grid-column-span: 5;
  grid-row: 1;
  display: flex;
  justify-content: space-between;
  gap: 7px;
  flex-wrap: wrap;
`;
const GraphLayoutHeaderText = newStyled.h4`
  color: rgba(86, 96, 114, 1);
  font-weight: normal;
  letter-spacing: 0.2px;
  margin: 0;
  font-size: 1.25rem;
  display: inline-flex;
  align-items: center;
`;
const GraphLayoutLeftAxis = newStyled.svg`
  -ms-grid-column: 3;
  grid-column: 3;
  -ms-grid-row: 3;
  grid-row: 3;
  vertical-align: middle;
  & text {
    text-anchor: end;
    dominant-baseline: middle;
  }
`;
const GraphLayoutRightAxis = newStyled.svg`
  -ms-grid-column: 7;
  grid-column: 7;
  -ms-grid-row: 3;
  grid-row: 3;
  vertical-align: middle;
  & text {
    text-anchor: start;
    dominant-baseline: middle;
  }
`;
const GraphLayoutHeaderLegend = newStyled.div`
  margin: 0;
  display: flex;
  align-items: center;
  margin-left: auto;
`;
const TitleMessage$1 = newStyled.span`
  margin: 0 0 0 0.7rem;
  color: #566072;
  font-weight: 400;
  font-size: 0.9rem;
`;

const ChartPanel = props => {
  return React__default.createElement(GraphLayoutGrid, null, props.children, React__default.createElement(GraphLayoutHeader, null, React__default.createElement(GraphLayoutHeaderText, null, props.title, " ", props.popoverText && React__default.createElement(ChartPopover, null, props.popoverText), props.titleMessage && React__default.createElement(TitleMessage$1, null, props.titleMessage)), props.legend && React__default.createElement(GraphLayoutHeaderLegend, null, props.legend)), props.leftAxisLabel && React__default.createElement(GraphLayoutLeftLabel, null, React__default.createElement(GraphLayoutLeftLabelText, null, props.leftAxisLabel)), props.bottom && React__default.createElement(GraphLayoutBottomLabel, null, props.bottom));
};

let LegendPositionEnum;

(function (LegendPositionEnum) {
  LegendPositionEnum["horizontal"] = "horizontal";
  LegendPositionEnum["vertical"] = "vertical";
})(LegendPositionEnum || (LegendPositionEnum = {}));

const LayoutStyle = props => props.layout === LegendPositionEnum.horizontal ? css`
        display: flex;
        font-size: 12px;
        color: #566072;
        align-items: center;
      ` : css`
        display: flex;
        font-size: 12px;
        color: #566072;
        flex-direction: column;
      `;

const ChartLegendContainer = newStyled.div`
  ${LayoutStyle}
  height: 14px;
`;
const LegendCircle$1 = newStyled.div`
  height: 15px;
  width: 15px;
  background-color: ${s => s.color};
  border-radius: 50px;
  display: inline-flex;
  margin-right: 5px;
  justify-self: center;
  align-self: center;
`;
const ChartLegendItem = newStyled.div`
  display: flex;
  align-items: center;
  height: 16px;
  margin-left: 32px;
  &:first-of-type {
    margin-left: 0;
  }
  & > span {
    padding-top: 1px;
  }
`;
const ChartLegend = props => {
  const legendLayout = props.position ? props.position : LegendPositionEnum.horizontal;
  return React__default.createElement(ChartLegendContainer, {
    layout: legendLayout
  }, props.legendItems.map((d, i) => {
    const color = d.color;
    const label = d.label;
    return React__default.createElement(ChartLegendItem, {
      key: i
    }, React__default.createElement(LegendCircle$1, {
      color: color
    }), React__default.createElement("span", null, label));
  }));
};

const TooltipWrapper = newStyled.div`
  position: ${p => p.fixed ? 'fixed' : 'absolute'};
  pointer-events: none;
  top: -12px;
  transition: transform 50ms ease-in-out 0s, opacity 0ms linear 50ms;
  left: 0;
  min-width: 80px;
  z-index: 1000;
  font-size: 12px;
  line-height: 25px;
  font-family: sans-serif;
  padding: 6px;
  color: #000;
  background-color: #fff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  word-wrap: normal;
  border-radius: 6px;
  word-break: keep-all;
  /* Tooltip Arrow is basically a div box rotated 45 degrees */
  &:before {
    content: '';
    width: 12px;
    height: 12px;
    left: 50%;
    z-index: 0;
    transform: translate(-50%, -50%) rotate(45deg);
    position: absolute;
    pointer-events: none;
    display: flex;
    background: #fff;
    top: 100%;
  }
`;

const ChartTooltip = p => {
  const ref = useRef(null);
  let x = p.x;
  let y = p.y;

  if (typeof window !== 'undefined' && window.document['documentMode']) {
    if (ref.current) {
      x = p.x - ref.current.clientWidth / 2;
      y = p.y - ref.current.clientHeight;
    }

    return React__default.createElement(TooltipWrapper, {
      fixed: p.fixed,
      ref: ref,
      style: {
        transform: `translate(${x}px, ${y}px)`,
        opacity: p.visible ? 1 : 0
      }
    }, p.message);
  } else {
    return React__default.createElement(TooltipWrapper, {
      fixed: p.fixed,
      style: {
        transform: `translate(calc(${p.x}px - 50%), calc(${p.y}px - 100%))`,
        opacity: p.visible ? 1 : 0
      }
    }, p.message);
  }
};

var xhtml = "http://www.w3.org/1999/xhtml";

var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

function namespace(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name; // eslint-disable-line no-prototype-builtins
}

function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

function creator(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
}

function none$2() {}

function selector(selector) {
  return selector == null ? none$2 : function() {
    return this.querySelector(selector);
  };
}

function selection_select(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection$1(subgroups, this._parents);
}

function array$1(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}

function empty() {
  return [];
}

function selectorAll(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}

function arrayAll(select) {
  return function() {
    var group = select.apply(this, arguments);
    return group == null ? [] : array$1(group);
  };
}

function selection_selectAll(select) {
  if (typeof select === "function") select = arrayAll(select);
  else select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection$1(subgroups, parents);
}

function matcher(selector) {
  return function() {
    return this.matches(selector);
  };
}

function childMatcher(selector) {
  return function(node) {
    return node.matches(selector);
  };
}

var find = Array.prototype.find;

function childFind(match) {
  return function() {
    return find.call(this.children, match);
  };
}

function childFirst() {
  return this.firstElementChild;
}

function selection_selectChild(match) {
  return this.select(match == null ? childFirst
      : childFind(typeof match === "function" ? match : childMatcher(match)));
}

var filter = Array.prototype.filter;

function children() {
  return this.children;
}

function childrenFilter(match) {
  return function() {
    return filter.call(this.children, match);
  };
}

function selection_selectChildren(match) {
  return this.selectAll(match == null ? children
      : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}

function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection$1(subgroups, this._parents);
}

function sparse(update) {
  return new Array(update.length);
}

function selection_enter() {
  return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
}

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

function constant$3(x) {
  return function() {
    return x;
  };
}

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = new Map,
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data[i], i, data) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue.get(keyValues[i]) === node)) {
      exit[i] = node;
    }
  }
}

function datum(node) {
  return node.__data__;
}

function selection_data(value, key) {
  if (!arguments.length) return Array.from(this, datum);

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant$3(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = array$1(value.call(parent, parent && parent.__data__, j, parents)),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection$1(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}

function selection_exit() {
  return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
}

function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update = onupdate(update);
  if (onexit == null) exit.remove(); else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}

function selection_merge(selection) {
  if (!(selection instanceof Selection$1)) throw new Error("invalid merge");

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection$1(merges, this._parents);
}

function selection_order() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
}

function selection_sort(compare) {
  if (!compare) compare = ascending$1;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection$1(sortgroups, this._parents).order();
}

function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}

function selection_nodes() {
  return Array.from(this);
}

function selection_node() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
}

function selection_size() {
  let size = 0;
  for (const node of this) ++size; // eslint-disable-line no-unused-vars
  return size;
}

function selection_empty() {
  return !this.node();
}

function selection_each(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
}

function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant$1(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS$1(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction$1(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS$1(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

function selection_attr(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS$1 : attrRemove$1) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)
      : (fullname.local ? attrConstantNS$1 : attrConstant$1)))(fullname, value));
}

function defaultView(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
}

function styleRemove$1(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant$1(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction$1(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

function selection_style(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove$1 : typeof value === "function"
            ? styleFunction$1
            : styleConstant$1)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
}

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

function selection_property(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
}

function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

function selection_classed(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
}

function textRemove() {
  this.textContent = "";
}

function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction$1(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

function selection_text(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction$1
          : textConstant$1)(value))
      : this.node().textContent;
}

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

function selection_html(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
}

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

function selection_raise() {
  return this.each(raise);
}

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

function selection_lower() {
  return this.each(lower);
}

function selection_append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}

function constantNull() {
  return null;
}

function selection_insert(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
}

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

function selection_remove() {
  return this.each(remove);
}

function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}

function selection_datum(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}

function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}

function parseTypenames$1(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, options) {
  return function() {
    var on = this.__on, o, listener = contextListener(value);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
        this.addEventListener(o.type, o.listener = listener, o.options = options);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, options: options};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

function selection_on(typename, value, options) {
  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, options));
  return this;
}

function dispatchEvent(node, type, params) {
  var window = defaultView(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

function selection_dispatch(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
}

function* selection_iterator() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) yield node;
    }
  }
}

var root = [null];

function Selection$1(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection$1([[document.documentElement]], root);
}

function selection_selection() {
  return this;
}

Selection$1.prototype = selection.prototype = {
  constructor: Selection$1,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: selection_iterator
};

function select(selector) {
  return typeof selector === "string"
      ? new Selection$1([[document.querySelector(selector)]], [document.documentElement])
      : new Selection$1([[selector]], root);
}

function sourceEvent(event) {
  let sourceEvent;
  while (sourceEvent = event.sourceEvent) event = sourceEvent;
  return event;
}

function pointer(event, node) {
  event = sourceEvent(event);
  if (node === undefined) node = event.currentTarget;
  if (node) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      point.x = event.clientX, point.y = event.clientY;
      point = point.matrixTransform(node.getScreenCTM().inverse());
      return [point.x, point.y];
    }
    if (node.getBoundingClientRect) {
      var rect = node.getBoundingClientRect();
      return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
    }
  }
  return [event.pageX, event.pageY];
}

function parseTransform(t) {
  return Number.parseInt(t.slice(t.indexOf('(') + 1, t.indexOf(',')));
}

function flipRight(flag, handleText) {
  flag.classList.remove('flip-left');
  flag.classList.add('flip-right');
  handleText.classList.remove('flip-text-left');
  handleText.classList.add('flip-text-right');
}

function flipLeft(flag, handleText) {
  flag.classList.remove('flip-right');
  flag.classList.add('flip-left');
  handleText.classList.remove('flip-text-right');
  handleText.classList.add('flip-text-left');
}

function getOppositeFlagX(clsName) {
  return clsName === 'left' ? parseTransform(select('g.zoom-handle-right').attr('transform')) : parseTransform(select('g.zoom-handle-left').attr('transform'));
}

const ZoomHelper = function () {
  return {
    parseTransform: parseTransform,
    flipRight: flipRight,
    flipLeft: flipLeft,
    getOppositeFlagX: getOppositeFlagX
  };
}();

function findNext(array, startIndex, check) {
  for (let index = startIndex; index < array.length; index++) {
    const element = array[index];

    if (check(element, index, array)) {
      return element;
    }
  }

  return undefined;
}

function findPrevious(array, startIndex, check) {
  for (let index = startIndex; index >= 0; index--) {
    const element = array[index];

    if (check(element, index, array)) {
      return element;
    }
  }

  return undefined;
}

const checkForKey = key => v => v[key] !== undefined;

const interpolateMissingPointsForKeys = keys => (currentSet, index, array) => {
  for (const key of keys) {
    if (currentSet[key]) {
      continue;
    }

    if (!currentSet[key]) {
      const prev = findPrevious(array, index, checkForKey(key));
      const next = findNext(array, index, checkForKey(key));

      if (prev && next) {
        const prevValue = prev[key] ? prev[key].value : 0;
        const nextValue = next[key] ? next[key].value : 0;
        const distanceToNext = next.timeStamp.getTime() - currentSet.timeStamp.getTime();
        const distanceToPrev = currentSet.timeStamp.getTime() - prev.timeStamp.getTime();
        const totalDistance = distanceToNext + distanceToPrev;
        const value = distanceToNext * prevValue / totalDistance + distanceToPrev * nextValue / totalDistance;
        currentSet[key] = {
          value,
          timeStamp: currentSet.timeStamp
        };
      } else {
        currentSet[key] = {
          value: 0,
          timeStamp: currentSet.timeStamp
        };
      }
    }
  }

  return currentSet;
};

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var constant$2 = x => () => x;

function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$2(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant$2(isNaN(a) ? b : a);
}

var interpolateRgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb$1(start, end) {
    var r = color((start = rgb(start)).r, (end = rgb(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$1.gamma = rgbGamma;

  return rgb$1;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolate$1(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date$1(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolate$1(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

function interpolateString(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolate$1(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$2(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
      : b instanceof color ? interpolateRgb
      : b instanceof Date ? date$1
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

var degrees = 180 / Math.PI;

var identity$4 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

function decompose(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

var svgNode;

/* eslint-disable no-undef */
function parseCss(value) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? identity$4 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
}

function parseSvg(value) {
  if (value == null) return identity$4;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$4;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: interpolateNumber(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: interpolateNumber(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

const interpolateRoundToFixed = n => (a, b) => t => parseFloat(interpolateNumber(a, b)(t).toFixed(n));

const euclideanDistance = (a, b) => {
  const distance = (b.y - a.y) ** 2 + (b.x - a.x) ** 2;
  return distance;
};
const sortByEuclideanDistanceTo = point => {
  return (a, b) => euclideanDistance(a, point) - euclideanDistance(b, point);
};

const mapSeriesToPlottedSeries = (pathFn, timeScale, valueScale) => series => {
  return {
    descriptor: pathFn(series.points) || '',
    points: series.points,
    plottedPoints: series.points.map((p, i) => ({
      x: timeScale(p.timeStamp),
      y: valueScale(p.value),
      index: i,
      series
    })),
    key: series.key,
    color: series.color
  };
};

var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

var second = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * durationSecond);
}, function(start, end) {
  return (end - start) / durationSecond;
}, function(date) {
  return date.getUTCSeconds();
});

var minute = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getMinutes();
});

var hour = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getHours();
});

var day = newInterval(
  date => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  date => date.getDate() - 1
);

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
weekday(2);
weekday(3);
var thursday = weekday(4);
weekday(5);
weekday(6);

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getUTCMinutes();
});

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getUTCHours();
});

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay;
}, function(date) {
  return date.getUTCDate() - 1;
});

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
utcWeekday(2);
utcWeekday(3);
var utcThursday = utcWeekday(4);
utcWeekday(5);
utcWeekday(6);

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector(f) {
  let delta = f;
  let compare = f;

  if (f.length === 1) {
    delta = (d, x) => f(d) - x;
    compare = ascendingComparator(f);
  }

  function left(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;
      else hi = mid;
    }
    return lo;
  }

  function right(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;
      else lo = mid + 1;
    }
    return lo;
  }

  function center(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
}

function ascendingComparator(f) {
  return (d, x) => ascending(f(d), x);
}

function number$3(x) {
  return x === null ? NaN : +x;
}

const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$3).center;

function extent(values, valueof) {
  let min;
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  }
  return [min, max];
}

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function generateTicks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    let r0 = Math.round(start / step), r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step), r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function max$1(values, valueof) {
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  }
  return max;
}

function ticker(year, month, week, day, hour, minute) {

  const tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function ticks(start, stop, count) {
    const reverse = stop < start;
    if (reverse) [start, stop] = [stop, start];
    const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
    const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
    return reverse ? ticks.reverse() : ticks;
  }

  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count;
    const i = bisector(([,, step]) => step).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
    if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }

  return [ticks, tickInterval];
}

ticker(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute);
const [timeTicks, timeTickInterval] = ticker(year, month, sunday, day, hour, minute);

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$1(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day$1;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day$1 = week.getUTCDay();
          week = day$1 > 4 || day$1 === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day$1 = week.getDay();
          week = day$1 > 4 || day$1 === 0 ? monday.ceil(week) : monday(week);
          week = day.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day$1 = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$1 + 5) % 7 : d.w + d.U * 7 - (day$1 + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + day.count(year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(year(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(thursday.count(year(d), d) + (year(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(year(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale$1;
var timeFormat;

defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  timeFormat = locale$1.format;
  return locale$1;
}

const dayFormat = timeFormat('%m/%d/%Y');
const hourMinuteFormat = timeFormat('%H:%M');

const getTextWidth = (text, fontSize) => {
  if (!text || !fontSize) return 0;
  const font = `${fontSize}px Open Sans`;
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (context) {
    context.font = font;
    return Math.ceil(context.measureText(text).width);
  }

  return 0;
};

const HorizontalDateAxis = ({
  timeScale
}) => {
  const width = timeScale.range()[1];
  const axis = timeScale.ticks(day).filter(tick => timeScale(tick) > 25 && timeScale(tick) < width - 25).map((tick, i) => React__default.createElement("text", {
    fill: "#848484",
    x: timeScale(tick),
    textAnchor: "middle",
    y: "10",
    height: "10",
    fontSize: "10",
    key: i
  }, dayFormat(tick)));
  return React__default.createElement(GraphLayoutDateAxis, {
    viewBox: `0 0 ${width >= 0 ? width : 0} 10`,
    width: "100%"
  }, axis);
};

const HorizontalHoursAndMinutesAxis = ({
  timeScale
}) => {
  const width = timeScale.range()[1];
  const axis = timeScale.ticks().filter(tick => timeScale(tick) > 25 && timeScale(tick) < width - 25).map((tick, i) => React__default.createElement("text", {
    fill: "#848484",
    x: timeScale(tick),
    textAnchor: "middle",
    y: "10",
    height: "10",
    fontSize: "10",
    key: i
  }, hourMinuteFormat(tick)));
  return React__default.createElement(GraphLayoutTimeAxis, {
    viewBox: `0 0 ${width >= 0 ? width : 0} 10`,
    width: "100%"
  }, axis);
};

const HorizontalPercentageAxis = ({
  scale,
  color
}) => {
  const width = scale.range()[1];
  const axis = scale.ticks().map((tick, i, arr) => {
    let anchor = 'middle';

    if (tick === 100) {
      anchor = 'end';
    }

    if (tick === 0) {
      anchor = 'start';
    }

    return React__default.createElement("text", {
      x: scale(tick),
      textAnchor: anchor,
      y: "10",
      height: "10",
      fontSize: "10",
      key: i
    }, tick, "%");
  });
  return React__default.createElement(GraphLayoutTimeAxis, {
    width: "100%",
    fill: color || '#848484',
    viewBox: `0,0,${width >= 0 ? width : 0},10`
  }, axis);
};

const HorizontalLabelAxis = ({
  labelScale,
  width
}) => {
  const fontConfig = {
    size: 10,
    lineHeight: 14,
    dy: 1.1
  };
  let totalLinesCount = 1;
  let maxLineWidth = 0,
      maxChars = 0;

  if (labelScale.length > 1) {
    maxLineWidth = labelScale[1].pos - labelScale[0].pos - BAR_GAP$1;
    maxChars = Math.floor(maxLineWidth / (fontConfig.size * 0.7));
  }

  const lastIdx = labelScale.length - 1;
  const axis = labelScale.map((labelElem, labelIdx) => {
    const labelWords = labelElem.label.split(" ");
    const lines = [];

    if (labelIdx == lastIdx) {
      maxLineWidth = width - labelElem.pos;
      maxChars = Math.floor(maxLineWidth / (fontConfig.size * 0.7));
    }

    for (let i = 0; i < labelWords.length; i++) {
      const currWordWidth = getTextWidth(labelWords[i], fontConfig.size);

      if (i == 0) {
        if (currWordWidth > maxLineWidth) {
          lines.push(labelElem.label);
          break;
        } else {
          lines.push(labelWords[i]);
          continue;
        }
      }

      const lastLineIdx = lines.length - 1;
      const lastLineWidth = getTextWidth(lines[lastLineIdx], fontConfig.size);

      if (currWordWidth > maxLineWidth) {
        lines[lastLineIdx] += ` ${labelWords.slice(i).join(' ')}`;
        break;
      }

      if (lastLineWidth + currWordWidth <= maxLineWidth) {
        lines[lastLineIdx] += ` ${labelWords[i]}`;
      } else {
        lines.push(labelWords[i]);
        totalLinesCount++;
      }
    }

    let trimmed = false;
    const lastLineIdx = lines.length - 1;

    if (lines.length && getTextWidth(lines[lastLineIdx], fontConfig.size) > maxLineWidth) {
      lines[lastLineIdx] = lines[lastLineIdx].substr(0, maxChars).trim() + "...";
      trimmed = true;
    }

    return React__default.createElement("text", {
      x: labelElem.pos,
      y: "10",
      dy: "0em",
      fontSize: fontConfig.size,
      key: labelIdx
    }, trimmed ? React__default.createElement("title", null, labelElem.label) : '', lines.map((line, lineIdx) => React__default.createElement("tspan", {
      x: labelElem.pos,
      y: "10",
      dy: `${lineIdx * fontConfig.dy}em`,
      key: `${labelIdx}${lineIdx}`
    }, line)));
  });
  return React__default.createElement(GraphLayoutTimeAxis, {
    width: `${width >= 0 ? width : 0}`,
    fill: "#848484",
    viewBox: `0,0,${width >= 0 ? width : 0},${totalLinesCount * fontConfig.lineHeight}`
  }, axis);
};

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};

function identity$3(x) {
  return x;
}

var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$3 : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity$3 : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale;
var format;
var formatPrefix;

defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

const VerticalLeftValueAxis = props => {
  const {
    percentage,
    valueScale,
    color,
    height
  } = props;
  const formatter = percentage ? d => `${d}%` : props.formatter ? props.formatter : format(',');
  const ticks = props.ticks ? props.ticks : valueScale.ticks();
  const formattedTicks = ticks.map(formatter);
  let width = formattedTicks.reduce((a, b) => a = a < b.toString().length ? b.toString().length : a, 0) * 6;

  if (percentage) {
    width += 8;
  }

  const axis = ticks.map((tick, i) => {
    const value = valueScale(tick);
    const displayValue = formattedTicks[i];
    return React__default.createElement("text", {
      x: width,
      fill: color || '#848484',
      y: value,
      fontSize: "10px",
      key: i
    }, displayValue);
  });
  return React__default.createElement(GraphLayoutLeftAxis, {
    viewBox: `0 0 ${width} ${height ? height : valueScale.range[0]}`,
    width: width,
    height: height
  }, axis);
};

const VerticalRightValueAxis = props => {
  const {
    percentage,
    valueScale,
    color,
    height
  } = props;
  const formatter = percentage ? d => `${d}%` : props.formatter ? props.formatter : format(',');
  const ticks = props.ticks ? props.ticks : valueScale.ticks();
  const formattedTicks = ticks.map(formatter);
  let width = formattedTicks.reduce((a, b) => a = a < b.toString().length ? b.toString().length : a, 0) * 6;

  if (percentage) {
    width += 8;
  }

  const axis = ticks.map((tick, i) => {
    const value = valueScale(tick);
    const displayValue = formattedTicks[i];
    return React__default.createElement("text", {
      x: 0,
      fill: color || '#848484',
      y: value,
      fontSize: "10px",
      key: i
    }, displayValue);
  });
  return React__default.createElement(GraphLayoutRightAxis, {
    viewBox: `0 0 ${width} ${height ? height : valueScale.range[0]}`,
    width: width,
    height: height
  }, axis);
};

const Line$1 = newStyled.path`
  stroke-width: 1px;
  stroke-linecap: round;
  stroke-opacity: 0.75;
  fill: none;
  &:hover {
    stroke-opacity: 0.9;
    stroke-width: 2px;
  }
`;

const Lines = props => {
  return React__default.createElement(Fragment$1, null, props.series.map(line => {
    return React__default.createElement(Line$1, {
      onMouseMove: ev => props.onMouseMove(ev, line),
      onMouseOut: () => props.onMouseLeave(),
      id: line.key,
      key: line.key,
      d: line.descriptor,
      stroke: line.color || 'black'
    });
  }));
};

const useResize = (selector, propsWidth) => {
  const [width, setWidth] = useState(propsWidth || DEFAULT_PADDING.left + DEFAULT_PADDING.right);
  const resize = useCallback(() => {
    const container = selector.current;

    if (container) {
      setWidth(container.clientWidth >= 0 ? container.clientWidth : 0);
    }
  }, [selector.current]);
  useEffect(() => {
    resize();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, [resize]);
  return width;
};

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function constants(x) {
  return function() {
    return x;
  };
}

function number$2(x) {
  return +x;
}

var unit = [0, 1];

function identity$2(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate = interpolate$1,
      transform,
      untransform,
      unknown,
      clamp = identity$2,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$2) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number$2), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity$2, rescale()) : clamp !== identity$2;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer()(identity$2, identity$2);
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return generateTicks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous();

  scale.copy = function() {
    return copy(scale, linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

function threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x != null && x <= x ? range[bisectRight(domain, x, 0, n)] : unknown;
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

function date(t) {
  return new Date(t);
}

function number$1(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
  var scale = continuous(),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(Array.from(_, number$1)) : domain().map(date);
  };

  scale.ticks = function(interval) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval) {
    var d = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d, interval)) : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
  };

  return scale;
}

function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, year, month, sunday, day, hour, minute, second, timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

const pi$1 = Math.PI,
    tau$1 = 2 * pi$1,
    epsilon$2 = 1e-6,
    tauEpsilon = tau$1 - epsilon$2;

function Path$1() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path$1;
}

Path$1.prototype = path.prototype = {
  constructor: Path$1,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$2));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$2) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$2) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$2 || Math.abs(this._y1 - y0) > epsilon$2) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$1 + tau$1;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$2) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$1)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function constant$1(x) {
  return function constant() {
    return x;
  };
}

var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon$1 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon$1) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$1(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi,
        a1 = endAngle.apply(this, arguments) - halfPi,
        da = abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon$1)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau - epsilon$1) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$1) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon$1) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon$1) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon$1) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$1) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > epsilon$1) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min(rc, (r0 - lc) / (kc - 1));
          rc1 = min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon$1)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon$1) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon$1) || !(da0 > epsilon$1)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon$1) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a) * r, sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
}

function array(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

function curveLinear(context) {
  return new Linear(context);
}

function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}

function line(x$1, y$1) {
  var defined = constant$1(true),
      context = null,
      curve = curveLinear,
      output = null;

  x$1 = typeof x$1 === "function" ? x$1 : (x$1 === undefined) ? x : constant$1(x$1);
  y$1 = typeof y$1 === "function" ? y$1 : (y$1 === undefined) ? y : constant$1(y$1);

  function line(data) {
    var i,
        n = (data = array(data)).length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant$1(+_), line) : x$1;
  };

  line.y = function(_) {
    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$1;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

function area(x0, y0, y1) {
  var x1 = null,
      defined = constant$1(true),
      context = null,
      curve = curveLinear,
      output = null;

  x0 = typeof x0 === "function" ? x0 : (x0 === undefined) ? x : constant$1(+x0);
  y0 = typeof y0 === "function" ? y0 : (y0 === undefined) ? constant$1(0) : constant$1(+y0);
  y1 = typeof y1 === "function" ? y1 : (y1 === undefined) ? y : constant$1(+y1);

  function area(data) {
    var i,
        j,
        k,
        n = (data = array(data)).length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
}

function descending(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

function identity$1(d) {
  return d;
}

function pie() {
  var value = identity$1,
      sortValues = descending,
      sort = null,
      startAngle = constant$1(0),
      endAngle = constant$1(tau),
      padAngle = constant$1(0);

  function pie(data) {
    var i,
        n = (data = array(data)).length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
  };

  return pie;
}

function none$1(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

function none(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

function stackValue(d, key) {
  return d[key];
}

function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}

function stack() {
  var keys = constant$1([]),
      order = none,
      offset = none$1,
      value = stackValue;

  function stack(data) {
    var sz = Array.from(keys.apply(this, arguments), stackSeries),
        i, n = sz.length, j = -1,
        oz;

    for (const d of data) {
      for (i = 0, ++j; i < n; ++i) {
        (sz[i][j] = [0, +value(d, sz[i].key, j, data)]).data = d;
      }
    }

    for (i = 0, oz = array(order(sz)); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none : typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
  };

  return stack;
}

const useAreasSeries = (areas, width, height, options = {
  isPercentage: false
}, padding = DEFAULT_PADDING) => {
  return useMemo(() => {
    const [dateMin, dateMax] = extent(areas[0].points, point => point.timeStamp);
    const graphBottom = height - padding.bottom;
    const graphTop = padding.top;
    let max = 0;

    if (options.isPercentage) {
      max = 100;
    } else {
      for (const a of areas) {
        const lMax = Math.max(...a.points.map(p => p.value));
        max = max < lMax ? lMax : max;
      }
    }

    const timeScale = time().domain([dateMin, dateMax]).interpolate(interpolateRoundToFixed(2)).range([padding.left, width - padding.right]);
    const valueScale = linear().domain([0, max]).interpolate(interpolateRoundToFixed(2)).range([graphBottom, max > 0 ? graphTop : graphBottom]).nice();
    const areaFn = area().x(d => timeScale(d.timeStamp)).y0(graphBottom).y1(d => valueScale(d.value));
    const plottedAreas = areas.map(s => ({
      descriptor: areaFn(s.points) || '',
      points: s.points,
      plottedPoints: s.points.map((p, i) => ({
        x: timeScale(p.timeStamp),
        y: valueScale(p.value),
        index: i,
        series: s
      })),
      key: s.key,
      color: s.color
    }));
    return {
      plottedSeries: plottedAreas,
      valueScale,
      timeScale
    };
  }, [areas, width, height, padding, options.isPercentage]);
};

const useBarsSeries = (series, width, height, options = {
  isPercentage: false
}, padding = DEFAULT_PADDING) => {
  return useMemo(() => {
    const [dateMin, dateMax] = extent(series[0].points, point => point.timeStamp);
    const graphBottom = height - padding.bottom;
    const graphTop = padding.top;
    let max = 0;

    if (options.isPercentage) {
      max = 100;
    } else {
      for (const s of series) {
        const sMax = Math.max(...s.points.map(p => p.value));
        max = max < sMax ? sMax : max;
      }
    }

    const timeScale = time().domain([dateMin, dateMax]).interpolate(interpolateRoundToFixed(2)).range([padding.left, width - padding.right]);
    const valueScale = linear().domain([0, max]).interpolate(interpolateRoundToFixed(2)).range([graphBottom, max > 0 ? graphTop : graphBottom]).nice();
    const plottedSeries = series.map(s => ({
      descriptor: '',
      points: s.points,
      plottedPoints: s.points.map((p, i) => ({
        x: timeScale(p.timeStamp),
        y: valueScale(p.value),
        index: i,
        series: s
      })),
      key: s.key,
      color: s.color || 'black'
    }));
    return {
      plottedSeries,
      valueScale,
      timeScale
    };
  }, [series, width, height, padding, options.isPercentage]);
};

var noop$1 = {value: () => {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get$1(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set$1(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set$1(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get$1(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set$1(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop$1, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

function nopropagation(event) {
  event.stopImmediatePropagation();
}

function noevent(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}

function nodrag(view) {
  var root = view.document.documentElement,
      selection = select(view).on("dragstart.drag", noevent, true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", noevent, true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
}

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = select(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", noevent, true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}

var constant = x => () => x;

function DragEvent(type, {
  sourceEvent,
  subject,
  target,
  identifier,
  active,
  x, y, dx, dy,
  dispatch
}) {
  Object.defineProperties(this, {
    type: {value: type, enumerable: true, configurable: true},
    sourceEvent: {value: sourceEvent, enumerable: true, configurable: true},
    subject: {value: subject, enumerable: true, configurable: true},
    target: {value: target, enumerable: true, configurable: true},
    identifier: {value: identifier, enumerable: true, configurable: true},
    active: {value: active, enumerable: true, configurable: true},
    x: {value: x, enumerable: true, configurable: true},
    y: {value: y, enumerable: true, configurable: true},
    dx: {value: dx, enumerable: true, configurable: true},
    dy: {value: dy, enumerable: true, configurable: true},
    _: {value: dispatch}
  });
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};

// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
  return !event.ctrlKey && !event.button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(event, d) {
  return d == null ? {x: event.x, y: event.y} : d;
}

function defaultTouchable() {
  return navigator.maxTouchPoints || ("ontouchstart" in this);
}

function drag() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = dispatch("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned(event, d) {
    if (touchending || !filter.call(this, event, d)) return;
    var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
    if (!gesture) return;
    select(event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    nodrag(event.view);
    nopropagation(event);
    mousemoving = false;
    mousedownx = event.clientX;
    mousedowny = event.clientY;
    gesture("start", event);
  }

  function mousemoved(event) {
    noevent(event);
    if (!mousemoving) {
      var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag", event);
  }

  function mouseupped(event) {
    select(event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(event.view, mousemoving);
    noevent(event);
    gestures.mouse("end", event);
  }

  function touchstarted(event, d) {
    if (!filter.call(this, event, d)) return;
    var touches = event.changedTouches,
        c = container.call(this, event, d),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
        nopropagation(event);
        gesture("start", event, touches[i]);
      }
    }
  }

  function touchmoved(event) {
    var touches = event.changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        noevent(event);
        gesture("drag", event, touches[i]);
      }
    }
  }

  function touchended(event) {
    var touches = event.changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        nopropagation(event);
        gesture("end", event, touches[i]);
      }
    }
  }

  function beforestart(that, container, event, d, identifier, touch) {
    var dispatch = listeners.copy(),
        p = pointer(touch || event, container), dx, dy,
        s;

    if ((s = subject.call(that, new DragEvent("beforestart", {
        sourceEvent: event,
        target: drag,
        identifier,
        active,
        x: p[0],
        y: p[1],
        dx: 0,
        dy: 0,
        dispatch
      }), d)) == null) return;

    dx = s.x - p[0] || 0;
    dy = s.y - p[1] || 0;

    return function gesture(type, event, touch) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[identifier] = gesture, n = active++; break;
        case "end": delete gestures[identifier], --active; // nobreak
        case "drag": p = pointer(touch || event, container), n = active; break;
      }
      dispatch.call(
        type,
        that,
        new DragEvent(type, {
          sourceEvent: event,
          subject: s,
          target: drag,
          identifier,
          active: n,
          x: p[0] + dx,
          y: p[1] + dy,
          dx: p[0] - p0[0],
          dy: p[1] - p0[1],
          dispatch
        }),
        d
      );
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
}

const Path = newStyled.path`
  cursor: pointer;
  transition: transform 200ms ease-in-out;

  &.flip-left {
    transform: translate(0, 0) scale(-1, 1);
  }

  &.flip-right {
    transform: translate(0, 0);
  }
`;
const Text$1 = newStyled.text`
  font-size: 0.75rem;
  fill: #fff;
  text-anchor: middle;
  pointer-events: none;
  transition: transform 200ms ease-in-out;

  &.flip-text-left {
    transform: translate(-24px, 0px);
  }

  &.flip-text-right {
    transform: translate(24px, 0);
  }
`;
const ZoomFlag = props => {
  const formatText = timeFormat('%H:%M');
  const {
    x,
    y,
    widthBoundary,
    clsName,
    onMoveHandle,
    xScale
  } = props;
  const handle = useRef(null);
  const handleText = useRef(null);
  const flag = useRef(null);

  function dragended() {
    const x1 = ZoomHelper.parseTransform(select('g.zoom-handle-left').attr('transform'));
    const x2 = ZoomHelper.parseTransform(select('g.zoom-handle-right').attr('transform'));
    onMoveHandle(x1, x2);
  }

  function dragged(event) {
    if (flag.current && handleText.current) {
      if (clsName === 'right' && event.x < widthBoundary - 49) {
        ZoomHelper.flipRight(flag.current, handleText.current);
      } else if (clsName === 'left' && event.x > 49) {
        ZoomHelper.flipLeft(flag.current, handleText.current);
      } else if (clsName === 'right' && event.x > widthBoundary - 49) {
        ZoomHelper.flipLeft(flag.current, handleText.current);
      } else if (clsName === 'left' && event.x < 49) {
        ZoomHelper.flipRight(flag.current, handleText.current);
      }
    }

    const oppositeFlagX = ZoomHelper.getOppositeFlagX(clsName);

    if (event.x > 0 && event.x < widthBoundary) {
      if (clsName === 'left' && event.x < oppositeFlagX || clsName === 'right' && event.x > oppositeFlagX) {
        select(this).attr('transform', `translate(${event.x}, -28)`);

        if (handleText.current) {
          handleText.current.textContent = formatText(new Date(xScale.invert(event.x)));
        }
      }
    }
  }

  useLayoutEffect(() => {
    select(`g.zoom-handle-${clsName}`).call(drag().on('drag', dragged).on('end', dragended));
  }, [clsName, dragended, dragged, widthBoundary, x]);
  return React__default.createElement("g", {
    ref: handle,
    className: `zoom-handle-${clsName}`,
    transform: `translate(${clsName === 'right' ? x : 0}, -28)`,
    "data-testid": `zoom-flag-${clsName}`
  }, React__default.createElement(Path, {
    ref: flag,
    d: "M0,0 L0,28 L6,21 L48,21 L48,0",
    stroke: "#4694CE",
    fill: "#4694CE",
    className: `${clsName === 'right' ? 'flip-left' : 'flip-right'}`
  }), React__default.createElement(Text$1, {
    ref: handleText,
    className: `zoom-handle-text-${clsName} ${clsName === 'right' ? 'flip-text-left' : 'flip-text-right'}`,
    y: y,
    dy: "10px"
  }, handleText.current && formatText(new Date(xScale.invert(x)))));
};

const ZoomContext = createContext({});
const ZoomProvider = props => {
  const [zoomCoordinates, setZoomCoordinates] = useState();
  const [zoomed, setZoomed] = useState(false);

  const zoomChart = (x1, x2) => {
    setZoomed(true);
    setZoomCoordinates({
      x1,
      x2
    });
  };

  return React__default.createElement(ZoomContext.Provider, {
    value: {
      zoomCoordinates,
      zoomChart,
      zoomed
    }
  }, props.children);
};
const useZoom = () => useContext(ZoomContext);

var slice = Array.prototype.slice;

function identity(x) {
  return x;
}

var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + x + ",0)";
}

function translateY(y) {
  return "translate(0," + y + ")";
}

function number(scale) {
  return d => +scale(d);
}

function center(scale, offset) {
  offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
  if (scale.round()) offset = Math.round(offset);
  return d => +scale(d) + offset;
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + offset,
        range1 = +range[range.length - 1] + offset,
        position = (scale.bandwidth ? center : number)(scale.copy(), offset),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "currentColor"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "currentColor")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "currentColor")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient === right
            ? (tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1)
            : (tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1));

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d) + offset); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = slice.call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  axis.offset = function(_) {
    return arguments.length ? (offset = +_, axis) : offset;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}

const getAxis = (type, scale) => {
  let axis;

  switch (type) {
    case 'Bottom':
      axis = axisBottom(scale);
      break;

    case 'Top':
      axis = axisTop(scale);
      break;

    case 'Left':
      axis = axisLeft(scale);
      break;

    case 'Right':
      axis = axisRight(scale);
      break;

    default:
      axis = axisBottom(scale);
  }

  return axis;
};

const Axis = props => {
  const groupRef = React__default.createRef();
  useEffect(() => {
    const {
      type,
      styleFunction,
      ticks,
      tickFormat
    } = props;
    const axis = getAxis(type, props.scale);

    if (ticks) {
      axis.ticks(ticks);
    }

    if (tickFormat) {
      axis.tickFormat(tickFormat);
    }

    if (styleFunction) {
      select(groupRef.current).call(axis).call(styleFunction);
    } else {
      select(groupRef.current).call(axis);
    }
  }, [groupRef, props, props.scale]);
  const {
    x,
    y,
    testId
  } = props;
  return React__default.createElement("g", {
    ref: groupRef,
    "data-testid": testId,
    transform: `translate(${x}, ${y})`
  });
};

let AxisType;

(function (AxisType) {
  AxisType["bottom"] = "Bottom";
  AxisType["top"] = "Top";
  AxisType["left"] = "Left";
  AxisType["right"] = "Right";
})(AxisType || (AxisType = {}));

const noLineTicks = fill => {
  return g => {
    g.select('.domain').attr('opacity', 0);
    g.selectAll('.tick line').remove();
    g.selectAll('.tick text').attr('fill', fill);
  };
};

const getWidth = width => {
  if (width && width >= 0) {
    return width;
  } else {
    return 1100;
  }
};

const ZoomSeriesBar = props => {
  const {
    data
  } = props;
  const containerRef = useRef(null);
  const {
    zoomChart
  } = useZoom();

  const _width = useResize(containerRef);

  const width = typeof window === 'undefined' ? getWidth(_width) : _width;
  const height = 10;
  let rectWidth = width - 80;
  rectWidth = rectWidth >= 0 ? rectWidth : 0;
  const dataExtent = extent(data, d => {
    return d.timeStamp;
  });
  const xScale = time().domain(dataExtent).interpolate(interpolateRoundToFixed(2)).range([0, rectWidth]);

  const onZoom = (x1, x2) => {
    zoomChart(xScale.invert(x1), xScale.invert(x2));
    const fillBar = select('rect.zoom-bar-fill');
    const fillX = rectWidth - x1;
    const fillX1 = rectWidth - x2;
    const fillWidth = x2 < rectWidth ? fillX - fillX1 : fillX;
    fillBar.attr('x', `${x1}px`);
    fillBar.style('width', `${fillWidth}px`);
  };

  return React__default.createElement("div", {
    ref: containerRef,
    className: "zoom-bar-container",
    "data-testid": "zoom-bar"
  }, React__default.createElement("svg", {
    width: `${width}px`,
    height: "100px"
  }, React__default.createElement("g", {
    transform: "translate(40, 50)"
  }, React__default.createElement("rect", {
    className: "zoom-bar",
    width: rectWidth,
    height: height,
    fill: "#ddd",
    rx: 5,
    ry: 5
  }), React__default.createElement("rect", {
    className: "zoom-bar-fill",
    height: height,
    width: rectWidth,
    fill: "#4694CE",
    rx: 5,
    ry: 5
  }), React__default.createElement(ZoomFlag, {
    clsName: "left",
    x: 0,
    y: 5,
    widthBoundary: rectWidth,
    onMoveHandle: onZoom,
    xScale: xScale
  }), React__default.createElement(ZoomFlag, {
    clsName: "right",
    x: rectWidth,
    y: 5,
    widthBoundary: rectWidth,
    onMoveHandle: onZoom,
    xScale: xScale
  }), React__default.createElement(Axis, {
    type: AxisType.bottom,
    scale: xScale,
    x: 0,
    y: height,
    styleFunction: noLineTicks('#848484'),
    tickFormat: timeFormat('%H:%M')
  }), React__default.createElement(Axis, {
    type: AxisType.bottom,
    scale: xScale,
    x: 0,
    y: height + 15,
    styleFunction: noLineTicks('#848484'),
    ticks: day,
    tickFormat: timeFormat('%m/%d/%Y')
  }))));
};

var frame = 0, // is an animation frame pending?
    timeout$1 = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout$1 = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout$1) timeout$1 = clearTimeout(timeout$1);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout$1 = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

function timeout(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(elapsed => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}

var emptyOn = dispatch("start", "end", "cancel", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

function schedule(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return timeout(start);

      // Interrupt the active transition, if any.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions.
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    timeout(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(node, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

function interrupt(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
}

function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}

function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

function transition_tween(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
}

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = set(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get(node, id).value[name];
  };
}

function interpolate(a, b) {
  var c;
  return (typeof b === "number" ? interpolateNumber
      : b instanceof color ? interpolateRgb
      : (c = color(b)) ? (b = c, interpolateRgb)
      : interpolateString)(a, b);
}

function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
}

function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}

function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}

function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}

function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

function transition_delay(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get(this.node(), id).delay;
}

function durationFunction(id, value) {
  return function() {
    set(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set(this, id).duration = value;
  };
}

function transition_duration(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get(this.node(), id).duration;
}

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set(this, id).ease = value;
  };
}

function transition_ease(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get(this.node(), id).ease;
}

function easeVarying(id, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (typeof v !== "function") throw new Error;
    set(this, id).ease = v;
  };
}

function transition_easeVarying(value) {
  if (typeof value !== "function") throw new Error;
  return this.each(easeVarying(this._id, value));
}

function transition_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
}

function transition_merge(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
}

function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : set;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

function transition_on(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
}

function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}

function transition_select(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, get(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
}

function transition_selectAll(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
}

var Selection = selection.prototype.constructor;

function transition_selection() {
  return new Selection(this._groups, this._parents);
}

function styleNull(name, interpolate) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        value1 = value(this),
        string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function styleMaybeRemove(id, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
  return function() {
    var schedule = set(this, id),
        on = schedule.on,
        listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);

    schedule.on = on1;
  };
}

function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate;
  return value == null ? this
      .styleTween(name, styleNull(name, i))
      .on("end.style." + name, styleRemove(name))
    : typeof value === "function" ? this
      .styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value)))
      .each(styleMaybeRemove(this._id, name))
    : this
      .styleTween(name, styleConstant(name, i, value), priority)
      .on("end.style." + name, null);
}

function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}

function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}

function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

function transition_text(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(tweenValue(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
}

function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}

function textTween(value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, textTween(value));
}

function transition_transition() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
}

function transition_end() {
  var on0, on1, that = this, id = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {value: reject},
        end = {value: function() { if (--size === 0) resolve(); }};

    that.each(function() {
      var schedule = set(this, id),
          on = schedule.on;

      // If this node shared a dispatch with the previous node,
      // just assign the updated shared dispatch and we’re done!
      // Otherwise, copy-on-write.
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }

      schedule.on = on1;
    });

    // The selection was empty, resolve end immediately
    if (size === 0) resolve();
  });
}

var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

Transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  easeVarying: transition_easeVarying,
  end: transition_end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      throw new Error(`transition ${id} not found`);
    }
  }
  return timing;
}

function selection_transition(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
}

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;

const Circle = newStyled.circle`
  cursor: pointer;
`;
const Text = newStyled.text`
  font-size: 0.75rem;
  fill: #0076ce;
  text-anchor: middle;
`;
const handleDiameter = 16;

const ZoomHandle = props => {
  const {
    radius,
    color,
    strokeColor,
    strokeWidth,
    cx,
    cy,
    widthBoundary,
    clsName,
    onMoveHandle
  } = props;
  const handle = useRef(null);
  const handleText = useRef(null);
  const xScale = linear().domain([0, 100]).range([0, widthBoundary]);
  const [textValue, setTextValue] = useState(0);

  function dragended() {
    const x1 = clsName === 'left' ? Number.parseInt(select(this).attr('cx')) : Number.parseInt(select('circle.zoom-handle-left').attr('cx'));
    const x2 = clsName === 'left' ? Number.parseInt(select('circle.zoom-handle-right').attr('cx')) : Number.parseInt(select(this).attr('cx'));
    onMoveHandle(Math.round(xScale.invert(x1)), Math.round(xScale.invert(x2)));
  }

  function dragged(event) {
    const otherHandle = clsName === 'left' ? Number.parseInt(select('circle.zoom-handle-right').attr('cx')) : Number.parseInt(select('circle.zoom-handle-left').attr('cx'));

    if (event.x > 0 && event.x <= widthBoundary) {
      if (clsName === 'left' && event.x < otherHandle - handleDiameter || clsName === 'right' && event.x > otherHandle + handleDiameter) {
        select(this).attr('cx', event.x);
        select(`text.zoom-handle-text-${clsName}`).attr('x', event.x);
        setTextValue(xScale.invert(event.x));
      }
    }
  }

  useLayoutEffect(() => {
    select(`circle.zoom-handle-${clsName}`).call(drag().on('drag', dragged).on('end', dragended));
    onMoveHandle(0, 100);

    if (clsName === 'left') {
      select(handle.current).transition().duration(500).attr('cx', 0);
      select(handleText.current).transition().duration(500).attr('x', 0);
    } else {
      select(handle.current).transition().duration(500).attr('cx', widthBoundary);
      select(handleText.current).transition().duration(500).attr('x', widthBoundary);
    }

    setTextValue(xScale.invert(cx));
  }, [widthBoundary]);
  return React__default.createElement("g", null, React__default.createElement(Circle, {
    ref: handle,
    className: `zoom-handle-${clsName}`,
    r: radius,
    fill: color,
    stroke: strokeColor,
    strokeWidth: strokeWidth,
    cx: cx,
    cy: cy
  }), React__default.createElement(Text, {
    ref: handleText,
    className: `zoom-handle-text-${clsName}`,
    x: cx,
    y: cy,
    dy: 25
  }, `${Math.round(textValue)}%`));
};

const HandlesOuterRadius = 12;
const HandlesInnerRadius = 3;
const MaxLabelWidth = 20;

const ZoomPercentageBar = props => {
  const {
    height,
    color,
    y,
    onZoom
  } = props;

  if (props.width < 0) {
    return React__default.createElement("g", null);
  }

  let width = props.width - MaxLabelWidth - HandlesOuterRadius;
  width = width >= 0 ? width : 0;
  const translate = `translate(${HandlesOuterRadius},${y})`;
  return React__default.createElement("g", {
    transform: translate
  }, React__default.createElement("rect", {
    className: "zoom-bar",
    width: width,
    height: height,
    fill: color,
    x: 0,
    y: 0,
    rx: 5,
    ry: 5
  }), React__default.createElement(ZoomHandle, {
    clsName: "left",
    radius: HandlesOuterRadius - HandlesInnerRadius * 1.5,
    strokeWidth: HandlesOuterRadius - HandlesInnerRadius,
    color: '#fff',
    strokeColor: '#4694CE',
    cx: 0,
    cy: height / 2,
    widthBoundary: width,
    onMoveHandle: onZoom
  }), React__default.createElement(ZoomHandle, {
    clsName: "right",
    radius: HandlesOuterRadius - HandlesInnerRadius * 1.5,
    strokeWidth: HandlesOuterRadius - HandlesInnerRadius,
    color: '#fff',
    strokeColor: '#4694CE',
    cx: width,
    cy: height / 2,
    widthBoundary: width,
    onMoveHandle: onZoom
  }));
};

function stepSize(ticks) {
  const length = ticks.length;

  if (length < 1) {
    return 0;
  }

  const [first, second] = ticks;
  return second - first;
}

const useNicedTicks = (max, min = 0) => {
  return useMemo(() => {
    if (min === 0) {
      const ticks = linear().domain([min, max]).nice().ticks();
      const nicedMin = ticks[0];
      const nicedMax = ticks[ticks.length - 1];
      return {
        ticks,
        nicedMin,
        nicedMax
      };
    } else {
      const upperTicks = generateTicks(0, max, 5);
      const lowerTicks = generateTicks(min, 0, 5);
      const highestTick = upperTicks[upperTicks.length - 1];
      const lowestTick = lowerTicks[0];

      if (highestTick < max) {
        const step = stepSize(upperTicks);
        upperTicks.push(highestTick + step);
      }

      if (lowestTick > min) {
        const step = stepSize(lowerTicks);
        lowerTicks.unshift(lowestTick - step);
      }

      const ticks = Array.from(new Set([...lowerTicks, ...upperTicks]));
      const nicedMin = lowerTicks[0];
      const nicedMax = upperTicks[upperTicks.length - 1];
      return {
        ticks,
        nicedMin,
        nicedMax
      };
    }
  }, [min, max]);
};

const useLinesSeries = (lines, width, height, options = {
  isPercentage: false
}, padding = DEFAULT_PADDING) => {
  const {
    zoomed,
    zoomCoordinates
  } = useZoom();
  const {
    dateMin,
    dateMax,
    max
  } = useMemo(() => {
    const [dMin, dMax] = extent(lines.map(l => l.points).flat(), point => point.timeStamp);
    let overallMax = 0;

    if (options.isPercentage) {
      overallMax = 100;
    } else {
      for (const l of lines) {
        const lineMax = Math.max(...l.points.map(p => p.value));
        overallMax = overallMax < lineMax ? lineMax : overallMax;
      }
    }

    return {
      dateMin: dMin,
      dateMax: dMax,
      max: overallMax
    };
  }, [lines, options.isPercentage]);
  const {
    nicedMax,
    ticks
  } = useNicedTicks(max);
  return useMemo(() => {
    const graphBottom = height - padding.bottom;
    const graphTop = padding.top;
    const timeScale = time().domain([dateMin, dateMax]).interpolate(interpolateRoundToFixed(2)).range([padding.left, width - padding.right]);
    const valueScale = linear().domain([0, nicedMax]).interpolate(interpolateRoundToFixed(2)).range([graphBottom, nicedMax > 0 ? graphTop : graphBottom]).nice();

    if (zoomed && zoomCoordinates) {
      const {
        x1,
        x2
      } = zoomCoordinates;
      timeScale.domain([x1, x2]).interpolate(interpolateRoundToFixed(2)).range([padding.left, width - padding.right]);
    }

    const lineFn = line().x(d => timeScale(d.timeStamp)).defined(d => {
      const x = timeScale(d.timeStamp);
      const [rangeMin, rangeMax] = timeScale.range();
      return x <= rangeMax && x >= rangeMin;
    }).y(d => valueScale(d.value));
    const plottedSeries = lines.map(s => ({
      descriptor: lineFn(s.points) || '',
      points: s.points,
      plottedPoints: s.points.map((p, i) => ({
        x: timeScale(p.timeStamp),
        y: valueScale(p.value),
        index: i,
        series: s
      })),
      key: s.key,
      color: s.color
    }));
    return {
      plottedSeries,
      valueScale,
      timeScale,
      ticks
    };
  }, [height, padding.bottom, padding.top, padding.left, padding.right, dateMin, dateMax, width, nicedMax, zoomed, zoomCoordinates, lines, ticks]);
};

const useStackedAreasSeries = (areas, width, height, options = {
  isPercentage: false
}, padding = DEFAULT_PADDING) => {
  const chartData = useMemo(() => {
    const [dateMin, dateMax] = extent(areas.map(a => a.points).flat(), point => point.timeStamp);
    const keys = areas.map(a => a.key);
    const stackedSet = {};
    let dataSet = [];
    areas.forEach(d => {
      d.points.forEach(p => {
        const entry = stackedSet[p.timeStamp.toString()];

        if (entry) {
          entry[d.key] = p;
        } else {
          const newEntry = {
            timeStamp: p.timeStamp,
            [d.key]: p
          };
          stackedSet[p.timeStamp.toString()] = newEntry;
          dataSet.push(newEntry);
        }
      });
    });
    dataSet.sort((a, b) => a.timeStamp.getTime() - b.timeStamp.getTime());
    dataSet = dataSet.map(interpolateMissingPointsForKeys(keys));
    const stacks = stack().keys(keys).value((data, key) => data[key] ? data[key].value : 0)(dataSet);
    let max = 0;

    if (options.isPercentage) {
      max = 100;
    } else {
      const lastStack = stacks[stacks.length - 1];
      max = Math.max(...lastStack.map(point => point[1]));
    }

    const graphBottom = height - padding.bottom;
    const graphTop = padding.top;
    const valueScale = linear().domain([0, max]).interpolate(interpolateRoundToFixed(2)).range([graphBottom, max > 0 ? graphTop : graphBottom]).nice();
    return {
      dateMin,
      dateMax,
      max,
      stacks,
      valueScale
    };
  }, [areas, padding, options.isPercentage, height]);
  return useMemo(() => {
    const timeScale = time().domain([chartData.dateMin, chartData.dateMax]).interpolate(interpolateRoundToFixed(2)).range([padding.left, width - padding.right]);
    const areaFn = area().x(d => timeScale(d.data.timeStamp)).y0(d => chartData.valueScale(d[0])).y1(d => chartData.valueScale(d[1]));
    const plottedAreas = areas.map((s, seriesIndex) => ({
      descriptor: areaFn(chartData.stacks[seriesIndex]) || '',
      points: s.points,
      plottedPoints: s.points.map((p, pointIndex) => {
        const series = chartData.stacks[seriesIndex];
        let stackPoint = series[pointIndex];

        if (stackPoint) {
          for (let idx = pointIndex; idx < series.length; idx++) {
            stackPoint = series[idx];

            if (!stackPoint) {
              continue;
            }

            const sameTime = stackPoint.data.timeStamp.getTime() === p.timeStamp.getTime();

            if (sameTime) {
              break;
            }
          }

          return {
            x: timeScale(p.timeStamp),
            y: chartData.valueScale(stackPoint[1]),
            index: pointIndex,
            series: s
          };
        }
      }),
      key: s.key,
      color: s.color
    }));
    return {
      plottedSeries: plottedAreas,
      valueScale: chartData.valueScale,
      timeScale
    };
  }, [areas, padding, width, chartData]);
};

function useTooltip(tooltipFunction) {
  const [tooltip, setTooltip] = useState({
    x: 0,
    y: 0,
    message: '',
    visible: false
  });

  const showTooltip = (p, ev) => {
    if (tooltipFunction) {
      setTooltip({
        x: ev ? ev.clientX : p.x,
        y: ev ? ev.clientY : p.y,
        message: tooltipFunction(p.series.points[p.index], p.index, p.series),
        visible: true
      });
    }
  };

  const hideTooltip = () => {
    if (tooltip.visible) {
      setTooltip(_objectSpread2(_objectSpread2({}, tooltip), {}, {
        visible: false
      }));
    }
  };

  return {
    showTooltip,
    hideTooltip,
    tooltip,
    setTooltip
  };
}

const defaultParams = {
  padding: DEFAULT_PADDING
};

const generateAxisPathFunction = (compositeSeries, timeScale, valueScale) => {
  switch (compositeSeries.type) {
    case 'line':
      return line().defined(d => {
        const x = timeScale(d.timeStamp);
        const [rangeMin, rangeMax] = timeScale.range();
        return x <= rangeMax && x >= rangeMin;
      }).x(p => timeScale(p.timeStamp)).y(p => valueScale(p.value));

    case 'area':
      return area().defined(d => {
        const x = timeScale(d.timeStamp);
        const [rangeMin, rangeMax] = timeScale.range();
        return x <= rangeMax && x >= rangeMin;
      }).x(p => timeScale(p.timeStamp)).y1(p => valueScale(p.value)).y0(valueScale.range()[0]);
  }
};

const useCompositeSeries = params => {
  const {
    zoomed,
    zoomCoordinates
  } = useZoom();
  const {
    left,
    right,
    width,
    height
  } = params;
  const padding = params.padding ? params.padding : defaultParams.padding;
  const extremes = useMemo(() => {
    const [dMin, dMax] = extent(left.series.map(l => l.points).flat().concat(right.series.map(r => r.points).flat()), point => point.timeStamp);
    let lMax = 100;
    let rMax = 100;

    if (!left.isPercentage) {
      lMax = extent(left.series.map(l => l.points).flat(), p => p.value)[1];
    }

    if (!right.isPercentage) {
      rMax = extent(right.series.map(l => l.points).flat(), p => p.value)[1];
    }

    return {
      dateMin: dMin,
      dateMax: dMax,
      leftMax: lMax,
      rightMax: rMax
    };
  }, [left.isPercentage, left.series, right.isPercentage, right.series]);
  const {
    nicedMax: leftMax,
    ticks: leftTicks
  } = useNicedTicks(extremes.leftMax);
  const {
    nicedMax: rightMax,
    ticks: rightTicks
  } = useNicedTicks(extremes.rightMax);
  return useMemo(() => {
    const {
      dateMin,
      dateMax
    } = extremes;
    const graphBottom = height - padding.bottom;
    const graphTop = padding.top;
    const timeScale = time().domain([dateMin, dateMax]).interpolate(interpolateRoundToFixed(2)).range([padding.left, width - padding.right]);
    const leftScale = linear().domain([0, leftMax]).interpolate(interpolateRoundToFixed(2)).range([graphBottom, leftMax > 0 ? graphTop : graphBottom]);
    const rightScale = linear().domain([0, rightMax]).interpolate(interpolateRoundToFixed(2)).range([graphBottom, rightMax > 0 ? graphTop : graphBottom]);

    if (zoomed && zoomCoordinates) {
      const {
        x1,
        x2
      } = zoomCoordinates;
      timeScale.domain([x1, x2]).interpolate(interpolateRoundToFixed(2)).range([padding.left, width - padding.right]);
    }

    const leftAxisFn = generateAxisPathFunction(left, timeScale, leftScale);
    const rightAxisFn = generateAxisPathFunction(right, timeScale, rightScale);
    const leftPlottedSeries = left.series.map(mapSeriesToPlottedSeries(leftAxisFn, timeScale, leftScale));
    const rightPlottedSeries = right.series.map(mapSeriesToPlottedSeries(rightAxisFn, timeScale, rightScale));
    return {
      leftPlottedSeries,
      rightPlottedSeries,
      leftScale,
      rightScale,
      timeScale,
      leftTicks,
      rightTicks
    };
  }, [extremes, height, padding.bottom, padding.top, padding.left, padding.right, width, leftMax, rightMax, zoomed, zoomCoordinates, left, right, leftTicks, rightTicks]);
};

const CirclePeaks = props => {
  const onMouseEnter = props.onMouseEnter ? props.onMouseEnter : () => null;
  const onMouseLeave = props.onMouseLeave ? props.onMouseLeave : () => null;
  return React__default.createElement(Fragment$1, null, props.plottedSeries.map(s => {
    const peak = Math.min(...s.plottedPoints.map(p => p.y));
    return s.plottedPoints.filter(p => p.series.points[p.index].value > 0).map((p, i) => {
      if (p.y === peak) {
        return React__default.createElement("circle", {
          key: i,
          onMouseEnter: ev => onMouseEnter(p, ev),
          onMouseLeave: ev => onMouseLeave(p, ev),
          cx: p.x,
          cy: p.y,
          strokeWidth: PEAK_CIRCLE_STROKEWIDTH,
          stroke: s.color,
          opacity: "1",
          fill: "white",
          r: PEAK_CIRCLE_RADIUS
        });
      }

      return null;
    });
  }));
};

const FONT_SIZE = 12;

const HorizontalLine = props => {
  return React__default.createElement("g", null, props.text && React__default.createElement("text", {
    x: "12",
    fillOpacity: "1",
    y: props.y - FONT_SIZE / 2,
    fontSize: FONT_SIZE,
    fontWeight: "500",
    fill: props.color
  }, props.text), React__default.createElement("path", _extends$3({}, props, {
    fillOpacity: "1",
    d: `M 0 ${props.y} L ${props.width} ${props.y}`,
    stroke: props.color,
    fill: "none",
    strokeWidth: props.strokeWidth ? props.strokeWidth : 1
  })));
};

const LineSeriesChart = props => {
  const graphSVG = useRef(null);
  const graphContainer = useRef(null);
  const height = props.height ? props.height : CHART_HEIGHT;
  const width = useResize(graphContainer, props.width);
  const {
    hideTooltip,
    showTooltip,
    tooltip
  } = useTooltip(props.tooltipFn);
  const {
    plottedSeries,
    valueScale,
    timeScale,
    ticks
  } = useLinesSeries(props.series, width, height, {
    isPercentage: props.percentage
  });

  const onMouseMove = (ev, series) => {
    if (graphSVG.current && props.tooltipFn) {
      ev.stopPropagation();
      const [x, y] = pointer(ev, graphSVG.current);
      const nearestPlottedPoint = series.plottedPoints.sort(sortByEuclideanDistanceTo({
        x,
        y
      }))[0];
      showTooltip(nearestPlottedPoint);
    }
  };

  return React__default.createElement(ChartPanel, props, React__default.createElement(GraphLayoutGraph, {
    ref: graphContainer
  }, React__default.createElement("svg", {
    height: height,
    width: "100%",
    preserveAspectRatio: "xMidYMax meet",
    viewBox: `0 0 ${width} ${height}`
  }, React__default.createElement("g", {
    ref: graphSVG
  }, ticks.map((tick, i) => React__default.createElement(HorizontalLine, {
    key: i,
    color: "#E4E4E4",
    y: valueScale(tick),
    width: width
  })), React__default.createElement(Lines, {
    series: plottedSeries,
    onMouseLeave: hideTooltip,
    onMouseMove: onMouseMove
  }), props.extraHorizontalLines && props.extraHorizontalLines.map((l, i) => {
    return React__default.createElement(HorizontalLine, {
      key: i,
      color: l.color,
      text: l.text,
      width: width,
      y: valueScale(l.value)
    });
  }), props.showPeaks && React__default.createElement(CirclePeaks, {
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    plottedSeries: plottedSeries
  }))), React__default.createElement(ChartTooltip, tooltip)), React__default.createElement(HorizontalDateAxis, {
    timeScale: timeScale
  }), React__default.createElement(HorizontalHoursAndMinutesAxis, {
    timeScale: timeScale
  }), React__default.createElement(VerticalLeftValueAxis, {
    percentage: props.percentage,
    height: height,
    valueScale: valueScale,
    ticks: ticks
  }));
};

const Area = newStyled.path`
  stroke-linecap: round;
  stroke-opacity: 0;
  stroke-width: 0;
  fill-opacity: 0.75;
  &:hover {
    fill-opacity: 0.9;
  }
`;

const Areas = props => {
  return React__default.createElement("g", null, props.series.map(area => {
    return React__default.createElement(Area, {
      onMouseMove: ev => props.onMouseMove(ev, area),
      onMouseOut: () => props.onMouseLeave(),
      id: area.key,
      key: area.key,
      d: area.descriptor,
      stroke: area.color,
      fill: area.color
    });
  }));
};

const AreaSeriesChart = props => {
  const graphSVG = useRef(null);
  const graphContainer = useRef(null);
  const height = props.height ? props.height : CHART_HEIGHT;
  const width = useResize(graphContainer, props.width);
  const {
    hideTooltip,
    showTooltip,
    tooltip
  } = useTooltip(props.tooltipFn);
  const {
    plottedSeries,
    valueScale,
    timeScale
  } = useAreasSeries(props.series, width, height, {
    isPercentage: props.percentage
  });

  const onMouseMove = (ev, series) => {
    if (graphSVG.current && props.tooltipFn) {
      const [x, y] = pointer(ev, graphSVG.current);
      const nearestPlottedPoint = series.plottedPoints.sort(sortByEuclideanDistanceTo({
        x,
        y
      }))[0];
      showTooltip(nearestPlottedPoint);
    }
  };

  return React__default.createElement(ChartPanel, props, React__default.createElement(GraphLayoutGraph, {
    ref: graphContainer
  }, React__default.createElement("svg", {
    height: height,
    width: "100%",
    preserveAspectRatio: "xMidYMax meet",
    viewBox: `0 0 ${width} ${height}`
  }, React__default.createElement("g", {
    ref: graphSVG
  }, valueScale.ticks().map((tick, i) => React__default.createElement(HorizontalLine, {
    key: i,
    color: "#E4E4E4",
    y: valueScale(tick),
    width: width
  })), React__default.createElement(Areas, {
    series: plottedSeries,
    onMouseLeave: hideTooltip,
    onMouseMove: onMouseMove
  }), props.extraHorizontalLines && props.extraHorizontalLines.map((l, i) => {
    return React__default.createElement(HorizontalLine, {
      key: i,
      color: l.color,
      text: l.text,
      width: width,
      y: valueScale(l.value)
    });
  }), props.showPeaks && React__default.createElement(CirclePeaks, {
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    plottedSeries: plottedSeries
  }))), React__default.createElement(ChartTooltip, tooltip)), React__default.createElement(HorizontalDateAxis, {
    timeScale: timeScale
  }), React__default.createElement(HorizontalHoursAndMinutesAxis, {
    timeScale: timeScale
  }), React__default.createElement(VerticalLeftValueAxis, {
    height: height,
    percentage: props.percentage,
    valueScale: valueScale
  }));
};

const VerticalLine = props => {
  return React__default.createElement("g", {
    pointerEvents: "none"
  }, React__default.createElement("path", _extends$3({
    strokeWidth: "1"
  }, props, {
    fillOpacity: "1",
    d: `M ${props.x} 0 L ${props.x} ${props.height}`,
    stroke: props.color,
    pointerEvents: "none",
    fill: "none"
  })));
};

const RECT_WIDTH$1 = 5;
const RECT_BORDER_RADIUS = RECT_WIDTH$1 / 2;
const roundedRect = ({
  x,
  y
}, yCenter = 0) => {
  const isNegative = y > yCenter;

  if (!isNegative) {
    return `M ${x - RECT_BORDER_RADIUS} ${yCenter} l ${RECT_WIDTH$1} 0 0 -${yCenter - y} m 0 0 a ${RECT_BORDER_RADIUS} ${RECT_BORDER_RADIUS} 0 0 0 -${RECT_WIDTH$1} 0 l 0 ${yCenter - y}`;
  } else {
    return `M ${x - RECT_BORDER_RADIUS} ${yCenter} l ${RECT_WIDTH$1} 0 0 ${-yCenter + y} m 0 0 a ${RECT_BORDER_RADIUS} ${RECT_BORDER_RADIUS} 0 0 1 ${-RECT_WIDTH$1} 0 l 0 ${yCenter - y}`;
  }
};

const Bar$1 = newStyled.path`
  fill: currentColor;
  stroke-linecap: round;
  &:hover {
    fill-opacity: 1 !important;
  }
`;
const Group = newStyled.g`
  ${p => p.dimmable ? `&:hover > path {
    fill-opacity: 0.50;
  }` : ''}
`;

const Bars$1 = props => {
  const center = props.center ? props.center : 0;
  const dimmable = props.dimmable !== undefined ? props.dimmable : true;

  const onMouseLeave = () => {
    if (props.onMouseLeave) {
      props.onMouseLeave();
    }
  };

  const onMouseEnter = point => {
    if (props.onMouseEnter) {
      props.onMouseEnter(point);
    }
  };

  const onMouseMove = (point, ev) => {
    if (props.onMouseMove) {
      ev.stopPropagation();
      props.onMouseMove(point, ev);
    }
  };

  return React__default.createElement(Group, {
    onMouseOut: () => onMouseLeave(),
    dimmable: dimmable
  }, props.series.map(bar => bar.plottedPoints.map((point, i) => {
    const color = props.colorScale ? props.colorScale(point.series.points[point.index].value) : point.series.color;
    return React__default.createElement(Bar$1, {
      key: i,
      color: color,
      onMouseMove: ev => onMouseMove(point, ev),
      onMouseEnter: () => onMouseEnter(point),
      d: !props.barShap ? roundedRect(point, center) : props.barShap(point, center, props.barWidth)
    });
  })));
};

const LinearPaths = props => {
  switch (props.type) {
    case 'line':
      return React__default.createElement(Lines, props);

    case 'area':
      return React__default.createElement(Areas, props);
  }
};

const Donut = ({
  data
}) => {
  const radius = 50;
  const pieFn = pie().value(d => {
    return d.value;
  })(data);
  const arcFn = arc().innerRadius(radius * 0.7).outerRadius(radius);
  return React__default.createElement("svg", {
    width: "100%",
    viewBox: "0 0 100 100",
    "data-testid": "donut"
  }, React__default.createElement("g", {
    transform: "translate(50, 50)"
  }, pieFn.map((d, i) => {
    const [x, y] = arcFn.centroid(d);
    return React__default.createElement("g", {
      key: `donut-path-${i}`
    }, React__default.createElement("path", {
      d: arcFn(d) || '',
      fill: d.data.color
    }), React__default.createElement("text", {
      x: x,
      y: y,
      dy: "2",
      fontSize: "6",
      textAnchor: "middle",
      fill: "#fff"
    }));
  })));
};

const GaugeBar = ({
  value,
  colorRanges
}) => {
  const colorScale = threshold().domain(colorRanges.map(d => d.range)).range(colorRanges.map(d => d.color));
  const fill = colorScale(value);
  return React__default.createElement("svg", {
    width: "100%",
    height: "30",
    "data-testid": "gauge-bar"
  }, React__default.createElement("rect", {
    height: "20",
    width: "100%",
    fill: "#ddd"
  }), React__default.createElement("rect", {
    height: "20",
    width: `${value}%`,
    fill: fill
  }));
};

const CompositeSeriesChart = props => {
  const graphSVG = useRef(null);
  const graphContainer = useRef(null);
  const height = props.height ? props.height : CHART_HEIGHT;
  const width = useResize(graphContainer, props.width);
  const {
    hideTooltip,
    showTooltip,
    tooltip
  } = useTooltip(props.tooltipFn);
  const {
    leftPlottedSeries,
    leftScale,
    rightPlottedSeries,
    rightScale,
    timeScale,
    leftTicks,
    rightTicks
  } = useCompositeSeries({
    left: props.left,
    right: props.right,
    height,
    width
  });

  const onMouseMove = (ev, series) => {
    if (graphSVG.current && props.tooltipFn) {
      const [x, y] = pointer(ev, graphSVG.current);
      const nearestPlottedPoint = series.plottedPoints.sort(sortByEuclideanDistanceTo({
        x,
        y
      }))[0];
      showTooltip(nearestPlottedPoint);
    }
  };

  const bothWithNoIndicators = !(props.left.indicatorLines && props.right.indicatorLines);
  const drawIndicatorsToLeftAxis = props.left.indicatorLines || bothWithNoIndicators;
  return React__default.createElement(ChartPanel, props, React__default.createElement(GraphLayoutGraph, {
    ref: graphContainer
  }, React__default.createElement("svg", {
    height: height,
    width: "100%",
    preserveAspectRatio: "xMidYMax meet",
    viewBox: `0 0 ${width} ${height}`
  }, React__default.createElement("g", {
    ref: graphSVG
  }, drawIndicatorsToLeftAxis && leftTicks.map((tick, i) => React__default.createElement(HorizontalLine, {
    key: i,
    color: "#E4E4E4",
    y: leftScale(tick),
    width: width
  })), props.right.indicatorLines && rightScale.ticks().map((tick, i) => React__default.createElement(HorizontalLine, {
    key: i,
    color: "#E4E4E4",
    y: rightScale(tick),
    width: width
  })), React__default.createElement(LinearPaths, {
    type: props.left.type,
    series: leftPlottedSeries,
    onMouseLeave: hideTooltip,
    onMouseMove: onMouseMove
  }), React__default.createElement(LinearPaths, {
    type: props.right.type,
    series: rightPlottedSeries,
    onMouseLeave: hideTooltip,
    onMouseMove: onMouseMove
  }), props.extraHorizontalLines && props.extraHorizontalLines.map((l, i) => {
    return React__default.createElement(HorizontalLine, {
      key: i,
      color: l.color,
      text: l.text,
      width: width,
      y: leftScale(l.value)
    });
  }), props.showPeaks && React__default.createElement(CirclePeaks, {
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    plottedSeries: leftPlottedSeries
  }), props.showPeaks && React__default.createElement(CirclePeaks, {
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    plottedSeries: rightPlottedSeries
  }))), React__default.createElement(ChartTooltip, tooltip)), React__default.createElement(HorizontalDateAxis, {
    timeScale: timeScale
  }), React__default.createElement(HorizontalHoursAndMinutesAxis, {
    timeScale: timeScale
  }), React__default.createElement(VerticalLeftValueAxis, {
    height: height,
    percentage: props.left.isPercentage,
    color: props.left.color,
    valueScale: leftScale,
    ticks: leftTicks
  }), React__default.createElement(VerticalRightValueAxis, {
    height: height,
    percentage: props.right.isPercentage,
    color: props.right.color,
    valueScale: rightScale,
    ticks: rightTicks
  }));
};

const StackedAreaSeriesChart = props => {
  const graphSVG = useRef(null);
  const graphContainer = useRef(null);
  const height = props.height ? props.height : CHART_HEIGHT;
  const width = useResize(graphContainer, props.width);
  const {
    hideTooltip,
    showTooltip,
    tooltip
  } = useTooltip(props.tooltipFn);
  const {
    plottedSeries,
    valueScale,
    timeScale
  } = useStackedAreasSeries(props.series, width, height, {
    isPercentage: props.percentage
  });

  const onMouseMove = (ev, series) => {
    if (graphSVG.current && props.tooltipFn) {
      const [x, y] = pointer(ev, graphSVG.current);
      const nearestPlottedPoint = series.plottedPoints.sort(sortByEuclideanDistanceTo({
        x,
        y
      }))[0];
      showTooltip(nearestPlottedPoint);
    }
  };

  return React__default.createElement(ChartPanel, props, React__default.createElement(GraphLayoutGraph, {
    ref: graphContainer
  }, React__default.createElement("svg", {
    height: height,
    width: "100%",
    preserveAspectRatio: "xMidYMax meet",
    viewBox: `0 0 ${width} ${height}`
  }, React__default.createElement("g", {
    ref: graphSVG
  }, valueScale.ticks().map((tick, i) => React__default.createElement(HorizontalLine, {
    key: i,
    color: "#E4E4E4",
    y: valueScale(tick),
    width: width
  })), React__default.createElement(Areas, {
    series: plottedSeries,
    onMouseLeave: hideTooltip,
    onMouseMove: onMouseMove
  }), props.extraHorizontalLines && props.extraHorizontalLines.map((l, i) => {
    return React__default.createElement(HorizontalLine, {
      key: i,
      color: l.color,
      text: l.text,
      width: width,
      y: valueScale(l.value)
    });
  }), props.showPeaks && React__default.createElement(CirclePeaks, {
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    plottedSeries: plottedSeries
  }))), React__default.createElement(ChartTooltip, tooltip)), React__default.createElement(HorizontalDateAxis, {
    timeScale: timeScale
  }), React__default.createElement(HorizontalHoursAndMinutesAxis, {
    timeScale: timeScale
  }), React__default.createElement(VerticalLeftValueAxis, {
    height: height,
    percentage: props.percentage,
    valueScale: valueScale
  }));
};

const BarsSeriesChart = props => {
  const graphSVG = useRef(null);
  const graphContainer = useRef(null);
  const height = props.height ? props.height : CHART_HEIGHT;
  const width = useResize(graphContainer, props.width);
  const {
    hideTooltip,
    showTooltip,
    tooltip
  } = useTooltip(props.tooltipFn);
  const {
    plottedSeries,
    valueScale,
    timeScale
  } = useBarsSeries(props.series, width, height, {
    isPercentage: props.percentage
  });
  let colorScale;

  if (props.colorsRanges) {
    const colorsRanges = props.colorsRanges.sort((a, b) => a.range - b.range);
    const colorsDomain = colorsRanges.map(d => d.range);
    const colors = colorsRanges.map(d => d.color);
    colorScale = threshold().domain(colorsDomain).range(colors);
  }

  return React__default.createElement(ChartPanel, props, React__default.createElement(GraphLayoutGraph, {
    ref: graphContainer
  }, React__default.createElement("svg", {
    onMouseLeave: hideTooltip,
    height: height,
    width: "100%",
    preserveAspectRatio: "xMidYMax meet",
    viewBox: `0,0,${width},${height}`
  }, React__default.createElement("g", {
    ref: graphSVG
  }, valueScale.ticks().map((tick, i) => React__default.createElement(HorizontalLine, {
    key: i,
    color: "#E4E4E4",
    y: valueScale(tick),
    width: width
  })), React__default.createElement(Bars$1, {
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    colorScale: colorScale,
    series: plottedSeries,
    center: valueScale(0)
  }), props.extraHorizontalLines && props.extraHorizontalLines.map((l, i) => {
    return React__default.createElement(HorizontalLine, {
      key: i,
      color: l.color,
      text: l.text,
      width: width,
      y: valueScale(l.value)
    });
  }))), React__default.createElement(ChartTooltip, tooltip)), React__default.createElement(HorizontalDateAxis, {
    timeScale: timeScale
  }), React__default.createElement(HorizontalHoursAndMinutesAxis, {
    timeScale: timeScale
  }), React__default.createElement(VerticalLeftValueAxis, {
    percentage: props.percentage,
    valueScale: valueScale,
    height: height
  }));
};

const RECT_WIDTH = 5;
const rect = ({
  x,
  y
}, yCenter = 0, barWidth) => {
  const isNegative = y > yCenter;
  const width = barWidth ? barWidth : RECT_WIDTH;

  if (!isNegative) {
    return `M ${x} ${yCenter} l ${width} 0 0 -${yCenter - y} m 0 0 l -${width} 0 l 0 ${yCenter - y}`;
  } else {
    return `M ${x} ${yCenter} l ${width} 0 0 ${-yCenter + y} m 0 0 l ${-width} 0 l 0 ${yCenter - y}`;
  }
};

const useMultiBarsSeries = (series, width, height, xAxisLabels, options = {
  isPercentage: false
}, padding = DEFAULT_PADDING) => {
  const allValues = series.flatMap(s => s.points).map(p => p.value);
  const maxValue = Math.max(...allValues);
  const maxLength = Math.max(...series.map(s => s.points ? s.points.length : 0));
  const seriesLength = series.length;
  const graphBottom = height - padding.bottom;
  const graphTop = padding.top;
  const {
    ticks
  } = useNicedTicks(maxValue);
  const MAX_BAR_GAP = 227;

  const xAxisScale = (index, seriesIndex, maxSeriesLength, seriesLength) => {
    let seriesValue = (width - 7) / (maxSeriesLength + (maxSeriesLength - 1));

    if (seriesValue > MAX_BAR_GAP) {
      seriesValue = MAX_BAR_GAP;
    }

    const pointValue = seriesValue / (seriesLength + (seriesLength - 1) * 0.5);
    return index * (seriesValue * 2) + seriesIndex * (pointValue * 1.5) + 7;
  };

  const labelScale = xAxisLabels.map((value, i) => ({
    label: value,
    pos: xAxisScale(i, 0, maxLength, seriesLength)
  }));
  const valueScale = linear().domain([0, maxValue]).interpolate(interpolateRoundToFixed(2)).range([graphBottom, maxValue > 0 ? graphTop : graphBottom]).nice();
  const plottedSeries = series.map((s, seriesIndex) => ({
    descriptor: s.key,
    points: s.points,
    plottedPoints: s.points.map((p, i) => ({
      x: xAxisScale(i, seriesIndex, maxLength, seriesLength),
      y: valueScale(p.value < 0.004 * maxValue && p.value != 0 ? 0.004 * maxValue : p.value),
      index: i,
      series: s
    })),
    key: s.key,
    color: s.color || 'black'
  }));
  return useMemo(() => {
    return {
      plottedSeries,
      valueScale,
      labelScale,
      ticks
    };
  }, [plottedSeries, valueScale, labelScale, ticks]);
};

const BarsMultiSeriesChart = props => {
  const currentLineRef = useRef(null);
  const extraHorizontalLines = props.extraHorizontalLines ? props.extraHorizontalLines : [];
  const graphContainer = useRef(null);
  const height = props.height ? props.height : VM_CHART_HEIGHT;
  const xAxisLabels = props.xAxisLabels ? props.xAxisLabels : [];
  const graphWidth = useResize(graphContainer) - DEFAULT_PADDING.left - DEFAULT_PADDING.right;
  let colorScale;
  const maxLength = Math.max(...props.matrix.map(s => s.points ? s.points.length : 0));
  const seriesLength = props.matrix.length;
  const MAX_BAR_WIDTH = 74;
  const getBarWidth = (graphWidth - 7) / (maxLength + (maxLength - 1)) / (seriesLength + (seriesLength - 1) * 0.5);
  const {
    plottedSeries,
    valueScale,
    labelScale,
    ticks
  } = useMultiBarsSeries(props.matrix, graphWidth, height, xAxisLabels);
  const svgWidth = graphWidth;
  const {
    showTooltip,
    hideTooltip,
    tooltip,
    setTooltip
  } = useTooltip(props.tooltipFn);

  const onMouseOverLine = (ev, line, index) => {
    if (props.lineTooltipfn) {
      ev.stopPropagation();

      if (!graphContainer.current) {
        return;
      }

      currentLineRef.current = index;
      const d = graphContainer.current.getBoundingClientRect();
      hideTooltip();
      setTooltip({
        x: ev.clientX,
        y: d.y + valueScale(line.value),
        message: props.lineTooltipfn(line),
        visible: true
      });
    }
  };

  return React__default.createElement(ChartPanel, props, React__default.createElement(VerticalLeftValueAxis, {
    valueScale: valueScale,
    height: height
  }), React__default.createElement(GraphLayoutGraph, {
    ref: graphContainer
  }, React__default.createElement("svg", {
    height: height,
    width: svgWidth,
    preserveAspectRatio: "xMinYMax slice",
    viewBox: `0 0 ${svgWidth} ${height}`
  }, ticks.map((tick, i) => React__default.createElement(HorizontalLine, {
    key: i,
    color: "#E4E4E4",
    y: valueScale(tick),
    width: svgWidth
  })), React__default.createElement(Bars$1, {
    onMouseMove: (p, ev) => showTooltip(p, ev),
    onMouseLeave: hideTooltip,
    colorScale: colorScale,
    series: plottedSeries,
    center: valueScale(0),
    barShap: rect,
    barWidth: getBarWidth <= MAX_BAR_WIDTH ? getBarWidth : MAX_BAR_WIDTH
  }), extraHorizontalLines.map((line, index) => {
    return React__default.createElement("g", {
      key: index
    }, React__default.createElement(HorizontalLine, {
      strokeWidth: 2,
      width: svgWidth,
      text: line.text,
      color: line.color,
      y: valueScale(line.value)
    }), React__default.createElement(HorizontalLine, {
      onMouseMove: ev => onMouseOverLine(ev, line, index),
      onMouseOut: () => {
        currentLineRef.current = null;
        hideTooltip();
      },
      strokeWidth: 10,
      width: svgWidth,
      text: line.text,
      color: "transparent",
      y: valueScale(line.value)
    }));
  })), React__default.createElement(HorizontalLabelAxis, {
    labelScale: labelScale,
    width: svgWidth
  }), React__default.createElement(ChartTooltip, _extends$3({
    fixed: true
  }, tooltip))));
};

const WorkloadLabel = newStyled.h4`
  color: #0076ce;
  text-align: center;
  width: 100%;
  font-size: 1.25rem;
  letter-spacing: 0.2px;
  font-weight: normal;
`;
const WorkloadBottomLabel = newStyled(WorkloadLabel)`
  margin-top: 0.125rem;
`;
const WorkloadCircle = newStyled.circle`
  opacity: 0.65;
  &:hover {
    opacity: 1;
  }
`;
const WorkloadAnnotationText = newStyled.div`
  grid-column: 5;
  -ms-grid-column: 5;
  grid-row: 2;
  -ms-grid-row: 2;
  color: #566072;
  letter-spacing: 0.32px;
  font-size: 1rem;
`;
const TitleMessage = newStyled.p`
  margin: 0 0 0 0.7rem;
  color: #566072;
  font-weight: 400;
  font-size: 0.9rem;
`;
const WorkloadConcentrationChart = props => {
  const graphContainer = useRef(null);
  const height = props.height ? props.height : 350;
  const width = useResize(graphContainer, props.width);
  const padding = DEFAULT_PADDING;
  const data = props.series.points.sort((a, b) => {
    return a.capacityInGb > b.capacityInGb ? -1 : a.capacityInGb < b.capacityInGb ? 1 : 0;
  });
  const [state, setState] = useState({
    zoomedScale: linear().domain([0, 100]).range([0, width])
  });
  const maxIops = useMemo(() => {
    const upperBounds = max$1(data, d => d.iopsPercentage);
    return upperBounds ? Math.ceil(upperBounds / 10) * 10 : 100;
  }, [data]);
  const yScale = linear().domain([0, maxIops]).range([height - padding.top, padding.bottom]);
  const colorScale = threshold().domain([0, 2, 10]).range(['#AAAAAA', '#009E3B', '#F2AF00', '#E22102']);
  const radiusExtent = extent(data, d => d.capacityInGb);
  const radiusScale = linear().domain(radiusExtent).range([10, 45]);

  const onZoom = (x1, x2) => {
    if (x1 >= 0 && x2 > 0 && width > 0) {
      const zoomScale = linear().domain([x1, x2]).range([0, width]);
      setState({
        zoomedScale: zoomScale
      });
    } else {
      const extent = [0, 100];
      const zoomScale = linear().domain([...extent]).range([0, width]);
      setState({
        zoomedScale: zoomScale
      });
    }
  };

  const {
    hideTooltip,
    showTooltip,
    tooltip
  } = useTooltip(props.tooltipFn);
  const plottedPoints = data.map((d, i) => {
    return {
      x: state.zoomedScale(d.rollingCapacityPercentage),
      y: yScale(d.iopsPercentage),
      index: i,
      series: props.series
    };
  });

  const showTooltipOnTopOfBubble = p => {
    const pointatTopOfCircle = _objectSpread2(_objectSpread2({}, p), {}, {
      y: p.y - radiusScale(p.series.points[p.index].capacityInGb)
    });

    return showTooltip(pointatTopOfCircle);
  };

  const yTicks = yScale.ticks();
  return React__default.createElement(GraphLayoutGrid, null, React__default.createElement(GraphLayoutGraph, {
    ref: graphContainer
  }, React__default.createElement("svg", {
    height: height,
    width: "100%",
    preserveAspectRatio: "xMidYMax meet",
    viewBox: `0,0,${width},${height}`
  }, React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "chart-clip-path"
  }, React__default.createElement("rect", {
    x: "0",
    y: yScale(yTicks[yTicks.length - 1]) - 0.5,
    width: width,
    height: yScale(yTicks[0]) - yScale(yTicks[yTicks.length - 1]) + 0.5
  }))), React__default.createElement("g", {
    clipPath: "url(#chart-clip-path)"
  }, yScale.ticks().map((tick, i) => React__default.createElement(HorizontalLine, {
    key: i,
    color: "#E4E4E4",
    y: yScale(tick),
    width: width
  })), state.zoomedScale.ticks().map((tick, i) => React__default.createElement(VerticalLine, {
    key: i,
    color: "#E4E4E4",
    x: state.zoomedScale(tick),
    height: height
  })), plottedPoints.map((p, i) => {
    return React__default.createElement(WorkloadCircle, {
      key: i,
      cx: p.x,
      cy: p.y,
      onMouseEnter: () => showTooltipOnTopOfBubble(p),
      onMouseLeave: () => hideTooltip(),
      r: radiusScale(p.series.points[p.index].capacityInGb),
      fill: colorScale(p.series.points[p.index].latency)
    });
  }), React__default.createElement(VerticalLine, {
    color: "#85be15",
    strokeWidth: "2px",
    x: state.zoomedScale(props.thresholdValue),
    height: height
  }))), React__default.createElement(ChartTooltip, tooltip)), props.annotationText && React__default.createElement(WorkloadAnnotationText, null, props.annotationText), React__default.createElement(GraphLayoutHeader, null, React__default.createElement(GraphLayoutHeaderText, null, props.title, " ", props.popoverText && React__default.createElement(ChartPopover, null, props.popoverText), props.titleMessage && React__default.createElement(TitleMessage, null, props.titleMessage)), props.legend && React__default.createElement(GraphLayoutHeaderLegend, null, props.legend)), React__default.createElement(GraphLayoutLeftLabel, null, React__default.createElement(GraphLayoutLeftLabelText, null, React__default.createElement(WorkloadLabel, null, "IOPS"))), React__default.createElement(GraphLayoutBottomLabel, null, React__default.createElement("svg", {
    preserveAspectRatio: "xMinYMin",
    width: "100%",
    viewBox: `0, 0, ${width}, 40`,
    height: 40
  }, React__default.createElement(ZoomPercentageBar, {
    width: width,
    height: 10,
    color: "#9AD3FD",
    x: 0,
    y: 10,
    onZoom: onZoom
  })), React__default.createElement("div", {
    style: {
      width: '100%'
    }
  }, React__default.createElement(WorkloadBottomLabel, null, "Capacity"))), React__default.createElement(VerticalLeftValueAxis, {
    color: "#809DC4",
    percentage: true,
    valueScale: yScale,
    height: height
  }), React__default.createElement(HorizontalPercentageAxis, {
    color: "#809DC4",
    scale: state.zoomedScale
  }));
};

const Title = newStyled.div`
  padding-top: 1.25rem;
  padding-bottom: 1rem;
  font-size: 1.25rem;
  color: #566072;
  text-align: center;
`;
const Content = newStyled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-bottom: 2rem;
  flex-wrap: wrap;
`;
const DonutWrapper = newStyled.div`
  flex: 3 0 128px;
  padding: 0.5rem;
`;
const LegendCircle = newStyled.div`
  height: 12px;
  width: 12px;
  background-color: ${p => p.color};
  border-color: ${p => p.color};
  border-width: 2px;
  border-style: solid;
  border-radius: 50px;
  display: inline-flex;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  justify-self: center;
  align-self: center;
`;
const LegendItem = newStyled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  max-width: 140px;
  margin-bottom: 0.25rem;
`;
const LegendWrapper = newStyled.div`
  padding-left: 0.5rem;
  padding-right: 1rem;
  flex: 1 1 140px;
`;
const DonutChartTile = ({
  title,
  data,
  percentage
}) => {
  return React__default.createElement(Fragment$1, null, React__default.createElement(Title, null, title), React__default.createElement(Content, null, React__default.createElement(LegendWrapper, null, data.map(d => {
    return React__default.createElement(LegendItem, {
      key: d.color
    }, React__default.createElement("div", null, React__default.createElement(LegendCircle, {
      color: d.color
    }), d.label), React__default.createElement("span", null, d.value, percentage && '%'));
  })), React__default.createElement(DonutWrapper, null, React__default.createElement(Donut, {
    data: data
  })), React__default.createElement(LegendWrapper, null)));
};

const transformSeriesToRects = (series, width) => {
  const widthScale = linear().range([0, width]);
  return series.map(s => {
    const sum = s.values.reduce((a, b) => a + b.value, 0);
    widthScale.domain([0, sum]);
    let rectEnd = 0;
    const rects = s.values.map(subRect => {
      const start = rectEnd;
      rectEnd += widthScale(subRect.value);
      const end = rectEnd;
      return _objectSpread2(_objectSpread2({}, subRect), {}, {
        start,
        end
      });
    });
    return {
      title: s.title,
      rects
    };
  });
};

const GaugeChartContainer = newStyled.div`
  display: flex;
`;
const GaugeChartGraphContainer = newStyled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const GaugeChartTitles = newStyled.div`
  display: flex;
  flex-direction: column;
  padding-right: 16px;
  align-items: flex-end;
  h5 {
    font-size: 14px;
    color: #566072;
    font-weight: normal;
    letter-spacing: 0.28px;
  }
`;
const GaugeChartText = newStyled.text`
  font-weight: 600;
  font-size: 13px;
`;
const GaugeChartNumbersText = newStyled(GaugeChartText)`
  text-anchor: middle;
  dominant-baseline: middle;
  fill: white;
  color: white;
`;
const GaugeChartPercentageAxisText = newStyled(GaugeChartText)`
  dominant-baseline: text-before-edge;
  fill: #566072;
  color: #566072;
`;
const xAxisMarkers = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
const formatter = format(',');
const HorizontalGaugeBarChart = props => {
  const graphContainer = useRef(null);
  const width = useResize(graphContainer, props.width);
  const rectSeries = useMemo(() => transformSeriesToRects(props.series, width), [props.series, width]);
  const height = 2 * GAUGE_CHART_VERTICAL_PADDING + rectSeries.length * (GAUGE_CHART_RECT_PADDING + GAUGE_CHART_RECT_HEIGHT) - GAUGE_CHART_RECT_PADDING;
  return React__default.createElement(GaugeChartContainer, null, React__default.createElement(GaugeChartTitles, null, rectSeries.map((s, idx) => {
    const isFirst = idx === 0;
    const isLast = idx === rectSeries.length - 1;
    return React__default.createElement("h5", {
      key: s.title,
      style: {
        height: GAUGE_CHART_RECT_HEIGHT,
        margin: 0,
        marginTop: isFirst ? GAUGE_CHART_VERTICAL_PADDING : 0,
        marginBottom: isLast ? GAUGE_CHART_VERTICAL_PADDING + GAUGE_CHART_RECT_HEIGHT : GAUGE_CHART_RECT_PADDING
      }
    }, s.title);
  })), React__default.createElement(GaugeChartGraphContainer, {
    ref: graphContainer
  }, React__default.createElement("svg", {
    height: height,
    width: "100%"
  }, React__default.createElement("g", null, xAxisMarkers.map((marker, idx) => {
    const isFirstOrLast = idx === 0 || idx === xAxisMarkers.length - 1;
    const xPosition = marker * width / 100;
    return React__default.createElement(VerticalLine, {
      key: marker,
      strokeWidth: isFirstOrLast ? '2px' : '1px',
      color: "#e4e4e4",
      height: height,
      x: xPosition
    });
  })), rectSeries.map((series, idx) => {
    const y = (GAUGE_CHART_RECT_PADDING + GAUGE_CHART_RECT_HEIGHT) * idx + GAUGE_CHART_VERTICAL_PADDING;
    return React__default.createElement("g", {
      key: series.title
    }, series.rects.map(r => {
      return React__default.createElement("g", {
        key: r.key
      }, React__default.createElement("rect", {
        y: y,
        x: r.start,
        width: r.end - r.start,
        fill: r.color,
        height: "25px"
      }), React__default.createElement(GaugeChartNumbersText, {
        y: y + 13,
        x: (r.start + r.end) / 2
      }, formatter(r.value)));
    }));
  })), React__default.createElement("svg", {
    height: 20,
    width: "100%"
  }, React__default.createElement("g", null, xAxisMarkers.filter(marker => marker % 20 === 0).map((marker, idx, arr) => {
    const isFirst = idx === 0;
    const isLast = idx === arr.length - 1;
    const textAnchor = isFirst ? 'start' : isLast ? 'end' : 'middle';
    return React__default.createElement(GaugeChartPercentageAxisText, {
      key: marker,
      textAnchor: textAnchor,
      y: 1,
      x: marker * width / 100
    }, marker, "%");
  })), "GaugeChartPercentageAxisTexta")));
};

const xAxisScale = index => BAR_GAP$1 * index + DEFAULT_PADDING.left;

function transformData(matrix) {
  const groupedBars = [];
  let largestGroupSize = 1;
  const groupsCount = matrix.length;
  let maxCalculated = 0;
  let minCalculated = 0;
  let maxLengthInLastGroup = 2;

  for (let groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
    const group = matrix[groupIndex];
    const seriesCount = group.length;
    let maxLengthInGroup = 0;

    for (let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex++) {
      const series = group[seriesIndex];
      const pointsCount = series.points.length;
      maxLengthInGroup = pointsCount > maxLengthInGroup ? pointsCount : maxLengthInGroup;

      for (let pointIndex = 0; pointIndex < pointsCount; pointIndex++) {
        const point = series.points[pointIndex];
        const plottedPoint = {
          index: pointIndex,
          x: xAxisScale(pointIndex + maxLengthInLastGroup),
          series: series
        };
        let group = groupedBars[maxLengthInLastGroup + pointIndex];

        if (group) {
          group.push(plottedPoint);
        } else {
          groupedBars[maxLengthInLastGroup + pointIndex] = [plottedPoint];
          group = groupedBars[maxLengthInLastGroup + pointIndex];
        }

        largestGroupSize = group && group.length > largestGroupSize ? group.length : largestGroupSize;
        maxCalculated = maxCalculated < point.value ? point.value : maxCalculated;
        minCalculated = minCalculated > point.value ? point.value : minCalculated;
      }
    }

    maxLengthInLastGroup += maxLengthInGroup;
  }

  return {
    largestGroupSize,
    groupedBars,
    minCalculated,
    maxCalculated
  };
}

const useOverlappedBars = (matrix, height, yMax, yMin) => {
  const {
    maxCalculated,
    minCalculated,
    groupedBars,
    largestGroupSize
  } = useMemo(() => transformData(matrix), [matrix]);
  const max = yMax ? yMax : maxCalculated;
  const min = yMin ? yMin : minCalculated;
  const {
    ticks,
    nicedMin,
    nicedMax
  } = useNicedTicks(max, min);
  const valueScale = useMemo(() => {
    const graphBottom = height - DEFAULT_PADDING.top;
    const graphTop = DEFAULT_PADDING.bottom;
    const graphCenter = (graphBottom - graphTop) / 2;

    if (nicedMin === 0) {
      const valueScale = linear().domain([0, nicedMax]).range([graphBottom, graphTop]);
      return valueScale;
    } else {
      const valueScale = linear().domain([nicedMin, 0, nicedMax]).range([graphBottom, graphCenter, graphTop]).interpolate(interpolateRoundToFixed(2));
      return valueScale;
    }
  }, [height, nicedMin, nicedMax]);
  return useMemo(() => {
    const plottedPoints = groupedBars.map(group => group.map(point => {
      point.y = valueScale(point.series.points[point.index].value);
      return point;
    }));
    return {
      plottedPoints,
      valueScale,
      largestGroupSize,
      ticks
    };
  }, [groupedBars, valueScale, largestGroupSize, ticks]);
};

const OverflowArea = newStyled.div`
  overflow-x: auto;
  position: relative;
  flex: 1 1 auto;
`;
const OverlappedBarsGraphContainer = newStyled.div`
  display: flex;
  justify-content: flex-start;
`;
const Bars = newStyled.g`
  ${p => p.dimmable ? `&:hover path {
    fill-opacity: 0.50;
  }` : ''}
`;
const BarGroup = newStyled.g`
  &:hover > path {
    fill-opacity: 1 !important;
  }
`;
const BAR_GAP = 9;
const OverlappedBarsChart = props => {
  const currentLineRef = useRef(null);
  const axisFormatter = props.axisFormatter ? props.axisFormatter : format(',');
  const extraHorizontalLines = props.extraHorizontalLines ? props.extraHorizontalLines : [];
  const graphContainer = useRef(null);
  const height = props.height ? props.height : VM_CHART_HEIGHT;
  const graphWidth = useResize(graphContainer) - DEFAULT_PADDING.left - DEFAULT_PADDING.right;
  const {
    plottedPoints,
    largestGroupSize,
    valueScale,
    ticks
  } = useOverlappedBars(props.matrix, height, props.yMax, props.yMin);
  const width = (plottedPoints.length + 1) * BAR_GAP + DEFAULT_PADDING.left;
  const svgWidth = width < graphWidth ? graphWidth : width;
  const {
    showTooltip,
    hideTooltip,
    tooltip,
    setTooltip
  } = useTooltip(props.tooltipFn);

  const onMouseMove = ev => {
    if (graphContainer.current && props.tooltipFn && currentLineRef.current === null) {
      const [x, y] = pointer(ev, graphContainer.current);
      const d = graphContainer.current.getBoundingClientRect();
      const xScroll = graphContainer.current.scrollLeft;
      const nearestPlottedPoint = plottedPoints.flat().sort((a, b) => Math.abs(x + xScroll - a.x) - Math.abs(x + xScroll - b.x)).filter((_, idx) => idx < largestGroupSize).sort((a, b) => Math.abs(y - a.y) - Math.abs(y - b.y))[0];
      showTooltip(_objectSpread2(_objectSpread2({}, nearestPlottedPoint), {}, {
        y: d.y + nearestPlottedPoint.y,
        x: nearestPlottedPoint.x + d.x - xScroll
      }));
    }
  };

  const onMouseOverLine = (ev, line, index) => {
    if (props.lineTooltipfn) {
      ev.stopPropagation();

      if (!graphContainer.current) {
        return;
      }

      currentLineRef.current = index;
      const d = graphContainer.current.getBoundingClientRect();
      hideTooltip();
      setTooltip({
        x: ev.clientX,
        y: d.y + valueScale(line.value),
        message: props.lineTooltipfn(line),
        visible: true
      });
    }
  };

  const barsZero = valueScale(0);
  return React__default.createElement(OverlappedBarsGraphContainer, null, React__default.createElement("div", null, React__default.createElement(VerticalLeftValueAxis, {
    percentage: false,
    height: height,
    formatter: axisFormatter,
    valueScale: valueScale,
    ticks: ticks
  })), React__default.createElement(OverflowArea, {
    ref: graphContainer
  }, React__default.createElement("svg", {
    height: height,
    width: svgWidth,
    preserveAspectRatio: "xMinYMax slice",
    viewBox: `0 0 ${svgWidth} ${height}`
  }, ticks.map((tick, i) => React__default.createElement(HorizontalLine, {
    key: i,
    color: "#E4E4E4",
    y: valueScale(tick),
    width: svgWidth
  })), React__default.createElement(Bars, {
    dimmable: true,
    onMouseMove: ev => onMouseMove(ev),
    onMouseLeave: hideTooltip
  }, plottedPoints.map(group => React__default.createElement(BarGroup, null, group.filter(p => p.y !== barsZero).map(p => React__default.createElement("path", {
    key: p.series.key + p.index,
    fill: p.series.color,
    d: roundedRect(p, barsZero)
  }))))), extraHorizontalLines.map((line, index) => {
    return React__default.createElement("g", {
      key: index
    }, React__default.createElement(HorizontalLine, {
      strokeWidth: 2,
      width: svgWidth,
      text: line.text,
      color: line.color,
      y: valueScale(line.value)
    }), React__default.createElement(HorizontalLine, {
      onMouseMove: ev => onMouseOverLine(ev, line, index),
      onMouseOut: () => {
        currentLineRef.current = null;
        hideTooltip();
      },
      strokeWidth: 10,
      width: svgWidth,
      text: line.text,
      color: "transparent",
      y: valueScale(line.value)
    }));
  })), React__default.createElement(ChartTooltip, _extends$3({
    fixed: true
  }, tooltip))));
};

const CheckboxWrapper = newStyled.div`
  display: flex;
  position: relative;
  padding-left: 24px;
  user-select: none;
  align-items: center;
  padding-right: 8px;
  width: calc(100% - 32px);
  & label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const CheckMark = newStyled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  border: 2px solid #bdcad2;
  border-radius: 3px;
  &:after {
    left: 5px;
    top: 3px;
    border: solid #7ab800;
    border-width: 0 2px 2px 0;
    width: 4px;
    height: 8px;
    transform: rotate(45deg);
    content: '';
    position: absolute;
    display: none;
  }
`;
const IndeteminateMark = newStyled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  border: 2px solid #bdcad2;
  border-radius: 3px;
  &:after {
    left: 2px;
    top: 6px;
    background-color: #7ab800;
    width: 10px;
    height: 2px;
    content: '';
    position: absolute;
    display: none;
  }
`;
const CheckboxInput = newStyled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  z-index: 10;
  &:checked ~ span:after {
    display: block;
  }
  &:checked ~ span {
    background-color: #ffffff;
  }
`;

const Checkbox = props => {
  const {
    indeterminate,
    checked
  } = props;

  const preventDefault = ev => ev.preventDefault();

  const handleCheckboxOnChange = ev => {
    if (props.onChange) {
      ev.stopPropagation();
      return props.onChange(ev);
    }
  };

  return React__default.createElement(CheckboxWrapper, null, React__default.createElement(CheckboxInput, {
    checked: checked || indeterminate,
    onChange: handleCheckboxOnChange,
    type: "checkbox"
  }), React__default.createElement("label", {
    onClick: preventDefault
  }, props.children), indeterminate ? React__default.createElement(IndeteminateMark, null) : React__default.createElement(CheckMark, null));
};

const MemoizedCheckbox = React__default.memo(Checkbox);

const FormLabel = newStyled.label`
  color: #566072;
  font-size: 14px;
  display: inline-block;
  margin-bottom: 10px;
`;

function getBgColorFromStatus(status, focus = false, hover = false) {
  switch (status) {
    case 'active':
      if (focus) return Color$1.blue50;else if (hover) return Color$1.blue50;
      return Color$1.white;

    case 'readonly':
      return Color$1.lameGrey200;

    case 'valid':
      return Color$1.white;

    case 'invalid':
      return Color$1.red100;

    default:
      return Color$1.white;
  }
}

function getBorderColorFromStatus(status, focus = false) {
  switch (status) {
    case 'active':
      return focus ? Color$1.blue500 : Color$1.coolGray300;

    case 'readonly':
      return Color$1.lameGrey400;

    case 'valid':
      return Color$1.green500;

    case 'invalid':
      return Color$1.red500;

    default:
      return Color$1.coolGray300;
  }
}

function getFocusShadow(status) {
  switch (status) {
    case 'active':
      return '0px 5px 8px #4694CE40';

    case 'valid':
      return '0px 5px 8px #7AB80059';

    case 'invalid':
      return '0px 5px 8px #CE112659';

    default:
      return 'none';
  }
}

function getFontSizeFromSizing(sizing) {
  switch (sizing) {
    case 'large':
      return '18px';

    case 'small':
      return '14px';

    case 'normal':
    default:
      return '16px';
  }
}

function getPaddingFromSizing(sizing) {
  switch (sizing) {
    case 'large':
      return '16px 40px 16px 12px';

    case 'small':
      return '8px 36px 8px 10px';

    case 'normal':
    default:
      return '12px 36px 12px 10px';
  }
}

const InputStyle = newStyled.input`
  position: relative;
  box-sizing: border-box;
  border-color: ${p => getBorderColorFromStatus(p.status)};
  background-color: ${p => getBgColorFromStatus(p.status)};
  border-width: 2px;
  border-style: solid;
  display: flex;
  align-items: center;
  font-size: ${p => getFontSizeFromSizing(p.sizing)};
  color: ${Color$1.coolGray700};
  padding: ${p => getPaddingFromSizing(p.sizing)};
  min-width: 280px;
  cursor: pointer;
  width: 100%;
  outline: none;
  &::placeholder {
    font-style: italic;
    color: ${Color$1.lameGrey700};
  }
  &:disabled {
    cursor: not-allowed;
    color: ${Color$1.lameGrey700};
    border-color: ${Color$1.lameGrey400};
    background-color: ${Color$1.lameGrey200};
  }
  &:hover {
    background-color: ${p => getBgColorFromStatus(p.status, true, true)};
  }
  &:focus {
    border-width: 2px;
    background-color: ${p => getBgColorFromStatus(p.status, true)};
    border-color: ${p => getBorderColorFromStatus(p.status, true)};
    box-shadow: ${p => getFocusShadow(p.status)};
  }
`;
const InputHintStyle = newStyled.span`
  display: block;
  color: #566072;
  font-size: 12px;
  margin-bottom: 10px;
`;
const RequiredStyle = newStyled.span`
  color: #ff0000;
  padding: 2px;
`;

const ErrorInputIcon = props => {
  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props, {
    fill: "none"
  }), React__default.createElement("path", {
    d: "M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm3.8 16L10 12.2 6.3 16l-2-2L8 10.1 4.3 6.5l2-2L10 8.1l3.8-3.8 2 2-3.7 3.8 3.7 3.7-2 2z",
    fill: props.fill || '#CE1126'
  }));
};

const ValidInputIcon = props => {
  return React__default.createElement("svg", _extends$3({
    fill: "#7ab800",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.99 16.99"
  }, props), React__default.createElement("path", {
    d: "M8.5 0A8.5 8.5 0 1 0 17 8.5 8.5 8.5 0 0 0 8.5 0zM7.05 13.07L3.04 9.06l1.7-1.71 2.3 2.3 5.33-5.32 1.7 1.71z"
  }));
};

const ValidationMessageStyle = newStyled.p`
  color: #ce1126;
  font-weight: 600;
  font-size: 12px;
  margin: 0;
  margin-top: 8px;
  display: flex;
  align-items: center;
`;
const FieldValidationMessage = ({
  message
}) => {
  return React__default.createElement(ValidationMessageStyle, null, message);
};

const TextInput = InputStyle;
const TextInputWrapper = newStyled.div`
  position: relative;
  line-height: 1;
  & > svg {
    position: absolute;
    width: 18px;
    right: 10px;
    top: 16px;
  }
`;
const TextInputField = props => {
  const disabled = props.status === 'readonly' || props.disabled;

  const isValidationMessageVisible = str => str !== undefined && props.status === 'invalid';

  return React__default.createElement(TextInputWrapper, null, React__default.createElement(FormLabel, {
    id: props.label.split(' ').join(''),
    htmlFor: props.id
  }, props.label, props.showRequired && React__default.createElement(RequiredStyle, null, "*")), props.hint && React__default.createElement(InputHintStyle, null, props.hint), React__default.createElement(TextInputWrapper, null, React__default.createElement(TextInput, _extends$3({}, props, {
    disabled: disabled
  })), props.status === 'invalid' && React__default.createElement(ErrorInputIcon, null), props.status === 'valid' && React__default.createElement(ValidInputIcon, null), isValidationMessageVisible(props.validationMessage) && React__default.createElement(FieldValidationMessage, {
    message: props.validationMessage
  })));
};

const TextArea = newStyled(InputStyle)`
  line-height: 1.25;
`.withComponent('textarea');
const TextAreaWrapper = newStyled.div`
  position: relative;
  line-height: 1;
  & > svg {
    position: absolute;
    width: 18px;
    right: 10px;
    top: 16px;
  }
`;
const TextAreaField = props => {
  const disabled = props.status === 'readonly' || props.disabled;

  const isValidationMessageVisible = str => str !== undefined && props.status === 'invalid';

  return React__default.createElement(TextAreaWrapper, null, React__default.createElement(FormLabel, {
    id: props.label.split(' ').join(''),
    htmlFor: props.id
  }, props.label), props.hint && React__default.createElement(InputHintStyle, null, props.hint), React__default.createElement(TextAreaWrapper, null, React__default.createElement(TextArea, _extends$3({}, props, {
    disabled: disabled
  })), props.status === 'invalid' && React__default.createElement(ErrorInputIcon, null), props.status === 'valid' && React__default.createElement(ValidInputIcon, null), isValidationMessageVisible(props.validationMessage) && React__default.createElement(FieldValidationMessage, {
    message: props.validationMessage
  })));
};

const Wrapper$1 = newStyled.div`
    position: relative;
    user-select: none;
`;
const Input = newStyled.input`
    padding-left: 7px;
    width: 100%;
    border: 2px solid #BDCAD2;
    color: ${props => props.color};
    font-style: ${props => props.value === 0 ? 'italic' : 'normal'};
`;
const ArrowWrapper = newStyled.div`
    position: absolute;
    right: 0;
    top: 0;
    border-left: 2px solid #BDCAD2;
    min-width: 2rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
`;
const Arrow = newStyled.div`
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
`;
const ArrowPartition = newStyled.div`
    border-top: 2px solid #BDCAD2;
`;
const Counter = React__default.forwardRef((props, ref) => {
  const {
    value,
    minVal = 0,
    maxVal = 999999,
    step = 1,
    minValueColor = '#AAAAAA',
    maxValueColor = '#444444',
    rangeColor = '#444444',
    onCountChange
  } = props;
  const countRef = useRef();

  const getCountValue = () => {
    if (countRef.current !== value) {
      return value;
    }

    if (value <= minVal) {
      return minVal;
    }

    if (value > maxVal) {
      return maxVal;
    }

    return value;
  };

  const [count, setCount] = useState(getCountValue());

  const isInvalidValue = val => {
    if (!val.match(/^-?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/g)) {
      return true;
    }

    if (Number(val) < minVal) {
      return true;
    }

    if (Number(val) > maxVal) {
      return true;
    }

    return false;
  };

  const onChange = val => {
    if (val && isInvalidValue(val)) {
      return false;
    }

    if (onCountChange) {
      onCountChange(Number(val));
    }

    setCount(Number(val));
  };

  const operation = op => {
    if (op) {
      if (op === 'INCREMENT') {
        if (count === maxVal) return false;
        setCount(count + step);

        if (onCountChange) {
          onCountChange(Number(count + step));
        }
      } else if (op === 'DECREMENT') {
        if (count === minVal) return false;
        setCount(count - step);

        if (onCountChange) {
          onCountChange(Number(count - step));
        }
      }
    }

    return false;
  };

  const getInputColor = () => {
    if (value === minVal) {
      return minValueColor;
    } else if (value === maxVal) {
      return maxValueColor;
    }

    return rangeColor;
  };

  useEffect(() => {
    countRef.current = value;
    setCount(value);
  }, [value]);
  return React__default.createElement(Wrapper$1, null, React__default.createElement(Input, {
    ref: ref,
    color: getInputColor(),
    type: "text",
    value: count,
    onChange: e => {
      onChange(e.target.value);
    }
  }), React__default.createElement(ArrowWrapper, null, React__default.createElement(Arrow, {
    onClick: () => {
      operation('INCREMENT');
    }
  }, React__default.createElement(CounterIncrementIcon, null)), React__default.createElement(ArrowPartition, null), React__default.createElement(Arrow, {
    onClick: () => {
      operation('DECREMENT');
    }
  }, React__default.createElement(CounterDecrementIcon, null))));
});

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value.dataTransfer);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (dt === null) {
                        return [2 /*return*/, []];
                    }
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var es = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};
});

var accepts = unwrapExports(es);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files';
var ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE,
  FileTooSmall: FILE_TOO_SMALL,
  TooManyFiles: TOO_MANY_FILES
}; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? 'byte' : 'bytes')
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? 'byte' : 'bytes')
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || accepts(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return 'showOpenFilePicker' in window;
}
/**
 * filePickerOptionsTypes returns the {types} option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 * based on the accept attr (see https://github.com/react-dropzone/attr-accept)
 * E.g: converts ['image/*', 'text/*'] to {'image/*': [], 'text/*': []}
 * @param {string|string[]} accept
 */

function filePickerOptionsTypes(accept) {
  accept = typeof accept === 'string' ? accept.split(',') : accept;
  return [{
    description: 'everything',
    // TODO: Need to handle filtering more elegantly than this!
    accept: Array.isArray(accept) // Accept just MIME types as per spec
    // NOTE: accept can be https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
    ? accept.filter(function (item) {
      return item === 'audio/*' || item === 'video/*' || item === 'image/*' || item === 'text/*' || /\w+\/[-+.\w]+/g.test(item);
    }).reduce(function (a, b) {
      return _objectSpread$1(_objectSpread$1({}, a), {}, _defineProperty$1({}, b, []));
    }, {}) : {}
  }];
}

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone$1 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React__default.createElement(Fragment$1, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone$1.displayName = 'Dropzone'; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false
};
Dropzone$1.defaultProps = defaultProps;
Dropzone$1.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: propTypes.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: propTypes.oneOfType([propTypes.string, propTypes.arrayOf(propTypes.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: propTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: propTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: propTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: propTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: propTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: propTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: propTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: propTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: propTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: propTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: propTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: propTypes.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: propTypes.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: propTypes.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: propTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: propTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: propTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: propTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: propTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: propTypes.func,

  /**
   * Custom validation function
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: propTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$options = _objectSpread(_objectSpread({}, defaultProps), options),
      accept = _defaultProps$options.accept,
      disabled = _defaultProps$options.disabled,
      getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
      maxSize = _defaultProps$options.maxSize,
      minSize = _defaultProps$options.minSize,
      multiple = _defaultProps$options.multiple,
      maxFiles = _defaultProps$options.maxFiles,
      onDragEnter = _defaultProps$options.onDragEnter,
      onDragLeave = _defaultProps$options.onDragLeave,
      onDragOver = _defaultProps$options.onDragOver,
      onDrop = _defaultProps$options.onDrop,
      onDropAccepted = _defaultProps$options.onDropAccepted,
      onDropRejected = _defaultProps$options.onDropRejected,
      onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$options.onFileDialogOpen,
      useFsAccessApi = _defaultProps$options.useFsAccessApi,
      preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
      noClick = _defaultProps$options.noClick,
      noKeyboard = _defaultProps$options.noKeyboard,
      noDrag = _defaultProps$options.noDrag,
      noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
      validator = _defaultProps$options.validator;

  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === 'function' ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === 'function' ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    if (useFsAccessApi && canUseFileSystemAccessAPI()) {
      return function () {};
    }

    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, useFsAccessApi]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, accept),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: 'setFiles'
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, accept, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [getFilesFromEvent, setFiles, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    if (useFsAccessApi && canUseFileSystemAccessAPI()) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: filePickerOptionsTypes(accept)
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        return setFiles(files, null);
      }).catch(function (e) {
        return onFileDialogCancelCb(e);
      }).finally(function () {
        return dispatch({
          type: 'closeDialog'
        });
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, accept, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === 'string' && role !== '' ? role : 'button'
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread(_objectSpread({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread(_objectSpread({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}

const DropzoneWrapper$1 = newStyled.div`
  border: 4px dashed #dddddd;
  background-color: #f5f6fb;
  padding: 0.5rem;
  text-align: center;
  min-height: 2rem;
`;
const Dropzone = ({
  onDropSuccess,
  onDropError,
  onDrop,
  allowedFileExtensions,
  maxFileSizeInBytes,
  maxFiles,
  children
}) => {
  const onDropAccepted = useCallback(acceptedFiles => {
    if (acceptedFiles.length > 0 && onDropSuccess) {
      onDropSuccess(acceptedFiles);
    }
  }, [onDropSuccess]);
  const onDropRejected = useCallback(rejectedFiles => {
    if (rejectedFiles.length > 0 && onDropError) {
      onDropError(rejectedFiles);
    }
  }, [onDropError]);
  const onDropCallback = useCallback((acceptedFiles, rejectedFiles) => {
    if (onDrop) {
      onDrop(acceptedFiles, rejectedFiles);
    }
  }, [onDrop]);
  const {
    acceptedFiles,
    open,
    getRootProps,
    getInputProps
  } = useDropzone({
    onDrop: onDropCallback,
    onDropAccepted,
    onDropRejected,
    accept: allowedFileExtensions,
    multiple: true,
    maxFiles,
    maxSize: maxFileSizeInBytes,
    noClick: true,
    noKeyboard: true
  });
  const rootProps = getRootProps({
    'data-testid': 'dropzone-root'
  });
  const inputProps = getInputProps();
  return React__default.createElement(DropzoneWrapper$1, null, React__default.createElement("div", rootProps, React__default.createElement("input", inputProps), children({
    acceptedFiles,
    open
  })));
};

let UploadOperationResult;

(function (UploadOperationResult) {
  UploadOperationResult[UploadOperationResult["UploadError"] = 0] = "UploadError";
  UploadOperationResult[UploadOperationResult["OperationalError"] = 1] = "OperationalError";
  UploadOperationResult[UploadOperationResult["Ok"] = 2] = "Ok";
})(UploadOperationResult || (UploadOperationResult = {}));

let ProgressBarStatus;

(function (ProgressBarStatus) {
  ProgressBarStatus[ProgressBarStatus["Active"] = 0] = "Active";
  ProgressBarStatus[ProgressBarStatus["Inactive"] = 1] = "Inactive";
  ProgressBarStatus[ProgressBarStatus["Error"] = 2] = "Error";
  ProgressBarStatus[ProgressBarStatus["Success"] = 3] = "Success";
})(ProgressBarStatus || (ProgressBarStatus = {}));

const BarWrap = newStyled.div`
  width: 100%;
  background-color: ${Color$1.grey400};
  height: 1.25rem;
  border-radius: 10px;
  margin: 0.375rem 0;
`;
const Bar = newStyled.div`
  width: ${p => p.widthPercent}%;
  position: relative;
  background-color: ${p => p.backGroundColor};
  color: ${p => p.fontColor};
  height: 1.25rem;
  border-radius: 10px;
  min-width: 6%;
  max-width: 100%;
  font-family: 'open sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-display: swap;
`;
const Icon = newStyled.span`
  background: none;
  margin-right: 0.5rem;
`;
const GreenBadge = newStyled(Icon)`
  color: ${Color$1.green500};
  margin-right: 0.625rem;
`;
const RedBadge = newStyled(Icon)`
  color: ${Color$1.red500};
  margin-right: 0.625rem;
`;
const ProgressPercent = newStyled.span`
  position: absolute;
  left: 50%;
  font-size: 0.85rem;
`;
const ProgressBarWrap = newStyled.div`
  position: relative;
  margin-bottom: 0.5rem;
`;
const ErrorMessage = newStyled.div`
  color: ${Color$1.red500};
  font-family: 'open sans', sans-serif;
  font-weight: 600;
  font-display: swap;
  font-size: 0.75rem;
`;
const SuccessMessage = newStyled.div`
  color: ${Color$1.green500};
  font-family: 'open sans', sans-serif;
  font-weight: 600;
  font-display: swap;
  font-size: 0.75rem;
`;
const BarMessage = newStyled.span`
  color: ${Color$1.grey700};
  font-family: 'open sans', sans-serif;
  font-display: swap;
  font-size: 0.825rem;
`;
const ProgressBar = props => {
  const {
    progressPercent,
    showProgressPercent,
    status,
    showErrorIcon,
    showSuccessIcon,
    barMessage,
    errorMessage,
    destroyProgressBar,
    successMessage
  } = props;
  if (destroyProgressBar) return null;

  function getBackgroundColor(status) {
    const defaultColor = Color$1.green500;
    const inactiveColor = Color$1.grey400;
    const errorColor = Color$1.red100;

    switch (status) {
      case ProgressBarStatus.Inactive:
        return inactiveColor;

      case ProgressBarStatus.Error:
        return errorColor;

      default:
        return defaultColor;
    }
  }

  function getFontColor(status) {
    switch (status) {
      case ProgressBarStatus.Error:
        return Color$1.red500;

      default:
        return Color$1.white;
    }
  }

  const progressPercentToShow = progressPercent > 100 ? 100 : progressPercent < 0 ? 0 : progressPercent;
  return React__default.createElement(ProgressBarWrap, {
    "data-testid": 'progress-bar-wrap'
  }, React__default.createElement("div", null, showErrorIcon && React__default.createElement(RedBadge, {
    "data-testid": 'error-icon'
  }, React__default.createElement(ErrorIcon, {
    width: 17,
    height: 17
  })), showSuccessIcon && React__default.createElement(GreenBadge, {
    "data-testid": 'success-icon'
  }, React__default.createElement(CheckIcon, {
    width: 17,
    height: 17
  })), barMessage && React__default.createElement(BarMessage, {
    "data-testid": 'bar-message'
  }, barMessage)), React__default.createElement(BarWrap, null, React__default.createElement(Bar, {
    "data-testid": props.testId,
    widthPercent: progressPercentToShow,
    backGroundColor: getBackgroundColor(status),
    fontColor: getFontColor(status)
  }, showProgressPercent && React__default.createElement(ProgressPercent, null, progressPercentToShow, "%"))), errorMessage && React__default.createElement(ErrorMessage, null, errorMessage), successMessage && React__default.createElement(SuccessMessage, null, successMessage));
};

const BinIconInactive = props => {
  return React__default.createElement("svg", _extends$3({
    "data-testid": "bin-Icon-Inactive",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.634",
    height: "17.867",
    viewBox: "0 0 15.634 17.867"
  }, props), React__default.createElement("path", {
    id: "trash",
    d: "M15.075,1.117H10.888L10.56.464A.838.838,0,0,0,9.81,0H5.821a.828.828,0,0,0-.747.464l-.328.653H.558A.558.558,0,0,0,0,1.675V2.792a.558.558,0,0,0,.558.558H15.075a.558.558,0,0,0,.558-.558V1.675A.558.558,0,0,0,15.075,1.117ZM1.857,16.3a1.675,1.675,0,0,0,1.672,1.57h8.578a1.675,1.675,0,0,0,1.672-1.57l.74-11.83H1.117Z",
    transform: "translate(0 0)",
    fill: "#e4e4e4"
  }));
};

const BinIconActive = props => {
  return React__default.createElement("svg", _extends$3({
    "data-testid": "bin-Icon-Active",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.634",
    height: "17.867",
    viewBox: "0 0 15.634 17.867"
  }, props), React__default.createElement("path", {
    id: "trash",
    d: "M15.075,1.117H10.888L10.56.464A.838.838,0,0,0,9.81,0H5.821a.828.828,0,0,0-.747.464l-.328.653H.558A.558.558,0,0,0,0,1.675V2.792a.558.558,0,0,0,.558.558H15.075a.558.558,0,0,0,.558-.558V1.675A.558.558,0,0,0,15.075,1.117ZM1.857,16.3a1.675,1.675,0,0,0,1.672,1.57h8.578a1.675,1.675,0,0,0,1.672-1.57l.74-11.83H1.117Z",
    transform: "translate(0 0)",
    fill: "#0076ce"
  }));
};

const ContentWrapper = newStyled.div(props => ({
  display: props.hidden ? 'none' : 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: '0.625rem'
}));
const ProgressBarsWrapper = newStyled.div`
  vertical-align: middle;
  order: 1;
  flex-grow: 2;
  min-height: 5.3125rem;
`;
const ActiveBin = newStyled.div(props => ({
  hidden: props.hidden
}));
const InActiveBin = newStyled.div(props => ({
  hidden: props.hidden
}));
const BinWrapper = newStyled.span`
  order: 3;
  vertical-align: middle;
  margin: 0rem 1.25rem 2.188rem 0rem;
`;
const Line = newStyled.div`
  order: 2;
  height: 2.813rem;
  width: 0.063rem;
  background-color: #e4e4e4;
  margin: 0rem 1.25rem 2.188rem 0.65rem;
`;
const FileUploadDropzoneProgressBar = prop => {
  const [deleteStatus, setDeleteStatus] = useState(false);

  function getFileSizeMessage(size) {
    let sizeUnit = size;
    if (sizeUnit < 999) return sizeUnit + 'B';
    sizeUnit = sizeUnit / 1024;
    if (sizeUnit < 999) return sizeUnit.toFixed(2) + 'KB';
    sizeUnit = sizeUnit / 1024;
    if (sizeUnit < 999) return sizeUnit.toFixed(2) + 'MB';
    sizeUnit = sizeUnit / 1024;
    if (sizeUnit < 999) return sizeUnit.toFixed(2) + 'GB';
    sizeUnit = sizeUnit / 1024;
    return sizeUnit.toFixed(2) + 'TB';
  }

  function getBarMessage(file) {
    return file.name + ' (' + getFileSizeMessage(file.size) + ')';
  }

  function getProgressBarStatus(prop) {
    if (prop === undefined || prop.status.operationResult === UploadOperationResult.Ok) {
      return ProgressBarStatus.Active;
    }

    if (prop.status.operationResult === UploadOperationResult.UploadError) {
      return ProgressBarStatus.Error;
    } else {
      return ProgressBarStatus.Inactive;
    }
  }

  function executeDelete() {
    setDeleteStatus(true);
  }

  useEffect(() => {
    if (deleteStatus === true) {
      prop.removeFunc();
      setDeleteStatus(false);
    }
  }, [deleteStatus]);
  return prop.status ? React__default.createElement(ContentWrapper, {
    hidden: deleteStatus
  }, React__default.createElement(ProgressBarsWrapper, {
    id: String(prop.status.id)
  }, React__default.createElement(ProgressBar, {
    barMessage: getBarMessage(prop.status.file),
    showProgressPercent: prop.status.operationResult !== UploadOperationResult.OperationalError,
    progressPercent: prop.status.progress,
    status: getProgressBarStatus(prop),
    showErrorIcon: prop.status.operationResult !== UploadOperationResult.Ok,
    showSuccessIcon: prop.status.operationResult === UploadOperationResult.Ok && prop.status.finishedUpload ? true : false,
    errorMessage: prop.status.error,
    successMessage: prop.status.operationResult === UploadOperationResult.Ok ? '' : undefined,
    testId: "progress-bar"
  })), React__default.createElement(Line, null), React__default.createElement(BinWrapper, null, React__default.createElement(ActiveBin, {
    hidden: prop.status.finishedUpload
  }, React__default.createElement(BinIconInactive, null)), React__default.createElement(InActiveBin, {
    "data-testid": "inActiveBin",
    hidden: !prop.status.finishedUpload,
    onClick: executeDelete
  }, React__default.createElement(BinIconActive, null)))) : React__default.createElement("div", null);
};

const DropzoneWrapper = newStyled.div`
  color: #bdcad2;
  font: normal normal normal 16px/22px 'open sans', sans-serif;
`;
const DropzoneLine1 = newStyled.div`
  margin-bottom: 0rem;
  margin-top: 1.75rem;
`;
const UploadCloudSVG = newStyled.svg`
  vertical-align: middle;
  display: inline-block;
  width: 2rem;
  height: 2rem;
`;
const UploadCloudPath = newStyled.path`
  background: #bdcad2 0% 0% no-repeat padding-box;
  margin-top: 0px;
`;
const CloudText = newStyled.p`
  font: normal normal normal 23px/20px 'open sans', sans-serif;
  vertical-align: middle;
  display: inline-block;
  text-align: left;
  margin: 0.359rem 0px 0.359rem 0.5rem;
`;
const DropzoneLine2 = newStyled.div`
  margin: 0.5rem 0rem 1.25rem 0.5rem;
  text-align: center;
`;
const BrowseText = newStyled.a`
  color: #0076ce;
  cursor: pointer;
`;
const DropzoneLine3 = newStyled.p`
  color: #444444;
  margin: 0rem auto 1.938rem;
`;
newStyled.b`
  color: #444444;
  font-weight: bold;
`;

const FileUploadDropzoneUi = props => {
  return React__default.createElement(DropzoneWrapper, {
    "data-testid": "drop-zone-ui"
  }, React__default.createElement(DropzoneLine1, null, React__default.createElement(UploadCloudSVG, {
    viewBox: "0 0 21 16"
  }, React__default.createElement(UploadCloudPath, {
    d: "M14,8.36a.36.36,0,0,1-.35.36H11.2v4a.37.37,0,0,1-.35.36H8.75a.37.37,0,0,1-.35-.36v-4H5.95a.35.35,0,0,1-.35-.36.43.43,0,0,1,.11-.27l3.84-4A.36.36,0,0,1,9.8,4a.34.34,0,0,1,.25.1l3.85,4A.39.39,0,0,1,14,8.36Zm7,3.27a4.34,4.34,0,0,0-3.25-4.25,2.93,2.93,0,0,0,.45-1.57,2.86,2.86,0,0,0-2.8-2.91,2.71,2.71,0,0,0-1.82.7A5.61,5.61,0,0,0,8.4,0,5.71,5.71,0,0,0,2.8,5.82c0,.16,0,.32,0,.49A5.09,5.09,0,0,0,0,10.91,5,5,0,0,0,4.9,16H16.8A4.29,4.29,0,0,0,21,11.64Z"
  })), React__default.createElement(CloudText, null, props.title, " ")), React__default.createElement(DropzoneLine2, null, React__default.createElement("span", null, " Or "), React__default.createElement(BrowseText, {
    "data-testid": "browse-text",
    onClick: () => props.open()
  }, "Browse")), React__default.createElement(DropzoneLine3, null, props.children));
};

let DropzoneActionName;

(function (DropzoneActionName) {
  DropzoneActionName["NEW_FILES"] = "new-files";
  DropzoneActionName["UPDATE_PROGRESS"] = "update-progress";
  DropzoneActionName["SUCCESSFUL_UPLOAD"] = "successful-upload";
  DropzoneActionName["FAILED_UPLOAD"] = "failed-upload";
  DropzoneActionName["UPLOAD_FINISHED"] = "upload-finished";
  DropzoneActionName["DELETE_FILE"] = "delete-file";
  DropzoneActionName["TOGGLE_ERROR"] = "show-error";
})(DropzoneActionName || (DropzoneActionName = {}));

function getUnfinishedFiles(files) {
  return files.find(item => !item.finishedUpload);
}

function FileUploadDropzoneReducer(state, action) {
  switch (action.Type) {
    case DropzoneActionName.NEW_FILES:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        Files: state.Files.concat(action.Payload),
        IdIndex: state.IdIndex + action.Payload.length
      });

    case DropzoneActionName.UPDATE_PROGRESS:
      const updatedFiles = state.Files.map(item => {
        if (item.id == action.Payload.id) {
          item.progress = action.Payload.progress;
        }

        return item;
      });
      return _objectSpread2(_objectSpread2({}, state), {}, {
        Files: updatedFiles
      });

    case DropzoneActionName.SUCCESSFUL_UPLOAD:
      const updatedState = state.Files.map(item => {
        if (item.id == action.Payload.id) {
          item.finishedUpload = true;
          item.progress = 100;
          item.FileId = action.Payload.FileId;
          item.operationResult = UploadOperationResult.Ok;
        }

        return item;
      });
      return _objectSpread2(_objectSpread2({}, state), {}, {
        Files: updatedState,
        FileFinishUploading: getUnfinishedFiles(updatedState) == undefined
      });

    case DropzoneActionName.FAILED_UPLOAD:
      const updatedStateFailed = state.Files.map(item => {
        if (item.id == action.Payload.id) {
          item.finishedUpload = true;
          item.progress = 100;
          item.operationResult = UploadOperationResult.UploadError;
          item.error = action.Payload.errorMessage;
          item.FileId = action.Payload.FileId;
        }

        return item;
      });
      return _objectSpread2(_objectSpread2({}, state), {}, {
        Files: updatedStateFailed,
        FileFinishUploading: getUnfinishedFiles(updatedStateFailed) == undefined
      });

    case DropzoneActionName.UPLOAD_FINISHED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        FileFinishUploading: false
      });

    case DropzoneActionName.DELETE_FILE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        Files: state.Files.filter(item => item.id != action.Payload.id),
        FileFinishUploading: true
      });

    case DropzoneActionName.TOGGLE_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        ShowError: !state.ShowError
      });

    default:
      return state;
  }
}

const ProgressBars = newStyled.div`
  text-align: left;
  font: normal normal normal 14px/20px 'open sans', sans-serif;
  margin-top: 2.313rem;
`;
const FieldLabel = newStyled.p`
  color: #566072;
  font-size: 14px;
  margin-top: 1.688rem;
  margin-bottom: 0.5rem;
`;
const FieldRequired = newStyled.span`
  color: #ff0000;
  padding: 2px;
`;
const FileUploadDropzone = props => {
  const uploadApiEndpoint = props.uploadApiEndpoint;
  const deleteApiEndpoint = props.deleteApiEndpoint;
  const maxFiles = props.maxFiles;
  const maxFileSizeInBytes = props.maxFileSizeInBytes;
  const unexpectedUploadErrorMessage = 'Unexpected error occurred while uploading file.';
  let allowedFileExtension = ".siokit";

  if (props.allowedFileExtension) {
    allowedFileExtension = props.allowedFileExtension;
  }

  const [state, dispatch] = useReducer(FileUploadDropzoneReducer, {
    Files: [],
    FileFinishUploading: false,
    IdIndex: 0,
    ShowError: false
  });

  const tryParseJson = function (text) {
    try {
      const jsonData = JSON.parse(text);
      return {
        IsValid: true,
        Json: jsonData
      };
    } catch (e) {
      return {
        IsValid: false,
        Json: null
      };
    }
  };

  function handleRedirect(response) {
    if (response.redirected) {
      window.location.reload();
      return true;
    }

    return false;
  }

  const uploadFile = fileUploadStatus => {
    const xhr = new XMLHttpRequest();

    xhr.upload.onerror = () => {
      const jsonResult = tryParseJson(xhr.response);
      dispatch({
        Type: DropzoneActionName.FAILED_UPLOAD,
        Payload: {
          id: fileUploadStatus.id,
          errorMessage: jsonResult.IsValid && jsonResult.Json.Message ? jsonResult.Json.Message : unexpectedUploadErrorMessage
        }
      });
    };

    xhr.upload.onabort = () => {
      const jsonResult = tryParseJson(xhr.response);
      dispatch({
        Type: DropzoneActionName.FAILED_UPLOAD,
        Payload: {
          id: fileUploadStatus.id,
          errorMessage: jsonResult.IsValid && jsonResult.Json.Message ? jsonResult.Json.Message : unexpectedUploadErrorMessage
        }
      });
    };

    xhr.upload.onprogress = event => {
      let progressValue = event.loaded / event.total * 100;
      progressValue = progressValue >= 100 ? 99 : progressValue;
      dispatch({
        Type: DropzoneActionName.UPDATE_PROGRESS,
        Payload: {
          id: fileUploadStatus.id,
          progress: progressValue.toFixed(0)
        }
      });
    };

    xhr.open('POST', uploadApiEndpoint, true);

    xhr.onreadystatechange = aEvt => {
      if (xhr.readyState == 4) {
        if (xhr.responseURL && xhr.responseURL.indexOf(uploadApiEndpoint) < 0) {
          window.location.reload();
          return;
        }

        const jsonResult = tryParseJson(xhr.response);

        if (xhr.status != 200 || !jsonResult.IsValid) {
          dispatch({
            Type: DropzoneActionName.FAILED_UPLOAD,
            Payload: {
              id: fileUploadStatus.id,
              errorMessage: jsonResult.IsValid && jsonResult.Json.Message ? jsonResult.Json.Message : unexpectedUploadErrorMessage,
              FileId: null
            }
          });
        } else {
          dispatch({
            Type: DropzoneActionName.SUCCESSFUL_UPLOAD,
            Payload: {
              id: fileUploadStatus.id,
              FileId: jsonResult.Json.Data.FileId
            }
          });
        }
      }
    };

    const formData = new FormData();
    formData.append(fileUploadStatus.file.name, fileUploadStatus.file);
    xhr.send(formData);
  };

  const handleFiles = (acceptedFiles, rejectedFiles) => {
    const newFiles = [];
    let currentId = state.IdIndex;
    const filesTooLarge = rejectedFiles.filter(f => f.errors && f.errors.length > 0 && f.errors.findIndex(e => e.code == ErrorCode.FileTooLarge) != -1);
    const tooManyFile = rejectedFiles.findIndex(e => e.errors.findIndex(error => error.code === ErrorCode.TooManyFiles) >= 0) >= 0 ? true : false;

    if (acceptedFiles.length + filesTooLarge.length + state.Files.length <= maxFiles && tooManyFile == false) {
      acceptedFiles.forEach(file => {
        const fileStatus = {};
        fileStatus.progress = 0;
        fileStatus.file = file;
        fileStatus.finishedUpload = false;
        fileStatus.operationResult = UploadOperationResult.Ok;
        fileStatus.id = currentId++;
        newFiles.push(fileStatus);
        props.onUploadStart();
      });
      filesTooLarge.forEach(fileRejection => {
        const fileStatus = {};
        fileStatus.progress = 0;
        fileStatus.file = fileRejection.file;
        fileStatus.finishedUpload = true;
        fileStatus.operationResult = UploadOperationResult.OperationalError;
        fileStatus.error = props.maxFileSizeValidationFailureMessage;
        fileStatus.id = currentId++;
        newFiles.push(fileStatus);
      });
      dispatch({
        Type: DropzoneActionName.NEW_FILES,
        Payload: newFiles
      });
      newFiles.forEach(file => {
        if (!file.finishedUpload) uploadFile(file);
      });
    } else {
      dispatch({
        Type: DropzoneActionName.TOGGLE_ERROR,
        Payload: null
      });
    }
  };

  const deleteFile = fileUpload => {
    if (fileUpload.FileId != null) {
      (async () => {
        const url = deleteApiEndpoint + '?fileId=' + fileUpload.FileId;
        const response = await fetch(url, {
          method: 'DELETE'
        });

        if (handleRedirect(response)) {
          return;
        }
      })();
    }

    dispatch({
      Type: DropzoneActionName.DELETE_FILE,
      Payload: {
        id: fileUpload.id
      }
    });
  };

  useEffect(() => {
    if (state.FileFinishUploading) {
      const uploadingFiles = state.Files.filter(item => !item.finishedUpload);
      const succesfulFiles = state.Files.filter(item => item.operationResult === UploadOperationResult.Ok && item.finishedUpload);

      if (succesfulFiles.length > 0 && uploadingFiles.length == 0) {
        props.onUploadFinish(succesfulFiles.map(item => {
          return item.FileId;
        }));
      } else {
        props.onUploadStart();
      }

      dispatch({
        Type: DropzoneActionName.UPLOAD_FINISHED,
        Payload: null
      });
    }
  }, [state.FileFinishUploading]);
  useEffect(() => {
    if (props.autoScrollToBottom) {
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      }, 0);
    }
  }, [state.IdIndex]);
  return React__default.createElement("div", null, React__default.createElement(FieldLabel, null, props.label, props.showRequired ? React__default.createElement(FieldRequired, null, "*") : null), React__default.createElement(Dropzone, {
    onDrop: handleFiles,
    allowedFileExtensions: allowedFileExtension,
    maxFiles: maxFiles,
    maxFileSizeInBytes: maxFileSizeInBytes
  }, ({
    open,
    acceptedFiles
  }) => {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(FileUploadDropzoneUi, {
      title: props.dropzoneTitle,
      open: open
    }, props.dropzoneContent));
  }), React__default.createElement(ProgressBars, null, state.Files.map((item, i) => React__default.createElement(FileUploadDropzoneProgressBar, {
    key: i,
    status: item,
    removeFunc: () => deleteFile(item)
  }))), state.ShowError && React__default.createElement(ErrorModal, {
    title: "Maximum Number of Files Exceeded",
    errorMessage: 'The maximum number of files accepted is ' + maxFiles + ' files.',
    primaryButtonName: "Close",
    closeDelayMiliseconds: 0,
    onClose: () => dispatch({
      Type: DropzoneActionName.TOGGLE_ERROR,
      Payload: null
    }),
    onPrimaryClick: () => dispatch({
      Type: DropzoneActionName.TOGGLE_ERROR,
      Payload: null
    })
  }));
};

const Overlay = newStyled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background-color: rgba(40, 40, 40);
  background-color: rgba(40, 40, 40, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const LoaderMessage = newStyled.h2`
  font-size: 2.125rem;
  color: #ffffff;
  margin-top: 2.4rem;
  color: #444444;
  margin-left: 3.125rem;
  font-weight: normal;
`;
const LogoOverlay = newStyled.div`
  position: relative;
  width: 19.188rem;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 10px;
  opacity: 1;
`;
const LogoWrapper = newStyled.div`
  position: relative;
  width: 8.729rem;
  height: 8.652rem;
  margin-top: 2.375rem;
  margin-left: 5.25rem;
`;

const LoadingOverlay = props => {
  return React__default.createElement(Overlay, null, React__default.createElement(LogoOverlay, null, React__default.createElement(LogoWrapper, null, React__default.createElement(GraphsIconColor, null)), React__default.createElement(LoaderMessage, null, props.message)));
};

const UnorderedList$1 = newStyled.ul`
  display: inline-flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
  list-style-type: none;
  white-space: nowrap;

  @media (max-width: 40em) {
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 0.625em;
  }
`;
const ListItem$1 = newStyled.li`
  font: normal normal 600 0.75em/1.063em Open Sans;

  @media (max-width: 40em) {
    padding-bottom: 0.625em;
  }
`;
const ListLink = newStyled.a`
  color: ${Color$1.blueDell};
  text-decoration: none;
  margin-left: 1.5em;

  :hover {
    text-decoration: underline;
  }
`;

const FooterLinksV2 = () => {
  return React__default.createElement(UnorderedList$1, null, React__default.createElement(ListItem$1, null, React__default.createElement(ListLink, {
    href: "https://www.dell.com/en-us/lp/privacy-center",
    target: "_blank",
    rel: "noopener"
  }, "Privacy Policy")), React__default.createElement(ListItem$1, null, React__default.createElement(ListLink, {
    href: "https://www.dell.com/learn/us/en/uscorp1/policies-cookies-ads-emails",
    target: "_blank",
    rel: "noopener"
  }, "Cookies")), React__default.createElement(ListItem$1, null, React__default.createElement(ListLink, {
    href: "https://www.dell.com/learn/us/en/uscorp1/policies-cookies-ads-emails",
    target: "_blank",
    rel: "noopener"
  }, "Ads & Email")), React__default.createElement(ListItem$1, null, React__default.createElement(ListLink, {
    href: "https://www.liveoptics.com/telemetry",
    target: "_blank",
    rel: "noopener"
  }, "Telemetry")), React__default.createElement(ListItem$1, null, React__default.createElement(ListLink, {
    href: "/EULA"
  }, "EULA")), React__default.createElement(ListItem$1, null, React__default.createElement(ListLink, {
    href: "https://support.liveoptics.com/",
    target: "_blank",
    rel: "noopener"
  }, "Support")));
};

const UnorderedList = newStyled.ul`
  display: inline-flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
  list-style-type: none;
  white-space: nowrap;

  @media (max-width: 40em) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
const ListItem = newStyled.li`
  color: ${Color$1.coolGray600};
  margin-right: 1.5em;
  font: normal normal normal 0.75em/1.063em Open Sans;

  @media (max-width: 40em) {
    padding-bottom: 0.625em;
  }
`;

const FooterInfoV2 = props => {
  const year = new Date().getFullYear();
  const {
    appVersion
  } = props;
  return React__default.createElement(UnorderedList, null, React__default.createElement(ListItem, null, "Version: ", appVersion), React__default.createElement(ListItem, null, "\xA9 ", year, " Dell Inc. All Rights Reserved"), React__default.createElement(ListItem, null, "Powered by Live Optics, a Dell Technology"));
};

const Wrapper = newStyled.footer`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: 3.75em;
  background-color: ${Color$1.white};
  justify-content: space-between;

  @media (max-width: 66.5em) {
    padding: 1.25em 0;
    flex-direction: column;
  }
`;
const FooterV2 = props => {
  return React__default.createElement(Wrapper, null, React__default.createElement(FooterLinksV2, null), React__default.createElement(FooterInfoV2, {
    appVersion: props.appVersion
  }));
};

export { AdminPanel, AreaSeriesChart, Areas, Bars$1 as Bars, BarsMultiSeriesChart, BarsSeriesChart, ButtonSize, ChartLegend, ChartLoadingIcon, ChartPanel, ChartPlaceholder, ChartPopover, ChartTooltip, CheckIcon, MemoizedCheckbox as Checkbox, CloseIcon$2 as CloseIcon, CollapsiblePanel, Color$1 as Color, CompositeSeriesChart, Counter, CounterDecrementIcon, CounterIncrementIcon, CustomTableHeaderCounter, DangerButton, DataCenterIcon, DatabaseIcon, Delete, DeleteAction, DeleteBinIcon, DeleteModal, SummaryIcon as DetailsIcon, Donut, DonutChartTile, DownloadRawFiles, DropdownMenu, Dropzone, DynamicModal, ErrorIcon, ErrorModal, ErrorStatusBar, FileUploadDropzone, FilledInfoIcon, FolderIcon, Footer, FooterV2, FormLabel, GaugeBar, GraphLayoutBottomLabel, GraphLayoutDateAxis, GraphLayoutGraph, GraphLayoutGrid, GraphLayoutHeader, GraphLayoutHeaderLegend, GraphLayoutHeaderText, GraphLayoutLeftAxis, GraphLayoutLeftLabel, GraphLayoutLeftLabelText, GraphLayoutRightAxis, GraphLayoutTimeAxis, GraphsIcon, GraphsIconColor, Grid, GridColumn, GridItem, Header, HeaderV2, HorizontalDateAxis, HorizontalGaugeBarChart, HorizontalHoursAndMinutesAxis, HorizontalLabelAxis, HorizontalLine, HorizontalPercentageAxis, HypervisorIcon, InProgressStatusBar, IncompleteStatusBar, InfoIcon, InputHintStyle, InputStyle, LegendPositionEnum, LineSeriesChart, LinearPaths, Lines, LoadingOverlay, LoadingPlaceholderIcon, Modal, MyTeam, Notification, NotificationWithCancel, OverlappedBarsChart, PPTIcon, PerformanceIcon, Popover$1 as Popover, PrimaryButton, PrimaryTabs, PrintIcon, ProgressBar, ProgressBarStatus, ProjectWarningTable, RadioButton, RegisterUser, RequiredStyle, Retry, RichDropdownMenu, SearchIcon$2 as SearchIcon, SecondaryTabs, SelectableTable, ServerClusterIcon, ServerIcon, ShareAction, ShareIcon, SideNav, SmallBasicModal, SpecialButton, StackedAreaSeriesChart, StatusBadge, StatusBar, StatusType, SuccessModal, SummaryIcon, SupportMenu, SupportMenuV2, SystemIcon, Tab, Table, TextArea, TextAreaField, TextButton, TextInput, TextInputField, Tile, ToggleButton$1 as ToggleButton, ToolbarItem$1 as ToolbarItem, Tooltip$1 as Tooltip, UploadIcon, UserMenu, UserMenuV2, VerticalLeftValueAxis, VerticalLine, VerticalRightValueAxis, ViewerTabs, ViewerTabsWithContext, ViewerToolbar, WarningIcon, WarningModal, WorkloadConcentrationChart, Wrapper$3 as Wrapper, XLSXIcon, ZoomContext, ZoomFlag, ZoomProvider, ZoomSeriesBar, brands, getStatusTypeFrom, numberComparator, stringComparator, useAreasSeries, useBarsSeries, useCompositeSeries, useLinesSeries, useResize, useStackedAreasSeries, useTooltip, useViewerTabsContext, useZoom };
//# sourceMappingURL=index.esm.js.map
